(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}



// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.fh.a5 === region.d8.a5)
	{
		return 'on line ' + region.fh.a5;
	}
	return 'on lines ' + region.fh.a5 + ' through ' + region.d8.a5;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (!x.$)
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800)
			+
			String.fromCharCode(code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

var _Json_decodeInt = { $: 2 };
var _Json_decodeBool = { $: 3 };
var _Json_decodeFloat = { $: 4 };
var _Json_decodeValue = { $: 5 };
var _Json_decodeString = { $: 6 };

function _Json_decodeList(decoder) { return { $: 7, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 8, b: decoder }; }

function _Json_decodeNull(value) { return { $: 9, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 10,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 11,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 12,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 13,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 14,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 15,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 3:
			return (typeof value === 'boolean')
				? $elm$core$Result$Ok(value)
				: _Json_expecting('a BOOL', value);

		case 2:
			if (typeof value !== 'number') {
				return _Json_expecting('an INT', value);
			}

			if (-2147483647 < value && value < 2147483647 && (value | 0) === value) {
				return $elm$core$Result$Ok(value);
			}

			if (isFinite(value) && !(value % 1)) {
				return $elm$core$Result$Ok(value);
			}

			return _Json_expecting('an INT', value);

		case 4:
			return (typeof value === 'number')
				? $elm$core$Result$Ok(value)
				: _Json_expecting('a FLOAT', value);

		case 6:
			return (typeof value === 'string')
				? $elm$core$Result$Ok(value)
				: (value instanceof String)
					? $elm$core$Result$Ok(value + '')
					: _Json_expecting('a STRING', value);

		case 9:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 5:
			return $elm$core$Result$Ok(_Json_wrap(value));

		case 7:
			if (!Array.isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 8:
			if (!Array.isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 10:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 11:
			var index = decoder.e;
			if (!Array.isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 12:
			if (typeof value !== 'object' || value === null || Array.isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 13:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 14:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 15:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 3:
		case 2:
		case 4:
		case 6:
		case 5:
			return true;

		case 9:
			return x.c === y.c;

		case 7:
		case 8:
		case 12:
			return _Json_equality(x.b, y.b);

		case 10:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 11:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 13:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 14:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 15:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.gC,
		impl.hT,
		impl.ht,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		gN: func(record.gN),
		du: record.du,
		da: record.da
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.gN;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.du;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.da) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.gC,
		impl.hT,
		impl.ht,
		function(sendToApp, initialModel) {
			var view = impl.fA;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.gC,
		impl.hT,
		impl.ht,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.dl && impl.dl(sendToApp)
			var view = impl.fA;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.fW);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.hz) && (_VirtualDom_doc.title = title = doc.hz);
			});
		}
	);
});



// ANIMATION


var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.gY;
	var onUrlRequest = impl.gZ;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		dl: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.download)
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.e_ === next.e_
							&& curr.ei === next.ei
							&& curr.eT.a === next.eT.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		gC: function(flags)
		{
			return A3(impl.gC, flags, _Browser_getUrl(), key);
		},
		fA: impl.fA,
		hT: impl.hT,
		ht: impl.ht
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { gw: 'hidden', f1: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { gw: 'mozHidden', f1: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { gw: 'msHidden', f1: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { gw: 'webkitHidden', f1: 'webkitvisibilitychange' }
		: { gw: 'hidden', f1: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		fa: _Browser_getScene(),
		fB: {
			v: _Browser_window.pageXOffset,
			w: _Browser_window.pageYOffset,
			fF: _Browser_doc.documentElement.clientWidth,
			eh: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		fF: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		eh: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			fa: {
				fF: node.scrollWidth,
				eh: node.scrollHeight
			},
			fB: {
				v: node.scrollLeft,
				w: node.scrollTop,
				fF: node.clientWidth,
				eh: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			fa: _Browser_getScene(),
			fB: {
				v: x,
				w: y,
				fF: _Browser_doc.documentElement.clientWidth,
				eh: _Browser_doc.documentElement.clientHeight
			},
			gi: {
				v: x + rect.left,
				w: y + rect.top,
				fF: rect.width,
				eh: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// SEND REQUEST

var _Http_toTask = F2(function(request, maybeProgress)
{
	return _Scheduler_binding(function(callback)
	{
		var xhr = new XMLHttpRequest();

		_Http_configureProgress(xhr, maybeProgress);

		xhr.addEventListener('error', function() {
			callback(_Scheduler_fail($elm$http$Http$NetworkError));
		});
		xhr.addEventListener('timeout', function() {
			callback(_Scheduler_fail($elm$http$Http$Timeout));
		});
		xhr.addEventListener('load', function() {
			callback(_Http_handleResponse(xhr, request.ea.a));
		});

		try
		{
			xhr.open(request.gP, request.hU, true);
		}
		catch (e)
		{
			return callback(_Scheduler_fail($elm$http$Http$BadUrl(request.hU)));
		}

		_Http_configureRequest(xhr, request);

		var body = request.fW;
		xhr.send($elm$http$Http$Internal$isStringBody(body)
			? (xhr.setRequestHeader('Content-Type', body.a), body.b)
			: body.a
		);

		return function() { xhr.abort(); };
	});
});

function _Http_configureProgress(xhr, maybeProgress)
{
	if (!$elm$core$Maybe$isJust(maybeProgress))
	{
		return;
	}

	xhr.addEventListener('progress', function(event) {
		if (!event.lengthComputable)
		{
			return;
		}
		_Scheduler_rawSpawn(maybeProgress.a({
			fZ: event.loaded,
			f_: event.total
		}));
	});
}

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.eg; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}

	xhr.responseType = request.ea.b;
	xhr.withCredentials = request.h$;

	$elm$core$Maybe$isJust(request.fp) && (xhr.timeout = request.fp.a);
}


// RESPONSES

function _Http_handleResponse(xhr, responseToResult)
{
	var response = _Http_toResponse(xhr);

	if (xhr.status < 200 || 300 <= xhr.status)
	{
		response.body = xhr.responseText;
		return _Scheduler_fail($elm$http$Http$BadStatus(response));
	}

	var result = responseToResult(response);

	if ($elm$core$Result$isOk(result))
	{
		return _Scheduler_succeed(result.a);
	}
	else
	{
		response.body = xhr.responseText;
		return _Scheduler_fail(A2($elm$http$Http$BadPayload, result.a, response));
	}
}

function _Http_toResponse(xhr)
{
	return {
		hU: xhr.responseURL,
		u: { f4: xhr.status, gN: xhr.statusText },
		eg: _Http_parseHeaders(xhr.getAllResponseHeaders()),
		fW: xhr.response
	};
}

function _Http_parseHeaders(rawHeaders)
{
	var headers = $elm$core$Dict$empty;

	if (!rawHeaders)
	{
		return headers;
	}

	var headerPairs = rawHeaders.split('\u000d\u000a');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf('\u003a\u0020');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}

	return headers;
}


// EXPECTORS

function _Http_expectStringResponse(responseToResult)
{
	return {
		$: 0,
		b: 'text',
		a: responseToResult
	};
}

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		b: expect.b,
		a: function(response) {
			var convertedResponse = expect.a(response);
			return A2($elm$core$Result$map, func, convertedResponse);
		}
	};
});


// BODY

function _Http_multipart(parts)
{


	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}

	return $elm$http$Http$Internal$FormDataBody(formData);
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.e) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.f),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.f);
		} else {
			var treeLen = builder.e * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.g) : builder.g;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.e);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.f) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.f);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{g: nodeList, e: (len / $elm$core$Array$branchFactor) | 0, f: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {ed: fragment, ei: host, c8: path, eT: port_, e_: protocol, e$: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$LandingSite$Page$GovernanceHome = {$: 7};
var $author$project$LandingSite$Page$Home = {$: 0};
var $author$project$LandingSite$Main$Tick = function (a) {
	return {$: 1, a: a};
};
var $author$project$Eth$Config$BasicConfig = F5(
	function (contracts, cTokensRaw, tokens, interestModels, blocks) {
		return {bx: blocks, dV: cTokensRaw, d0: contracts, gE: interestModels, fr: tokens};
	});
var $author$project$Eth$Ethereum$Contract = $elm$core$Basics$identity;
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $elm$core$String$toLower = _String_toLower;
var $author$project$Eth$Decoders$decodeContractAddress = A2(
	$elm$json$Json$Decode$andThen,
	A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Basics$identity),
	A2($elm$json$Json$Decode$map, $elm$core$String$toLower, $elm$json$Json$Decode$string));
var $author$project$Eth$Config$InterestRateModelConfig = F2(
	function (contract, address) {
		return {dL: address, ga: contract};
	});
var $author$project$Eth$Config$decodeInterestRateModel = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Eth$Config$InterestRateModelConfig,
	A2($elm$json$Json$Decode$field, 'contract', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'address', $author$project$Eth$Decoders$decodeContractAddress));
var $author$project$Eth$Config$RawCTokenConfig = F5(
	function (name, symbol, decimals, address, underlying) {
		return {dL: address, H: decimals, gT: name, hv: symbol, aO: underlying};
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Eth$Config$decodeRawCToken = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Eth$Config$RawCTokenConfig,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'symbol', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'address', $author$project$Eth$Decoders$decodeContractAddress),
	A2($elm$json$Json$Decode$field, 'underlying', $author$project$Eth$Decoders$decodeContractAddress));
var $author$project$Eth$Config$TokenConfig = F6(
	function (name, symbol, decimals, address, supported, reader) {
		return {dL: address, H: decimals, gT: name, e2: reader, fm: supported, hv: symbol};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$map6 = _Json_map6;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Eth$Config$decodeToken = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Eth$Config$TokenConfig,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'symbol', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'decimals', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'address', $author$project$Eth$Decoders$decodeContractAddress),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'supported', $elm$json$Json$Decode$bool)),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'reader', $author$project$Eth$Decoders$decodeContractAddress)));
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Eth$Config$basicConfigDecoder = $elm$json$Json$Decode$dict(
	$elm$json$Json$Decode$maybe(
		A6(
			$elm$json$Json$Decode$map5,
			$author$project$Eth$Config$BasicConfig,
			A2(
				$elm$json$Json$Decode$field,
				'Contracts',
				$elm$json$Json$Decode$dict($author$project$Eth$Decoders$decodeContractAddress)),
			A2(
				$elm$json$Json$Decode$field,
				'cTokens',
				$elm$json$Json$Decode$dict($author$project$Eth$Config$decodeRawCToken)),
			A2(
				$elm$json$Json$Decode$field,
				'Tokens',
				$elm$json$Json$Decode$dict($author$project$Eth$Config$decodeToken)),
			A2(
				$elm$json$Json$Decode$field,
				'InterestRateModel',
				$elm$json$Json$Decode$dict($author$project$Eth$Config$decodeInterestRateModel)),
			A2(
				$elm$json$Json$Decode$field,
				'Blocks',
				$elm$json$Json$Decode$dict($elm$json$Json$Decode$int)))));
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Governance$AccountProfile$Loading = {$: 2};
var $author$project$Governance$AccountProfile$emptyState = {U: $author$project$Governance$AccountProfile$Loading, at: 1, aW: _List_Nil, cY: $elm$core$Maybe$Nothing, bV: $elm$core$Maybe$Nothing, bq: $elm$core$Dict$empty};
var $author$project$Governance$Home$emptyState = {aW: _List_Nil, bO: $elm$core$Maybe$Nothing, bP: $elm$core$Maybe$Nothing, bU: $elm$core$Maybe$Nothing};
var $author$project$Governance$Leaderboard$emptyState = {aW: _List_Nil, bT: $elm$core$Maybe$Nothing};
var $author$project$Governance$ProposalDetail$emptyState = {aW: _List_Nil, a6: $elm$core$Maybe$Nothing, a7: $elm$core$Maybe$Nothing, C: $elm$core$Maybe$Nothing, bf: $elm$core$Maybe$Nothing};
var $author$project$Governance$ProposalOverview$emptyState = {as: 1, aW: _List_Nil, a8: $elm$core$Maybe$Nothing, aH: $elm$core$Dict$empty};
var $author$project$LandingSite$About$emptyState = {aW: _List_Nil, bL: $elm$core$Maybe$Nothing};
var $author$project$Strings$Translations$En = 0;
var $author$project$Utils$CompoundHtmlAttributes$External = 2;
var $author$project$LandingSite$Page$Markets = {$: 5};
var $author$project$Utils$CompoundHtmlAttributes$PageNavigation = 0;
var $elm$html$Html$a = _VirtualDom_node('a');
var $author$project$Strings$Translations$can_i_transfer = function (lang) {
	switch (lang) {
		case 0:
			return 'Can I transfer cTokens?';
		case 1:
			return '¿Puedo transferir cTokens?';
		default:
			return '我可以转让cTokens吗？';
	}
};
var $author$project$Strings$Translations$can_i_transfer_description_beginning = function (lang) {
	switch (lang) {
		case 0:
			return 'Yes, but exercise caution! By transferring cTokens, you’re transferring your balance of the underlying asset inside the Compound protocol. If you send a cToken to your friend, your balance (viewable in the ';
		case 1:
			return 'Sí, ¡pero ten cuidado! Al transferir cTokens, está transfiriendo su saldo del activo subyacente dentro del Protocolo Compound. Si envía un cToken a su amigo, su saldo (visible en el';
		default:
			return '是的，但请谨慎行事！通过转移cTokens，您将在复合协议中转移基础资产的余额。如果您将cToken发送给您的朋友，您的余额（可在以下位置查看）';
	}
};
var $author$project$Strings$Translations$can_i_transfer_description_end = function (lang) {
	switch (lang) {
		case 0:
			return ') will decline, and your friend will see their balance increase.';
		case 1:
			return ') disminuirá y su amigo verá aumentar su saldo.';
		default:
			return '）会下降，你的朋友会看到他们的余额增加。';
	}
};
var $author$project$Strings$Translations$can_i_transfer_description_link = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound Interface';
		case 1:
			return 'Interfaz de Compound';
		default:
			return 'Compound 界面';
	}
};
var $author$project$Strings$Translations$can_you_walk_me = function (lang) {
	switch (lang) {
		case 0:
			return 'Can you walk me through an example?';
		case 1:
			return '¿Puedes guiarme a través de un ejemplo?';
		default:
			return '你能告诉我一个例子吗？';
	}
};
var $author$project$Strings$Translations$can_you_walk_me_description_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Let’s say you supply 1,000 DAI to the Compound protocol, when the exchange rate is 0.020070; you would receive 49,825.61 cDAI (1,000/0.020070).';
		case 1:
			return 'Supongamos que suministra 1,000 DAI al Protocolo Compound, cuando el tipo de cambio es 0.020070; recibirías 49,825.61 cDAI (1,000 / 0.020070).';
		default:
			return '假设您在化合物协议中提供1,000 DAI，当汇率为0.020070时;你会得到49,825.61 cDAI（1,000 / 0.020070）。';
	}
};
var $author$project$Strings$Translations$can_you_walk_me_description_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'A few months later, you decide it’s time to withdraw your DAI from the protocol; the exchange rate is now 0.021591:';
		case 1:
			return 'Unos meses después, decide que es hora de retirar su DAI del protocolo; el tipo de cambio ahora es 0.021591:';
		default:
			return '几个月后，您决定是时候从协议中撤回DAI了;汇率现在是0.021591：';
	}
};
var $author$project$Strings$Translations$can_you_walk_me_description_3 = function (lang) {
	switch (lang) {
		case 0:
			return 'Your 49,825.61 cDAI is now equal to 1,075.78 DAI (49,825.61 * 0.021591)';
		case 1:
			return 'Su 49,825.61 cDAI ahora es igual a 1,075.78 DAI (49,825.61 * 0.021591)';
		default:
			return '您的49,825.61 cDAI现在等于1,075.78 DAI（49,825.61 * 0.021591）';
	}
};
var $author$project$Strings$Translations$can_you_walk_me_description_4 = function (lang) {
	switch (lang) {
		case 0:
			return 'You could withdraw 1,075.78 DAI, which would redeem all 49,825.61 cDAI';
		case 1:
			return 'Puede retirar 1,075.78 DAI, lo que redimiría todos los 49,825.61 cDAI';
		default:
			return '您可以提取1,075.78 DAI，这将赎回所有49,825.61 cDAI';
	}
};
var $author$project$Strings$Translations$can_you_walk_me_description_5 = function (lang) {
	switch (lang) {
		case 0:
			return 'Or, you could withdraw a portion, such as your original 1,000 DAI, which would redeem 46,315.59 cDAI (keeping 3,510.01 cDAI in your wallet)';
		case 1:
			return 'O bien, puede retirar una parte, como su 1,000 DAI original, que redimiría 46,315.59 cDAI (manteniendo 3,510.01 cDAI en su billetera)';
		default:
			return '或者，您可以提取一部分，例如您的原始1,000 DAI，这将赎回46,315.59 cDAI（在您的钱包中保留3,510.01 cDAI）';
	}
};
var $author$project$Strings$Translations$do_i_need = function (lang) {
	switch (lang) {
		case 0:
			return 'Do I need to calculate the cToken exchange rate?';
		case 1:
			return '¿Necesito calcular el tipo de cambio de cToken?';
		default:
			return '我需要计算cToken汇率吗？';
	}
};
var $author$project$Strings$Translations$do_i_need_description_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'When a market is launched, the cToken exchange rate (how much ETH one cETH is worth) begins at 0.020000 — and increases at a rate equal to the compounding market interest rate. For example, after one year, the exchange rate might equal 0.021591.';
		case 1:
			return 'Cuando se lanza un mercado, el tipo de cambio cToken (cuánto vale ETH un cETH) comienza en 0.020000 y aumenta a un tipo igual al tipo de interés compuesto del mercado. Por ejemplo, después de un año, el tipo de cambio podría ser igual a 0.021591.';
		default:
			return '当一个市场启动时，cToken 汇率(1 / cETH的价值)从 0.02 万开始，并以与 Compound 市场利率相等的速度增长。例如，一年后，汇率可能等于0.021591。';
	}
};
var $author$project$Strings$Translations$do_i_need_description_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'Each user has the same cToken exchange rate; there’s nothing unique to your wallet that you have to worry about.';
		case 1:
			return 'Cada usuario tiene el mismo tipo de cambio cToken; No hay nada único en su billetera de lo que deba preocuparse.';
		default:
			return '每个用户的 cToken 汇率都是相同的。';
	}
};
var $author$project$LandingSite$Page$getHrefUrl = function (page) {
	switch (page.$) {
		case 0:
			return '/';
		case 1:
			return '/about';
		case 2:
			return '/ctokens';
		case 3:
			var subPage = page.a;
			var fragment = page.b;
			var subsection = function () {
				if (!fragment.$) {
					var s = fragment.a;
					return '#' + s;
				} else {
					return '';
				}
			}();
			var section = function () {
				switch (subPage) {
					case 0:
						return '';
					case 1:
						return '/ctokens';
					case 2:
						return '/comptroller';
					case 3:
						return '/governance';
					case 4:
						return '/api';
					default:
						return '/security';
				}
			}();
			var base = '/developers';
			return _Utils_ap(
				base,
				_Utils_ap(section, subsection));
		case 4:
			var networkString = page.a;
			var contractName = page.b;
			return '/developers/abi/' + (networkString + ('/' + contractName));
		case 5:
			return '/markets';
		case 6:
			var address = page.a;
			return '/governance/address/' + address;
		case 7:
			return '/governance';
		case 8:
			var proposalId = page.a;
			return '/governance/proposals/' + $elm$core$String$fromInt(proposalId);
		case 9:
			return '/governance/proposals';
		default:
			return '/governance/leaderboard';
	}
};
var $author$project$Strings$Translations$how_do_cTokens = function (lang) {
	switch (lang) {
		case 0:
			return 'How do cTokens earn interest?';
		case 1:
			return '¿Cómo ganan intereses los cTokens?';
		default:
			return 'cTokens 如何赚取利息？';
	}
};
var $author$project$Strings$Translations$how_do_cTokens_description_1_beginning = function (lang) {
	switch (lang) {
		case 0:
			return 'Each ';
		case 1:
			return 'Cada';
		default:
			return '每个';
	}
};
var $author$project$Strings$Translations$how_do_cTokens_description_1_end = function (lang) {
	switch (lang) {
		case 0:
			return ' has its own Supply interest rate (APR). Interest isn\'t distributed; instead, simply by holding cTokens, you\'ll earn interest.';
		case 1:
			return 'tiene su propia tasa de interés de suministro (APR). El interés no se distribuye; en cambio, simplemente manteniendo cTokens, ganarás intereses.';
		default:
			return '有自己的供应利率（APR）。利息不分配；相反，只需持有cTokens，您就可以获得利息。';
	}
};
var $author$project$Strings$Translations$how_do_cTokens_description_1_link = function (lang) {
	switch (lang) {
		case 0:
			return 'market';
		case 1:
			return 'mercado';
		default:
			return '市场';
	}
};
var $author$project$Strings$Translations$how_do_cTokens_description_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'cTokens accumulates interest through their exchange rate — over time, each cToken becomes convertible into an increasing amount of it\'s underlying asset, even while the number of cTokens in you wallet stays the same.';
		case 1:
			return 'cTokens acumula intereses a través de su tipo de cambio: con el tiempo, cada cToken se convierte en una cantidad creciente de su activo subyacente, incluso mientras el número de cTokens en su billetera se mantiene igual.';
		default:
			return 'cTokens通过汇率累积利息 - 随着时间的推移，每个cToken都可以转换为越来越多的基础资产，即使你钱包中的cTokens数量保持不变。';
	}
};
var $author$project$Strings$Translations$how_do_i = function (lang) {
	switch (lang) {
		case 0:
			return 'How do I view my cTokens?';
		case 1:
			return '¿Cómo veo mis cTokens?';
		default:
			return '我如何查看我的cTokens？';
	}
};
var $author$project$Strings$Translations$how_do_i_description_1_beginning = function (lang) {
	switch (lang) {
		case 0:
			return 'Each cToken is visible on ';
		case 1:
			return 'Cada cToken es visible en';
		default:
			return '每个cToken都可见';
	}
};
var $author$project$Strings$Translations$how_do_i_description_1_end = function (lang) {
	switch (lang) {
		case 0:
			return ', and you should be able to view them in the list of tokens associated with your address';
		case 1:
			return ', y debería poder verlos en la lista de tokens asociados con su dirección';
		default:
			return '，您应该能够在与您的地址相关联的代币列表中查看它们';
	}
};
var $author$project$Strings$Translations$how_do_i_description_1_link = function (lang) {
	switch (lang) {
		case 0:
			return 'Etherscan';
		case 1:
			return 'Etherscan';
		default:
			return 'Etherscan';
	}
};
var $author$project$Strings$Translations$how_do_i_description_2_beginning = function (lang) {
	switch (lang) {
		case 0:
			return 'cToken balances have been integrated into ';
		case 1:
			return 'Los saldos de cToken se han integrado en';
		default:
			return 'cToken余额已整合到';
	}
};
var $author$project$Strings$Translations$how_do_i_description_2_end = function (lang) {
	switch (lang) {
		case 0:
			return ' and MetaMask; other wallets may add cToken support';
		case 1:
			return 'y MetaMask; otras billeteras pueden agregar soporte cToken';
		default:
			return '和MetaMask；其他钱包可能会添加cToken支持';
	}
};
var $author$project$Strings$Translations$how_do_i_description_2_link = function (lang) {
	switch (lang) {
		case 0:
			return 'Coinbase Wallet';
		case 1:
			return 'Coinbase Wallet';
		default:
			return 'Coinbase钱包';
	}
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Utils$CompoundHtmlAttributes$href = F2(
	function (linkType, linkString) {
		var relAttributes = function () {
			switch (linkType) {
				case 1:
					return _List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'rel', 'internal')
						]);
				case 2:
					return _List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'rel', 'external')
						]);
				default:
					return _List_Nil;
			}
		}();
		return _Utils_ap(
			relAttributes,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'href', linkString)
				]));
	});
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$Utils$CompoundHtmlAttributes$target = function (targetName) {
	return A2($elm$html$Html$Attributes$attribute, 'target', targetName);
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$LandingSite$CTokens$accordianData = function (userLanguage) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$Strings$Translations$how_do_cTokens(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$how_do_cTokens_description_1_beginning(userLanguage)),
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$target('_blank')
									]),
								A2(
									$author$project$Utils$CompoundHtmlAttributes$href,
									0,
									$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Markets))),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$how_do_cTokens_description_1_link(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$how_do_cTokens_description_1_end(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$how_do_cTokens_description_2(userLanguage))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$do_i_need(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$do_i_need_description_1(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$do_i_need_description_2(userLanguage))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$can_you_walk_me(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$can_you_walk_me_description_1(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$can_you_walk_me_description_2(userLanguage))
						])),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$can_you_walk_me_description_3(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$can_you_walk_me_description_4(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$can_you_walk_me_description_5(userLanguage))
										]))
								]))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$how_do_i(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$how_do_i_description_1_beginning(userLanguage)),
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$target('_blank')
									]),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://etherscan.io/tokens/label/compound')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$how_do_i_description_1_link(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$how_do_i_description_1_end(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$how_do_i_description_2_beginning(userLanguage)),
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$target('_blank')
									]),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://itunes.apple.com/us/app/coinbase-wallet/id1278383455')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$how_do_i_description_2_link(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$how_do_i_description_2_end(userLanguage))
						]))
				])),
			_Utils_Tuple2(
			$author$project$Strings$Translations$can_i_transfer(userLanguage),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$can_i_transfer_description_beginning(userLanguage)),
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$target('_blank')
									]),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://app.compound.finance/')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$can_i_transfer_description_link(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$can_i_transfer_description_end(userLanguage))
						]))
				]))
		]);
};
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $author$project$LandingSite$CTokens$emptyState = {
	br: 0,
	aV: false,
	aW: _List_Nil,
	W: A2(
		$elm$core$Array$repeat,
		$elm$core$List$length(
			$author$project$LandingSite$CTokens$accordianData(0)),
		false),
	az: $elm$core$Maybe$Nothing,
	aK: $elm$core$Maybe$Nothing
};
var $author$project$Network$MainNet = 1;
var $author$project$Bootstrap$Carousel$Paused = 0;
var $author$project$Bootstrap$Carousel$Active = 1;
var $author$project$Bootstrap$Carousel$defaultStateOptions = {
	x: 1,
	aA: $elm$core$Maybe$Just(5000),
	a3: true,
	c9: true,
	dt: 0,
	ao: true
};
var $author$project$Bootstrap$Carousel$IgnoreHover = 2;
var $author$project$Bootstrap$Carousel$NotAnimating = {$: 2};
var $author$project$Bootstrap$Carousel$NotHovered = 1;
var $author$project$Bootstrap$Carousel$State = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Bootstrap$Carousel$initialStateWithOptions = function (options) {
	return A2(
		$author$project$Bootstrap$Carousel$State,
		$author$project$Bootstrap$Carousel$NotAnimating,
		{
			V: options.dt,
			x: options.x,
			a1: options.c9 ? 1 : 2,
			aA: A2($elm$core$Maybe$withDefault, 0, options.aA),
			a3: options.a3,
			ak: 2,
			ao: options.ao
		});
};
var $author$project$LandingSite$Developers$emptyState = {
	a9: false,
	N: $author$project$Bootstrap$Carousel$initialStateWithOptions(
		_Utils_update(
			$author$project$Bootstrap$Carousel$defaultStateOptions,
			{
				x: 0,
				aA: $elm$core$Maybe$Just(0)
			})),
	be: $elm$core$Dict$empty,
	b4: 1
};
var $author$project$LandingSite$Home$emptyState = {
	aq: $author$project$Bootstrap$Carousel$initialStateWithOptions(
		_Utils_update(
			$author$project$Bootstrap$Carousel$defaultStateOptions,
			{x: 0, c9: false})),
	aW: _List_Nil
};
var $author$project$LandingSite$Markets$emptyState = {aW: _List_Nil, gy: $elm$core$Maybe$Nothing, a4: $elm$core$Maybe$Nothing};
var $author$project$Strings$Translations$Es = 1;
var $author$project$Strings$Translations$Zh = 2;
var $author$project$Strings$Translations$getLnFromCode = function (code) {
	switch (code) {
		case 'en':
			return 0;
		case 'es':
			return 1;
		case 'zh':
			return 2;
		default:
			return 0;
	}
};
var $author$project$Utils$Graph$emptyState = {by: $elm$core$Dict$empty, aW: _List_Nil, go: $elm$core$Dict$empty, cP: $elm$core$Maybe$Nothing, b6: $elm$core$Dict$empty, b8: $elm$core$Dict$empty, b9: $elm$core$Dict$empty};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Utils$Graph$init = _Utils_Tuple2($author$project$Utils$Graph$emptyState, $elm$core$Platform$Cmd$none);
var $author$project$Network$Goerli = 5;
var $author$project$Network$Kovan = 7;
var $author$project$Network$Rinkeby = 4;
var $author$project$Network$Ropsten = 3;
var $author$project$Network$networkFromName = function (name) {
	var _v0 = $elm$core$String$toLower(name);
	switch (_v0) {
		case 'mainnet':
			return 1;
		case 'ropsten':
			return 3;
		case 'goerli':
			return 5;
		case 'kovan':
			return 7;
		case 'rinkeby':
			return 4;
		default:
			return 1;
	}
};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Preferences$USD = 1;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Preferences$askStoredPreferencesPort = _Platform_outgoingPort(
	'askStoredPreferencesPort',
	function ($) {
		return $elm$json$Json$Encode$object(_List_Nil);
	});
var $author$project$Preferences$askStoredPreferences = $author$project$Preferences$askStoredPreferencesPort(
	{});
var $author$project$Preferences$preferencesInit = _Utils_Tuple2(
	{au: 1},
	$author$project$Preferences$askStoredPreferences);
var $author$project$LandingSite$Main$GovernanceAccountProfileMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$LandingSite$Main$GovernanceHomeMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$LandingSite$Main$GovernanceLeaderboardMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$LandingSite$Main$GovernanceProposalDetailMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$LandingSite$Main$GovernanceProposalOverviewMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Governance$ProposalDetail$AgainstVoteReceiptsResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Governance$ProposalDetail$ForVoteReceiptsResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$ProposalDetail$ProposalsResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$ProposalDetail$desiredVoteReceiptsSize = 25;
var $elm$http$Http$Internal$EmptyBody = {$: 0};
var $elm$http$Http$emptyBody = $elm$http$Http$Internal$EmptyBody;
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$BadPayload = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Internal$FormDataBody = function (a) {
	return {$: 2, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$http$Http$Internal$isStringBody = function (body) {
	if (body.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = _Http_expectStringResponse;
var $elm$http$Http$expectJson = function (decoder) {
	return $elm$http$Http$expectStringResponse(
		function (response) {
			var _v0 = A2($elm$json$Json$Decode$decodeString, decoder, response.fW);
			if (_v0.$ === 1) {
				var decodeError = _v0.a;
				return $elm$core$Result$Err(
					$elm$json$Json$Decode$errorToString(decodeError));
			} else {
				var value = _v0.a;
				return $elm$core$Result$Ok(value);
			}
		});
};
var $elm$http$Http$Internal$Request = $elm$core$Basics$identity;
var $elm$http$Http$request = $elm$core$Basics$identity;
var $elm$http$Http$get = F2(
	function (url, decoder) {
		return $elm$http$Http$request(
			{
				fW: $elm$http$Http$emptyBody,
				ea: $elm$http$Http$expectJson(decoder),
				eg: _List_Nil,
				gP: 'GET',
				fp: $elm$core$Maybe$Nothing,
				hU: url,
				h$: false
			});
	});
var $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Models$ProposalVoteReceiptRequest = F6(
	function (proposal_id, account, support, with_proposal_data, page_size, page_number) {
		return {fJ: account, g1: page_number, g2: page_size, dc: proposal_id, dv: support, h2: with_proposal_data};
	});
var $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Models$ProposalVoteReceiptResponse = F4(
	function (request, pagination_summary, proposal_vote_receipts, error) {
		return {gk: error, g3: pagination_summary, g7: proposal_vote_receipts, hb: request};
	});
var $author$project$CompoundApi$Common$Models$API_Error = F2(
	function (error_code, message) {
		return {gl: error_code, gN: message};
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$CompoundApi$Common$Decoders$apiErrorDecoder = $elm$json$Json$Decode$nullable(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$CompoundApi$Common$Models$API_Error,
		A2($elm$json$Json$Decode$field, 'error_code', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string)));
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$map4 = _Json_map4;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$CompoundApi$Common$Models$PaginationSummary = F4(
	function (page_number, page_size, total_entries, total_pages) {
		return {g1: page_number, g2: page_size, hL: total_entries, hM: total_pages};
	});
var $author$project$CompoundApi$Common$Decoders$paginationSummaryDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Common$Models$PaginationSummary,
	A2($elm$json$Json$Decode$field, 'page_number', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'page_size', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'total_entries', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'total_pages', $elm$json$Json$Decode$int));
var $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Models$createProposalVoteReceipt = F5(
	function (id, displayAccount, support, votes, proposal) {
		return {eY: proposal, dc: id, dv: support, fC: displayAccount, hY: votes};
	});
var $author$project$CompoundApi$Governance$Common$Models$createDisplayAccount = F4(
	function (address, display_name, image_url, account_url) {
		return {dJ: account_url, dL: address, d6: display_name, em: image_url};
	});
var $author$project$CompoundApi$Governance$Common$Decoders$displayAccountDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Governance$Common$Models$createDisplayAccount,
	A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'display_name',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'image_url',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$field,
		'account_url',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)));
var $author$project$CompoundApi$Governance$ProposalService$Models$createProposal = F6(
	function (id, title, description, states, for_votes, against_votes) {
		return {dM: against_votes, d5: description, ec: for_votes, el: id, fj: states, hz: title};
	});
var $author$project$CompoundApi$Governance$ProposalService$Models$ProposalState = F4(
	function (state, start_time, end_time, trx_hash) {
		return {gj: end_time, hk: start_time, fi: state, hQ: trx_hash};
	});
var $author$project$CompoundApi$Governance$ProposalService$Models$Active = 1;
var $author$project$CompoundApi$Governance$ProposalService$Models$Canceled = 6;
var $author$project$CompoundApi$Governance$ProposalService$Models$Executed = 5;
var $author$project$CompoundApi$Governance$ProposalService$Models$Expired = 7;
var $author$project$CompoundApi$Governance$ProposalService$Models$Failed = 3;
var $author$project$CompoundApi$Governance$ProposalService$Models$Pending = 0;
var $author$project$CompoundApi$Governance$ProposalService$Models$Queued = 4;
var $author$project$CompoundApi$Governance$ProposalService$Models$Succeeded = 2;
var $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalStateEnumDecoder = function () {
	var proposalStateStringDecoder = function (stateString) {
		switch (stateString) {
			case 'pending':
				return $elm$json$Json$Decode$succeed(0);
			case 'active':
				return $elm$json$Json$Decode$succeed(1);
			case 'succeeded':
				return $elm$json$Json$Decode$succeed(2);
			case 'defeated':
				return $elm$json$Json$Decode$succeed(3);
			case 'failed':
				return $elm$json$Json$Decode$succeed(3);
			case 'queued':
				return $elm$json$Json$Decode$succeed(4);
			case 'executed':
				return $elm$json$Json$Decode$succeed(5);
			case 'canceled':
				return $elm$json$Json$Decode$succeed(6);
			case 'expired':
				return $elm$json$Json$Decode$succeed(7);
			default:
				return $elm$json$Json$Decode$fail('Unrecognized proposal state: ' + stateString);
		}
	};
	return A2($elm$json$Json$Decode$andThen, proposalStateStringDecoder, $elm$json$Json$Decode$string);
}();
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalStateDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'trx_hash',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'end_time',
		$elm$json$Json$Decode$nullable(
			A2(
				$elm$json$Json$Decode$map,
				$elm$time$Time$millisToPosix,
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Basics$mul(1000),
					$elm$json$Json$Decode$int))),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'start_time',
			A2(
				$elm$json$Json$Decode$map,
				$elm$time$Time$millisToPosix,
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Basics$mul(1000),
					$elm$json$Json$Decode$int)),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'state',
				$author$project$CompoundApi$Governance$ProposalService$Decoders$proposalStateEnumDecoder,
				$elm$json$Json$Decode$succeed($author$project$CompoundApi$Governance$ProposalService$Models$ProposalState)))));
var $author$project$Eth$Decoders$forceMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var val = maybe.a;
			return $elm$json$Json$Decode$succeed(val);
		} else {
			return $elm$json$Json$Decode$fail(err);
		}
	});
var $author$project$Decimal$Decimal = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $cmditch$elm_bigint$BigInt$Negative = 1;
var $cmditch$elm_bigint$BigInt$Positive = 0;
var $cmditch$elm_bigint$BigInt$Magnitude = $elm$core$Basics$identity;
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$traverse = function (f) {
	var step = F2(
		function (e, acc) {
			var _v0 = f(e);
			if (_v0.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = _v0.a;
				return A2(
					$elm$core$Maybe$map,
					$elm$core$List$cons(x),
					acc);
			}
		});
	return A2(
		$elm$core$List$foldr,
		step,
		$elm$core$Maybe$Just(_List_Nil));
};
var $elm_community$maybe_extra$Maybe$Extra$combine = $elm_community$maybe_extra$Maybe$Extra$traverse($elm$core$Basics$identity);
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm_community$list_extra$List$Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var $cmditch$elm_bigint$BigInt$emptyZero = function (_v0) {
	var xs = _v0;
	var _v1 = A2(
		$elm_community$list_extra$List$Extra$dropWhile,
		$elm$core$Basics$eq(0),
		xs);
	if (!_v1.b) {
		return _List_Nil;
	} else {
		return xs;
	}
};
var $elm$core$String$fromList = _String_fromList;
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, xs) {
		var xs_ = A2($elm$core$List$drop, step, xs);
		var okayXs = $elm$core$List$length(xs) > 0;
		var okayArgs = (size > 0) && (step > 0);
		return (okayArgs && okayXs) ? A2(
			$elm$core$List$cons,
			A2($elm$core$List$take, size, xs),
			A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, step, xs_)) : _List_Nil;
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $cmditch$elm_bigint$Constants$maxDigitMagnitude = 7;
var $cmditch$elm_bigint$BigInt$fromString_ = function (x) {
	return A2(
		$elm$core$Maybe$map,
		A2($elm$core$Basics$composeL, $cmditch$elm_bigint$BigInt$emptyZero, $elm$core$Basics$identity),
		$elm_community$maybe_extra$Maybe$Extra$combine(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$reverse,
					A2($elm$core$Basics$composeR, $elm$core$String$fromList, $elm$core$String$toInt)),
				A2(
					$elm_community$list_extra$List$Extra$greedyGroupsOf,
					$cmditch$elm_bigint$Constants$maxDigitMagnitude,
					$elm$core$List$reverse(x)))));
};
var $cmditch$elm_bigint$BigInt$Neg = function (a) {
	return {$: 1, a: a};
};
var $cmditch$elm_bigint$BigInt$Pos = function (a) {
	return {$: 0, a: a};
};
var $cmditch$elm_bigint$BigInt$Zer = {$: 2};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $cmditch$elm_bigint$BigInt$mkBigInt = F2(
	function (s, mag) {
		var digits = mag;
		if ($elm$core$List$isEmpty(digits)) {
			return $cmditch$elm_bigint$BigInt$Zer;
		} else {
			switch (s) {
				case 2:
					return $cmditch$elm_bigint$BigInt$Zer;
				case 0:
					return $cmditch$elm_bigint$BigInt$Pos(mag);
				default:
					return $cmditch$elm_bigint$BigInt$Neg(mag);
			}
		}
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $cmditch$elm_bigint$BigInt$fromString = function (x) {
	var _v0 = $elm$core$String$toList(
		$elm$core$String$toLower(x));
	if (!_v0.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		switch (_v0.a) {
			case '-':
				if (!_v0.b.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var xs = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						$cmditch$elm_bigint$BigInt$mkBigInt(1),
						$cmditch$elm_bigint$BigInt$fromString_(xs));
				}
			case '+':
				if (!_v0.b.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var xs = _v0.b;
					return A2(
						$elm$core$Maybe$map,
						$cmditch$elm_bigint$BigInt$mkBigInt(0),
						$cmditch$elm_bigint$BigInt$fromString_(xs));
				}
			default:
				var xs = _v0;
				return A2(
					$elm$core$Maybe$map,
					$cmditch$elm_bigint$BigInt$mkBigInt(0),
					$cmditch$elm_bigint$BigInt$fromString_(xs));
		}
	}
};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$Decimal$fromString = function (s) {
	var stringToDecimal = function (targetString) {
		var stringIntToDecimal = F2(
			function (s_, e) {
				var _v8 = $cmditch$elm_bigint$BigInt$fromString(s_);
				if (_v8.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var a = _v8.a;
					return $elm$core$Maybe$Just(
						A2($author$project$Decimal$Decimal, a, e));
				}
			});
		var _v6 = A2($elm$core$String$split, '.', targetString);
		_v6$2:
		while (true) {
			if (_v6.b) {
				if (_v6.b.b) {
					if (!_v6.b.b.b) {
						var a = _v6.a;
						var _v7 = _v6.b;
						var b = _v7.a;
						return A2(
							stringIntToDecimal,
							_Utils_ap(a, b),
							-$elm$core$String$length(b));
					} else {
						break _v6$2;
					}
				} else {
					var a = _v6.a;
					return A2(stringIntToDecimal, a, 0);
				}
			} else {
				break _v6$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	};
	var makeMantissa = function (targetString) {
		var _v4 = A2($elm$core$String$split, '.', targetString);
		_v4$2:
		while (true) {
			if (_v4.b) {
				if (!_v4.b.b) {
					var s1 = _v4.a;
					return stringToDecimal(s1);
				} else {
					if (!_v4.b.b.b) {
						var s1 = _v4.a;
						var _v5 = _v4.b;
						var s2 = _v5.a;
						return stringToDecimal(
							A2(
								$elm$core$String$join,
								'',
								_List_fromArray(
									[s1, s2])));
					} else {
						break _v4$2;
					}
				}
			} else {
				break _v4$2;
			}
		}
		return $elm$core$Maybe$Nothing;
	};
	var splitMantissaExponent = function (targetString) {
		var _v2 = A2(
			$elm$core$String$split,
			'e',
			$elm$core$String$toLower(targetString));
		_v2$2:
		while (true) {
			if (_v2.b) {
				if (!_v2.b.b) {
					var s1 = _v2.a;
					return _Utils_Tuple2(
						stringToDecimal(s1),
						$elm$core$Maybe$Just(0));
				} else {
					if (!_v2.b.b.b) {
						var s1 = _v2.a;
						var _v3 = _v2.b;
						var s2 = _v3.a;
						return _Utils_Tuple2(
							stringToDecimal(s1),
							$elm$core$String$toInt(s2));
					} else {
						break _v2$2;
					}
				}
			} else {
				break _v2$2;
			}
		}
		return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
	};
	var _v0 = splitMantissaExponent(s);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var _v1 = _v0.a.a;
		var m = _v1.a;
		var a = _v1.b;
		var e = _v0.b.a;
		return $elm$core$Maybe$Just(
			A2($author$project$Decimal$Decimal, m, e + a));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Eth$Decoders$stringDecimal = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Eth$Decoders$forceMaybe('invalid float'),
	A2($elm$json$Json$Decode$map, $author$project$Decimal$fromString, $elm$json$Json$Decode$string));
var $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'against_votes',
	$author$project$Eth$Decoders$stringDecimal,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'for_votes',
		$author$project$Eth$Decoders$stringDecimal,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'states',
			$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalStateDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'description',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'title',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$CompoundApi$Governance$ProposalService$Models$createProposal)))))));
var $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Decoders$proposalVoteReceiptDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'proposal',
	$elm$json$Json$Decode$nullable($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalDecoder),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'votes',
		$author$project$Eth$Decoders$stringDecimal,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'support',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'voter',
				$author$project$CompoundApi$Governance$Common$Decoders$displayAccountDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'proposal_id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$CompoundApi$Governance$ProposalVoteReceiptService$Models$createProposalVoteReceipt))))));
var $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Decoders$proposalVoteReceiptResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Governance$ProposalVoteReceiptService$Models$ProposalVoteReceiptResponse,
	A2(
		$elm$json$Json$Decode$field,
		'request',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'page_number',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'page_size',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'with_proposal_data',
					$elm$json$Json$Decode$bool,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'support',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
						$elm$core$Maybe$Nothing,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'account',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'proposal_id',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
								$elm$core$Maybe$Nothing,
								$elm$json$Json$Decode$succeed($author$project$CompoundApi$Governance$ProposalVoteReceiptService$Models$ProposalVoteReceiptRequest)))))))),
	A2($elm$json$Json$Decode$field, 'pagination_summary', $author$project$CompoundApi$Common$Decoders$paginationSummaryDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'proposal_vote_receipts',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$ProposalVoteReceiptService$Decoders$proposalVoteReceiptDecoder)),
	A2($elm$json$Json$Decode$field, 'error', $author$project$CompoundApi$Common$Decoders$apiErrorDecoder));
var $author$project$Network$networkName = function (network) {
	switch (network) {
		case 0:
			return 'Olympic';
		case 1:
			return 'Mainnet';
		case 2:
			return 'Morden';
		case 3:
			return 'Ropsten';
		case 4:
			return 'Rinkeby';
		case 5:
			return 'Goerli';
		case 6:
			return 'Ubiq';
		case 7:
			return 'Kovan';
		case 8:
			return 'Sokol';
		case 9:
			return 'Core';
		case 10:
			return 'Development';
		default:
			return 'unknown';
	}
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$relative = F2(
	function (pathSegments, parameters) {
		return _Utils_ap(
			A2($elm$core$String$join, '/', pathSegments),
			$elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$CompoundApi$Common$Url$buildApiUrl = F4(
	function (apiBaseUrlMap, network, apiEndpoint, endpointQueryParams) {
		var shouldAddNetworkQueryParam = function () {
			switch (network) {
				case 1:
					return true;
				case 3:
					return true;
				case 4:
					return true;
				case 5:
					return true;
				case 7:
					return true;
				default:
					return false;
			}
		}();
		var lowercaseNetworkName = $elm$core$String$toLower(
			$author$project$Network$networkName(network));
		var finalQueryParams = shouldAddNetworkQueryParam ? _Utils_ap(
			endpointQueryParams,
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'network', lowercaseNetworkName)
				])) : endpointQueryParams;
		return A2(
			$elm$core$Maybe$map,
			function (apiBaseUrl) {
				return _Utils_ap(
					apiBaseUrl,
					A2(
						$elm$url$Url$Builder$relative,
						_List_fromArray(
							[apiEndpoint]),
						finalQueryParams));
			},
			A2($elm$core$Dict$get, lowercaseNetworkName, apiBaseUrlMap));
	});
var $author$project$CompoundApi$Governance$ProposalService$Encoders$encodeProposalStateEnum = function (stateEnum) {
	switch (stateEnum) {
		case 0:
			return 'pending';
		case 1:
			return 'active';
		case 2:
			return 'succeeded';
		case 3:
			return 'defeated';
		case 4:
			return 'queued';
		case 5:
			return 'executed';
		case 6:
			return 'canceled';
		default:
			return 'expired';
	}
};
var $author$project$CompoundApi$Governance$ProposalService$Urls$proposalsRequestUrl = F3(
	function (apiBaseUrlMap, network, proposalRequest) {
		var requiredQueryParams = _List_fromArray(
			[
				A2(
				$elm$url$Url$Builder$string,
				'page_size',
				$elm$core$String$fromInt(proposalRequest.g2)),
				A2(
				$elm$url$Url$Builder$string,
				'page_number',
				$elm$core$String$fromInt(proposalRequest.g1))
			]);
		var intermediateQueryParams = _Utils_ap(
			requiredQueryParams,
			_Utils_ap(
				function () {
					var _v1 = proposalRequest.g6;
					if (!_v1.b) {
						return _List_Nil;
					} else {
						var proposalIdsList = _v1;
						var proposalsQueryArg = A2(
							$elm$core$String$join,
							',',
							A2($elm$core$List$map, $elm$core$String$fromInt, proposalIdsList));
						return _List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'proposal_ids', proposalsQueryArg)
							]);
					}
				}(),
				function () {
					var _v2 = proposalRequest.h0;
					if (!_v2.$) {
						if (_v2.a) {
							return _List_fromArray(
								[
									A2($elm$url$Url$Builder$string, 'with_detail', 'true')
								]);
						} else {
							return _List_fromArray(
								[
									A2($elm$url$Url$Builder$string, 'with_detail', 'false')
								]);
						}
					} else {
						return _List_Nil;
					}
				}()));
		var finalQueryParams = function () {
			var _v0 = proposalRequest.fi;
			if (!_v0.$) {
				var actualStateFilter = _v0.a;
				return _Utils_ap(
					intermediateQueryParams,
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'state',
							$author$project$CompoundApi$Governance$ProposalService$Encoders$encodeProposalStateEnum(actualStateFilter))
						]));
			} else {
				return intermediateQueryParams;
			}
		}();
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/governance/proposals', finalQueryParams);
	});
var $author$project$CompoundApi$Governance$ProposalService$Models$ProposalsRequest = F5(
	function (proposal_ids, state, page_size, page_number, with_detail) {
		return {g1: page_number, g2: page_size, g6: proposal_ids, fi: state, h0: with_detail};
	});
var $author$project$CompoundApi$Governance$ProposalService$Models$ProposalsWithDetailResponse = F4(
	function (request, pagination_summary, proposals, error) {
		return {gk: error, g3: pagination_summary, eZ: proposals, hb: request};
	});
var $author$project$CompoundApi$Governance$ProposalService$Models$createProposalWithDetail = F8(
	function (id, title, description, proposer, actions, states, for_votes, against_votes) {
		return {fL: actions, dM: against_votes, d5: description, ec: for_votes, el: id, g9: proposer, fj: states, hz: title};
	});
var $author$project$CompoundApi$Governance$ProposalService$Models$ProposalAction = F5(
	function (title, target, value, signature, data) {
		return {gc: data, hi: signature, hw: target, hz: title, aP: value};
	});
var $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalActionDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$CompoundApi$Governance$ProposalService$Models$ProposalAction,
	A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'target', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'value', $author$project$Eth$Decoders$stringDecimal),
	A2($elm$json$Json$Decode$field, 'signature', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'data', $elm$json$Json$Decode$string));
var $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalWithDetailDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'against_votes',
	$author$project$Eth$Decoders$stringDecimal,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'for_votes',
		$author$project$Eth$Decoders$stringDecimal,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'states',
			$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalStateDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'actions',
				$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalActionDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'proposer',
					$author$project$CompoundApi$Governance$Common$Decoders$displayAccountDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'description',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'title',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$int,
								$elm$json$Json$Decode$succeed($author$project$CompoundApi$Governance$ProposalService$Models$createProposalWithDetail)))))))));
var $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalsWithDetailResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Governance$ProposalService$Models$ProposalsWithDetailResponse,
	A2(
		$elm$json$Json$Decode$field,
		'request',
		A6(
			$elm$json$Json$Decode$map5,
			$author$project$CompoundApi$Governance$ProposalService$Models$ProposalsRequest,
			A2(
				$elm$json$Json$Decode$field,
				'proposal_ids',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
			A2(
				$elm$json$Json$Decode$field,
				'state',
				$elm$json$Json$Decode$maybe($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalStateEnumDecoder)),
			A2($elm$json$Json$Decode$field, 'page_size', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'page_number', $elm$json$Json$Decode$int),
			A2(
				$elm$json$Json$Decode$field,
				'with_detail',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool)))),
	A2($elm$json$Json$Decode$field, 'pagination_summary', $author$project$CompoundApi$Common$Decoders$paginationSummaryDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'proposals',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalWithDetailDecoder)),
	A2($elm$json$Json$Decode$field, 'error', $author$project$CompoundApi$Common$Decoders$apiErrorDecoder));
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$http$Http$toTask = function (_v0) {
	var request_ = _v0;
	return A2(_Http_toTask, request_, $elm$core$Maybe$Nothing);
};
var $elm$http$Http$send = F2(
	function (resultToMessage, request_) {
		return A2(
			$elm$core$Task$attempt,
			resultToMessage,
			$elm$http$Http$toTask(request_));
	});
var $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Urls$voteReceiptsRequestUrl = F3(
	function (apiBaseUrlMap, network, request) {
		var requiredQueryParams = _List_fromArray(
			[
				A2(
				$elm$url$Url$Builder$string,
				'page_size',
				$elm$core$String$fromInt(request.g2)),
				A2(
				$elm$url$Url$Builder$string,
				'page_number',
				$elm$core$String$fromInt(request.g1))
			]);
		var finalQueryParams = _Utils_ap(
			requiredQueryParams,
			_Utils_ap(
				function () {
					var _v0 = request.dv;
					if (!_v0.$) {
						var support = _v0.a;
						return support ? _List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'support', 'true')
							]) : _List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'support', 'false')
							]);
					} else {
						return _List_Nil;
					}
				}(),
				_Utils_ap(
					function () {
						var _v1 = request.dc;
						if (!_v1.$) {
							var id = _v1.a;
							return _List_fromArray(
								[
									A2(
									$elm$url$Url$Builder$string,
									'proposal_id',
									$elm$core$String$fromInt(id))
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						function () {
							var _v2 = request.fJ;
							if (!_v2.$) {
								var accountAddress = _v2.a;
								return _List_fromArray(
									[
										A2($elm$url$Url$Builder$string, 'account', accountAddress)
									]);
							} else {
								return _List_Nil;
							}
						}(),
						request.h2 ? _List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'with_proposal_data', 'true')
							]) : _List_fromArray(
							[
								A2($elm$url$Url$Builder$string, 'with_proposal_data', 'false')
							])))));
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/governance/proposal_vote_receipts', finalQueryParams);
	});
var $author$project$Governance$ProposalDetail$attempToLoadProposalId = F3(
	function (apiBaseUrlMap, network, proposalId) {
		var maybeRequestProposalsUrl = A3(
			$author$project$CompoundApi$Governance$ProposalService$Urls$proposalsRequestUrl,
			apiBaseUrlMap,
			network,
			{
				g1: 1,
				g2: 1,
				g6: _List_fromArray(
					[proposalId]),
				fi: $elm$core$Maybe$Nothing,
				h0: $elm$core$Maybe$Just(true)
			});
		var maybeRequestForVoteReceiptsUrl = A3(
			$author$project$CompoundApi$Governance$ProposalVoteReceiptService$Urls$voteReceiptsRequestUrl,
			apiBaseUrlMap,
			network,
			{
				fJ: $elm$core$Maybe$Nothing,
				g1: 1,
				g2: $author$project$Governance$ProposalDetail$desiredVoteReceiptsSize,
				dc: $elm$core$Maybe$Just(proposalId),
				dv: $elm$core$Maybe$Just(true),
				h2: false
			});
		var maybeRequestAgainstVoteReceiptsUrl = A3(
			$author$project$CompoundApi$Governance$ProposalVoteReceiptService$Urls$voteReceiptsRequestUrl,
			apiBaseUrlMap,
			network,
			{
				fJ: $elm$core$Maybe$Nothing,
				g1: 1,
				g2: $author$project$Governance$ProposalDetail$desiredVoteReceiptsSize,
				dc: $elm$core$Maybe$Just(proposalId),
				dv: $elm$core$Maybe$Just(false),
				h2: false
			});
		var apiRequestCmds = $elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$List$cons,
				function () {
					if (!maybeRequestProposalsUrl.$) {
						var requestProposalsUrl = maybeRequestProposalsUrl.a;
						return A2(
							$elm$http$Http$send,
							$author$project$Governance$ProposalDetail$ProposalsResponse,
							A2($elm$http$Http$get, requestProposalsUrl, $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalsWithDetailResponseDecoder));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}(),
				function () {
					var _v1 = _Utils_Tuple2(maybeRequestForVoteReceiptsUrl, maybeRequestAgainstVoteReceiptsUrl);
					if ((!_v1.a.$) && (!_v1.b.$)) {
						var requestForVoteReceiptsUrl = _v1.a.a;
						var requestAgainstVoteReceiptsUrl = _v1.b.a;
						return _List_fromArray(
							[
								A2(
								$elm$http$Http$send,
								$author$project$Governance$ProposalDetail$ForVoteReceiptsResponse,
								A2($elm$http$Http$get, requestForVoteReceiptsUrl, $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Decoders$proposalVoteReceiptResponseDecoder)),
								A2(
								$elm$http$Http$send,
								$author$project$Governance$ProposalDetail$AgainstVoteReceiptsResponse,
								A2($elm$http$Http$get, requestAgainstVoteReceiptsUrl, $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Decoders$proposalVoteReceiptResponseDecoder))
							]);
					} else {
						return _List_Nil;
					}
				}()));
		return _Utils_Tuple2($author$project$Governance$ProposalDetail$emptyState, apiRequestCmds);
	});
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {X: frag, af: params, S: unvisited, aP: value, am: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.S;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.aP);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.aP);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.c8),
					$elm$url$Url$Parser$prepareQuery(url.e$),
					url.ed,
					$elm$core$Basics$identity)));
	});
var $author$project$LandingSite$Page$API = 4;
var $author$project$LandingSite$Page$About = {$: 1};
var $author$project$LandingSite$Page$CTokens = {$: 2};
var $author$project$LandingSite$Page$Comptroller = 2;
var $author$project$LandingSite$Page$Developers = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$LandingSite$Page$DevelopersABIView = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$LandingSite$Page$DevelopersCTokens = 1;
var $author$project$LandingSite$Page$GettingStarted = 0;
var $author$project$LandingSite$Page$Governance = 3;
var $author$project$LandingSite$Page$GovernanceAccountProfile = function (a) {
	return {$: 6, a: a};
};
var $author$project$LandingSite$Page$GovernanceLeaderboard = {$: 10};
var $author$project$LandingSite$Page$GovernanceProposalDetail = function (a) {
	return {$: 8, a: a};
};
var $author$project$LandingSite$Page$GovernanceProposalOverview = {$: 9};
var $author$project$LandingSite$Page$Security = 5;
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$fragment = function (toFrag) {
	return function (_v0) {
		var visited = _v0.am;
		var unvisited = _v0.S;
		var params = _v0.af;
		var frag = _v0.X;
		var value = _v0.aP;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					toFrag(frag)))
			]);
	};
};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.am;
			var unvisited = _v0.S;
			var params = _v0.af;
			var frag = _v0.X;
			var value = _v0.aP;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.am;
		var unvisited = _v0.S;
		var params = _v0.af;
		var frag = _v0.X;
		var value = _v0.aP;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.am;
			var unvisited = _v1.S;
			var params = _v1.af;
			var frag = _v1.X;
			var value = _v1.aP;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.am;
		var unvisited = _v0.S;
		var params = _v0.af;
		var frag = _v0.X;
		var value = _v0.aP;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$LandingSite$Page$parser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$LandingSite$Page$Home, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Markets,
			$elm$url$Url$Parser$s('markets')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$About,
			$elm$url$Url$Parser$s('about')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$CTokens,
			$elm$url$Url$Parser$s('ctokens')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Developers(0),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('developers'),
				$elm$url$Url$Parser$fragment($elm$core$Basics$identity))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Developers(1),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('developers'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('ctokens'),
					$elm$url$Url$Parser$fragment($elm$core$Basics$identity)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Developers(2),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('developers'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('comptroller'),
					$elm$url$Url$Parser$fragment($elm$core$Basics$identity)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Developers(3),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('developers'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('governance'),
					$elm$url$Url$Parser$fragment($elm$core$Basics$identity)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Developers(4),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('developers'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('api'),
					$elm$url$Url$Parser$fragment($elm$core$Basics$identity)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$Developers(5),
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('developers'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('security'),
					$elm$url$Url$Parser$fragment($elm$core$Basics$identity)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$DevelopersABIView,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('developers'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('abi'),
					A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$GovernanceAccountProfile,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('governance'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('address'),
					$elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$GovernanceHome,
			$elm$url$Url$Parser$s('governance')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$GovernanceProposalDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('governance'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('proposals'),
					$elm$url$Url$Parser$int))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$GovernanceProposalOverview,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('governance'),
				$elm$url$Url$Parser$s('proposals'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$LandingSite$Page$GovernanceLeaderboard,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('governance'),
				$elm$url$Url$Parser$s('leaderboard')))
		]));
var $author$project$LandingSite$Page$getLandingPage = function (location) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$LandingSite$Page$Home,
		A2($elm$url$Url$Parser$parse, $author$project$LandingSite$Page$parser, location));
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Functions$demaybeify = function (maybeMaybeVal) {
	if (!maybeMaybeVal.$) {
		var val = maybeMaybeVal.a;
		return val;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Eth$Ethereum$areContractsEqual = F2(
	function (_v0, _v1) {
		var addressA = _v0;
		var addressB = _v1;
		return _Utils_eq(
			$elm$core$String$toLower(addressA),
			$elm$core$String$toLower(addressB));
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $author$project$Functions$dictFilterMap = F2(
	function (f, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, acc) {
					var _v0 = A2(f, k, v);
					if (!_v0.$) {
						var newVal = _v0.a;
						return A3($elm$core$Dict$insert, k, newVal, acc);
					} else {
						return acc;
					}
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Functions$andMap = F2(
	function (f, x) {
		return A2(
			$elm$core$Maybe$andThen,
			function (x_) {
				return A2(
					$elm$core$Maybe$andThen,
					function (f_) {
						return $elm$core$Maybe$Just(
							f_(x_));
					},
					f);
			},
			x);
	});
var $author$project$Functions$map2 = F3(
	function (m0, m1, f) {
		var _v0 = _Utils_Tuple2(m0, m1);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var v0 = _v0.a.a;
			var v1 = _v0.b.a;
			return $elm$core$Maybe$Just(
				A2(f, v0, v1));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Functions$map3 = F4(
	function (m0, m1, m2, f) {
		var r = A3($author$project$Functions$map2, m0, m1, f);
		return A2($author$project$Functions$andMap, r, m2);
	});
var $author$project$Functions$map4 = F5(
	function (m0, m1, m2, m3, f) {
		var r = A4($author$project$Functions$map3, m0, m1, m2, f);
		return A2($author$project$Functions$andMap, r, m3);
	});
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Eth$Config$loadConfig = F2(
	function (networkName, _v0) {
		var contracts = _v0.d0;
		var cTokensRaw = _v0.dV;
		var tokens = _v0.fr;
		var blocks = _v0.bx;
		var maybeUSDCAssetAddress = A2(
			$elm$core$Maybe$andThen,
			function (tokenConfig) {
				return $elm$core$Maybe$Just(tokenConfig.dL);
			},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (tokenConfig) {
						return tokenConfig.hv === 'USDC';
					},
					$elm$core$Dict$values(tokens))));
		var maybeTimelock = A2($elm$core$Dict$get, 'Timelock', contracts);
		var maybePriceOracle = A2($elm$core$Dict$get, 'PriceOracleProxy', contracts);
		var maybeMaximillion = A2($elm$core$Dict$get, 'Maximillion', contracts);
		var maybeLiquidator = A2($elm$core$Dict$get, 'Liquidator', contracts);
		var maybeGovernor = A2($elm$core$Dict$get, 'GovernorAlpha', contracts);
		var maybeComptroller = A2($elm$core$Dict$get, 'Comptroller', contracts);
		var maybeCompToken = A2($elm$core$Dict$get, 'COMP', tokens);
		var maybeCEtherToken = A2($elm$core$Dict$get, 'cETH', tokens);
		var maybeCErc20Delegate = A2($elm$core$Dict$get, 'cErc20Delegate', contracts);
		var maybeCDaiDelegate = A2($elm$core$Dict$get, 'cDaiDelegate', contracts);
		var cTokensWithoutCEth = A2(
			$author$project$Functions$dictFilterMap,
			F2(
				function (key, rawCTokenConfig) {
					return A2(
						$elm$core$Maybe$andThen,
						function (tokenConfig) {
							var underlyingRebrandTokenConfig = function () {
								switch (networkName) {
									case 'mainnet':
										return A2($author$project$Eth$Ethereum$areContractsEqual, rawCTokenConfig.dL, '0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643') ? _Utils_update(
											tokenConfig,
											{gT: 'Dai'}) : (A2($author$project$Eth$Ethereum$areContractsEqual, rawCTokenConfig.dL, '0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359') ? _Utils_update(
											tokenConfig,
											{gT: 'Sai (Legacy DAI)'}) : tokenConfig);
									case 'kovan':
										return A2($author$project$Eth$Ethereum$areContractsEqual, rawCTokenConfig.dL, '0xe7bc397DBd069fC7d0109C0636d06888bb50668c') ? _Utils_update(
											tokenConfig,
											{gT: 'Dai'}) : (A2($author$project$Eth$Ethereum$areContractsEqual, rawCTokenConfig.dL, '0x63c344BF8651222346DD870be254D4347c9359f7') ? _Utils_update(
											tokenConfig,
											{gT: 'Sai (Legacy DAI)'}) : tokenConfig);
									default:
										return tokenConfig;
								}
							}();
							return $elm$core$Maybe$Just(
								{dL: rawCTokenConfig.dL, H: rawCTokenConfig.H, gT: rawCTokenConfig.gT, hv: rawCTokenConfig.hv, aO: underlyingRebrandTokenConfig});
						},
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (tokenConfig) {
									return _Utils_eq(tokenConfig.dL, rawCTokenConfig.aO);
								},
								$elm$core$Dict$values(tokens))));
				}),
			cTokensRaw);
		var cTokens = function () {
			if (!maybeCEtherToken.$) {
				var cEtherTokenConfig = maybeCEtherToken.a;
				var dummyEthConfig = {
					dL: cEtherTokenConfig.dL,
					H: 18,
					gT: 'Ether',
					e2: $elm$core$Maybe$Nothing,
					fm: $elm$core$Maybe$Just(true),
					hv: 'ETH'
				};
				var actualCEtherTokenConfig = {dL: cEtherTokenConfig.dL, H: cEtherTokenConfig.H, gT: cEtherTokenConfig.gT, hv: cEtherTokenConfig.hv, aO: dummyEthConfig};
				return A3($elm$core$Dict$insert, cEtherTokenConfig.hv, actualCEtherTokenConfig, cTokensWithoutCEth);
			} else {
				return cTokensWithoutCEth;
			}
		}();
		return A5(
			$author$project$Functions$map4,
			maybeComptroller,
			maybePriceOracle,
			maybeCEtherToken,
			maybeMaximillion,
			F4(
				function (comptroller, priceOracle, cEtherToken, maximillion) {
					return {bx: blocks, dT: cEtherToken, dU: cTokens, d$: comptroller, eA: maximillion, eB: maybeCDaiDelegate, eC: maybeCErc20Delegate, eD: maybeCompToken, eE: maybeGovernor, eF: maybeUSDCAssetAddress, eG: maybeLiquidator, eH: maybeTimelock, eU: priceOracle};
				}));
	});
var $author$project$LandingSite$Main$getMainNetConfig = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		$author$project$Eth$Config$loadConfig('mainnet'),
		$author$project$Functions$demaybeify(
			A2($elm$core$Dict$get, 'mainnet', model.bB)));
};
var $author$project$LandingSite$About$AllJobsResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$LandingSite$About$ForSelf = $elm$core$Basics$identity;
var $author$project$GoogleHire$Models$Job = F3(
	function (jobLocation, title, url) {
		return {gJ: jobLocation, hz: title, hU: url};
	});
var $author$project$GoogleHire$Models$JobLocation = function (address) {
	return {dL: address};
};
var $author$project$GoogleHire$Models$Address = function (addressLocality) {
	return {fP: addressLocality};
};
var $author$project$GoogleHire$Decoders$addressDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$GoogleHire$Models$Address,
	A2($elm$json$Json$Decode$field, 'addressLocality', $elm$json$Json$Decode$string));
var $author$project$GoogleHire$Decoders$jobLocationDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$GoogleHire$Models$JobLocation,
	A2($elm$json$Json$Decode$field, 'address', $author$project$GoogleHire$Decoders$addressDecoder));
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$GoogleHire$Decoders$jobDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$GoogleHire$Models$Job,
	A2($elm$json$Json$Decode$field, 'jobLocation', $author$project$GoogleHire$Decoders$jobLocationDecoder),
	A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string));
var $author$project$GoogleHire$Decoders$jobsResponseDecoder = $elm$json$Json$Decode$list($author$project$GoogleHire$Decoders$jobDecoder);
var $author$project$LandingSite$About$loadJobs = function () {
	var jobsRequestHttpGet = A2($elm$http$Http$get, 'https://hire.withgoogle.com/v2/api/t/compoundfinance/public/jobs', $author$project$GoogleHire$Decoders$jobsResponseDecoder);
	return A2(
		$elm$http$Http$send,
		A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$LandingSite$About$AllJobsResponse),
		jobsRequestHttpGet);
}();
var $author$project$LandingSite$About$init = _Utils_Tuple2($author$project$LandingSite$About$emptyState, $author$project$LandingSite$About$loadJobs);
var $author$project$Utils$ProtoDoc$File = F4(
	function (name, enums, messages, services) {
		return {bH: enums, eI: messages, gT: name, fd: services};
	});
var $author$project$Utils$ProtoDoc$Enum = F4(
	function (name, longName, fullName, values) {
		return {aw: fullName, cT: longName, gT: name, hW: values};
	});
var $author$project$Utils$ProtoDoc$EnumValue = F3(
	function (name, number, description) {
		return {d5: description, gT: name, gU: number};
	});
var $author$project$Utils$ProtoDoc$decodeEnumValue = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Utils$ProtoDoc$EnumValue,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'number', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string));
var $author$project$Utils$ProtoDoc$decodeEnum = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Utils$ProtoDoc$Enum,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'longName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'fullName', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'values',
		$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeEnumValue)));
var $author$project$Utils$ProtoDoc$Message = F5(
	function (name, longName, fullName, description, fields) {
		return {d5: description, bI: fields, aw: fullName, cT: longName, gT: name};
	});
var $author$project$Utils$ProtoDoc$Field = F4(
	function (name, description, fieldType, fullType) {
		return {d5: description, aX: fieldType, aY: fullType, gT: name};
	});
var $author$project$Utils$ProtoDoc$decodeField = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Utils$ProtoDoc$Field,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'fullType', $elm$json$Json$Decode$string));
var $author$project$Utils$ProtoDoc$decodeMessage = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Utils$ProtoDoc$Message,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'longName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'fullName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'fields',
		$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeField)));
var $author$project$Utils$ProtoDoc$Service = F5(
	function (name, longName, fullName, description, methods) {
		return {d5: description, aw: fullName, cT: longName, gQ: methods, gT: name};
	});
var $author$project$Utils$ProtoDoc$Method = F5(
	function (name, description, requestFullType, responseFullType, rules) {
		return {d5: description, gT: name, e4: requestFullType, e6: responseFullType, hh: rules};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $author$project$Utils$ProtoDoc$Rule = F2(
	function (method, pattern) {
		return {gP: method, g4: pattern};
	});
var $author$project$Utils$ProtoDoc$decodeRule = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Utils$ProtoDoc$Rule,
	A2($elm$json$Json$Decode$field, 'method', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'pattern', $elm$json$Json$Decode$string));
var $author$project$Utils$ProtoDoc$decodeMethod = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Utils$ProtoDoc$Method,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'requestFullType', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'responseFullType', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['options', 'google.api.http', 'rules']),
		$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeRule)));
var $author$project$Utils$ProtoDoc$decodeService = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Utils$ProtoDoc$Service,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'longName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'fullName', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'methods',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeMethod),
					$elm$json$Json$Decode$succeed(_List_Nil)
				]))));
var $author$project$Utils$ProtoDoc$decodeFile = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Utils$ProtoDoc$File,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'enums',
		$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeEnum)),
	A2(
		$elm$json$Json$Decode$field,
		'messages',
		$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeMessage)),
	A2(
		$elm$json$Json$Decode$field,
		'services',
		$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeService)));
var $author$project$Utils$ProtoDoc$toDict = F2(
	function (els, fn) {
		return $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				function (el) {
					return _Utils_Tuple2(
						fn(el),
						el);
				},
				els));
	});
var $author$project$Utils$ProtoDoc$fileToProtoDoc = function (_v0) {
	var name = _v0.gT;
	var enums = _v0.bH;
	var messages = _v0.eI;
	var services = _v0.fd;
	return _Utils_Tuple2(
		name,
		{
			bH: A2(
				$author$project$Utils$ProtoDoc$toDict,
				enums,
				function ($) {
					return $.aw;
				}),
			eI: A2(
				$author$project$Utils$ProtoDoc$toDict,
				messages,
				function ($) {
					return $.aw;
				}),
			fd: A2(
				$author$project$Utils$ProtoDoc$toDict,
				services,
				function ($) {
					return $.aw;
				})
		});
};
var $author$project$Utils$ProtoDoc$decodeProtoDoc = function (val) {
	return A2(
		$elm$core$Result$map,
		$elm$core$Dict$fromList,
		A2(
			$elm$core$Result$map,
			$elm$core$List$map($author$project$Utils$ProtoDoc$fileToProtoDoc),
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2(
					$elm$json$Json$Decode$field,
					'files',
					$elm$json$Json$Decode$list($author$project$Utils$ProtoDoc$decodeFile)),
				val)));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Utils$Highlighter$highlightScroll = _Platform_outgoingPort(
	'highlightScroll',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$LandingSite$Developers$init = function (protoDocJson) {
	var protoDoc = A2(
		$elm$core$Result$withDefault,
		$elm$core$Dict$empty,
		$author$project$Utils$ProtoDoc$decodeProtoDoc(protoDocJson));
	return _Utils_Tuple2(
		_Utils_update(
			$author$project$LandingSite$Developers$emptyState,
			{be: protoDoc}),
		$author$project$Utils$Highlighter$highlightScroll(
			_Utils_Tuple2('.side-navigation a', 'section[id],.function[id]')));
};
var $author$project$LandingSite$Main$LandingAboutMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$LandingSite$About$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.eP;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$landingAboutTranslator = $author$project$LandingSite$About$translator(
	{eP: $author$project$LandingSite$Main$LandingAboutMsg});
var $author$project$LandingSite$Main$LandingCTokensMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$LandingSite$Main$WrappedGraphMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$LandingSite$CTokens$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.eP;
		var onWrappedGraphMsg = _v0.eR;
		if (!msg.$) {
			var internal = msg.a;
			return onInternalMessage(internal);
		} else {
			var graphMsg = msg.a;
			return onWrappedGraphMsg(graphMsg);
		}
	});
var $author$project$LandingSite$Main$landingCTokensTranslator = $author$project$LandingSite$CTokens$translator(
	{eP: $author$project$LandingSite$Main$LandingCTokensMsg, eR: $author$project$LandingSite$Main$WrappedGraphMsg});
var $author$project$LandingSite$Main$LandingDevelopersPresidioMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$LandingSite$Developers$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.eP;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$landingDevelopersPresidioTranslator = $author$project$LandingSite$Developers$translator(
	{eP: $author$project$LandingSite$Main$LandingDevelopersPresidioMsg});
var $author$project$Governance$AccountProfile$GovAccountResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$AccountProfile$RecentVoteReceiptsResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$AccountProfile$desiredPageSize = 5;
var $author$project$CompoundApi$Governance$AccountService$Encoders$encodeAccountFilterEnum = function (accountFilterEnum) {
	switch (accountFilterEnum) {
		case 0:
			return 'votes';
		case 1:
			return 'balance';
		default:
			return 'proposals_created';
	}
};
var $author$project$CompoundApi$Governance$AccountService$Urls$governanceAccountRequestUrl = F3(
	function (apiBaseUrlMap, network, accountRequest) {
		var requiredQueryParams = _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$url$Url$Builder$string,
					'page_size',
					$elm$core$String$fromInt(accountRequest.g2)),
					A2(
					$elm$url$Url$Builder$string,
					'page_number',
					$elm$core$String$fromInt(accountRequest.g1))
				]),
			accountRequest.h1 ? _List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'with_history', 'true')
				]) : _List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'with_history', 'false')
				]));
		var intermediateQueryParams = _Utils_ap(
			requiredQueryParams,
			function () {
				var _v1 = accountRequest.fQ;
				if (!_v1.b) {
					return _List_Nil;
				} else {
					var addressList = _v1;
					var addressesQueryArg = A2($elm$core$String$join, ',', addressList);
					return _List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'addresses', addressesQueryArg)
						]);
				}
			}());
		var finalQueryParams = function () {
			var _v0 = accountRequest.g0;
			if (!_v0.$) {
				var actualOrderBy = _v0.a;
				return _Utils_ap(
					intermediateQueryParams,
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'order_by',
							$author$project$CompoundApi$Governance$AccountService$Encoders$encodeAccountFilterEnum(actualOrderBy))
						]));
			} else {
				return intermediateQueryParams;
			}
		}();
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/governance/accounts', finalQueryParams);
	});
var $author$project$CompoundApi$Governance$AccountService$Models$GovernanceAccountRequest = F5(
	function (addresses, order_by, page_size, page_number, with_history) {
		return {fQ: addresses, g0: order_by, g1: page_number, g2: page_size, h1: with_history};
	});
var $author$project$CompoundApi$Governance$AccountService$Models$GovernanceAccountResponse = F4(
	function (request, pagination_summary, accounts, error) {
		return {fK: accounts, gk: error, g3: pagination_summary, hb: request};
	});
var $author$project$CompoundApi$Governance$AccountService$Models$Balance = 1;
var $author$project$CompoundApi$Governance$AccountService$Models$ProposalsCreated = 2;
var $author$project$CompoundApi$Governance$AccountService$Models$Votes = 0;
var $author$project$CompoundApi$Governance$AccountService$Decoders$accountFilterByDecoder = function () {
	var accountFilterStringDecoder = function (accountFilterString) {
		switch (accountFilterString) {
			case 'votes':
				return $elm$json$Json$Decode$succeed(0);
			case 'balance':
				return $elm$json$Json$Decode$succeed(1);
			case 'proposals_created':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unrecognized account filter option: ' + accountFilterString);
		}
	};
	return A2($elm$json$Json$Decode$andThen, accountFilterStringDecoder, $elm$json$Json$Decode$string);
}();
var $author$project$CompoundApi$Governance$Common$Models$CompAccountTransaction = F4(
	function (title, timestamp, trx_hash, delta) {
		return {gg: delta, hy: timestamp, hz: title, hQ: trx_hash};
	});
var $author$project$CompoundApi$Governance$Common$Decoders$compAccountTransactionDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Governance$Common$Models$CompAccountTransaction,
	A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$map,
		$elm$time$Time$millisToPosix,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Basics$mul(1000),
			A2($elm$json$Json$Decode$field, 'timestamp', $elm$json$Json$Decode$int))),
	A2($elm$json$Json$Decode$field, 'trx_hash', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'delta', $author$project$Eth$Decoders$stringDecimal));
var $author$project$CompoundApi$Governance$Common$Models$createCompAccount = function (address) {
	return function (display_name) {
		return function (image_url) {
			return function (account_url) {
				return function (balance) {
					return function (votes) {
						return function (vote_weight) {
							return function (proposals_created) {
								return function (delegate) {
									return function (rank) {
										return function (transactions) {
											return {dJ: account_url, dL: address, fS: balance, ge: delegate, d6: display_name, em: image_url, g8: proposals_created, ha: rank, hP: transactions, hX: vote_weight, hY: votes};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$CompoundApi$Governance$Common$Decoders$compAccountDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'transactions',
	$elm$json$Json$Decode$maybe(
		$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$Common$Decoders$compAccountTransactionDecoder)),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rank',
		$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'delegate',
			$author$project$CompoundApi$Governance$Common$Decoders$displayAccountDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'proposals_created',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'vote_weight',
					$author$project$Eth$Decoders$stringDecimal,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'votes',
						$author$project$Eth$Decoders$stringDecimal,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'balance',
							$author$project$Eth$Decoders$stringDecimal,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'account_url',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'image_url',
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'display_name',
										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'address',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$CompoundApi$Governance$Common$Models$createCompAccount))))))))))));
var $author$project$CompoundApi$Governance$AccountService$Decoders$governanceAccountResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Governance$AccountService$Models$GovernanceAccountResponse,
	A2(
		$elm$json$Json$Decode$field,
		'request',
		A6(
			$elm$json$Json$Decode$map5,
			$author$project$CompoundApi$Governance$AccountService$Models$GovernanceAccountRequest,
			A2(
				$elm$json$Json$Decode$field,
				'addresses',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
			A2(
				$elm$json$Json$Decode$field,
				'order_by',
				$elm$json$Json$Decode$maybe($author$project$CompoundApi$Governance$AccountService$Decoders$accountFilterByDecoder)),
			A2($elm$json$Json$Decode$field, 'page_size', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'page_number', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'with_history', $elm$json$Json$Decode$bool))),
	A2($elm$json$Json$Decode$field, 'pagination_summary', $author$project$CompoundApi$Common$Decoders$paginationSummaryDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'accounts',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$Common$Decoders$compAccountDecoder)),
	A2($elm$json$Json$Decode$field, 'error', $author$project$CompoundApi$Common$Decoders$apiErrorDecoder));
var $author$project$Governance$AccountProfile$loadAccountDetails = F3(
	function (apiBaseUrlMap, network, accountAddress) {
		var maybeRequestRecentVoteReceiptsUrl = A3(
			$author$project$CompoundApi$Governance$ProposalVoteReceiptService$Urls$voteReceiptsRequestUrl,
			apiBaseUrlMap,
			network,
			{
				fJ: $elm$core$Maybe$Just(accountAddress),
				g1: 1,
				g2: $author$project$Governance$AccountProfile$desiredPageSize,
				dc: $elm$core$Maybe$Nothing,
				dv: $elm$core$Maybe$Nothing,
				h2: true
			});
		var maybeRequestGovAccountUrl = A3(
			$author$project$CompoundApi$Governance$AccountService$Urls$governanceAccountRequestUrl,
			apiBaseUrlMap,
			network,
			{
				fQ: _List_fromArray(
					[accountAddress]),
				g0: $elm$core$Maybe$Nothing,
				g1: 1,
				g2: 1,
				h1: true
			});
		var requestCmds = function () {
			var _v0 = _Utils_Tuple2(maybeRequestGovAccountUrl, maybeRequestRecentVoteReceiptsUrl);
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var requestGovAccountUrl = _v0.a.a;
				var requestRecentVoteReceiptsUrl = _v0.b.a;
				var recentVoteReceiptsRequest = A2($elm$http$Http$get, requestRecentVoteReceiptsUrl, $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Decoders$proposalVoteReceiptResponseDecoder);
				var govAccountRequest = A2($elm$http$Http$get, requestGovAccountUrl, $author$project$CompoundApi$Governance$AccountService$Decoders$governanceAccountResponseDecoder);
				return _List_fromArray(
					[
						A2($elm$http$Http$send, $author$project$Governance$AccountProfile$GovAccountResponse, govAccountRequest),
						A2($elm$http$Http$send, $author$project$Governance$AccountProfile$RecentVoteReceiptsResponse, recentVoteReceiptsRequest)
					]);
			} else {
				return _List_fromArray(
					[$elm$core$Platform$Cmd$none]);
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				$author$project$Governance$AccountProfile$emptyState,
				{U: $author$project$Governance$AccountProfile$Loading}),
			$elm$core$Platform$Cmd$batch(requestCmds));
	});
var $author$project$Governance$Home$HistoricalDataResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Home$LatestProposalsResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Governance$Home$TopDelegatesResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$CompoundApi$Governance$HistoryService$Urls$governanceHistoryRequestUrl = F3(
	function (apiBaseUrlMap, network, _v0) {
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/governance/history', _List_Nil);
	});
var $author$project$CompoundApi$Governance$HistoryService$Models$GovernanceHistoryResponse = F5(
	function (error, proposals_created, total_delegatees, total_delegators, votes_delegated) {
		return {gk: error, g8: proposals_created, hJ: total_delegatees, hK: total_delegators, hZ: votes_delegated};
	});
var $author$project$CompoundApi$Governance$HistoryService$Decoders$governanceHistoryResponseDecoder = A6(
	$elm$json$Json$Decode$map5,
	$author$project$CompoundApi$Governance$HistoryService$Models$GovernanceHistoryResponse,
	A2($elm$json$Json$Decode$field, 'error', $author$project$CompoundApi$Common$Decoders$apiErrorDecoder),
	A2($elm$json$Json$Decode$field, 'proposals_created', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'total_delegatees', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'total_delegators', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'votes_delegated', $author$project$Eth$Decoders$stringDecimal));
var $author$project$CompoundApi$Governance$ProposalService$Models$ProposalsResponse = F4(
	function (request, pagination_summary, proposals, error) {
		return {gk: error, g3: pagination_summary, eZ: proposals, hb: request};
	});
var $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalsResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Governance$ProposalService$Models$ProposalsResponse,
	A2(
		$elm$json$Json$Decode$field,
		'request',
		A6(
			$elm$json$Json$Decode$map5,
			$author$project$CompoundApi$Governance$ProposalService$Models$ProposalsRequest,
			A2(
				$elm$json$Json$Decode$field,
				'proposal_ids',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$int)),
			A2(
				$elm$json$Json$Decode$field,
				'state',
				$elm$json$Json$Decode$maybe($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalStateEnumDecoder)),
			A2($elm$json$Json$Decode$field, 'page_size', $elm$json$Json$Decode$int),
			A2($elm$json$Json$Decode$field, 'page_number', $elm$json$Json$Decode$int),
			A2(
				$elm$json$Json$Decode$field,
				'with_detail',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$bool)))),
	A2($elm$json$Json$Decode$field, 'pagination_summary', $author$project$CompoundApi$Common$Decoders$paginationSummaryDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'proposals',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Governance$ProposalService$Decoders$proposalDecoder)),
	A2($elm$json$Json$Decode$field, 'error', $author$project$CompoundApi$Common$Decoders$apiErrorDecoder));
var $author$project$Governance$Home$loadDashboard = F2(
	function (apiBaseUrlMap, network) {
		var maybeRequestTopDelegatesUrl = A3(
			$author$project$CompoundApi$Governance$AccountService$Urls$governanceAccountRequestUrl,
			apiBaseUrlMap,
			network,
			{
				fQ: _List_Nil,
				g0: $elm$core$Maybe$Just(0),
				g1: 1,
				g2: 5,
				h1: false
			});
		var maybeRequestProposalsUrl = A3(
			$author$project$CompoundApi$Governance$ProposalService$Urls$proposalsRequestUrl,
			apiBaseUrlMap,
			network,
			{
				g1: 1,
				g2: 5,
				g6: _List_Nil,
				fi: $elm$core$Maybe$Nothing,
				h0: $elm$core$Maybe$Just(false)
			});
		var maybeRequestHistoryUrl = A3(
			$author$project$CompoundApi$Governance$HistoryService$Urls$governanceHistoryRequestUrl,
			apiBaseUrlMap,
			network,
			{});
		var requestCmds = function () {
			var _v0 = _Utils_Tuple3(maybeRequestHistoryUrl, maybeRequestProposalsUrl, maybeRequestTopDelegatesUrl);
			if (((!_v0.a.$) && (!_v0.b.$)) && (!_v0.c.$)) {
				var requestHistoryUrl = _v0.a.a;
				var requestProposalsUrl = _v0.b.a;
				var requestTopDelegatesUrl = _v0.c.a;
				var topDelegatesRequest = A2($elm$http$Http$get, requestTopDelegatesUrl, $author$project$CompoundApi$Governance$AccountService$Decoders$governanceAccountResponseDecoder);
				var latestProposalsRequest = A2($elm$http$Http$get, requestProposalsUrl, $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalsResponseDecoder);
				var historyRequest = A2($elm$http$Http$get, requestHistoryUrl, $author$project$CompoundApi$Governance$HistoryService$Decoders$governanceHistoryResponseDecoder);
				return _List_fromArray(
					[
						A2($elm$http$Http$send, $author$project$Governance$Home$LatestProposalsResponse, latestProposalsRequest),
						A2($elm$http$Http$send, $author$project$Governance$Home$TopDelegatesResponse, topDelegatesRequest),
						A2($elm$http$Http$send, $author$project$Governance$Home$HistoricalDataResponse, historyRequest)
					]);
			} else {
				return _List_fromArray(
					[$elm$core$Platform$Cmd$none]);
			}
		}();
		return $elm$core$Platform$Cmd$batch(requestCmds);
	});
var $author$project$LandingSite$CTokens$ForParent = function (a) {
	return {$: 1, a: a};
};
var $author$project$LandingSite$CTokens$WrappedGraphMsg = $elm$core$Basics$identity;
var $author$project$Eth$Ethereum$getContractAddressString = function (contractAddress) {
	var addressString = contractAddress;
	return addressString;
};
var $author$project$Utils$Graph$GetInterestRateHistoryGraphResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Console$log = _Platform_outgoingPort('log', $elm$json$Json$Encode$string);
var $author$project$Console$error = function (err) {
	return $author$project$Console$log('Error: ' + err);
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Utils$Graph$getInterestRateHistoryGraphRequestEncoder = function (request) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'asset',
				$elm$json$Json$Encode$string(request.bt)),
				_Utils_Tuple2(
				'min_block_timestamp',
				$elm$json$Json$Encode$int(request.c0)),
				_Utils_Tuple2(
				'max_block_timestamp',
				$elm$json$Json$Encode$int(request.cX)),
				_Utils_Tuple2(
				'num_buckets',
				$elm$json$Json$Encode$int(request.c4))
			]));
};
var $author$project$Utils$Graph$API_MarketTotal = F2(
	function (block_number, total) {
		return {fU: block_number, dy: total};
	});
var $author$project$Utils$Graph$API_Rate = F3(
	function (block_number, block_timestamp, rate) {
		return {fU: block_number, fV: block_timestamp, e0: rate};
	});
var $author$project$Utils$Graph$InterestRateHistoryGraph = F6(
	function (assetAddress, supplyRateData, borrowRateData, exchangeRateData, totalSupplyData, totalBorrowsData) {
		return {E: assetAddress, dS: borrowRateData, d9: exchangeRateData, fl: supplyRateData, fs: totalBorrowsData, ft: totalSupplyData};
	});
var $author$project$CompoundApi$Common$Decoders$apiPrecise = A2($elm$json$Json$Decode$field, 'value', $author$project$Eth$Decoders$stringDecimal);
var $cmditch$elm_bigint$BigInt$BigIntNotNormalised = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $cmditch$elm_bigint$BigInt$MagnitudeNotNormalised = $elm$core$Basics$identity;
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $cmditch$elm_bigint$BigInt$isNegativeMagnitude = function (digits) {
	var _v0 = $elm_community$list_extra$List$Extra$last(digits);
	if (_v0.$ === 1) {
		return false;
	} else {
		var x = _v0.a;
		return x < 0;
	}
};
var $cmditch$elm_bigint$BigInt$mkBigIntNotNormalised = F2(
	function (s, digits) {
		return A2($cmditch$elm_bigint$BigInt$BigIntNotNormalised, s, digits);
	});
var $elm_community$list_extra$List$Extra$dropWhileRight = function (p) {
	return A2(
		$elm$core$List$foldr,
		F2(
			function (x, xs) {
				return (p(x) && $elm$core$List$isEmpty(xs)) ? _List_Nil : A2($elm$core$List$cons, x, xs);
			}),
		_List_Nil);
};
var $cmditch$elm_bigint$BigInt$dropZeroes = $elm_community$list_extra$List$Extra$dropWhileRight(
	$elm$core$Basics$eq(0));
var $elm$core$Basics$pow = _Basics_pow;
var $cmditch$elm_bigint$Constants$maxDigitValue = (-1) + A2($elm$core$Basics$pow, 10, $cmditch$elm_bigint$Constants$maxDigitMagnitude);
var $cmditch$elm_bigint$BigInt$baseDigit = $cmditch$elm_bigint$Constants$maxDigitValue + 1;
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $cmditch$elm_bigint$BigInt$normaliseDigit = function (x) {
	return (x < 0) ? A2(
		$elm$core$Tuple$mapFirst,
		$elm$core$Basics$add(-1),
		$cmditch$elm_bigint$BigInt$normaliseDigit(x + $cmditch$elm_bigint$BigInt$baseDigit)) : _Utils_Tuple2((x / $cmditch$elm_bigint$BigInt$baseDigit) | 0, x % $cmditch$elm_bigint$BigInt$baseDigit);
};
var $cmditch$elm_bigint$BigInt$normaliseDigitList = F2(
	function (carry, xs) {
		normaliseDigitList:
		while (true) {
			if (!xs.b) {
				if (_Utils_cmp(carry, $cmditch$elm_bigint$BigInt$baseDigit) > 0) {
					var $temp$carry = 0,
						$temp$xs = _List_fromArray(
						[carry]);
					carry = $temp$carry;
					xs = $temp$xs;
					continue normaliseDigitList;
				} else {
					return _List_fromArray(
						[carry]);
				}
			} else {
				var x = xs.a;
				var xs_ = xs.b;
				var _v1 = $cmditch$elm_bigint$BigInt$normaliseDigit(x + carry);
				var newCarry = _v1.a;
				var x_ = _v1.b;
				return A2(
					$elm$core$List$cons,
					x_,
					A2($cmditch$elm_bigint$BigInt$normaliseDigitList, newCarry, xs_));
			}
		}
	});
var $cmditch$elm_bigint$BigInt$normaliseMagnitude = function (_v0) {
	var xs = _v0;
	return $cmditch$elm_bigint$BigInt$dropZeroes(
		A2($cmditch$elm_bigint$BigInt$normaliseDigitList, 0, xs));
};
var $cmditch$elm_bigint$BigInt$reverseMagnitude = $elm$core$List$map($elm$core$Basics$negate);
var $cmditch$elm_bigint$BigInt$Zero = 2;
var $cmditch$elm_bigint$BigInt$signNegate = function (sign_) {
	switch (sign_) {
		case 0:
			return 1;
		case 1:
			return 0;
		default:
			return 2;
	}
};
var $cmditch$elm_bigint$BigInt$normalise = function (_v0) {
	normalise:
	while (true) {
		var s = _v0.a;
		var digits = _v0.b;
		var _v1 = $cmditch$elm_bigint$BigInt$normaliseMagnitude(digits);
		var normalisedMag = _v1;
		if ($cmditch$elm_bigint$BigInt$isNegativeMagnitude(normalisedMag)) {
			var $temp$_v0 = A2(
				$cmditch$elm_bigint$BigInt$mkBigIntNotNormalised,
				$cmditch$elm_bigint$BigInt$signNegate(s),
				$cmditch$elm_bigint$BigInt$reverseMagnitude(normalisedMag));
			_v0 = $temp$_v0;
			continue normalise;
		} else {
			return A2($cmditch$elm_bigint$BigInt$mkBigInt, s, normalisedMag);
		}
	}
};
var $cmditch$elm_bigint$BigInt$signFromInt = function (x) {
	var _v0 = A2($elm$core$Basics$compare, x, 0);
	switch (_v0) {
		case 0:
			return 1;
		case 2:
			return 0;
		default:
			return 2;
	}
};
var $cmditch$elm_bigint$BigInt$fromInt = function (x) {
	return $cmditch$elm_bigint$BigInt$normalise(
		A2(
			$cmditch$elm_bigint$BigInt$BigIntNotNormalised,
			$cmditch$elm_bigint$BigInt$signFromInt(x),
			_List_fromArray(
				[
					$elm$core$Basics$abs(x)
				])));
};
var $author$project$Decimal$fromIntWithExponent = F2(
	function (n, e) {
		return A2(
			$author$project$Decimal$Decimal,
			$cmditch$elm_bigint$BigInt$fromInt(n),
			e);
	});
var $cmditch$elm_bigint$BigInt$magnitude = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return _List_Nil;
		case 0:
			var mag = bigInt.a;
			return mag;
		default:
			var mag = bigInt.a;
			return mag;
	}
};
var $cmditch$elm_bigint$BigInt$MagnitudePair = $elm$core$Basics$identity;
var $cmditch$elm_bigint$BigInt$sameSizeRaw = F2(
	function (xs, ys) {
		var _v0 = _Utils_Tuple2(xs, ys);
		if (!_v0.a.b) {
			if (!_v0.b.b) {
				return _List_Nil;
			} else {
				var _v2 = _v0.b;
				var y = _v2.a;
				var ys_ = _v2.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(0, y),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, _List_Nil, ys_));
			}
		} else {
			if (!_v0.b.b) {
				var _v1 = _v0.a;
				var x = _v1.a;
				var xs_ = _v1.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(x, 0),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs_, _List_Nil));
			} else {
				var _v3 = _v0.a;
				var x = _v3.a;
				var xs_ = _v3.b;
				var _v4 = _v0.b;
				var y = _v4.a;
				var ys_ = _v4.b;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(x, y),
					A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs_, ys_));
			}
		}
	});
var $cmditch$elm_bigint$BigInt$sameSizeNotNormalized = F2(
	function (_v0, _v1) {
		var xs = _v0;
		var ys = _v1;
		return A2($cmditch$elm_bigint$BigInt$sameSizeRaw, xs, ys);
	});
var $cmditch$elm_bigint$BigInt$toPositiveSign = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return A2($cmditch$elm_bigint$BigInt$mkBigIntNotNormalised, 2, _List_Nil);
		case 1:
			var digits = bigInt.a;
			return A2(
				$cmditch$elm_bigint$BigInt$mkBigIntNotNormalised,
				0,
				$cmditch$elm_bigint$BigInt$reverseMagnitude(digits));
		default:
			var digits = bigInt.a;
			return A2($cmditch$elm_bigint$BigInt$mkBigIntNotNormalised, 0, digits);
	}
};
var $cmditch$elm_bigint$BigInt$add = F2(
	function (a, b) {
		var _v0 = $cmditch$elm_bigint$BigInt$toPositiveSign(b);
		var mb = _v0.b;
		var _v1 = $cmditch$elm_bigint$BigInt$toPositiveSign(a);
		var ma = _v1.b;
		var _v2 = A2($cmditch$elm_bigint$BigInt$sameSizeNotNormalized, ma, mb);
		var pairs = _v2;
		var added = A2(
			$elm$core$List$map,
			function (_v3) {
				var a_ = _v3.a;
				var b_ = _v3.b;
				return a_ + b_;
			},
			pairs);
		return $cmditch$elm_bigint$BigInt$normalise(
			A2($cmditch$elm_bigint$BigInt$BigIntNotNormalised, 0, added));
	});
var $cmditch$elm_bigint$BigInt$mulSingleDigit = F2(
	function (_v0, d) {
		var xs = _v0;
		return $cmditch$elm_bigint$BigInt$normaliseMagnitude(
			A2(
				$elm$core$List$map,
				$elm$core$Basics$mul(d),
				xs));
	});
var $cmditch$elm_bigint$BigInt$mulMagnitudes = F2(
	function (_v0, _v1) {
		var mag1 = _v0;
		var mag2 = _v1;
		if (!mag1.b) {
			return _List_Nil;
		} else {
			if (!mag1.b.b) {
				var m = mag1.a;
				return A2($cmditch$elm_bigint$BigInt$mulSingleDigit, mag2, m);
			} else {
				var m = mag1.a;
				var mx = mag1.b;
				var accum = A2($cmditch$elm_bigint$BigInt$mulSingleDigit, mag2, m);
				var _v3 = A2($cmditch$elm_bigint$BigInt$mulMagnitudes, mx, mag2);
				var rest = _v3;
				var bigInt = A2(
					$cmditch$elm_bigint$BigInt$add,
					A2($cmditch$elm_bigint$BigInt$mkBigInt, 0, accum),
					A2(
						$cmditch$elm_bigint$BigInt$mkBigInt,
						0,
						A2($elm$core$List$cons, 0, rest)));
				return $cmditch$elm_bigint$BigInt$magnitude(bigInt);
			}
		}
	});
var $cmditch$elm_bigint$BigInt$sign = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return 2;
		case 0:
			return 0;
		default:
			return 1;
	}
};
var $cmditch$elm_bigint$BigInt$signProduct = F2(
	function (x, y) {
		return ((x === 2) || (y === 2)) ? 2 : (_Utils_eq(x, y) ? 0 : 1);
	});
var $cmditch$elm_bigint$BigInt$mul = F2(
	function (int1, int2) {
		return A2(
			$cmditch$elm_bigint$BigInt$mkBigInt,
			A2(
				$cmditch$elm_bigint$BigInt$signProduct,
				$cmditch$elm_bigint$BigInt$sign(int1),
				$cmditch$elm_bigint$BigInt$sign(int2)),
			A2(
				$cmditch$elm_bigint$BigInt$mulMagnitudes,
				$cmditch$elm_bigint$BigInt$magnitude(int1),
				$cmditch$elm_bigint$BigInt$magnitude(int2)));
	});
var $author$project$Decimal$mul = F2(
	function (_v0, _v1) {
		var ma = _v0.a;
		var ea = _v0.b;
		var mb = _v1.a;
		var eb = _v1.b;
		return A2(
			$author$project$Decimal$Decimal,
			A2($cmditch$elm_bigint$BigInt$mul, ma, mb),
			ea + eb);
	});
var $author$project$Eth$Decoders$encodedDecimal = A2(
	$elm$json$Json$Decode$map,
	function (_v0) {
		var man = _v0.a;
		var exp = _v0.b;
		var expDec = A2($author$project$Decimal$fromIntWithExponent, 1, (-1) * exp);
		return A2($author$project$Decimal$mul, man, expDec);
	},
	A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (a, b) {
				return _Utils_Tuple2(a, b);
			}),
		A2($elm$json$Json$Decode$field, 'man', $author$project$Eth$Decoders$stringDecimal),
		A2($elm$json$Json$Decode$field, 'exp', $elm$json$Json$Decode$int)));
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Decimal$fromFloat = function (f) {
	return $author$project$Decimal$fromString(
		$elm$core$String$fromFloat(f));
};
var $author$project$Eth$Decoders$floatDecimal = A2(
	$elm$json$Json$Decode$andThen,
	$author$project$Eth$Decoders$forceMaybe('invalid float'),
	A2($elm$json$Json$Decode$map, $author$project$Decimal$fromFloat, $elm$json$Json$Decode$float));
var $author$project$Eth$Decoders$decimal = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Eth$Decoders$floatDecimal, $author$project$Eth$Decoders$stringDecimal, $author$project$Eth$Decoders$encodedDecimal]));
var $author$project$Utils$Graph$getInterestRateHistoryGraphResponseDecoder = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Utils$Graph$InterestRateHistoryGraph,
	A2($elm$json$Json$Decode$field, 'asset', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'supply_rates',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Utils$Graph$API_Rate,
				A2($elm$json$Json$Decode$field, 'block_number', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'block_timestamp', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'rate', $author$project$Eth$Decoders$decimal)))),
	A2(
		$elm$json$Json$Decode$field,
		'borrow_rates',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Utils$Graph$API_Rate,
				A2($elm$json$Json$Decode$field, 'block_number', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'block_timestamp', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'rate', $author$project$Eth$Decoders$decimal)))),
	A2(
		$elm$json$Json$Decode$field,
		'exchange_rates',
		$elm$json$Json$Decode$list(
			A4(
				$elm$json$Json$Decode$map3,
				$author$project$Utils$Graph$API_Rate,
				A2($elm$json$Json$Decode$field, 'block_number', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'block_timestamp', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'rate', $author$project$Eth$Decoders$decimal)))),
	A2(
		$elm$json$Json$Decode$field,
		'total_supply_history',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Utils$Graph$API_MarketTotal,
				A2($elm$json$Json$Decode$field, 'block_number', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'total', $author$project$CompoundApi$Common$Decoders$apiPrecise)))),
	A2(
		$elm$json$Json$Decode$field,
		'total_borrows_history',
		$elm$json$Json$Decode$list(
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$Utils$Graph$API_MarketTotal,
				A2($elm$json$Json$Decode$field, 'block_number', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'total', $author$project$CompoundApi$Common$Decoders$apiPrecise)))));
var $elm$http$Http$Internal$StringBody = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		$elm$http$Http$Internal$StringBody,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$http$Http$post = F3(
	function (url, body, decoder) {
		return $elm$http$Http$request(
			{
				fW: body,
				ea: $elm$http$Http$expectJson(decoder),
				eg: _List_Nil,
				gP: 'POST',
				fp: $elm$core$Maybe$Nothing,
				hU: url,
				h$: false
			});
	});
var $author$project$Utils$Graph$getInterestRateHistoryGraph = F2(
	function (request, url) {
		var body = $elm$http$Http$jsonBody(
			$author$project$Utils$Graph$getInterestRateHistoryGraphRequestEncoder(request));
		return A3($elm$http$Http$post, url, body, $author$project$Utils$Graph$getInterestRateHistoryGraphResponseDecoder);
	});
var $author$project$Utils$Graph$getInterestRateHistoryGraphUrl = F2(
	function (apiBaseUrlMap, network) {
		var _v0 = A2(
			$elm$core$Dict$get,
			$elm$core$String$toLower(
				$author$project$Network$networkName(network)),
			apiBaseUrlMap);
		if (!_v0.$) {
			var apiBaseUrl = _v0.a;
			return $elm$core$Maybe$Just(apiBaseUrl + 'v2/market_history/graph');
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Utils$Graph$graphBuckets = 30;
var $author$project$Utils$Graph$graphLengthSeconds = ((60 * 60) * 24) * 30;
var $author$project$Utils$Graph$loadInterestRateHistoryGraph = F4(
	function (assetAddress, time, apiBaseUrlMap, network) {
		var maybeGetInterestRateHistoryGraphUrl = A2($author$project$Utils$Graph$getInterestRateHistoryGraphUrl, apiBaseUrlMap, network);
		if (!maybeGetInterestRateHistoryGraphUrl.$) {
			var interestRateHistoryGraphUrl = maybeGetInterestRateHistoryGraphUrl.a;
			return A2(
				$elm$http$Http$send,
				$author$project$Utils$Graph$GetInterestRateHistoryGraphResponse,
				A2(
					$author$project$Utils$Graph$getInterestRateHistoryGraph,
					{bt: assetAddress, cX: time, c0: time - $author$project$Utils$Graph$graphLengthSeconds, c4: $author$project$Utils$Graph$graphBuckets},
					interestRateHistoryGraphUrl));
		} else {
			return $author$project$Console$error(
				'UNSUPPORTED NETWORK' + $author$project$Network$networkName(network));
		}
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $author$project$Utils$Time$posixToSeconds = function (time) {
	var ms = $elm$time$Time$posixToMillis(time);
	var msFloat = ms / 1000;
	return $elm$core$Basics$floor(msFloat);
};
var $author$project$LandingSite$CTokens$loadGraphCmd = F3(
	function (apiBaseUrlMap, maybeCurrentTime, maybeCToken) {
		var _v0 = _Utils_Tuple2(maybeCurrentTime, maybeCToken);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var currentTime = _v0.a.a;
			var token = _v0.b.a;
			return A2(
				$elm$core$Platform$Cmd$map,
				A2($elm$core$Basics$composeL, $author$project$LandingSite$CTokens$ForParent, $elm$core$Basics$identity),
				A4(
					$author$project$Utils$Graph$loadInterestRateHistoryGraph,
					$author$project$Eth$Ethereum$getContractAddressString(token.dL),
					$author$project$Utils$Time$posixToSeconds(currentTime),
					apiBaseUrlMap,
					1));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Governance$ProposalOverview$AllProposalsResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$ProposalOverview$desiredPageSize = 25;
var $author$project$Governance$ProposalOverview$loadProposals = F2(
	function (apiBaseUrlMap, network) {
		var maybeRequestProposalsUrl = A3(
			$author$project$CompoundApi$Governance$ProposalService$Urls$proposalsRequestUrl,
			apiBaseUrlMap,
			network,
			{
				g1: 1,
				g2: $author$project$Governance$ProposalOverview$desiredPageSize,
				g6: _List_Nil,
				fi: $elm$core$Maybe$Nothing,
				h0: $elm$core$Maybe$Just(false)
			});
		var requestCmd = function () {
			if (!maybeRequestProposalsUrl.$) {
				var requestProposalsUrl = maybeRequestProposalsUrl.a;
				var allProposalsRequest = A2($elm$http$Http$get, requestProposalsUrl, $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalsResponseDecoder);
				return A2($elm$http$Http$send, $author$project$Governance$ProposalOverview$AllProposalsResponse, allProposalsRequest);
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return requestCmd;
	});
var $author$project$Governance$Leaderboard$TopDelegatesResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$Leaderboard$loadTop100Delegates = F2(
	function (apiBaseUrlMap, network) {
		var maybeRequestTopDelegatesUrl = A3(
			$author$project$CompoundApi$Governance$AccountService$Urls$governanceAccountRequestUrl,
			apiBaseUrlMap,
			network,
			{fQ: _List_Nil, g0: $elm$core$Maybe$Nothing, g1: 1, g2: 100, h1: false});
		if (!maybeRequestTopDelegatesUrl.$) {
			var requestTopDelegatesUrl = maybeRequestTopDelegatesUrl.a;
			var topDelegatesRequest = A2($elm$http$Http$get, requestTopDelegatesUrl, $author$project$CompoundApi$Governance$AccountService$Decoders$governanceAccountResponseDecoder);
			return A2($elm$http$Http$send, $author$project$Governance$Leaderboard$TopDelegatesResponse, topDelegatesRequest);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$LandingSite$Main$scrollIntoView = _Platform_outgoingPort('scrollIntoView', $elm$json$Json$Encode$string);
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$LandingSite$Main$scrollTop = _Platform_outgoingPort(
	'scrollTop',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$LandingSite$Main$maybeScroll = function (page) {
	if ((page.$ === 3) && (!page.b.$)) {
		var fragment = page.b.a;
		return $author$project$LandingSite$Main$scrollIntoView(fragment);
	} else {
		return $author$project$LandingSite$Main$scrollTop(0);
	}
};
var $elm$core$Basics$neq = _Utils_notEqual;
var $author$project$LandingSite$Main$pageTransition = _Platform_outgoingPort(
	'pageTransition',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$LandingSite$Main$setTitle = _Platform_outgoingPort('setTitle', $elm$json$Json$Encode$string);
var $author$project$Strings$Translations$site_title = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound';
		case 1:
			return 'Compound';
		default:
			return 'Compound';
	}
};
var $author$project$LandingSite$Page$buildTitle = F2(
	function (userLanguage, subTitle) {
		if (subTitle.$ === 1) {
			return $author$project$Strings$Translations$site_title(userLanguage);
		} else {
			var s = subTitle.a;
			return $author$project$Strings$Translations$site_title(userLanguage) + (' | ' + s);
		}
	});
var $author$project$Strings$Translations$site_title_abi = function (lang) {
	switch (lang) {
		case 0:
			return 'ABI';
		case 1:
			return 'ABI';
		default:
			return 'ABI';
	}
};
var $author$project$Strings$Translations$site_title_about = function (lang) {
	switch (lang) {
		case 0:
			return 'About';
		case 1:
			return 'Acerca de';
		default:
			return '关于';
	}
};
var $author$project$Strings$Translations$site_title_account_profile = F2(
	function (lang, addr) {
		switch (lang) {
			case 0:
				return 'Account Profile - ' + (addr + '');
			case 1:
				return 'Perfil de cuenta - ' + (addr + '');
			default:
				return '帐户资料-' + (addr + '');
		}
	});
var $author$project$Strings$Translations$site_title_ctokens = function (lang) {
	switch (lang) {
		case 0:
			return 'cTokens';
		case 1:
			return 'cTokens';
		default:
			return 'cTokens';
	}
};
var $author$project$Strings$Translations$site_title_dashboard = function (lang) {
	switch (lang) {
		case 0:
			return 'Dashboard';
		case 1:
			return 'Tablero';
		default:
			return '仪表板';
	}
};
var $author$project$Strings$Translations$site_title_developers = function (lang) {
	switch (lang) {
		case 0:
			return 'Developers';
		case 1:
			return 'Desarrolladores';
		default:
			return '开发者';
	}
};
var $author$project$Strings$Translations$site_title_leaderboard = function (lang) {
	switch (lang) {
		case 0:
			return 'Leaderboard';
		case 1:
			return 'Tabla de clasificación';
		default:
			return '排行榜';
	}
};
var $author$project$Strings$Translations$site_title_markets = function (lang) {
	switch (lang) {
		case 0:
			return 'Markets';
		case 1:
			return 'Mercados';
		default:
			return '市场';
	}
};
var $author$project$Strings$Translations$site_title_proposal_detail = F2(
	function (lang, id) {
		switch (lang) {
			case 0:
				return 'Proposal Detail - ' + (id + '');
			case 1:
				return 'Detalle de la propuesta - ' + (id + '');
			default:
				return '投标详细信息-' + (id + '');
		}
	});
var $author$project$Strings$Translations$site_title_proposal_overview = function (lang) {
	switch (lang) {
		case 0:
			return 'Proposal Overview';
		case 1:
			return 'Resumen de la propuesta';
		default:
			return '提案概述';
	}
};
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$LandingSite$Page$title = F2(
	function (userLanguage, page) {
		switch (page.$) {
			case 0:
				return A2($author$project$LandingSite$Page$buildTitle, userLanguage, $elm$core$Maybe$Nothing);
			case 1:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_about(userLanguage)));
			case 2:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_ctokens(userLanguage)));
			case 3:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_developers(userLanguage)));
			case 4:
				var network = page.a;
				var contract = page.b;
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$elm$core$String$toUpper(network) + (' ' + (contract + (' ' + $author$project$Strings$Translations$site_title_abi(userLanguage))))));
			case 5:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_markets(userLanguage)));
			case 6:
				var accountAddress = page.a;
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						A2($author$project$Strings$Translations$site_title_account_profile, userLanguage, accountAddress)));
			case 7:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_dashboard(userLanguage)));
			case 8:
				var proposalId = page.a;
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						A2(
							$author$project$Strings$Translations$site_title_proposal_detail,
							userLanguage,
							$elm$core$String$fromInt(proposalId))));
			case 9:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_proposal_overview(userLanguage)));
			default:
				return A2(
					$author$project$LandingSite$Page$buildTitle,
					userLanguage,
					$elm$core$Maybe$Just(
						$author$project$Strings$Translations$site_title_leaderboard(userLanguage)));
		}
	});
var $author$project$LandingSite$Main$transitionPage = F2(
	function (model, url) {
		var abiResetModel = _Utils_update(
			model,
			{aU: $elm$core$Maybe$Nothing});
		var _v0 = function () {
			if (!url.$) {
				var location = url.a;
				var newPage_ = $author$project$LandingSite$Page$getLandingPage(location);
				var newPages_ = function () {
					var _v2 = $elm$core$List$head(model.P);
					if (!_v2.$) {
						var prevHead = _v2.a;
						return _Utils_eq(prevHead, newPage_) ? A2($elm$core$List$drop, 1, model.P) : A2($elm$core$List$cons, model.z, model.P);
					} else {
						return _List_fromArray(
							[model.z]);
					}
				}();
				return _Utils_Tuple2(newPage_, newPages_);
			} else {
				return _Utils_Tuple2($author$project$LandingSite$Page$Home, model.P);
			}
		}();
		var newPage = _v0.a;
		var newPages = _v0.b;
		var pageTransitionCmd = $author$project$LandingSite$Main$pageTransition(
			_Utils_Tuple2(
				$author$project$LandingSite$Page$getHrefUrl(model.z),
				$author$project$LandingSite$Page$getHrefUrl(newPage)));
		var _v3 = function () {
			if (!_Utils_eq(model.z, newPage)) {
				switch (newPage.$) {
					case 1:
						var _v5 = $author$project$LandingSite$About$init;
						var landingModel = _v5.a;
						var landingCmd = _v5.b;
						return _Utils_Tuple2(
							_Utils_update(
								abiResetModel,
								{aD: landingModel}),
							A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingAboutTranslator, landingCmd));
					case 2:
						var oldLandingCTokensModel = abiResetModel.L;
						var maybeConfig = $author$project$LandingSite$Main$getMainNetConfig(model);
						var maybeCToken = function () {
							if (!maybeConfig.$) {
								var config = maybeConfig.a;
								return A2($elm$core$Dict$get, 'cUSDC', config.dU);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						}();
						var landingCTokensModel = _Utils_update(
							oldLandingCTokensModel,
							{aK: maybeCToken});
						var landingCTokensCmd = A3($author$project$LandingSite$CTokens$loadGraphCmd, model.m, model.q, maybeCToken);
						return _Utils_Tuple2(
							_Utils_update(
								abiResetModel,
								{L: landingCTokensModel}),
							A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingCTokensTranslator, landingCTokensCmd));
					case 3:
						var _v7 = $author$project$LandingSite$Developers$init(model.aI);
						var landingModel = _v7.a;
						var landingCmd = _v7.b;
						return _Utils_Tuple2(
							_Utils_update(
								abiResetModel,
								{ab: landingModel}),
							A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingDevelopersPresidioTranslator, landingCmd));
					case 4:
						var networkString = newPage.a;
						var contractName = newPage.b;
						return _Utils_Tuple2(
							_Utils_update(
								abiResetModel,
								{
									aU: $elm$core$Maybe$Just(
										_Utils_Tuple2(networkString, contractName))
								}),
							$elm$core$Platform$Cmd$none);
					case 6:
						var accountAddress = newPage.a;
						var _v8 = A3($author$project$Governance$AccountProfile$loadAccountDetails, model.m, model.ae, accountAddress);
						var updatedAccountProfileModel = _v8.a;
						var accountProfileCmd = _v8.b;
						return _Utils_Tuple2(
							_Utils_update(
								abiResetModel,
								{ax: updatedAccountProfileModel}),
							A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$GovernanceAccountProfileMsg, accountProfileCmd));
					case 7:
						return _Utils_Tuple2(
							abiResetModel,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$LandingSite$Main$GovernanceHomeMsg,
								A2($author$project$Governance$Home$loadDashboard, model.m, model.ae)));
					case 8:
						var proposalId = newPage.a;
						var _v9 = A3($author$project$Governance$ProposalDetail$attempToLoadProposalId, model.m, model.ae, proposalId);
						var updatedProposalDetailModel = _v9.a;
						var proposalDetailCmd = _v9.b;
						return _Utils_Tuple2(
							_Utils_update(
								abiResetModel,
								{ay: updatedProposalDetailModel}),
							A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$GovernanceProposalDetailMsg, proposalDetailCmd));
					case 9:
						return _Utils_Tuple2(
							abiResetModel,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$LandingSite$Main$GovernanceProposalOverviewMsg,
								A2($author$project$Governance$ProposalOverview$loadProposals, model.m, model.ae)));
					case 10:
						return _Utils_Tuple2(
							abiResetModel,
							A2(
								$elm$core$Platform$Cmd$map,
								$author$project$LandingSite$Main$GovernanceLeaderboardMsg,
								A2($author$project$Governance$Leaderboard$loadTop100Delegates, model.m, model.ae)));
					default:
						return _Utils_Tuple2(abiResetModel, $elm$core$Platform$Cmd$none);
				}
			} else {
				return _Utils_Tuple2(abiResetModel, $elm$core$Platform$Cmd$none);
			}
		}();
		var newModel = _v3.a;
		var newCmd = _v3.b;
		return _Utils_Tuple2(
			_Utils_update(
				newModel,
				{z: newPage, P: newPages}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						pageTransitionCmd,
						$author$project$LandingSite$Main$maybeScroll(newPage),
						$author$project$LandingSite$Main$setTitle(
						A2($author$project$LandingSite$Page$title, model.bp, newPage)),
						newCmd
					])));
	});
var $author$project$LandingSite$Main$transitionTo = F2(
	function (url, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = A2($author$project$LandingSite$Main$transitionPage, model, url);
		var newModel = _v1.a;
		var pageCmd = _v1.b;
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[pageCmd, cmd])));
	});
var $author$project$LandingSite$Main$init = function (_v0) {
	var path = _v0.c8;
	var configAbiFiles = _v0.ck;
	var configurations = _v0.cm;
	var apiBaseUrlMap = _v0.m;
	var language = _v0.cO;
	var protoDocJson = _v0.aI;
	var targetNetwork = _v0.dw;
	var decodedApiBaseUrlMap = A2(
		$elm$core$Result$withDefault,
		$elm$core$Dict$empty,
		A2(
			$elm$json$Json$Decode$decodeValue,
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
			apiBaseUrlMap));
	var configs = A2(
		$elm$core$Result$withDefault,
		$elm$core$Dict$empty,
		A2($elm$json$Json$Decode$decodeValue, $author$project$Eth$Config$basicConfigDecoder, configurations));
	var _v1 = $author$project$Preferences$preferencesInit;
	var initPreferences = _v1.a;
	var _v2 = $author$project$Utils$Graph$init;
	var initGraphModel = _v2.a;
	return A2(
		$author$project$LandingSite$Main$transitionTo,
		$elm$url$Url$fromString(path),
		_Utils_Tuple2(
			{
				m: decodedApiBaseUrlMap,
				cl: configAbiFiles,
				bB: configs,
				q: $elm$core$Maybe$Nothing,
				aU: $elm$core$Maybe$Nothing,
				aW: _List_Nil,
				ax: $author$project$Governance$AccountProfile$emptyState,
				aZ: $author$project$Governance$Home$emptyState,
				a_: $author$project$Governance$Leaderboard$emptyState,
				ay: $author$project$Governance$ProposalDetail$emptyState,
				a$: $author$project$Governance$ProposalOverview$emptyState,
				a0: initGraphModel,
				aD: $author$project$LandingSite$About$emptyState,
				L: $author$project$LandingSite$CTokens$emptyState,
				ab: $author$project$LandingSite$Developers$emptyState,
				M: $author$project$LandingSite$Home$emptyState,
				B: $author$project$LandingSite$Markets$emptyState,
				a4: $elm$core$Maybe$Nothing,
				bX: false,
				ae: $author$project$Network$networkFromName(targetNetwork),
				z: $author$project$LandingSite$Page$Home,
				P: _List_fromArray(
					[$author$project$LandingSite$Page$GovernanceHome]),
				b0: initPreferences,
				aI: protoDocJson,
				bp: $author$project$Strings$Translations$getLnFromCode(language)
			},
			A2($elm$core$Task$perform, $author$project$LandingSite$Main$Tick, $elm$time$Time$now)));
};
var $author$project$LandingSite$Main$UrlChange = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {eX: processes, fo: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.eX;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.fo);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$LandingSite$Main$LandingHomeMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$LandingSite$Home$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.eP;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$landingHomeTranslator = $author$project$LandingSite$Home$translator(
	{eP: $author$project$LandingSite$Main$LandingHomeMsg});
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$LandingSite$Main$onUrlChange = _Platform_incomingPort('onUrlChange', $elm$json$Json$Decode$string);
var $author$project$Utils$Time$seconds = 1;
var $author$project$LandingSite$Developers$ForSelf = $elm$core$Basics$identity;
var $author$project$LandingSite$Developers$NetworkCarouselMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Bootstrap$Carousel$Hovered = 0;
var $author$project$Bootstrap$Carousel$Next = {$: 0};
var $author$project$Bootstrap$Carousel$SetAnimating = {$: 3};
var $author$project$Bootstrap$Carousel$StartTransition = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$core$Basics$not = _Basics_not;
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {c5: oldTime, hb: request, fk: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.hb;
		var oldTime = _v0.c5;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.fk;
		var oldTime = _v0.c5;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Time(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrame = $elm$browser$Browser$AnimationManager$onAnimationFrame;
var $author$project$Bootstrap$Carousel$subscriptions = F2(
	function (model, toMsg) {
		switch (model.a.$) {
			case 2:
				var _v1 = model.a;
				var interval = model.b.aA;
				var cycling = model.b.x;
				var wrap = model.b.ao;
				var currentIndex = model.b.V;
				var hovering = model.b.a1;
				var size = model.b.ak;
				var atEnd = (!wrap) && _Utils_eq(currentIndex, size - 1);
				return ((cycling === 1) && ((!(!hovering)) && ((!(!interval)) && (!atEnd)))) ? A2(
					$elm$time$Time$every,
					interval,
					function (_v2) {
						return toMsg(
							$author$project$Bootstrap$Carousel$StartTransition($author$project$Bootstrap$Carousel$Next));
					}) : $elm$core$Platform$Sub$none;
			case 0:
				var transition = model.a.a;
				return $elm$browser$Browser$Events$onAnimationFrame(
					function (_v3) {
						return toMsg($author$project$Bootstrap$Carousel$SetAnimating);
					});
			default:
				var transition = model.a.a;
				return $elm$core$Platform$Sub$none;
		}
	});
var $author$project$LandingSite$Developers$subscriptions = function (model) {
	return A2(
		$author$project$Bootstrap$Carousel$subscriptions,
		model.N,
		A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$LandingSite$Developers$NetworkCarouselMsg));
};
var $author$project$LandingSite$Home$CarouselMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$LandingSite$Home$ForSelf = $elm$core$Basics$identity;
var $author$project$LandingSite$Home$subscriptions = function (model) {
	return A2(
		$author$project$Bootstrap$Carousel$subscriptions,
		model.aq,
		A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$LandingSite$Home$CarouselMsg));
};
var $author$project$LandingSite$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, (1000.0 * 1.0) * $author$project$Utils$Time$seconds, $author$project$LandingSite$Main$Tick),
				$author$project$LandingSite$Main$onUrlChange(
				A2($elm$core$Basics$composeR, $elm$url$Url$fromString, $author$project$LandingSite$Main$UrlChange)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$LandingSite$Main$landingHomeTranslator,
				$author$project$LandingSite$Home$subscriptions(model.M)),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$LandingSite$Main$landingDevelopersPresidioTranslator,
				$author$project$LandingSite$Developers$subscriptions(model.ab))
			]));
};
var $author$project$LandingSite$Main$WrappedPreferencesMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$LandingSite$Main$LandingMarketsMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$LandingSite$Markets$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.eP;
		var onWrappedPreferencesdMsg = _v0.g_;
		if (!msg.$) {
			var internal = msg.a;
			return onInternalMessage(internal);
		} else {
			var preferencesMsg = msg.a;
			return onWrappedPreferencesdMsg(preferencesMsg);
		}
	});
var $author$project$LandingSite$Main$landingMarketsTranslator = $author$project$LandingSite$Markets$translator(
	{eP: $author$project$LandingSite$Main$LandingMarketsMsg, g_: $author$project$LandingSite$Main$WrappedPreferencesMsg});
var $author$project$LandingSite$Main$AllCTokensHistoricalStatsResponse = function (a) {
	return {$: 5, a: a};
};
var $author$project$LandingSite$Main$AllCTokensLatestStatsResponse = function (a) {
	return {$: 4, a: a};
};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$CompoundApi$Presidio$CTokens$Urls$cTokenRequestUrl = F3(
	function (apiBaseUrlMap, network, requestOptions) {
		var queryMeta = _List_fromArray(
			[
				A2(
				$elm$url$Url$Builder$string,
				'meta',
				A2(
					$elm$json$Json$Encode$encode,
					0,
					$elm$json$Json$Encode$bool(requestOptions.en)))
			]);
		var queryFinal = function () {
			var _v0 = requestOptions.fV;
			if (!_v0.$) {
				var timestamp = _v0.a;
				return _Utils_ap(
					queryMeta,
					_List_fromArray(
						[
							A2(
							$elm$url$Url$Builder$string,
							'block_timestamp',
							$elm$core$String$fromInt(timestamp))
						]));
			} else {
				return queryMeta;
			}
		}();
		return A4($author$project$CompoundApi$Common$Url$buildApiUrl, apiBaseUrlMap, network, 'v2/ctoken', queryFinal);
	});
var $author$project$CompoundApi$Presidio$CTokens$Models$CTokenRequest = F3(
	function (addresses, block_number, block_timestamp) {
		return {fQ: addresses, fU: block_number, fV: block_timestamp};
	});
var $author$project$CompoundApi$Presidio$CTokens$Models$CTokenResponse = F4(
	function (request, cToken, error, meta) {
		return {f$: cToken, gk: error, gO: meta, hb: request};
	});
var $author$project$CompoundApi$Presidio$CTokens$Models$Metadata = F2(
	function (unique_borrowers, unique_suppliers) {
		return {hR: unique_borrowers, hS: unique_suppliers};
	});
var $author$project$CompoundApi$Presidio$CTokens$Decoders$apiErrorDecoder = $elm$json$Json$Decode$nullable(
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$CompoundApi$Common$Models$API_Error,
		A2($elm$json$Json$Decode$field, 'error_code', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string)));
var $author$project$CompoundApi$Presidio$CTokens$Models$CToken = function (borrow_rate) {
	return function (cash) {
		return function (collateral_factor) {
			return function (exchange_rate) {
				return function (interest_rate_model_address) {
					return function (name) {
						return function (number_of_borrowers) {
							return function (number_of_suppliers) {
								return function (reserves) {
									return function (supply_rate) {
										return function (symbol) {
											return function (token_address) {
												return function (total_borrows) {
													return function (total_supply) {
														return function (underlying_address) {
															return function (underlying_name) {
																return function (underlying_price) {
																	return function (underlying_symbol) {
																		return function (total_supply_value_in_eth) {
																			return function (total_borrow_value_in_eth) {
																				return {fX: borrow_rate, f0: cash, f5: collateral_factor, gp: exchange_rate, gF: interest_rate_model_address, gT: name, gV: number_of_borrowers, gW: number_of_suppliers, he: reserves, hu: supply_rate, hv: symbol, fq: token_address, hH: total_borrow_value_in_eth, hI: total_borrows, hN: total_supply, hO: total_supply_value_in_eth, fx: underlying_address, fy: underlying_name, fz: underlying_price, dB: underlying_symbol};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Utils$DecoderHelper$andMap = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $author$project$CompoundApi$Presidio$CTokens$Decoders$calculateTotalBorrow = function (_v0) {
	var total_borrows = _v0.hI;
	var underlying_price = _v0.fz;
	return A2($author$project$Decimal$mul, underlying_price, total_borrows);
};
var $author$project$CompoundApi$Presidio$CTokens$Decoders$calculateTotalSupply = function (_v0) {
	var total_supply = _v0.hN;
	var exchange_rate = _v0.gp;
	var underlying_price = _v0.fz;
	return A2(
		$author$project$Decimal$mul,
		underlying_price,
		A2($author$project$Decimal$mul, exchange_rate, total_supply));
};
var $author$project$CompoundApi$Presidio$CTokens$Decoders$renameDaiNameToSaiLegacyDecoder = function (apiToken) {
	var _v0 = (A2($author$project$Eth$Ethereum$areContractsEqual, apiToken.fq, '0x5d3a536E4D6DbD6114cc1Ead35777bAB948E3643') && A2(
		$author$project$Eth$Ethereum$areContractsEqual,
		A2($elm$core$Maybe$withDefault, '', apiToken.fx),
		'0x6B175474E89094C44Da98b954EedeAC495271d0F')) ? _Utils_Tuple2('Dai', apiToken.dB) : ((A2($author$project$Eth$Ethereum$areContractsEqual, apiToken.fq, '0xF5DCe57282A584D2746FaF1593d3121Fcac444dC') && A2(
		$author$project$Eth$Ethereum$areContractsEqual,
		A2($elm$core$Maybe$withDefault, '', apiToken.fx),
		'0x89d24a6b4ccb1b6faa2625fe562bdd9a23260359')) ? _Utils_Tuple2('Sai (Legacy DAI)', 'SAI') : _Utils_Tuple2(apiToken.fy, apiToken.dB));
	var underlyingName = _v0.a;
	var underlyingSymbol = _v0.b;
	return $elm$json$Json$Decode$succeed(
		_Utils_update(
			apiToken,
			{fy: underlyingName, dB: underlyingSymbol}));
};
var $author$project$Decimal$fromInt = function (n) {
	return A2($author$project$Decimal$fromIntWithExponent, n, 0);
};
var $author$project$Decimal$zero = $author$project$Decimal$fromInt(0);
var $author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenDecoder = function () {
	var addEthValues = function (apiToken) {
		var supplyValue = $author$project$CompoundApi$Presidio$CTokens$Decoders$calculateTotalSupply(apiToken);
		var borrowValue = $author$project$CompoundApi$Presidio$CTokens$Decoders$calculateTotalBorrow(apiToken);
		return $elm$json$Json$Decode$succeed(
			_Utils_update(
				apiToken,
				{hH: borrowValue, hO: supplyValue}));
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		$author$project$CompoundApi$Presidio$CTokens$Decoders$renameDaiNameToSaiLegacyDecoder,
		A2(
			$elm$json$Json$Decode$andThen,
			addEthValues,
			A2(
				$author$project$Utils$DecoderHelper$andMap,
				$elm$json$Json$Decode$succeed($author$project$Decimal$zero),
				A2(
					$author$project$Utils$DecoderHelper$andMap,
					$elm$json$Json$Decode$succeed($author$project$Decimal$zero),
					A2(
						$author$project$Utils$DecoderHelper$andMap,
						A2($elm$json$Json$Decode$field, 'underlying_symbol', $elm$json$Json$Decode$string),
						A2(
							$author$project$Utils$DecoderHelper$andMap,
							A2($elm$json$Json$Decode$field, 'underlying_price', $author$project$CompoundApi$Common$Decoders$apiPrecise),
							A2(
								$author$project$Utils$DecoderHelper$andMap,
								A2($elm$json$Json$Decode$field, 'underlying_name', $elm$json$Json$Decode$string),
								A2(
									$author$project$Utils$DecoderHelper$andMap,
									A2(
										$elm$json$Json$Decode$field,
										'underlying_address',
										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
									A2(
										$author$project$Utils$DecoderHelper$andMap,
										A2($elm$json$Json$Decode$field, 'total_supply', $author$project$CompoundApi$Common$Decoders$apiPrecise),
										A2(
											$author$project$Utils$DecoderHelper$andMap,
											A2($elm$json$Json$Decode$field, 'total_borrows', $author$project$CompoundApi$Common$Decoders$apiPrecise),
											A2(
												$author$project$Utils$DecoderHelper$andMap,
												A2($elm$json$Json$Decode$field, 'token_address', $elm$json$Json$Decode$string),
												A2(
													$author$project$Utils$DecoderHelper$andMap,
													A2($elm$json$Json$Decode$field, 'symbol', $elm$json$Json$Decode$string),
													A2(
														$author$project$Utils$DecoderHelper$andMap,
														A2($elm$json$Json$Decode$field, 'supply_rate', $author$project$CompoundApi$Common$Decoders$apiPrecise),
														A2(
															$author$project$Utils$DecoderHelper$andMap,
															A2($elm$json$Json$Decode$field, 'reserves', $author$project$CompoundApi$Common$Decoders$apiPrecise),
															A2(
																$author$project$Utils$DecoderHelper$andMap,
																A2($elm$json$Json$Decode$field, 'number_of_suppliers', $elm$json$Json$Decode$int),
																A2(
																	$author$project$Utils$DecoderHelper$andMap,
																	A2($elm$json$Json$Decode$field, 'number_of_borrowers', $elm$json$Json$Decode$int),
																	A2(
																		$author$project$Utils$DecoderHelper$andMap,
																		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
																		A2(
																			$author$project$Utils$DecoderHelper$andMap,
																			A2($elm$json$Json$Decode$field, 'interest_rate_model_address', $elm$json$Json$Decode$string),
																			A2(
																				$author$project$Utils$DecoderHelper$andMap,
																				A2($elm$json$Json$Decode$field, 'exchange_rate', $author$project$CompoundApi$Common$Decoders$apiPrecise),
																				A2(
																					$author$project$Utils$DecoderHelper$andMap,
																					A2($elm$json$Json$Decode$field, 'collateral_factor', $author$project$CompoundApi$Common$Decoders$apiPrecise),
																					A2(
																						$author$project$Utils$DecoderHelper$andMap,
																						A2($elm$json$Json$Decode$field, 'cash', $author$project$CompoundApi$Common$Decoders$apiPrecise),
																						A2(
																							$author$project$Utils$DecoderHelper$andMap,
																							A2($elm$json$Json$Decode$field, 'borrow_rate', $author$project$CompoundApi$Common$Decoders$apiPrecise),
																							$elm$json$Json$Decode$succeed($author$project$CompoundApi$Presidio$CTokens$Models$CToken)))))))))))))))))))))));
}();
var $author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenResponseDecoder = A5(
	$elm$json$Json$Decode$map4,
	$author$project$CompoundApi$Presidio$CTokens$Models$CTokenResponse,
	A2(
		$elm$json$Json$Decode$field,
		'request',
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$CompoundApi$Presidio$CTokens$Models$CTokenRequest,
			A2(
				$elm$json$Json$Decode$field,
				'addresses',
				$elm$json$Json$Decode$list($elm$json$Json$Decode$string)),
			A2(
				$elm$json$Json$Decode$field,
				'block_number',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)),
			A2(
				$elm$json$Json$Decode$field,
				'block_timestamp',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int)))),
	A2(
		$elm$json$Json$Decode$field,
		'cToken',
		$elm$json$Json$Decode$list($author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenDecoder)),
	A2($elm$json$Json$Decode$field, 'error', $author$project$CompoundApi$Presidio$CTokens$Decoders$apiErrorDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'meta',
		$elm$json$Json$Decode$nullable(
			A3(
				$elm$json$Json$Decode$map2,
				$author$project$CompoundApi$Presidio$CTokens$Models$Metadata,
				A2($elm$json$Json$Decode$field, 'unique_borrowers', $elm$json$Json$Decode$int),
				A2($elm$json$Json$Decode$field, 'unique_suppliers', $elm$json$Json$Decode$int)))));
var $elm$core$Basics$round = _Basics_round;
var $author$project$LandingSite$Main$loadMarkets = F3(
	function (currentTime, apiBaseUrlMap, network) {
		var maybeCTokenLatestUrl = A3(
			$author$project$CompoundApi$Presidio$CTokens$Urls$cTokenRequestUrl,
			apiBaseUrlMap,
			network,
			{fV: $elm$core$Maybe$Nothing, en: true});
		var historyTime = A2(
			$elm$core$Maybe$andThen,
			function (timeToDie) {
				return $elm$core$Maybe$Just(
					$elm$core$Basics$round(
						function (millis) {
							return millis / 1000;
						}(
							(-86400000) + $elm$time$Time$posixToMillis(timeToDie))));
			},
			currentTime);
		var maybeCTokenHistoricalUrl = A3(
			$author$project$CompoundApi$Presidio$CTokens$Urls$cTokenRequestUrl,
			apiBaseUrlMap,
			network,
			{fV: historyTime, en: false});
		var cTokensRequestCmds = function () {
			var _v0 = _Utils_Tuple2(maybeCTokenHistoricalUrl, maybeCTokenLatestUrl);
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var cTokenHistoricalUrl = _v0.a.a;
				var cTokenLatestUrl = _v0.b.a;
				var cTokenLatestRequest = A2($elm$http$Http$get, cTokenLatestUrl, $author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenResponseDecoder);
				var cTokenHistoricRequest = A2($elm$http$Http$get, cTokenHistoricalUrl, $author$project$CompoundApi$Presidio$CTokens$Decoders$cTokenResponseDecoder);
				return _List_fromArray(
					[
						A2($elm$http$Http$send, $author$project$LandingSite$Main$AllCTokensLatestStatsResponse, cTokenLatestRequest),
						A2($elm$http$Http$send, $author$project$LandingSite$Main$AllCTokensHistoricalStatsResponse, cTokenHistoricRequest)
					]);
			} else {
				return _List_fromArray(
					[$elm$core$Platform$Cmd$none]);
			}
		}();
		return $elm$core$Platform$Cmd$batch(cTokensRequestCmds);
	});
var $author$project$Preferences$askClearPreferencesPort = _Platform_outgoingPort(
	'askClearPreferencesPort',
	function ($) {
		return $elm$json$Json$Encode$object(_List_Nil);
	});
var $author$project$Preferences$askClearPreferences = $author$project$Preferences$askClearPreferencesPort(
	{});
var $author$project$Preferences$displayCurrencyToString = function (displayCurrency) {
	switch (displayCurrency) {
		case 0:
			return 'Ether';
		case 1:
			return 'USD';
		case 2:
			return 'GBP';
		default:
			return 'EUR';
	}
};
var $author$project$Preferences$storePreferencesPort = _Platform_outgoingPort(
	'storePreferencesPort',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'displayCurrency',
					$elm$json$Json$Encode$string($.au))
				]));
	});
var $author$project$Preferences$storePreferences = function (_v0) {
	var displayCurrency = _v0.au;
	return $author$project$Preferences$storePreferencesPort(
		{
			au: $author$project$Preferences$displayCurrencyToString(displayCurrency)
		});
};
var $author$project$Preferences$preferencesUpdate = F2(
	function (msg, state) {
		switch (msg.$) {
			case 0:
				var displayCurrency = msg.a;
				var updatedState = _Utils_update(
					state,
					{au: displayCurrency});
				return _Utils_Tuple2(
					updatedState,
					$author$project$Preferences$storePreferences(updatedState));
			case 1:
				var preferences = msg.a;
				return _Utils_Tuple2(preferences, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(state, $author$project$Preferences$askClearPreferences);
		}
	});
var $author$project$Utils$Http$showError = function (err) {
	switch (err.$) {
		case 0:
			var url = err.a;
			return 'BadUrl: ' + url;
		case 1:
			return 'Timeout';
		case 2:
			return 'NetworkError';
		case 3:
			var resp = err.a;
			return 'BadStatus ' + resp.u.gN;
		default:
			var info = err.a;
			var resp = err.b;
			return 'BadPayload: ' + (info + ('; ' + resp.u.gN));
	}
};
var $author$project$Governance$AccountProfile$AccountFound = function (a) {
	return {$: 0, a: a};
};
var $author$project$Governance$AccountProfile$NoAccountFound = {$: 1};
var $author$project$Utils$Copy$copy = _Platform_outgoingPort('copy', $elm$json$Json$Encode$string);
var $author$project$Governance$AccountProfile$update = F4(
	function (apiBaseUrlMap, network, internalMsg, model) {
		var currentVoteReceiptPageNumber = model.at;
		var voteReceiptsPageMap = model.bq;
		switch (internalMsg.$) {
			case 0:
				var result = internalMsg.a;
				if (!result.$) {
					var accountResponse = result.a;
					var targetCompAccount = $elm$core$List$head(accountResponse.fK);
					var nextCompAccountState = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Governance$AccountProfile$NoAccountFound,
						A2($elm$core$Maybe$map, $author$project$Governance$AccountProfile$AccountFound, targetCompAccount));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{U: nextCompAccountState}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Gov Account Profile API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 1:
				var result = internalMsg.a;
				if (!result.$) {
					var receiptReceiptsResponse = result.a;
					var voteReceiptsMapUpdate = A3($elm$core$Dict$insert, receiptReceiptsResponse.g3.g1, receiptReceiptsResponse.g7, voteReceiptsPageMap);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cY: $elm$core$Maybe$Just(receiptReceiptsResponse.g7),
								bV: $elm$core$Maybe$Just(receiptReceiptsResponse.g3.hL),
								bq: voteReceiptsMapUpdate
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from For Votes Receipts Proposal Detail API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{at: currentVoteReceiptPageNumber - 1}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var loadNextPageCmd = function () {
					var _v3 = _Utils_Tuple2(
						model.U,
						A2($elm$core$Dict$get, currentVoteReceiptPageNumber + 1, voteReceiptsPageMap));
					if ((!_v3.a.$) && (_v3.b.$ === 1)) {
						var compAccount = _v3.a.a;
						var _v4 = _v3.b;
						return A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Platform$Cmd$none,
							A2(
								$elm$core$Maybe$map,
								function (requestVoteReceiptsUrl) {
									return A2(
										$elm$http$Http$send,
										$author$project$Governance$AccountProfile$RecentVoteReceiptsResponse,
										A2($elm$http$Http$get, requestVoteReceiptsUrl, $author$project$CompoundApi$Governance$ProposalVoteReceiptService$Decoders$proposalVoteReceiptResponseDecoder));
								},
								A3(
									$author$project$CompoundApi$Governance$ProposalVoteReceiptService$Urls$voteReceiptsRequestUrl,
									apiBaseUrlMap,
									network,
									{
										fJ: $elm$core$Maybe$Just(compAccount.dL),
										g1: currentVoteReceiptPageNumber + 1,
										g2: $author$project$Governance$AccountProfile$desiredPageSize,
										dc: $elm$core$Maybe$Nothing,
										dv: $elm$core$Maybe$Nothing,
										h2: true
									})));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{at: currentVoteReceiptPageNumber + 1}),
					loadNextPageCmd);
			case 4:
				var copyText = internalMsg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Utils$Copy$copy(copyText));
			default:
				var error = internalMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aW: A2($elm$core$List$cons, error, model.aW)
						}),
					$author$project$Console$error(error));
		}
	});
var $author$project$Governance$Home$update = F2(
	function (internalMsg, model) {
		switch (internalMsg.$) {
			case 0:
				var result = internalMsg.a;
				if (!result.$) {
					var governanceHistory = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bO: $elm$core$Maybe$Just(governanceHistory)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Proposals API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 1:
				var result = internalMsg.a;
				if (!result.$) {
					var latestProposalsResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bP: $elm$core$Maybe$Just(latestProposalsResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Proposals API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 2:
				var result = internalMsg.a;
				if (!result.$) {
					var topDelegatesResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bU: $elm$core$Maybe$Just(topDelegatesResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Comp Accounts API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			default:
				var error = internalMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aW: A2($elm$core$List$cons, error, model.aW)
						}),
					$author$project$Console$error(error));
		}
	});
var $author$project$Governance$Leaderboard$update = F2(
	function (internalMsg, model) {
		if (!internalMsg.$) {
			var result = internalMsg.a;
			if (!result.$) {
				var topDelegatesResponse = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bT: $elm$core$Maybe$Just(topDelegatesResponse)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var errMsg = result.a;
				return _Utils_Tuple2(
					model,
					$author$project$Console$error(
						'Error from Comp Accounts API, ' + $author$project$Utils$Http$showError(errMsg)));
			}
		} else {
			var error = internalMsg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aW: A2($elm$core$List$cons, error, model.aW)
					}),
				$author$project$Console$error(error));
		}
	});
var $author$project$Governance$ProposalDetail$update = F2(
	function (internalMsg, model) {
		switch (internalMsg.$) {
			case 0:
				var result = internalMsg.a;
				if (!result.$) {
					var proposalsResponse = result.a;
					var _v2 = $elm$core$List$head(proposalsResponse.eZ);
					if (!_v2.$) {
						var firstProposalDetail = _v2.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									C: $elm$core$Maybe$Just(firstProposalDetail)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Gov Proposal Detail API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 1:
				var result = internalMsg.a;
				if (!result.$) {
					var forVoteReceiptsResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a7: $elm$core$Maybe$Just(
									{dz: forVoteReceiptsResponse.g3.hL, T: forVoteReceiptsResponse.g7})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from For Votes Receipts Proposal Detail API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 2:
				var result = internalMsg.a;
				if (!result.$) {
					var againstVoteReceiptsResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a6: $elm$core$Maybe$Just(
									{dz: againstVoteReceiptsResponse.g3.hL, T: againstVoteReceiptsResponse.g7})
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Against Votes Receipts Proposal Detail API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 3:
				var showForVotes = internalMsg.a;
				var votesModalContent = function () {
					var _v5 = _Utils_Tuple3(model.C, model.a7, model.a6);
					if (((!_v5.a.$) && (!_v5.b.$)) && (!_v5.c.$)) {
						var proposalDetail = _v5.a.a;
						var forVotes = _v5.b.a;
						var againstVotes = _v5.c.a;
						return $elm$core$Maybe$Just(
							{
								db: proposalDetail,
								dm: showForVotes,
								dE: showForVotes ? forVotes : againstVotes
							});
					} else {
						return $elm$core$Maybe$Nothing;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bf: votesModalContent}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bf: $elm$core$Maybe$Nothing}),
					$elm$core$Platform$Cmd$none);
			default:
				var error = internalMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aW: A2($elm$core$List$cons, error, model.aW)
						}),
					$author$project$Console$error(error));
		}
	});
var $author$project$Governance$ProposalOverview$update = F4(
	function (apiBaseUrlMap, network, internalMsg, model) {
		var currentPageNumber = model.as;
		var proposalsPageMap = model.aH;
		switch (internalMsg.$) {
			case 0:
				var result = internalMsg.a;
				if (!result.$) {
					var allProposalsResponse = result.a;
					var proposalMapUpdate = A3($elm$core$Dict$insert, allProposalsResponse.g3.g1, allProposalsResponse.eZ, proposalsPageMap);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a8: $elm$core$Maybe$Just(allProposalsResponse.g3.hL),
								aH: proposalMapUpdate
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from Proposals API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{as: currentPageNumber - 1}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var loadNextPageCmd = _Utils_eq(
					A2($elm$core$Dict$get, currentPageNumber + 1, proposalsPageMap),
					$elm$core$Maybe$Nothing) ? A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$map,
						function (requestProposalsUrl) {
							return A2(
								$elm$http$Http$send,
								$author$project$Governance$ProposalOverview$AllProposalsResponse,
								A2($elm$http$Http$get, requestProposalsUrl, $author$project$CompoundApi$Governance$ProposalService$Decoders$proposalsResponseDecoder));
						},
						A3(
							$author$project$CompoundApi$Governance$ProposalService$Urls$proposalsRequestUrl,
							apiBaseUrlMap,
							network,
							{
								g1: currentPageNumber + 1,
								g2: $author$project$Governance$ProposalOverview$desiredPageSize,
								g6: _List_Nil,
								fi: $elm$core$Maybe$Nothing,
								h0: $elm$core$Maybe$Just(false)
							}))) : $elm$core$Platform$Cmd$none;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{as: currentPageNumber + 1}),
					loadNextPageCmd);
			default:
				var error = internalMsg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aW: A2($elm$core$List$cons, error, model.aW)
						}),
					$author$project$Console$error(error));
		}
	});
var $author$project$LandingSite$About$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var error = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aW: A2($elm$core$List$cons, error, model.aW)
					}),
				$author$project$Console$error(error));
		} else {
			var result = msg.a;
			if (!result.$) {
				var jobsResponse = result.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bL: $elm$core$Maybe$Just(jobsResponse)
						}),
					$elm$core$Platform$Cmd$none);
			} else {
				var errMsg = result.a;
				return _Utils_Tuple2(
					model,
					$author$project$Console$error(
						'Error from hire.withgoogle.com , ' + $author$project$Utils$Http$showError(errMsg)));
			}
		}
	});
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $author$project$LandingSite$CTokens$update = F4(
	function (apiBaseUrlMap, maybeCurrentTime, msg, model) {
		switch (msg.$) {
			case 0:
				var error = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aW: A2($elm$core$List$cons, error, model.aW)
						}),
					$author$project$Console$error(error));
			case 1:
				var points = msg.a;
				var maybeXPoint = $elm$core$List$isEmpty(points) ? $elm$core$Maybe$Nothing : A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.fV;
					},
					$elm$core$List$head(points));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{az: maybeXPoint}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var dropdownState = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aV: dropdownState}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var index = msg.a;
				var oldStateAtIndex = A2($elm$core$Array$get, index, model.W);
				var newFaqAccordianState = function () {
					if (!oldStateAtIndex.$) {
						var oldState = oldStateAtIndex.a;
						return A3($elm$core$Array$set, index, !oldState, model.W);
					} else {
						return model.W;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{W: newFaqAccordianState}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var index = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{br: index}),
					$elm$core$Platform$Cmd$none);
			default:
				var token = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aK: $elm$core$Maybe$Just(token)
						}),
					A3(
						$author$project$LandingSite$CTokens$loadGraphCmd,
						apiBaseUrlMap,
						maybeCurrentTime,
						$elm$core$Maybe$Just(token)));
		}
	});
var $author$project$Bootstrap$Carousel$Number = function (a) {
	return {$: 2, a: a};
};
var $author$project$Bootstrap$Carousel$Animating = function (a) {
	return {$: 1, a: a};
};
var $author$project$Bootstrap$Carousel$Start = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $author$project$Bootstrap$Carousel$nextIndex = F3(
	function (stage, currentIndex, size) {
		var helper = function (transition) {
			switch (transition.$) {
				case 0:
					return A2($elm$core$Basics$modBy, size, currentIndex + 1);
				case 1:
					return A2($elm$core$Basics$modBy, size, currentIndex - 1);
				default:
					var m = transition.a;
					return A2($elm$core$Basics$modBy, size, m);
			}
		};
		switch (stage.$) {
			case 0:
				var transition = stage.a;
				return helper(transition);
			case 1:
				var transition = stage.a;
				return helper(transition);
			default:
				return currentIndex;
		}
	});
var $author$project$Bootstrap$Carousel$update = F2(
	function (message, model) {
		var tstage = model.a;
		var settings = model.b;
		var currentIndex = settings.V;
		var size = settings.ak;
		switch (message.$) {
			case 1:
				return A2(
					$author$project$Bootstrap$Carousel$State,
					tstage,
					_Utils_update(
						settings,
						{x: 0}));
			case 0:
				return A2(
					$author$project$Bootstrap$Carousel$State,
					tstage,
					_Utils_update(
						settings,
						{x: 1}));
			case 5:
				var hovering = message.a;
				return A2(
					$author$project$Bootstrap$Carousel$State,
					tstage,
					_Utils_update(
						settings,
						{a1: hovering}));
			case 2:
				var transition = message.a;
				var newSettings = function () {
					var _v2 = settings.x;
					if (_v2 === 2) {
						return _Utils_update(
							settings,
							{x: 1});
					} else {
						return settings;
					}
				}();
				if (tstage.$ === 2) {
					return (!_Utils_eq(
						A3(
							$author$project$Bootstrap$Carousel$nextIndex,
							$author$project$Bootstrap$Carousel$Start(transition),
							currentIndex,
							size),
						currentIndex)) ? A2(
						$author$project$Bootstrap$Carousel$State,
						$author$project$Bootstrap$Carousel$Start(transition),
						newSettings) : A2($author$project$Bootstrap$Carousel$State, tstage, newSettings);
				} else {
					return A2($author$project$Bootstrap$Carousel$State, tstage, newSettings);
				}
			case 3:
				switch (tstage.$) {
					case 2:
						return model;
					case 0:
						var transition = tstage.a;
						return A2(
							$author$project$Bootstrap$Carousel$State,
							$author$project$Bootstrap$Carousel$Animating(transition),
							settings);
					default:
						var transition = tstage.a;
						return A2(
							$author$project$Bootstrap$Carousel$State,
							$author$project$Bootstrap$Carousel$Animating(transition),
							settings);
				}
			default:
				var size_ = message.a;
				if (tstage.$ === 2) {
					return A2(
						$author$project$Bootstrap$Carousel$State,
						$author$project$Bootstrap$Carousel$NotAnimating,
						_Utils_update(
							settings,
							{ak: size_}));
				} else {
					return A2(
						$author$project$Bootstrap$Carousel$State,
						$author$project$Bootstrap$Carousel$NotAnimating,
						_Utils_update(
							settings,
							{
								V: A3($author$project$Bootstrap$Carousel$nextIndex, tstage, currentIndex, size),
								ak: size
							}));
				}
		}
	});
var $author$project$LandingSite$Developers$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var network = msg.a;
				var index = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							N: A2(
								$author$project$Bootstrap$Carousel$update,
								$author$project$Bootstrap$Carousel$StartTransition(
									$author$project$Bootstrap$Carousel$Number(index)),
								model.N),
							b4: network
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var subMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							N: A2($author$project$Bootstrap$Carousel$update, subMsg, model.N)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var copyText = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Utils$Copy$copy(copyText));
			default:
				var status = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a9: status}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$LandingSite$Home$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var error = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aW: A2($elm$core$List$cons, error, model.aW)
					}),
				$author$project$Console$error(error));
		} else {
			var subMsg = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aq: A2($author$project$Bootstrap$Carousel$update, subMsg, model.aq)
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$LandingSite$Markets$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				if (!result.$) {
					var cTokenResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a4: $elm$core$Maybe$Just(cTokenResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from CToken API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 1:
				var result = msg.a;
				if (!result.$) {
					var cTokenResponse = result.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								gy: $elm$core$Maybe$Just(cTokenResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from CToken API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			default:
				var error = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aW: A2($elm$core$List$cons, error, model.aW)
						}),
					$author$project$Console$error(error));
		}
	});
var $author$project$Console$errorExt = F2(
	function (info, err) {
		return $author$project$Console$log('Error ' + (info + (': ' + err)));
	});
var $author$project$Utils$Graph$update = F3(
	function (maybeTime, msg, model) {
		if (!msg.$) {
			var result = msg.a;
			if (!result.$) {
				var assetAddress = result.a.E;
				var supplyRateData = result.a.fl;
				var exchangeRateData = result.a.d9;
				var borrowRateData = result.a.dS;
				var totalSupplyData = result.a.ft;
				var totalBorrowsData = result.a.fs;
				var updatedTotalSupplyData = A3(
					$elm$core$List$foldl,
					function (api_total) {
						return A2($elm$core$Dict$insert, api_total.fU, api_total.dy);
					},
					$elm$core$Dict$empty,
					totalSupplyData);
				var updatedTotalBorrowsData = A3(
					$elm$core$List$foldl,
					function (api_total) {
						return A2($elm$core$Dict$insert, api_total.fU, api_total.dy);
					},
					$elm$core$Dict$empty,
					totalBorrowsData);
				var updatedSupplyRateData = A3(
					$elm$core$List$foldl,
					function (api_rate) {
						return A2($elm$core$Dict$insert, api_rate.fV, api_rate.e0);
					},
					$elm$core$Dict$empty,
					supplyRateData);
				var updatedExchangeRateData = A3(
					$elm$core$List$foldl,
					function (api_rate) {
						return A2($elm$core$Dict$insert, api_rate.fV, api_rate.e0);
					},
					$elm$core$Dict$empty,
					exchangeRateData);
				var updatedBorrowRateData = A3(
					$elm$core$List$foldl,
					function (api_rate) {
						return A2($elm$core$Dict$insert, api_rate.fV, api_rate.e0);
					},
					$elm$core$Dict$empty,
					borrowRateData);
				var newTotalSupplyMap = A3($elm$core$Dict$insert, assetAddress, updatedTotalSupplyData, model.b9);
				var newTotalBorrowsMap = A3($elm$core$Dict$insert, assetAddress, updatedTotalBorrowsData, model.b8);
				var newSupplyRateMap = A3($elm$core$Dict$insert, assetAddress, updatedSupplyRateData, model.b6);
				var newExchangeRateMap = A3($elm$core$Dict$insert, assetAddress, updatedExchangeRateData, model.go);
				var newBorrowRateMap = A3($elm$core$Dict$insert, assetAddress, updatedBorrowRateData, model.by);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{by: newBorrowRateMap, go: newExchangeRateMap, cP: maybeTime, b6: newSupplyRateMap, b8: newTotalBorrowsMap, b9: newTotalSupplyMap}),
					$elm$core$Platform$Cmd$none);
			} else {
				var errorMsg = result.a;
				return _Utils_Tuple2(
					model,
					A2(
						$author$project$Console$errorExt,
						'Graph Error getting graph data from Market Data API',
						$author$project$Utils$Http$showError(errorMsg)));
			}
		} else {
			var error = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aW: A2($elm$core$List$cons, error, model.aW)
					}),
				A2($author$project$Console$errorExt, 'Graph Error', error));
		}
	});
var $author$project$LandingSite$Main$update = F2(
	function (msg, model) {
		var page = model.z;
		var apiBaseUrlMap = model.m;
		var graphModel = model.a0;
		var landingCTokensModel = model.L;
		var network = model.ae;
		switch (msg.$) {
			case 0:
				var location = msg.a;
				return A2($author$project$LandingSite$Main$transitionPage, model, location);
			case 1:
				var time = msg.a;
				var loadMarketsCmd = _Utils_eq(model.q, $elm$core$Maybe$Nothing) ? A3(
					$author$project$LandingSite$Main$loadMarkets,
					$elm$core$Maybe$Just(time),
					apiBaseUrlMap,
					1) : $elm$core$Platform$Cmd$none;
				var loadGraphCmd = function () {
					if (_Utils_eq(model.q, $elm$core$Maybe$Nothing)) {
						if (page.$ === 2) {
							var selectedCToken = landingCTokensModel.aK;
							return A2(
								$elm$core$Platform$Cmd$map,
								$author$project$LandingSite$Main$landingCTokensTranslator,
								A3(
									$author$project$LandingSite$CTokens$loadGraphCmd,
									apiBaseUrlMap,
									$elm$core$Maybe$Just(time),
									selectedCToken));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							q: $elm$core$Maybe$Just(time)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[loadMarketsCmd, loadGraphCmd])));
			case 2:
				var preferencesMsg = msg.a;
				var _v2 = A2($author$project$Preferences$preferencesUpdate, preferencesMsg, model.b0);
				var updatedPreferences = _v2.a;
				var preferencesCmd = _v2.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b0: updatedPreferences}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$WrappedPreferencesMsg, preferencesCmd));
			case 3:
				var graphMsg = msg.a;
				var _v3 = A3($author$project$Utils$Graph$update, model.q, graphMsg, graphModel);
				var updatedGraphModel = _v3.a;
				var graphCmd = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a0: updatedGraphModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$WrappedGraphMsg, graphCmd));
			case 4:
				var result = msg.a;
				if (!result.$) {
					var cTokenResponse = result.a;
					var oldMarketsModel = model.B;
					var updatedMarketsModel = _Utils_update(
						oldMarketsModel,
						{
							a4: $elm$core$Maybe$Just(cTokenResponse)
						});
					var oldLandingHomeModel = model.M;
					var newLandingHomeModel = _Utils_update(
						oldLandingHomeModel,
						{
							aq: $author$project$Bootstrap$Carousel$initialStateWithOptions(
								_Utils_update(
									$author$project$Bootstrap$Carousel$defaultStateOptions,
									{x: 1, c9: false}))
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								M: newLandingHomeModel,
								B: updatedMarketsModel,
								a4: $elm$core$Maybe$Just(cTokenResponse)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from CToken API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 5:
				var result = msg.a;
				if (!result.$) {
					var cTokenResponse = result.a;
					var oldMarketsModel = model.B;
					var updatedMarketsModel = _Utils_update(
						oldMarketsModel,
						{
							gy: $elm$core$Maybe$Just(cTokenResponse)
						});
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{B: updatedMarketsModel}),
						$elm$core$Platform$Cmd$none);
				} else {
					var errMsg = result.a;
					return _Utils_Tuple2(
						model,
						$author$project$Console$error(
							'Error from CToken API, ' + $author$project$Utils$Http$showError(errMsg)));
				}
			case 6:
				var landingCommonMsg = msg.a;
				var newMobileShowingState = function () {
					var newMobileMenuShowing = landingCommonMsg;
					return newMobileMenuShowing;
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bX: newMobileShowingState}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var landingCTokensMsg = msg.a;
				var _v7 = A4($author$project$LandingSite$CTokens$update, apiBaseUrlMap, model.q, landingCTokensMsg, model.L);
				var updatedLandingCTokensModel = _v7.a;
				var landingCTokensCmd = _v7.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{L: updatedLandingCTokensModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingCTokensTranslator, landingCTokensCmd));
			case 8:
				var landingHomeMsg = msg.a;
				var _v8 = A2($author$project$LandingSite$Home$update, landingHomeMsg, model.M);
				var updatedlandingHomeModel = _v8.a;
				var landingHomeCmd = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{M: updatedlandingHomeModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingHomeTranslator, landingHomeCmd));
			case 9:
				var landingAboutMsg = msg.a;
				var _v9 = A2($author$project$LandingSite$About$update, landingAboutMsg, model.aD);
				var updatedlandingAboutModel = _v9.a;
				var landingAboutCmd = _v9.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aD: updatedlandingAboutModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingAboutTranslator, landingAboutCmd));
			case 10:
				var landingMarketsMsg = msg.a;
				var _v10 = A2($author$project$LandingSite$Markets$update, landingMarketsMsg, model.B);
				var updatedLandingMarketsModel = _v10.a;
				var landingMarketsCmd = _v10.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{B: updatedLandingMarketsModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingMarketsTranslator, landingMarketsCmd));
			case 11:
				var landingDevelopersPresidioMsg = msg.a;
				var _v11 = A2($author$project$LandingSite$Developers$update, landingDevelopersPresidioMsg, model.ab);
				var updatedLandingDevelopersPresidioModel = _v11.a;
				var landingDevelopersPresidioCmd = _v11.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ab: updatedLandingDevelopersPresidioModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$landingDevelopersPresidioTranslator, landingDevelopersPresidioCmd));
			case 12:
				var accountProfilePageMsg = msg.a;
				var _v12 = A4($author$project$Governance$AccountProfile$update, apiBaseUrlMap, network, accountProfilePageMsg, model.ax);
				var updatedGovAccountProfileModel = _v12.a;
				var govAccountProfilePageCmd = _v12.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ax: updatedGovAccountProfileModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$GovernanceAccountProfileMsg, govAccountProfilePageCmd));
			case 13:
				var homePageMsg = msg.a;
				var _v13 = A2($author$project$Governance$Home$update, homePageMsg, model.aZ);
				var updatedGovHomeModel = _v13.a;
				var govHomePageCmd = _v13.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aZ: updatedGovHomeModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$GovernanceHomeMsg, govHomePageCmd));
			case 14:
				var proposalDetailPageMsg = msg.a;
				var _v14 = A2($author$project$Governance$ProposalDetail$update, proposalDetailPageMsg, model.ay);
				var updatedProposalDetailPageModel = _v14.a;
				var proposalDetailPageCmd = _v14.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ay: updatedProposalDetailPageModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$GovernanceProposalDetailMsg, proposalDetailPageCmd));
			case 15:
				var proposalOverviewPageMsg = msg.a;
				var _v15 = A4($author$project$Governance$ProposalOverview$update, model.m, model.ae, proposalOverviewPageMsg, model.a$);
				var updatedProposalOverviewModel = _v15.a;
				var proposalOverviewPageCmd = _v15.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a$: updatedProposalOverviewModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$GovernanceProposalOverviewMsg, proposalOverviewPageCmd));
			case 16:
				var leaderboardPageMsg = msg.a;
				var _v16 = A2($author$project$Governance$Leaderboard$update, leaderboardPageMsg, model.a_);
				var updatedLeaderboardModel = _v16.a;
				var leaderboardPageCmd = _v16.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{a_: updatedLeaderboardModel}),
					A2($elm$core$Platform$Cmd$map, $author$project$LandingSite$Main$GovernanceLeaderboardMsg, leaderboardPageCmd));
			default:
				var error = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aW: model.aW}),
					$author$project$Console$log(error));
		}
	});
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Utils$CompoundHtmlAttributes$id = function (idName) {
	return A2($elm$html$Html$Attributes$attribute, 'id', idName);
};
var $author$project$LandingSite$Main$LandingCommonMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$LandingSite$CommonViews$translator = F2(
	function (_v0, msg) {
		var onToggleMobileNaveMsg = _v0.eQ;
		var toggleMsg = msg;
		return onToggleMobileNaveMsg(toggleMsg);
	});
var $author$project$LandingSite$Main$landingCommonTranslator = $author$project$LandingSite$CommonViews$translator(
	{eQ: $author$project$LandingSite$Main$LandingCommonMsg});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Utils$CompoundHtmlAttributes$Internal = 1;
var $author$project$Strings$Translations$about = function (lang) {
	switch (lang) {
		case 0:
			return 'About';
		case 1:
			return 'Acerca de';
		default:
			return '关于';
	}
};
var $author$project$Utils$CompoundHtmlAttributes$class = function (className) {
	return A2($elm$html$Html$Attributes$attribute, 'class', className);
};
var $author$project$Strings$Translations$copyright = function (lang) {
	switch (lang) {
		case 0:
			return '© 2020 Compound Labs, Inc.';
		case 1:
			return '© 2020 Compound Labs, Inc.';
		default:
			return '©2020 Compound Labs，Inc.';
	}
};
var $author$project$Strings$Translations$ctokens = function (lang) {
	switch (lang) {
		case 0:
			return 'cTokens';
		case 1:
			return 'cTokens';
		default:
			return 'cTokens';
	}
};
var $author$project$Strings$Translations$developers = function (lang) {
	switch (lang) {
		case 0:
			return 'Developers';
		case 1:
			return 'Desarrolladores';
		default:
			return '开发者';
	}
};
var $author$project$Strings$Translations$faq = function (lang) {
	switch (lang) {
		case 0:
			return 'FAQ';
		case 1:
			return 'Preguntas más frecuentes';
		default:
			return 'FAQ';
	}
};
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $author$project$LandingSite$Page$getWhitepaperUrl = '/documents/Compound.Whitepaper.pdf';
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$Strings$Translations$markets = function (lang) {
	switch (lang) {
		case 0:
			return 'Markets';
		case 1:
			return 'Mercados';
		default:
			return '市场';
	}
};
var $author$project$Strings$Translations$whitepaper = function (lang) {
	switch (lang) {
		case 0:
			return 'Whitepaper';
		case 1:
			return 'Papel blanco';
		default:
			return '白皮书';
	}
};
var $author$project$LandingSite$CommonViews$pageFooter = function (userLanguage) {
	return A2(
		$elm$html$Html$footer,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$id('footer'),
				$author$project$Utils$CompoundHtmlAttributes$class('landing')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('container-large')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('row top')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-2')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										A2(
											$elm$core$List$append,
											A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '/'),
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('mark')
												])),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-10 links')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$About)),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Strings$Translations$about(userLanguage))
											])),
										A2(
										$elm$html$Html$a,
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Markets)),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Strings$Translations$markets(userLanguage))
											])),
										A2(
										$elm$html$Html$a,
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$CTokens)),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Strings$Translations$ctokens(userLanguage))
											])),
										A2(
										$elm$html$Html$a,
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Developers, 0, $elm$core$Maybe$Nothing))),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Strings$Translations$developers(userLanguage))
											])),
										A2(
										$elm$html$Html$a,
										A2(
											$elm$core$List$cons,
											$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
											A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/faq-1a2636713b69')),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Strings$Translations$faq(userLanguage))
											])),
										A2(
										$elm$html$Html$a,
										A2(
											$elm$core$List$cons,
											$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
											A2($author$project$Utils$CompoundHtmlAttributes$href, 1, $author$project$LandingSite$Page$getWhitepaperUrl)),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Strings$Translations$whitepaper(userLanguage))
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('bottom')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('small')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$copyright(userLanguage))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('social')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_Utils_ap(
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('icn discord'),
													$author$project$Utils$CompoundHtmlAttributes$target('_blank')
												]),
											A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://compound.finance/discord')),
										_List_Nil),
										A2(
										$elm$html$Html$a,
										_Utils_ap(
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('icn github'),
													$author$project$Utils$CompoundHtmlAttributes$target('_blank')
												]),
											A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://github.com/compound-finance/compound-protocol')),
										_List_Nil),
										A2(
										$elm$html$Html$a,
										_Utils_ap(
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('icn medium'),
													$author$project$Utils$CompoundHtmlAttributes$target('_blank')
												]),
											A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance')),
										_List_Nil),
										A2(
										$elm$html$Html$a,
										_Utils_ap(
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('icn twitter'),
													$author$project$Utils$CompoundHtmlAttributes$target('_blank')
												]),
											A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://twitter.com/compoundfinance')),
										_List_Nil)
									]))
							]))
					]))
			]));
};
var $author$project$LandingSite$CommonViews$ForParent = $elm$core$Basics$identity;
var $author$project$LandingSite$CommonViews$ToggleMobileNavMsg = $elm$core$Basics$identity;
var $author$project$Strings$Translations$app = function (lang) {
	switch (lang) {
		case 0:
			return 'App';
		case 1:
			return 'Aplicación';
		default:
			return 'App';
	}
};
var $author$project$Strings$Translations$docs = function (lang) {
	switch (lang) {
		case 0:
			return 'Docs';
		case 1:
			return 'Docs';
		default:
			return '文件';
	}
};
var $author$project$Strings$Translations$governance = function (lang) {
	switch (lang) {
		case 0:
			return 'Governance';
		case 1:
			return 'Gobernancia';
		default:
			return '管治';
	}
};
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$Strings$Translations$home = function (lang) {
	switch (lang) {
		case 0:
			return 'Home';
		case 1:
			return 'Casa';
		default:
			return '主页';
	}
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$LandingSite$CommonViews$pageHeader = F3(
	function (userLanguage, page, shouldShowMobileMenu) {
		var mobileHeaderClass = shouldShowMobileMenu ? 'active' : '';
		var headerClass = function () {
			switch (page.$) {
				case 0:
					return '';
				case 5:
					return '';
				case 6:
					return '';
				case 7:
					return '';
				case 8:
					return '';
				case 9:
					return '';
				case 10:
					return '';
				default:
					return ' light';
			}
		}();
		var _v0 = function () {
			var emptyClasses = {ct: '', cw: '', Y: '', cU: ''};
			switch (page.$) {
				case 5:
					return _Utils_update(
						emptyClasses,
						{cU: 'active'});
				case 6:
					return _Utils_update(
						emptyClasses,
						{Y: 'active'});
				case 7:
					return _Utils_update(
						emptyClasses,
						{Y: 'active'});
				case 8:
					return _Utils_update(
						emptyClasses,
						{Y: 'active'});
				case 9:
					return _Utils_update(
						emptyClasses,
						{Y: 'active'});
				case 10:
					return _Utils_update(
						emptyClasses,
						{Y: 'active'});
				case 2:
					return _Utils_update(
						emptyClasses,
						{ct: 'active'});
				case 3:
					return _Utils_update(
						emptyClasses,
						{cw: 'active'});
				default:
					return emptyClasses;
			}
		}();
		var marketsClass = _v0.cU;
		var governanceClass = _v0.Y;
		var developersClass = _v0.ct;
		var docsClass = _v0.cw;
		return A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('header'),
					$author$project$Utils$CompoundHtmlAttributes$class('landing ' + headerClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('container-large')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('row align-middle')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3 col-xs-10 logo')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$append,
												A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '/'),
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('brand'),
														$elm$html$Html$Events$onClick(false)
													])),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide col-xs-6 text-center')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$author$project$Utils$CompoundHtmlAttributes$class(marketsClass),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Markets))),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$markets(userLanguage))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$author$project$Utils$CompoundHtmlAttributes$class(governanceClass),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceHome))),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$governance(userLanguage))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$author$project$Utils$CompoundHtmlAttributes$class(developersClass),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$CTokens))),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$developers(userLanguage))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$author$project$Utils$CompoundHtmlAttributes$class(docsClass),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl(
														A2($author$project$LandingSite$Page$Developers, 0, $elm$core$Maybe$Nothing)))),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$docs(userLanguage))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide col-xs-3 text-right')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$author$project$Utils$CompoundHtmlAttributes$class('dapp button hollow'),
												A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://app.compound.finance/')),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$app(userLanguage))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('mobile-only col-xs-2 hamburger ' + mobileHeaderClass),
											$elm$html$Html$Events$onClick(!shouldShowMobileMenu)
										]),
									_List_fromArray(
										[
											A2($elm$html$Html$span, _List_Nil, _List_Nil),
											A2($elm$html$Html$span, _List_Nil, _List_Nil),
											A2($elm$html$Html$span, _List_Nil, _List_Nil)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('mobile-header ' + (mobileHeaderClass + (' ' + headerClass)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('links')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(false),
												A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '/')),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$home(userLanguage))
																]))
														]))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(false),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$Markets))),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$markets(userLanguage))
																]))
														]))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(false),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$CTokens))),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$developers(userLanguage))
																]))
														]))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(false),
												A2(
													$author$project$Utils$CompoundHtmlAttributes$href,
													0,
													$author$project$LandingSite$Page$getHrefUrl(
														A2($author$project$LandingSite$Page$Developers, 0, $elm$core$Maybe$Nothing)))),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$docs(userLanguage))
																]))
														]))
												])),
											A2(
											$elm$html$Html$a,
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Events$onClick(false),
												A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/faq-1a2636713b69')),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$li,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$p,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$faq(userLanguage))
																]))
														]))
												]))
										]))
								])),
							A2(
							$elm$html$Html$a,
							A2(
								$elm$core$List$cons,
								$author$project$Utils$CompoundHtmlAttributes$class('dapp button hollow'),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://app.compound.finance/')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$app(userLanguage))
								]))
						]))
				]));
	});
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Utils$CompoundHtmlAttributes$style = F2(
	function (styleName, styleValue) {
		return A2($elm$html$Html$Attributes$style, styleName, styleValue);
	});
var $author$project$LandingSite$AbiViewer$view = F3(
	function (networkName, contractName, abiFilesRaw) {
		var contractAbiText = function () {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2(
					$elm$json$Json$Decode$field,
					networkName,
					A2($elm$json$Json$Decode$field, contractName, $elm$json$Json$Decode$value)),
				abiFilesRaw);
			if (!_v0.$) {
				var decodedAbi = _v0.a;
				return A2($elm$json$Json$Encode$encode, 4, decodedAbi);
			} else {
				var error = _v0.a;
				return '{\"error\": \"unknown abi\"}';
			}
		}();
		return A2(
			$elm$html$Html$pre,
			_List_fromArray(
				[
					A2($author$project$Utils$CompoundHtmlAttributes$style, 'word-wrap', 'break-word')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(contractAbiText)
				]));
	});
var $author$project$Governance$AccountProfile$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.eP;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$accountProfileTranslator = $author$project$Governance$AccountProfile$translator(
	{eP: $author$project$LandingSite$Main$GovernanceAccountProfileMsg});
var $author$project$Governance$ProposalDetail$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.eP;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$proposalDetailTranslator = $author$project$Governance$ProposalDetail$translator(
	{eP: $author$project$LandingSite$Main$GovernanceProposalDetailMsg});
var $author$project$Governance$ProposalOverview$translator = F2(
	function (_v0, msg) {
		var onInternalMessage = _v0.eP;
		var internal = msg;
		return onInternalMessage(internal);
	});
var $author$project$LandingSite$Main$proposalOverviewTranslator = $author$project$Governance$ProposalOverview$translator(
	{eP: $author$project$LandingSite$Main$GovernanceProposalOverviewMsg});
var $elm$core$String$cons = _String_cons;
var $author$project$Functions$default = F2(
	function (maybeVal, defaultVal) {
		if (!maybeVal.$) {
			var val = maybeVal.a;
			return val;
		} else {
			return defaultVal;
		}
	});
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $author$project$Utils$NumberFormatter$dropRight = F2(
	function (dropChar, string) {
		var reducer = F2(
			function (nextChar, res) {
				if (res.$ === 1) {
					return _Utils_eq(nextChar, dropChar) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$elm$core$String$fromChar(nextChar));
				} else {
					var str = res.a;
					return $elm$core$Maybe$Just(
						A2($elm$core$String$cons, nextChar, str));
				}
			});
		return A2(
			$author$project$Functions$default,
			A3($elm$core$String$foldr, reducer, $elm$core$Maybe$Nothing, string),
			'');
	});
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $author$project$Utils$NumberFormatter$splitThousands = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cmditch$elm_bigint$BigInt$compareMagnitude = F4(
	function (x, y, xs, ys) {
		compareMagnitude:
		while (true) {
			var _v0 = _Utils_Tuple2(xs, ys);
			if (!_v0.a.b) {
				if (!_v0.b.b) {
					return A2($elm$core$Basics$compare, x, y);
				} else {
					return 0;
				}
			} else {
				if (!_v0.b.b) {
					return 2;
				} else {
					var _v1 = _v0.a;
					var x_ = _v1.a;
					var xss = _v1.b;
					var _v2 = _v0.b;
					var y_ = _v2.a;
					var yss = _v2.b;
					if (_Utils_eq(x_, y_)) {
						var $temp$x = x,
							$temp$y = y,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					} else {
						var $temp$x = x_,
							$temp$y = y_,
							$temp$xs = xss,
							$temp$ys = yss;
						x = $temp$x;
						y = $temp$y;
						xs = $temp$xs;
						ys = $temp$ys;
						continue compareMagnitude;
					}
				}
			}
		}
	});
var $cmditch$elm_bigint$BigInt$orderNegate = function (x) {
	switch (x) {
		case 0:
			return 2;
		case 1:
			return 1;
		default:
			return 0;
	}
};
var $cmditch$elm_bigint$BigInt$compare = F2(
	function (int1, int2) {
		var _v0 = _Utils_Tuple2(int1, int2);
		switch (_v0.a.$) {
			case 0:
				if (!_v0.b.$) {
					var mag1 = _v0.a.a;
					var mag2 = _v0.b.a;
					return A4($cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2);
				} else {
					return 2;
				}
			case 1:
				if (_v0.b.$ === 1) {
					var mag1 = _v0.a.a;
					var mag2 = _v0.b.a;
					return $cmditch$elm_bigint$BigInt$orderNegate(
						A4($cmditch$elm_bigint$BigInt$compareMagnitude, 0, 0, mag1, mag2));
				} else {
					return 0;
				}
			default:
				switch (_v0.b.$) {
					case 0:
						var _v1 = _v0.a;
						return 0;
					case 2:
						var _v2 = _v0.a;
						var _v3 = _v0.b;
						return 1;
					default:
						var _v4 = _v0.a;
						return 2;
				}
		}
	});
var $cmditch$elm_bigint$BigInt$lt = F2(
	function (x, y) {
		return !A2($cmditch$elm_bigint$BigInt$compare, x, y);
	});
var $cmditch$elm_bigint$BigInt$gte = F2(
	function (x, y) {
		return !A2($cmditch$elm_bigint$BigInt$lt, x, y);
	});
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $author$project$Decimal$insert_decimal_period = F2(
	function (pos, s) {
		var extra_zeros = pos - $elm$core$String$length(s);
		var padded_s = (extra_zeros >= 0) ? _Utils_ap(
			A2($elm$core$String$repeat, extra_zeros + 1, '0'),
			s) : s;
		var before = A2($elm$core$String$dropRight, pos, padded_s);
		var after = A2($elm$core$String$right, pos, padded_s);
		return before + ('.' + after);
	});
var $cmditch$elm_bigint$BigInt$negate = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return $cmditch$elm_bigint$BigInt$Zer;
		case 0:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Neg(mag);
		default:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$Pos(mag);
	}
};
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $cmditch$elm_bigint$BigInt$fillZeroes = A2(
	$elm$core$Basics$composeL,
	A2($elm$core$String$padLeft, $cmditch$elm_bigint$Constants$maxDigitMagnitude, '0'),
	$elm$core$String$fromInt);
var $cmditch$elm_bigint$BigInt$revMagnitudeToString = function (_v0) {
	var digits = _v0;
	var _v1 = $elm$core$List$reverse(digits);
	if (!_v1.b) {
		return '0';
	} else {
		var x = _v1.a;
		var xs = _v1.b;
		return $elm$core$String$concat(
			A2(
				$elm$core$List$cons,
				$elm$core$String$fromInt(x),
				A2($elm$core$List$map, $cmditch$elm_bigint$BigInt$fillZeroes, xs)));
	}
};
var $cmditch$elm_bigint$BigInt$toString = function (bigInt) {
	switch (bigInt.$) {
		case 2:
			return '0';
		case 0:
			var mag = bigInt.a;
			return $cmditch$elm_bigint$BigInt$revMagnitudeToString(mag);
		default:
			var mag = bigInt.a;
			return '-' + $cmditch$elm_bigint$BigInt$revMagnitudeToString(mag);
	}
};
var $author$project$Decimal$toString = function (_v0) {
	var m = _v0.a;
	var e = _v0.b;
	var sign = A2(
		$cmditch$elm_bigint$BigInt$gte,
		m,
		$cmditch$elm_bigint$BigInt$fromInt(0)) ? '' : '-';
	var add_zeros = function (n) {
		return A2($elm$core$String$repeat, n, '0');
	};
	var abs_m = A2(
		$cmditch$elm_bigint$BigInt$gte,
		m,
		$cmditch$elm_bigint$BigInt$fromInt(0)) ? m : $cmditch$elm_bigint$BigInt$negate(m);
	var s = $cmditch$elm_bigint$BigInt$toString(abs_m);
	var _v1 = A2($elm$core$Basics$compare, e, 0);
	switch (_v1) {
		case 1:
			return _Utils_ap(sign, s);
		case 2:
			return _Utils_ap(
				sign,
				_Utils_ap(
					s,
					add_zeros(e)));
		default:
			return _Utils_ap(
				sign,
				A2($author$project$Decimal$insert_decimal_period, 0 - e, s));
	}
};
var $author$project$Utils$NumberFormatter$formatToDecimalPlaces = F3(
	function (decimalPlaces, dropZeros, decimalValue) {
		var floatString = $author$project$Decimal$toString(decimalValue);
		var dropper = dropZeros ? $author$project$Utils$NumberFormatter$dropRight('0') : function (i) {
			return i;
		};
		var _v0 = function () {
			var _v1 = A2($elm$core$String$split, '.', floatString);
			if (!_v1.b) {
				return _Utils_Tuple2('', '');
			} else {
				if (!_v1.b.b) {
					var headValue = _v1.a;
					return _Utils_Tuple2(
						A2(
							$elm$core$String$join,
							',',
							$author$project$Utils$NumberFormatter$splitThousands(headValue)),
						'');
				} else {
					if (!_v1.b.b.b) {
						var headValue = _v1.a;
						var _v2 = _v1.b;
						var tailValue = _v2.a;
						return _Utils_Tuple2(
							A2(
								$elm$core$String$join,
								',',
								$author$project$Utils$NumberFormatter$splitThousands(headValue)),
							A2(
								$elm$core$String$left,
								decimalPlaces,
								dropper(tailValue)));
					} else {
						return _Utils_Tuple2('', '');
					}
				}
			}
		}();
		var digitString = _v0.a;
		var decimalString = _v0.b;
		var _v3 = $elm$core$String$isEmpty(decimalString);
		if (_v3) {
			return digitString;
		} else {
			return digitString + ('.' + decimalString);
		}
	});
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Decimal$addDecimals = F2(
	function (i, _v0) {
		addDecimals:
		while (true) {
			var m = _v0.a;
			var e = _v0.b;
			var mul10 = function (x) {
				return A2(
					$cmditch$elm_bigint$BigInt$mul,
					x,
					$cmditch$elm_bigint$BigInt$fromInt(10));
			};
			if (!i) {
				return A2($author$project$Decimal$Decimal, m, e);
			} else {
				if (i > 0) {
					var $temp$i = i - 1,
						$temp$_v0 = A2(
						$author$project$Decimal$Decimal,
						mul10(m),
						e - 1);
					i = $temp$i;
					_v0 = $temp$_v0;
					continue addDecimals;
				} else {
					return A2($author$project$Decimal$Decimal, m, e);
				}
			}
		}
	});
var $author$project$Decimal$toExponent = F2(
	function (e, _v0) {
		var md = _v0.a;
		var ed = _v0.b;
		return A2(
			$author$project$Decimal$addDecimals,
			ed - e,
			A2($author$project$Decimal$Decimal, md, ed));
	});
var $author$project$Decimal$toCommonExponent = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var _v1 = b;
	var mb = _v1.a;
	var eb = _v1.b;
	var _v2 = a;
	var ma = _v2.a;
	var ea = _v2.b;
	var exponent = A2($elm$core$Basics$min, ea, eb);
	return _Utils_Tuple2(
		A2($author$project$Decimal$toExponent, exponent, a),
		A2($author$project$Decimal$toExponent, exponent, b));
};
var $author$project$Decimal$add = F2(
	function (a, b) {
		var _v0 = $author$project$Decimal$toCommonExponent(
			_Utils_Tuple2(a, b));
		var ra = _v0.a;
		var rb = _v0.b;
		var _v1 = rb;
		var mb = _v1.a;
		var eb = _v1.b;
		var _v2 = ra;
		var ma = _v2.a;
		var ea = _v2.b;
		return A2(
			$author$project$Decimal$Decimal,
			A2($cmditch$elm_bigint$BigInt$add, ma, mb),
			ea);
	});
var $author$project$Decimal$getDigit = F2(
	function (n, d) {
		var decimalAsString = $author$project$Decimal$toString(d);
		var toInt = function (targetDecimal) {
			switch (targetDecimal) {
				case '1':
					return 1;
				case '2':
					return 2;
				case '3':
					return 3;
				case '4':
					return 4;
				case '5':
					return 5;
				case '6':
					return 6;
				case '7':
					return 7;
				case '8':
					return 8;
				case '9':
					return 9;
				case '0':
					return 0;
				case '':
					return 0;
				default:
					return -1;
			}
		};
		var _v0 = _Utils_Tuple2(
			A2($elm$core$String$split, '.', decimalAsString),
			A2($elm$core$Basics$compare, n, 0));
		_v0$6:
		while (true) {
			if (_v0.a.b) {
				if (!_v0.a.b.b) {
					switch (_v0.b) {
						case 2:
							var _v1 = _v0.a;
							var a = _v1.a;
							var _v2 = _v0.b;
							return toInt(
								A2(
									$elm$core$String$right,
									1,
									A2($elm$core$String$dropRight, n, a)));
						case 1:
							var _v3 = _v0.a;
							var a = _v3.a;
							var _v4 = _v0.b;
							return toInt(
								A2($elm$core$String$right, 1, a));
						default:
							var _v5 = _v0.a;
							var a = _v5.a;
							var _v6 = _v0.b;
							return 0;
					}
				} else {
					if (!_v0.a.b.b.b) {
						switch (_v0.b) {
							case 2:
								var _v7 = _v0.a;
								var a = _v7.a;
								var _v8 = _v7.b;
								var b = _v8.a;
								var _v9 = _v0.b;
								return toInt(
									A2(
										$elm$core$String$right,
										1,
										A2($elm$core$String$dropRight, n, a)));
							case 1:
								var _v10 = _v0.a;
								var a = _v10.a;
								var _v11 = _v10.b;
								var b = _v11.a;
								var _v12 = _v0.b;
								return toInt(
									A2($elm$core$String$right, 1, a));
							default:
								var _v13 = _v0.a;
								var a = _v13.a;
								var _v14 = _v13.b;
								var b = _v14.a;
								var _v15 = _v0.b;
								return toInt(
									A2(
										$elm$core$String$left,
										1,
										A2($elm$core$String$dropLeft, (-n) - 1, b)));
						}
					} else {
						break _v0$6;
					}
				}
			} else {
				break _v0$6;
			}
		}
		return -13;
	});
var $author$project$Decimal$compare = F2(
	function (a, b) {
		var _v0 = $author$project$Decimal$toCommonExponent(
			_Utils_Tuple2(a, b));
		var fa = _v0.a;
		var fb = _v0.b;
		var _v1 = fb;
		var mb = _v1.a;
		var eb = _v1.b;
		var _v2 = fa;
		var ma = _v2.a;
		var ea = _v2.b;
		return A2($cmditch$elm_bigint$BigInt$compare, ma, mb);
	});
var $author$project$Decimal$signAsInt = function (d) {
	var _v0 = A2($author$project$Decimal$compare, d, $author$project$Decimal$zero);
	switch (_v0) {
		case 0:
			return -1;
		case 1:
			return 0;
		default:
			return 1;
	}
};
var $author$project$Decimal$truncate = F2(
	function (n, d) {
		var decimalAsString = $author$project$Decimal$toString(d);
		var toDecimal = function (s) {
			var _v7 = $author$project$Decimal$fromString(s);
			if (!_v7.$) {
				var a = _v7.a;
				return a;
			} else {
				return $author$project$Decimal$zero;
			}
		};
		var _v0 = _Utils_Tuple2(
			A2($elm$core$String$split, '.', decimalAsString),
			n >= 0);
		_v0$4:
		while (true) {
			if (_v0.a.b) {
				if (!_v0.a.b.b) {
					if (_v0.b) {
						var _v1 = _v0.a;
						var a = _v1.a;
						return toDecimal(
							_Utils_ap(
								A2($elm$core$String$dropRight, n, a),
								A2($elm$core$String$repeat, n, '0')));
					} else {
						var _v2 = _v0.a;
						var a = _v2.a;
						return toDecimal(a);
					}
				} else {
					if (!_v0.a.b.b.b) {
						if (_v0.b) {
							var _v3 = _v0.a;
							var a = _v3.a;
							var _v4 = _v3.b;
							var b = _v4.a;
							return toDecimal(
								_Utils_ap(
									A2($elm$core$String$dropRight, n, a),
									A2($elm$core$String$repeat, n, '0')));
						} else {
							var _v5 = _v0.a;
							var a = _v5.a;
							var _v6 = _v5.b;
							var b = _v6.a;
							return toDecimal(
								a + ('.' + A2($elm$core$String$left, -n, b)));
						}
					} else {
						break _v0$4;
					}
				}
			} else {
				break _v0$4;
			}
		}
		return $author$project$Decimal$zero;
	});
var $author$project$Decimal$round = F2(
	function (n, d) {
		var to_increment = A2(
			$author$project$Decimal$fromIntWithExponent,
			$author$project$Decimal$signAsInt(d),
			n);
		var t = A2($author$project$Decimal$truncate, n, d);
		var next_digit = A2($author$project$Decimal$getDigit, n - 1, d);
		return (next_digit >= 5) ? A2($author$project$Decimal$add, t, to_increment) : t;
	});
var $author$project$Utils$NumberFormatter$interestRateAsPercentage = function (interestRate) {
	return A2(
		$author$project$Decimal$round,
		-2,
		A2(
			$author$project$Decimal$mul,
			interestRate,
			$author$project$Decimal$fromInt(100)));
};
var $author$project$Utils$NumberFormatter$formatPercentage = function (decimalValue) {
	return A3(
		$author$project$Utils$NumberFormatter$formatToDecimalPlaces,
		2,
		false,
		$author$project$Utils$NumberFormatter$interestRateAsPercentage(decimalValue)) + '%';
};
var $author$project$Decimal$abs = function (_v0) {
	var m = _v0.a;
	var e = _v0.b;
	var _v1 = A2(
		$cmditch$elm_bigint$BigInt$compare,
		m,
		$cmditch$elm_bigint$BigInt$fromInt(0));
	if (!_v1) {
		return A2(
			$author$project$Decimal$Decimal,
			$cmditch$elm_bigint$BigInt$negate(m),
			e);
	} else {
		return A2($author$project$Decimal$Decimal, m, e);
	}
};
var $author$project$Decimal$lt = F2(
	function (a, b) {
		var _v0 = A2($author$project$Decimal$compare, a, b);
		if (!_v0) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Utils$NumberFormatter$getSignAndAbsValue = function (decimalValue) {
	var signString = A2($author$project$Decimal$lt, decimalValue, $author$project$Decimal$zero) ? '- ' : '';
	return _Utils_Tuple2(
		signString,
		$author$project$Decimal$abs(decimalValue));
};
var $author$project$Utils$NumberFormatter$tokenDecimalPlaces = 4;
var $author$project$Utils$NumberFormatter$formatTokenBalance = function (decimalValue) {
	var roundedValue = A2($author$project$Decimal$round, -$author$project$Utils$NumberFormatter$tokenDecimalPlaces, decimalValue);
	var _v0 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(roundedValue);
	var signString = _v0.a;
	var absoluteDecimalValue = _v0.b;
	return _Utils_ap(
		signString,
		A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, $author$project$Utils$NumberFormatter$tokenDecimalPlaces, true, absoluteDecimalValue));
};
var $author$project$Eth$Ethereum$shortenedAddressString = F3(
	function (numberOfDigitsLeft, numberOfDigitsRight, address) {
		return A2($elm$core$String$left, numberOfDigitsLeft + 2, address) + ('...' + A2($elm$core$String$right, numberOfDigitsRight, address));
	});
var $author$project$Governance$AccountProfile$buildAccountProfileDetails = F2(
	function (targetAcountAddress, _v0) {
		var compAccountState = _v0.U;
		if (!compAccountState.$) {
			var compAccount = compAccountState.a;
			return {
				dL: compAccount.dL,
				fS: $author$project$Utils$NumberFormatter$formatTokenBalance(compAccount.fS),
				bD: (compAccount.ge.dL === '0x0000000000000000000000000000000000000000') ? 'Undelegated' : A2(
					$elm$core$Maybe$withDefault,
					A3($author$project$Eth$Ethereum$shortenedAddressString, 4, 4, compAccount.ge.dL),
					compAccount.ge.d6),
				bF: A2($elm$core$Maybe$withDefault, compAccount.dL, compAccount.d6),
				bQ: compAccount.dJ,
				bR: compAccount.em,
				bS: compAccount.ha,
				cb: $author$project$Utils$NumberFormatter$formatPercentage(compAccount.hX),
				hY: $author$project$Utils$NumberFormatter$formatTokenBalance(compAccount.hY)
			};
		} else {
			return {
				dL: targetAcountAddress,
				fS: $author$project$Utils$NumberFormatter$formatTokenBalance($author$project$Decimal$zero),
				bD: '–',
				bF: targetAcountAddress,
				bQ: $elm$core$Maybe$Nothing,
				bR: $elm$core$Maybe$Nothing,
				bS: $elm$core$Maybe$Nothing,
				cb: $author$project$Utils$NumberFormatter$formatPercentage($author$project$Decimal$zero),
				hY: $author$project$Utils$NumberFormatter$formatTokenBalance($author$project$Decimal$zero)
			};
		}
	});
var $author$project$Eth$Ethereum$EtherscanAddress = function (a) {
	return {$: 2, a: a};
};
var $author$project$Strings$Translations$action = function (lang) {
	switch (lang) {
		case 0:
			return 'Action';
		case 1:
			return 'Acción';
		default:
			return '行动';
	}
};
var $author$project$Strings$Translations$age = function (lang) {
	switch (lang) {
		case 0:
			return 'Age';
		case 1:
			return 'Años';
		default:
			return '年龄';
	}
};
var $author$project$Eth$Ethereum$etherscanUrl = F2(
	function (network, urlValue) {
		var _v0 = function () {
			switch (urlValue.$) {
				case 0:
					var suffix = urlValue.a;
					return _Utils_Tuple2('tx', suffix);
				case 1:
					var suffix = urlValue.a;
					return _Utils_Tuple2('token', suffix);
				default:
					var suffix = urlValue.a;
					return _Utils_Tuple2('address', suffix);
			}
		}();
		var linkType = _v0.a;
		var linkValue = _v0.b;
		switch (network) {
			case 1:
				return $elm$core$Maybe$Just('https://etherscan.io/' + (linkType + ('/' + linkValue)));
			case 4:
				return $elm$core$Maybe$Just('https://rinkeby.etherscan.io/' + (linkType + ('/' + linkValue)));
			case 7:
				return $elm$core$Maybe$Just('https://kovan.etherscan.io/' + (linkType + ('/' + linkValue)));
			case 3:
				return $elm$core$Maybe$Just('https://ropsten.etherscan.io/' + (linkType + ('/' + linkValue)));
			case 5:
				return $elm$core$Maybe$Just('https://goerli.etherscan.io/' + (linkType + ('/' + linkValue)));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Eth$Ethereum$etherscanLink = F3(
	function (maybeNetwork, value, attributes) {
		if (!maybeNetwork.$) {
			var network = maybeNetwork.a;
			var _v1 = A2($author$project$Eth$Ethereum$etherscanUrl, network, value);
			if (!_v1.$) {
				var etherscanLinkVal = _v1.a;
				return $elm$html$Html$a(
					A2(
						$elm$core$List$cons,
						$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
						_Utils_ap(
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, etherscanLinkVal),
							attributes)));
			} else {
				return $elm$html$Html$a(attributes);
			}
		} else {
			return $elm$html$Html$a(attributes);
		}
	});
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$Strings$Translations$no_account_transactions = function (lang) {
	switch (lang) {
		case 0:
			return 'No COMP transactions';
		case 1:
			return 'No hay transacciones COMP';
		default:
			return '没有COMP交易';
	}
};
var $author$project$Governance$AccountProfile$noTransactionsRow = function (userLanguage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row transactions-panel__transaction-row--empty')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Strings$Translations$no_account_transactions(userLanguage))
					]))
			]));
};
var $author$project$Strings$Translations$result = function (lang) {
	switch (lang) {
		case 0:
			return 'Result';
		case 1:
			return 'Resultado';
		default:
			return '结果';
	}
};
var $ryannhg$date_format$DateFormat$AmPmLowercase = {$: 23};
var $ryannhg$date_format$DateFormat$amPmLowercase = $ryannhg$date_format$DateFormat$AmPmLowercase;
var $ryannhg$date_format$DateFormat$DayOfMonthSuffix = {$: 6};
var $ryannhg$date_format$DateFormat$dayOfMonthSuffix = $ryannhg$date_format$DateFormat$DayOfMonthSuffix;
var $ryannhg$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {hA: toAmPm, hB: toMonthAbbreviation, hC: toMonthName, aN: toOrdinalSuffix, hD: toWeekdayAbbreviation, hE: toWeekdayName};
	});
var $ryannhg$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryannhg$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryannhg$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryannhg$date_format$DateFormat$Language$english = A6(
	$ryannhg$date_format$DateFormat$Language$Language,
	$ryannhg$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryannhg$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryannhg$date_format$DateFormat$Language$toEnglishAmPm,
	$ryannhg$date_format$DateFormat$Language$toEnglishSuffix);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.fh, posixMinutes) < 0) {
					return posixMinutes + era.eO;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $ryannhg$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.hA(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		d2: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		eK: month,
		fG: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).d2;
	});
var $ryannhg$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $ryannhg$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryannhg$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryannhg$date_format$DateFormat$days)))));
	});
var $ryannhg$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryannhg$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryannhg$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $ryannhg$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).eK;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $ryannhg$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryannhg$date_format$DateFormat$months))));
	});
var $ryannhg$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryannhg$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).fG;
	});
var $ryannhg$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryannhg$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryannhg$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryannhg$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $ryannhg$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $ryannhg$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $ryannhg$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryannhg$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryannhg$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryannhg$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryannhg$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryannhg$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryannhg$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.aN(num));
				}(
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.hB(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.hC(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryannhg$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.aN(num));
				}(
					1 + A2($ryannhg$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.aN(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.aN(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					3,
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.aN(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.hD(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.hE(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.aN(num));
				}(
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryannhg$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryannhg$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryannhg$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryannhg$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryannhg$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					$ryannhg$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryannhg$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryannhg$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryannhg$date_format$DateFormat$format = $ryannhg$date_format$DateFormat$formatWithLanguage($ryannhg$date_format$DateFormat$Language$english);
var $ryannhg$date_format$DateFormat$HourNumber = {$: 26};
var $ryannhg$date_format$DateFormat$hourNumber = $ryannhg$date_format$DateFormat$HourNumber;
var $ryannhg$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryannhg$date_format$DateFormat$minuteFixed = $ryannhg$date_format$DateFormat$MinuteFixed;
var $ryannhg$date_format$DateFormat$MonthNameFull = {$: 4};
var $ryannhg$date_format$DateFormat$monthNameFull = $ryannhg$date_format$DateFormat$MonthNameFull;
var $ryannhg$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryannhg$date_format$DateFormat$text = $ryannhg$date_format$DateFormat$Text;
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Eth$Transaction$transactionDateFormatter = A2(
	$ryannhg$date_format$DateFormat$format,
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$monthNameFull,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$dayOfMonthSuffix,
			$ryannhg$date_format$DateFormat$text(', '),
			$ryannhg$date_format$DateFormat$hourNumber,
			$ryannhg$date_format$DateFormat$text(':'),
			$ryannhg$date_format$DateFormat$minuteFixed,
			$ryannhg$date_format$DateFormat$amPmLowercase
		]),
	$elm$time$Time$utc);
var $author$project$Eth$Ethereum$TransactionHash = function (a) {
	return {$: 0, a: a};
};
var $author$project$Decimal$eq = F2(
	function (a, b) {
		var _v0 = A2($author$project$Decimal$compare, a, b);
		if (_v0 === 1) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Governance$AccountProfile$transactionRow = F5(
	function (network, title, time, delta, trxHash) {
		var deltaSection = A2($author$project$Decimal$eq, $author$project$Decimal$zero, delta) ? A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__delta transactions-panel__transaction-row__delta--no-change')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('0.00')
				])) : (A2($author$project$Decimal$lt, delta, $author$project$Decimal$zero) ? A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__delta transactions-panel__transaction-row__delta--decrease')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3(
						$author$project$Utils$NumberFormatter$formatToDecimalPlaces,
						2,
						false,
						$author$project$Decimal$abs(delta)))
				])) : A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__delta transactions-panel__transaction-row__delta--increase')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 2, false, delta))
				])));
		return A4(
			$author$project$Eth$Ethereum$etherscanLink,
			$elm$core$Maybe$Just(network),
			$author$project$Eth$Ethereum$TransactionHash(trxHash),
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transaction-row__time')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(time)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 text-right')
						]),
					_List_fromArray(
						[deltaSection]))
				]));
	});
var $author$project$Strings$Translations$transactions = function (lang) {
	switch (lang) {
		case 0:
			return 'Transactions';
		case 1:
			return 'Actas';
		default:
			return '交易次数';
	}
};
var $author$project$Strings$Translations$view_more = function (lang) {
	switch (lang) {
		case 0:
			return 'View More';
		case 1:
			return 'Ver más';
		default:
			return '查看更多';
	}
};
var $author$project$Governance$AccountProfile$compTransactionsPanel = F4(
	function (userLanguage, _v0, network, model) {
		var _v1 = function () {
			var _v2 = model.U;
			switch (_v2.$) {
				case 0:
					var compAccount = _v2.a;
					return _Utils_Tuple3(
						compAccount.dL,
						A2(
							$elm$core$Maybe$withDefault,
							$elm$html$Html$text(''),
							A2(
								$elm$core$Maybe$map,
								function (transactionDeltas) {
									var transactionsToShow = A2(
										$elm$core$List$map,
										function (_v3) {
											var title = _v3.hz;
											var timestamp = _v3.hy;
											var trx_hash = _v3.hQ;
											var delta = _v3.gg;
											return A5(
												$author$project$Governance$AccountProfile$transactionRow,
												network,
												title,
												$author$project$Eth$Transaction$transactionDateFormatter(timestamp),
												delta,
												trx_hash);
										},
										A2($elm$core$List$take, 4, transactionDeltas));
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transactions')
											]),
										($elm$core$List$length(transactionsToShow) > 0) ? transactionsToShow : _List_fromArray(
											[
												$author$project$Governance$AccountProfile$noTransactionsRow(userLanguage)
											]));
								},
								compAccount.hP)),
						A2($elm$core$Maybe$withDefault, _List_Nil, compAccount.hP));
				case 1:
					return _Utils_Tuple3(
						'',
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('transactions-panel__transactions')
								]),
							_List_fromArray(
								[
									$author$project$Governance$AccountProfile$noTransactionsRow(userLanguage)
								])),
						_List_Nil);
				default:
					return _Utils_Tuple3(
						'',
						$elm$html$Html$text(''),
						_List_Nil);
			}
		}();
		var address = _v1.a;
		var compTransactions = _v1.b;
		var allTransactions = _v1.c;
		var viewAllRow = $elm$core$List$isEmpty(allTransactions) ? $elm$html$Html$text('') : (($elm$core$List$length(allTransactions) > 4) ? A4(
			$author$project$Eth$Ethereum$etherscanLink,
			$elm$core$Maybe$Just(network),
			$author$project$Eth$Ethereum$EtherscanAddress(address),
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Strings$Translations$view_more(userLanguage))
				])) : $elm$html$Html$text(''));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$transactions(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__labels')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 text-left')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$action(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 transactions-panel__transaction-row__time')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$age(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 text-right')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$result(userLanguage))
										]))
								]))
						])),
					compTransactions,
					viewAllRow
				]));
	});
var $author$project$Strings$Translations$comp_balance = function (lang) {
	switch (lang) {
		case 0:
			return 'Comp Balance';
		case 1:
			return 'Balance de compensación';
		default:
			return '补偿余额';
	}
};
var $author$project$Strings$Translations$delegating_to = function (lang) {
	switch (lang) {
		case 0:
			return 'Delegating To';
		case 1:
			return 'Delegar a';
		default:
			return '委托给';
	}
};
var $author$project$Strings$Translations$address = function (lang) {
	switch (lang) {
		case 0:
			return 'Address';
		case 1:
			return 'Habla a';
		default:
			return '地址';
	}
};
var $author$project$Strings$Translations$details = function (lang) {
	switch (lang) {
		case 0:
			return 'Details';
		case 1:
			return 'Detalles';
		default:
			return '细节';
	}
};
var $author$project$Strings$Translations$leaderboard = function (lang) {
	switch (lang) {
		case 0:
			return 'Leaderboard';
		case 1:
			return 'Tabla de clasificación';
		default:
			return '排行榜';
	}
};
var $author$project$Strings$Translations$overview = function (lang) {
	switch (lang) {
		case 0:
			return 'Overview';
		case 1:
			return 'Visión general';
		default:
			return '总览';
	}
};
var $author$project$Strings$Translations$proposals = function (lang) {
	switch (lang) {
		case 0:
			return 'Proposals';
		case 1:
			return 'Propuestas';
		default:
			return '提案';
	}
};
var $author$project$LandingSite$Page$getInPageBackTitleHref = F2(
	function (userLanguage, previousPage) {
		switch (previousPage.$) {
			case 10:
				return _Utils_Tuple2(
					$author$project$Strings$Translations$leaderboard(userLanguage),
					$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceLeaderboard));
			case 9:
				return _Utils_Tuple2(
					$author$project$Strings$Translations$proposals(userLanguage),
					$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceProposalOverview));
			case 8:
				var proposalId = previousPage.a;
				return _Utils_Tuple2(
					$author$project$Strings$Translations$details(userLanguage),
					$author$project$LandingSite$Page$getHrefUrl(
						$author$project$LandingSite$Page$GovernanceProposalDetail(proposalId)));
			case 6:
				var address = previousPage.a;
				return _Utils_Tuple2(
					$author$project$Strings$Translations$address(userLanguage),
					$author$project$LandingSite$Page$getHrefUrl(
						$author$project$LandingSite$Page$GovernanceAccountProfile(address)));
			default:
				return _Utils_Tuple2(
					$author$project$Strings$Translations$overview(userLanguage),
					$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceHome));
		}
	});
var $author$project$Strings$Translations$holdings = function (lang) {
	switch (lang) {
		case 0:
			return 'Holdings';
		case 1:
			return 'Valores en cartera';
		default:
			return '控股公司';
	}
};
var $author$project$Governance$CommonViews$pageHeader = F4(
	function (backText, backUrl, headerView, maybeDetailsSection) {
		var detailsSection = function () {
			if (!maybeDetailsSection.$) {
				var detailSection_ = maybeDetailsSection.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('page-header__detail-section')
						]),
					_List_fromArray(
						[detailSection_]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('page-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('page-header__main-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							A2(
								$elm$core$List$cons,
								$author$project$Utils$CompoundHtmlAttributes$class('page-header__main-section__back'),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 0, backUrl)),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('small page-header__main-section__back__text')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(backText)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('page-header__main-section__title')
								]),
							_List_fromArray(
								[headerView]))
						])),
					detailsSection
				]));
	});
var $author$project$Governance$AccountProfile$CopyMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Governance$AccountProfile$ForSelf = $elm$core$Basics$identity;
var $author$project$Utils$CompoundHtmlAttributes$data = function (data_) {
	return A2($elm$html$Html$Attributes$attribute, 'data', data_);
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$object = _VirtualDom_node('object');
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation = function (msg) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'click',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$Utils$CompoundHtmlAttributes$src = function (srcName) {
	return A2($elm$html$Html$Attributes$attribute, 'src', srcName);
};
var $author$project$Governance$AccountProfile$profileHeader = F4(
	function (displayName_, address, maybeImageUrl, maybeOrgUrl) {
		var profileImageUrl = A2($elm$core$Maybe$withDefault, '', maybeImageUrl);
		var orgUrlButton = A2(
			$elm$core$Maybe$withDefault,
			$elm$html$Html$text(''),
			A2(
				$elm$core$Maybe$map,
				function (orgUrl) {
					return A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link line-icon--external-link'),
									$author$project$Utils$CompoundHtmlAttributes$target('_blank')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, orgUrl)),
						_List_Nil);
				},
				maybeOrgUrl));
		var displayName = _Utils_eq(displayName_, address) ? A3($author$project$Eth$Ethereum$shortenedAddressString, 4, 4, address) : displayName_;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('profile-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$object,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('profile-header__img'),
							$author$project$Utils$CompoundHtmlAttributes$data(profileImageUrl)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$src('/images/icn-default-avatar-large.svg')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('profile-header__details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('profile-header__details__display-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(displayName),
									orgUrlButton
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('profile-header__details__address')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(address),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--copy mobile-hide'),
											$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
											$author$project$Governance$AccountProfile$CopyMsg(address))
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$rank = function (lang) {
	switch (lang) {
		case 0:
			return 'Rank';
		case 1:
			return 'Rango';
		default:
			return '秩';
	}
};
var $author$project$Governance$AccountProfile$rankPane = F2(
	function (userLanguage, maybeRank) {
		return A2(
			$elm$core$Maybe$map,
			function (rank) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('rank-pane')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('rank-pane__text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$rank(userLanguage))
								])),
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('rank-pane__number')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(rank))
								]))
						]));
			},
			maybeRank);
	});
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Strings$Translations$votes = function (lang) {
	switch (lang) {
		case 0:
			return 'Votes';
		case 1:
			return 'Votos';
		default:
			return '投票数';
	}
};
var $author$project$Governance$AccountProfile$VoteReceiptsPagerNext = {$: 3};
var $author$project$Governance$AccountProfile$VoteReceiptsPagerPrevious = {$: 2};
var $author$project$Strings$Translations$next = function (lang) {
	switch (lang) {
		case 0:
			return 'Next';
		case 1:
			return 'próximo';
		default:
			return '下一个';
	}
};
var $author$project$Strings$Translations$prev = function (lang) {
	switch (lang) {
		case 0:
			return 'Prev';
		case 1:
			return 'Anterior';
		default:
			return '上一个';
	}
};
var $author$project$Strings$Translations$against = function (lang) {
	switch (lang) {
		case 0:
			return 'Against';
		case 1:
			return 'En contra';
		default:
			return '反对';
	}
};
var $author$project$Strings$Translations$for = function (lang) {
	switch (lang) {
		case 0:
			return 'For';
		case 1:
			return 'por';
		default:
			return '对于';
	}
};
var $author$project$Strings$Translations$canceled_time = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return 'Canceled ' + (time + '');
			case 1:
				return 'Cancelado ' + (time + '');
			default:
				return '已取消' + (time + '');
		}
	});
var $author$project$Utils$Time$differenceInSeconds = F2(
	function (end, start) {
		return $author$project$Utils$Time$posixToSeconds(end) - $author$project$Utils$Time$posixToSeconds(start);
	});
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $author$project$Strings$Translations$day = function (lang) {
	switch (lang) {
		case 0:
			return 'day';
		case 1:
			return 'día';
		default:
			return '天';
	}
};
var $author$project$Strings$Translations$days = function (lang) {
	switch (lang) {
		case 0:
			return 'days';
		case 1:
			return 'dias';
		default:
			return '天';
	}
};
var $author$project$Strings$Translations$hour = function (lang) {
	switch (lang) {
		case 0:
			return 'hour';
		case 1:
			return 'hora';
		default:
			return '小时';
	}
};
var $author$project$Strings$Translations$hours = function (lang) {
	switch (lang) {
		case 0:
			return 'hours';
		case 1:
			return 'horas';
		default:
			return '小时';
	}
};
var $author$project$Strings$Translations$minute = function (lang) {
	switch (lang) {
		case 0:
			return 'minute';
		case 1:
			return 'minuto';
		default:
			return '分钟';
	}
};
var $author$project$Strings$Translations$minutes = function (lang) {
	switch (lang) {
		case 0:
			return 'minutes';
		case 1:
			return 'minutos';
		default:
			return '分钟';
	}
};
var $author$project$Strings$Translations$second = function (lang) {
	switch (lang) {
		case 0:
			return 'second';
		case 1:
			return 'segundo';
		default:
			return '第二';
	}
};
var $author$project$Strings$Translations$seconds = function (lang) {
	switch (lang) {
		case 0:
			return 'seconds';
		case 1:
			return 'segundos';
		default:
			return '秒';
	}
};
var $author$project$Strings$Translations$year = function (lang) {
	switch (lang) {
		case 0:
			return 'year';
		case 1:
			return 'año';
		default:
			return '年';
	}
};
var $author$project$Strings$Translations$years = function (lang) {
	switch (lang) {
		case 0:
			return 'years';
		case 1:
			return 'años';
		default:
			return '年份';
	}
};
var $author$project$Utils$Time$timeElements = function (userLanguage) {
	return _List_fromArray(
		[
			{
			ac: ((60 * 60) * 24) * 365,
			ah: $author$project$Strings$Translations$years(userLanguage),
			aj: $author$project$Strings$Translations$year(userLanguage)
		},
			{
			ac: (60 * 60) * 24,
			ah: $author$project$Strings$Translations$days(userLanguage),
			aj: $author$project$Strings$Translations$day(userLanguage)
		},
			{
			ac: 60 * 60,
			ah: $author$project$Strings$Translations$hours(userLanguage),
			aj: $author$project$Strings$Translations$hour(userLanguage)
		},
			{
			ac: 60,
			ah: $author$project$Strings$Translations$minutes(userLanguage),
			aj: $author$project$Strings$Translations$minute(userLanguage)
		},
			{
			ac: 1,
			ah: $author$project$Strings$Translations$seconds(userLanguage),
			aj: $author$project$Strings$Translations$second(userLanguage)
		}
		]);
};
var $author$project$Strings$Translations$time_ago = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return '' + (time + ' ago');
			case 1:
				return '{{hace tiempo';
			default:
				return '{{过去';
		}
	});
var $author$project$Utils$Time$distanceTimeInWords = F2(
	function (userLanguage, time) {
		var str = A3(
			$elm$core$List$foldl,
			$elm$core$Basics$append,
			'',
			A2(
				$elm$core$List$intersperse,
				', ',
				A3(
					$elm$core$List$foldl,
					F2(
						function (_v0, _v1) {
							var singleName = _v0.aj;
							var pluralName = _v0.ah;
							var len = _v0.ac;
							var currEls = _v1.a;
							var remaining = _v1.b;
							if ((_Utils_cmp(remaining, len) > 0) && ($elm$core$List$length(currEls) < 2)) {
								var amt = (remaining / len) | 0;
								var name = (amt === 1) ? singleName : pluralName;
								var el = $elm$core$String$fromInt(amt) + (' ' + name);
								return _Utils_Tuple2(
									A2($elm$core$List$cons, el, currEls),
									remaining - (amt * len));
							} else {
								return _Utils_Tuple2(currEls, remaining);
							}
						}),
					_Utils_Tuple2(
						_List_Nil,
						$elm$core$Basics$abs(time)),
					$author$project$Utils$Time$timeElements(userLanguage)).a));
		return (time < 0) ? A2($author$project$Strings$Translations$time_ago, userLanguage, str) : str;
	});
var $author$project$Strings$Translations$ends_on = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return 'Ends on ' + (time + '');
			case 1:
				return 'Finaliza el ' + (time + '');
			default:
				return '于' + (time + '结束');
		}
	});
var $author$project$Strings$Translations$executed_time = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return 'Executed ' + (time + '');
			case 1:
				return 'Ejecutado ' + (time + '');
			default:
				return '已执行' + (time + '');
		}
	});
var $author$project$Strings$Translations$expired_time = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return 'Expired ' + (time + '');
			case 1:
				return 'Cancelado ' + (time + '');
			default:
				return '已取消' + (time + '');
		}
	});
var $author$project$Strings$Translations$failed_time = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return 'Failed ' + (time + '');
			case 1:
				return 'Falló ' + (time + '');
			default:
				return '' + (time + '失败');
		}
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Strings$Translations$proposal_state_active = function (lang) {
	switch (lang) {
		case 0:
			return 'Active';
		case 1:
			return 'Activo';
		default:
			return '活性';
	}
};
var $author$project$Strings$Translations$proposal_state_failed = function (lang) {
	switch (lang) {
		case 0:
			return 'Failed';
		case 1:
			return 'Ha fallado';
		default:
			return '失败的';
	}
};
var $author$project$Strings$Translations$proposal_state_passed = function (lang) {
	switch (lang) {
		case 0:
			return 'Passed';
		case 1:
			return 'Pasado';
		default:
			return '已通过';
	}
};
var $author$project$Strings$Translations$proposal_state_pending = function (lang) {
	switch (lang) {
		case 0:
			return 'Pending';
		case 1:
			return 'Pendiente';
		default:
			return '待定';
	}
};
var $author$project$Strings$Translations$queued_time = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return 'Queued ' + (time + '');
			case 1:
				return 'En cola ' + (time + '');
			default:
				return '' + (time + '已排队');
		}
	});
var $author$project$Strings$Translations$succeeded_time = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return 'Succeeded ' + (time + '');
			case 1:
				return 'Sucedido ' + (time + '');
			default:
				return '成功' + (time + '');
		}
	});
var $author$project$Strings$Translations$time_left = F2(
	function (lang, time) {
		switch (lang) {
			case 0:
				return '' + (time + ' left');
			case 1:
				return '{{tiempo restante';
			default:
				return '{{剩下的时间';
		}
	});
var $ryannhg$date_format$DateFormat$YearNumber = {$: 16};
var $ryannhg$date_format$DateFormat$yearNumber = $ryannhg$date_format$DateFormat$YearNumber;
var $author$project$Governance$CommonViews$proposalContentView = F4(
	function (userLanguage, maybeCurrentTime, _v0, asHeader) {
		var id = _v0.el;
		var title = _v0.hz;
		var states = _v0.fj;
		var stateTimeFormatter = A2(
			$ryannhg$date_format$DateFormat$format,
			_List_fromArray(
				[
					$ryannhg$date_format$DateFormat$monthNameFull,
					$ryannhg$date_format$DateFormat$text(' '),
					$ryannhg$date_format$DateFormat$dayOfMonthSuffix,
					$ryannhg$date_format$DateFormat$text(', '),
					$ryannhg$date_format$DateFormat$yearNumber
				]),
			$elm$time$Time$utc);
		var maybeCurrentState = $elm$core$List$head(
			$elm$core$List$reverse(states));
		var _v1 = asHeader ? _Utils_Tuple3(' proposal__content--header', ' proposal__content__description__title--header', ' proposal__content__description__details--large') : _Utils_Tuple3('', '', '');
		var headerContentClass = _v1.a;
		var headerTitleClass = _v1.b;
		var headerDetailsClass = _v1.c;
		if (!maybeCurrentState.$) {
			var currentState = maybeCurrentState.a;
			var prependZeros = function (value) {
				return ($elm$core$String$length(value) < 3) ? prependZeros(
					A2($elm$core$String$cons, '0', value)) : value;
			};
			var _v3 = function () {
				var _v4 = currentState.fi;
				if (_v4 === 1) {
					var timeString = function () {
						var _v5 = _Utils_Tuple2(maybeCurrentTime, currentState.gj);
						if (!_v5.b.$) {
							if (!_v5.a.$) {
								var currentTime = _v5.a.a;
								var endTime = _v5.b.a;
								var difference = A2($author$project$Utils$Time$differenceInSeconds, endTime, currentTime);
								return A2(
									$author$project$Strings$Translations$time_left,
									userLanguage,
									A2($author$project$Utils$Time$distanceTimeInWords, userLanguage, difference));
							} else {
								var endTime = _v5.b.a;
								return A2(
									$author$project$Strings$Translations$ends_on,
									userLanguage,
									stateTimeFormatter(endTime));
							}
						} else {
							return '';
						}
					}();
					var pulse = asHeader ? $elm$html$Html$text('') : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('pulsating-dot proposal__content__pulsating-dot mobile-hide')
							]),
						_List_Nil);
					return _Utils_Tuple3(
						pulse,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__tag proposal__content__description__details__tag--active')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$proposal_state_active(userLanguage))
								])),
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__text proposal__content__description__details__text--active')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											prependZeros(
												$elm$core$String$fromInt(id)))
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('•')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(timeString)
										]))
								])));
				} else {
					var states_ = A2(
						$elm$core$List$map,
						function ($) {
							return $.fi;
						},
						states);
					var tag_ = A2($elm$core$List$member, 2, states_) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__tag proposal__content__description__details__tag--passed')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$proposal_state_passed(userLanguage))
							])) : (A2($elm$core$List$member, 3, states_) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__tag proposal__content__description__details__tag--not-passed')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$proposal_state_failed(userLanguage))
							])) : (A2($elm$core$List$member, 6, states_) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__tag proposal__content__description__details__tag--not-passed')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$proposal_state_failed(userLanguage))
							])) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__tag proposal__content__description__details__tag--not-passed')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$proposal_state_pending(userLanguage))
							]))));
					var detailsText_ = function () {
						var _v6 = currentState.fi;
						switch (_v6) {
							case 0:
								if (!maybeCurrentTime.$) {
									var currentTime = maybeCurrentTime.a;
									var difference = A2($author$project$Utils$Time$differenceInSeconds, currentState.hk, currentTime);
									return A2(
										$author$project$Strings$Translations$time_left,
										userLanguage,
										A2($author$project$Utils$Time$distanceTimeInWords, userLanguage, difference));
								} else {
									return A2(
										$author$project$Strings$Translations$ends_on,
										userLanguage,
										stateTimeFormatter(currentState.hk));
								}
							case 2:
								return A2(
									$author$project$Strings$Translations$succeeded_time,
									userLanguage,
									stateTimeFormatter(currentState.hk));
							case 3:
								return A2(
									$author$project$Strings$Translations$failed_time,
									userLanguage,
									stateTimeFormatter(currentState.hk));
							case 4:
								return A2(
									$author$project$Strings$Translations$queued_time,
									userLanguage,
									stateTimeFormatter(currentState.hk));
							case 5:
								return A2(
									$author$project$Strings$Translations$executed_time,
									userLanguage,
									stateTimeFormatter(currentState.hk));
							case 6:
								return A2(
									$author$project$Strings$Translations$canceled_time,
									userLanguage,
									stateTimeFormatter(currentState.hk));
							case 7:
								return A2(
									$author$project$Strings$Translations$expired_time,
									userLanguage,
									stateTimeFormatter(currentState.hk));
							default:
								return '';
						}
					}();
					return _Utils_Tuple3(
						$elm$html$Html$text(''),
						tag_,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details__text proposal__content__description__details__text')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											prependZeros(
												$elm$core$String$fromInt(id)))
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('•')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(detailsText_)
										]))
								])));
				}
			}();
			var pulsatingDot = _v3.a;
			var tag = _v3.b;
			var detailsText = _v3.c;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('proposal__content' + headerContentClass)
					]),
				_List_fromArray(
					[
						pulsatingDot,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__title' + headerTitleClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(title)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('proposal__content__description__details' + headerDetailsClass)
									]),
								_List_fromArray(
									[tag, detailsText]))
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$Decimal$toFloat = function (d) {
	var _v0 = $elm$core$String$toFloat(
		$author$project$Decimal$toString(d));
	if (!_v0.$) {
		var a = _v0.a;
		return a;
	} else {
		return 42.0;
	}
};
var $author$project$Decimal$fastdiv = F2(
	function (a, b) {
		var fb = $author$project$Decimal$toFloat(b);
		var fa = $author$project$Decimal$toFloat(a);
		var res = fa / fb;
		return $author$project$Decimal$fromFloat(res);
	});
var $author$project$Utils$NumberFormatter$formatPercentageToNearestWhole = function (decimalValue) {
	return A3(
		$author$project$Utils$NumberFormatter$formatToDecimalPlaces,
		0,
		false,
		$author$project$Utils$NumberFormatter$interestRateAsPercentage(decimalValue)) + '%';
};
var $author$project$Governance$CommonViews$proposalReceiptVoteTallies = function (_v0) {
	var for_votes = _v0.ec;
	var against_votes = _v0.dM;
	var totalVotes = A2($author$project$Decimal$add, for_votes, against_votes);
	var forPercent = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Decimal$zero,
		A2($author$project$Decimal$fastdiv, for_votes, totalVotes));
	var againstPercent = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Decimal$zero,
		A2($author$project$Decimal$fastdiv, against_votes, totalVotes));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-votes mobile-hide')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-votes__row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-votes__row__vote-bar')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-votes__row__vote-bar__fill proposal__receipt-votes__row__vote-bar__fill--for'),
										A2(
										$author$project$Utils$CompoundHtmlAttributes$style,
										'width',
										$author$project$Utils$NumberFormatter$formatPercentageToNearestWhole(forPercent))
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-votes__row')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-votes__row__vote-bar')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-votes__row__vote-bar__fill proposal__receipt-votes__row__vote-bar__fill--against'),
										A2(
										$author$project$Utils$CompoundHtmlAttributes$style,
										'width',
										$author$project$Utils$NumberFormatter$formatPercentageToNearestWhole(againstPercent))
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Governance$CommonViews$proposalReceiptRow = F3(
	function (userLanguage, maybeCurrentTime, proposalVoteReceipt) {
		var _v0 = proposalVoteReceipt.eY;
		if (!_v0.$) {
			var proposal = _v0.a;
			var detailView = proposalVoteReceipt.dv ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-support proposal__receipt-support--for')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-support__text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$for(userLanguage))
							]))
					])) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-support proposal__receipt-support--against')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('proposal__receipt-support__text')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$against(userLanguage))
							]))
					]));
			return A2(
				$elm$html$Html$a,
				A2(
					$elm$core$List$cons,
					$author$project$Utils$CompoundHtmlAttributes$class('proposal'),
					A2(
						$author$project$Utils$CompoundHtmlAttributes$href,
						0,
						$author$project$LandingSite$Page$getHrefUrl(
							$author$project$LandingSite$Page$GovernanceProposalDetail(proposal.el)))),
				_List_fromArray(
					[
						A4($author$project$Governance$CommonViews$proposalContentView, userLanguage, maybeCurrentTime, proposal, false),
						$author$project$Governance$CommonViews$proposalReceiptVoteTallies(proposal),
						detailView
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Strings$Translations$voting_history = function (lang) {
	switch (lang) {
		case 0:
			return 'Voting History';
		case 1:
			return 'Historial de votación';
		default:
			return '投票历史';
	}
};
var $author$project$Governance$AccountProfile$votingHistoryPanel = F3(
	function (userLanguage, maybeCurrentTime, _v0) {
		var currentVoteReceiptPageNumber = _v0.at;
		var maybeTotalVoteReceipts = _v0.bV;
		var voteReceiptsPageMap = _v0.bq;
		var voteReceiptsForPage = function () {
			var _v1 = A2($elm$core$Dict$get, currentVoteReceiptPageNumber, voteReceiptsPageMap);
			if (!_v1.$) {
				var voteReceipts = _v1.a;
				return A2(
					$elm$core$List$map,
					A2($author$project$Governance$CommonViews$proposalReceiptRow, userLanguage, maybeCurrentTime),
					voteReceipts);
			} else {
				return _List_Nil;
			}
		}();
		var totalPages = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (totalVoteReceipts) {
					return $elm$core$Basics$ceiling(totalVoteReceipts / $author$project$Governance$AccountProfile$desiredPageSize);
				},
				maybeTotalVoteReceipts));
		var pagerFooter = function () {
			if (totalPages > 1) {
				var prevButton = (currentVoteReceiptPageNumber > 1) ? A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__previous'),
							$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation($author$project$Governance$AccountProfile$VoteReceiptsPagerPrevious)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$prev(userLanguage))
								]))
						])) : A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]));
				var pagerIndicator = A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__indicator')
						]),
					A2(
						$elm$core$List$map,
						function (i) {
							var activeClass = _Utils_eq(currentVoteReceiptPageNumber, i) ? ' governance-panel__pager__indicator__text--active' : '';
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__indicator__text' + activeClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(i))
									]));
						},
						A2($elm$core$List$range, 1, totalPages)));
				var nextButton = (_Utils_cmp(currentVoteReceiptPageNumber, totalPages) < 0) ? A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__next'),
							$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation($author$project$Governance$AccountProfile$VoteReceiptsPagerNext)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$next(userLanguage))
								]))
						])) : A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager')
						]),
					_List_fromArray(
						[prevButton, pagerIndicator, nextButton]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return ($elm$core$List$length(voteReceiptsForPage) > 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$voting_history(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposals')
						]),
					voteReceiptsForPage),
					pagerFooter
				])) : $elm$html$Html$text('');
	});
var $author$project$Governance$AccountProfile$view = F6(
	function (userLanguage, backPage, targetAcountAddress, maybeCurrentTime, network, model) {
		var _v0 = A2($author$project$Governance$AccountProfile$buildAccountProfileDetails, targetAcountAddress, model);
		var address = _v0.dL;
		var displayName = _v0.bF;
		var balance = _v0.fS;
		var votes = _v0.hY;
		var voteWeight = _v0.cb;
		var delegateDisplayName = _v0.bD;
		var maybeRank = _v0.bS;
		var maybeProfileImageUrl = _v0.bR;
		var maybeOrgUrl = _v0.bQ;
		var _v1 = A2($author$project$LandingSite$Page$getInPageBackTitleHref, userLanguage, backPage);
		var inPageHeaderTitle = _v1.a;
		var inPageHeaderHref = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('Account-Profile')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container container--governance')
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Governance$CommonViews$pageHeader,
									inPageHeaderTitle,
									inPageHeaderHref,
									A4($author$project$Governance$AccountProfile$profileHeader, displayName, address, maybeProfileImageUrl, maybeOrgUrl),
									A2($author$project$Governance$AccountProfile$rankPane, userLanguage, maybeRank))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container container--governance')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 holdings-panel')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h4,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$holdings(userLanguage))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$label,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__label')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$comp_balance(userLanguage))
																				])),
																			A2(
																			$elm$html$Html$p,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__value')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(balance)
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$label,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__label')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$votes(userLanguage))
																				])),
																			A2(
																			$elm$html$Html$p,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__value')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(votes)
																				])),
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__vote-weight')
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__vote-weight__fill'),
																							A2($author$project$Utils$CompoundHtmlAttributes$style, 'width', voteWeight)
																						]),
																					_List_Nil)
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$label,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__label')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$delegating_to(userLanguage))
																				])),
																			A2(
																			$elm$html$Html$p,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('holdings-panel__holdings__row__value')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(delegateDisplayName)
																				]))
																		]))
																]))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-8 transactions-panel')
												]),
											_List_fromArray(
												[
													A4($author$project$Governance$AccountProfile$compTransactionsPanel, userLanguage, maybeCurrentTime, network, model)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-12 voting-history-panel')
												]),
											_List_fromArray(
												[
													A3($author$project$Governance$AccountProfile$votingHistoryPanel, userLanguage, maybeCurrentTime, model)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$active_proposal = function (lang) {
	switch (lang) {
		case 0:
			return 'Active Proposal';
		case 1:
			return 'Propuesta activa';
		default:
			return '主动提案';
	}
};
var $author$project$Strings$Translations$active_proposals = function (lang) {
	switch (lang) {
		case 0:
			return 'Active Proposals';
		case 1:
			return 'Propuestas activas';
		default:
			return '活动提案';
	}
};
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $author$project$Strings$Translations$no_active_proposals = function (lang) {
	switch (lang) {
		case 0:
			return 'No proposals have been created.';
		case 1:
			return 'No se han creado propuestas.';
		default:
			return '尚未创建提案。';
	}
};
var $author$project$Governance$CommonViews$noProposalsRow = function (userLanguage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$class('proposal proposal--empty')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Strings$Translations$no_active_proposals(userLanguage))
					]))
			]));
};
var $author$project$Decimal$gt = F2(
	function (a, b) {
		var _v0 = A2($author$project$Decimal$compare, a, b);
		if (_v0 === 2) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Decimal$one = $author$project$Decimal$fromInt(1);
var $author$project$Utils$NumberFormatter$commonFormatInThousandsOrMillions = F2(
	function (currencySymbol, decimalValue) {
		var thousandsValue = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Decimal$zero,
			A2(
				$author$project$Decimal$fastdiv,
				decimalValue,
				$author$project$Decimal$fromInt(1000)));
		var millionsValue = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Decimal$zero,
			A2(
				$author$project$Decimal$fastdiv,
				decimalValue,
				$author$project$Decimal$fromInt(1000000)));
		var _v0 = A2($author$project$Decimal$gt, millionsValue, $author$project$Decimal$one) ? _Utils_Tuple3(millionsValue, 2, 'M') : _Utils_Tuple3(thousandsValue, 0, 'k');
		var scaledValueToUse = _v0.a;
		var roundedDecimals = _v0.b;
		var valueSuffix = _v0.c;
		var _v1 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(scaledValueToUse);
		var signString = _v1.a;
		var absoluteRoundedValue = _v1.b;
		return _Utils_ap(
			signString,
			_Utils_ap(
				currencySymbol,
				_Utils_ap(
					A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, roundedDecimals, false, absoluteRoundedValue),
					valueSuffix)));
	});
var $author$project$Governance$CommonViews$proposalActiveTalliesView = F2(
	function (_v0, _v1) {
		var for_votes = _v1.ec;
		var against_votes = _v1.dM;
		var totalVotes = A2($author$project$Decimal$add, for_votes, against_votes);
		var forPercent = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Decimal$zero,
			A2($author$project$Decimal$fastdiv, for_votes, totalVotes));
		var againstPercent = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Decimal$zero,
			A2($author$project$Decimal$fastdiv, against_votes, totalVotes));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row__vote-bar')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row__vote-bar__fill proposal__active-votes__row__vote-bar__fill--for'),
											A2(
											$author$project$Utils$CompoundHtmlAttributes$style,
											'width',
											$author$project$Utils$NumberFormatter$formatPercentageToNearestWhole(forPercent))
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row__value')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Utils$NumberFormatter$commonFormatInThousandsOrMillions, '', for_votes))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row__vote-bar')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row__vote-bar__fill proposal__active-votes__row__vote-bar__fill--against'),
											A2(
											$author$project$Utils$CompoundHtmlAttributes$style,
											'width',
											$author$project$Utils$NumberFormatter$formatPercentageToNearestWhole(againstPercent))
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__active-votes__row__value')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Utils$NumberFormatter$commonFormatInThousandsOrMillions, '', against_votes))
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$proposal_state_canceled = function (lang) {
	switch (lang) {
		case 0:
			return 'Canceled';
		case 1:
			return 'Cancelado';
		default:
			return '取消';
	}
};
var $author$project$Strings$Translations$proposal_state_executed = function (lang) {
	switch (lang) {
		case 0:
			return 'Executed';
		case 1:
			return 'Ejecutado';
		default:
			return '已执行';
	}
};
var $author$project$Strings$Translations$proposal_state_expired = function (lang) {
	switch (lang) {
		case 0:
			return 'Expired';
		case 1:
			return 'Caducado';
		default:
			return '已过期';
	}
};
var $author$project$Strings$Translations$proposal_state_queued = function (lang) {
	switch (lang) {
		case 0:
			return 'Queued';
		case 1:
			return 'Puesto en cola';
		default:
			return '排队';
	}
};
var $author$project$Governance$CommonViews$proposalRow = F3(
	function (userLanguage, maybeCurrentTime, proposal) {
		var maybeCurrentState = $elm$core$List$head(
			$elm$core$List$reverse(proposal.fj));
		var detailView = function () {
			if (!maybeCurrentState.$) {
				var currentState = maybeCurrentState.a;
				var _v1 = currentState.fi;
				switch (_v1) {
					case 0:
						return $elm$html$Html$text('');
					case 1:
						return A2($author$project$Governance$CommonViews$proposalActiveTalliesView, userLanguage, proposal);
					case 2:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state proposal__current-state-view__state--active')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state__text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$proposal_state_passed(userLanguage))
												]))
										]))
								]));
					case 3:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state proposal__current-state-view__state--failed')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state__text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$proposal_state_failed(userLanguage))
												]))
										]))
								]));
					case 4:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state proposal__current-state-view__state--active')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state__text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$proposal_state_queued(userLanguage))
												]))
										]))
								]));
					case 5:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state proposal__current-state-view__state--active')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state__text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$proposal_state_executed(userLanguage))
												]))
										]))
								]));
					case 6:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state proposal__current-state-view__state--failed')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state__text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$proposal_state_canceled(userLanguage))
												]))
										]))
								]));
					default:
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state proposal__current-state-view__state--failed')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('proposal__current-state-view__state__text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$proposal_state_expired(userLanguage))
												]))
										]))
								]));
				}
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$author$project$Utils$CompoundHtmlAttributes$class('proposal'),
				A2(
					$author$project$Utils$CompoundHtmlAttributes$href,
					0,
					$author$project$LandingSite$Page$getHrefUrl(
						$author$project$LandingSite$Page$GovernanceProposalDetail(proposal.el)))),
			_List_fromArray(
				[
					A4($author$project$Governance$CommonViews$proposalContentView, userLanguage, maybeCurrentTime, proposal, false),
					detailView
				]));
	});
var $author$project$Strings$Translations$recent_proposals = function (lang) {
	switch (lang) {
		case 0:
			return 'Recent Proposals';
		case 1:
			return 'Propuestas activas';
		default:
			return '活动提案';
	}
};
var $author$project$Strings$Translations$view_all_proposals = function (lang) {
	switch (lang) {
		case 0:
			return 'View All Proposals';
		case 1:
			return 'Ver todas las propuestas';
		default:
			return '查看所有提案';
	}
};
var $author$project$Governance$Home$importantProposalsPane = F3(
	function (userLanguage, maybeCurrentTime, model) {
		var _v0 = function () {
			var _v1 = model.bP;
			if (!_v1.$) {
				var proposals = _v1.a.eZ;
				if (!proposals.b) {
					return _Utils_Tuple2(
						$author$project$Strings$Translations$active_proposals(userLanguage),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('proposals')
									]),
								_List_fromArray(
									[
										$author$project$Governance$CommonViews$noProposalsRow(userLanguage)
									]))
							]));
				} else {
					var activeProposals = A2(
						$elm$core$List$filterMap,
						function (proposal) {
							var maybeCurrentState = A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.fi;
								},
								$elm$core$List$head(
									$elm$core$List$reverse(proposal.fj)));
							if ((!maybeCurrentState.$) && (maybeCurrentState.a === 1)) {
								var _v5 = maybeCurrentState.a;
								return $elm$core$Maybe$Just(proposal);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						proposals);
					var _v3 = (!$elm$core$List$length(activeProposals)) ? _Utils_Tuple2(
						$author$project$Strings$Translations$recent_proposals(userLanguage),
						A2($elm$core$List$take, 3, proposals)) : (($elm$core$List$length(activeProposals) === 1) ? _Utils_Tuple2(
						$author$project$Strings$Translations$active_proposal(userLanguage),
						activeProposals) : _Utils_Tuple2(
						$author$project$Strings$Translations$active_proposals(userLanguage),
						activeProposals));
					var header_ = _v3.a;
					var importantProposals = _v3.b;
					return _Utils_Tuple2(
						header_,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('proposals')
									]),
								A2(
									$elm$core$List$map,
									function (proposal) {
										return A3($author$project$Governance$CommonViews$proposalRow, userLanguage, maybeCurrentTime, proposal);
									},
									importantProposals)),
								A2(
								$elm$html$Html$a,
								A2(
									$elm$core$List$cons,
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer'),
									A2(
										$author$project$Utils$CompoundHtmlAttributes$href,
										0,
										$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceProposalOverview))),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$view_all_proposals(userLanguage))
									]))
							]));
				}
			} else {
				return _Utils_Tuple2(
					$author$project$Strings$Translations$active_proposals(userLanguage),
					_List_Nil);
			}
		}();
		var headerText = _v0.a;
		var latestProposalsAndViewAll = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('important-proposals-pane')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(headerText)
										]))
								])),
						latestProposalsAndViewAll))
				]));
	});
var $author$project$Strings$Translations$proposals_created = function (lang) {
	switch (lang) {
		case 0:
			return 'Proposals Created';
		case 1:
			return 'Propuestas creadas';
		default:
			return '提案已创建';
	}
};
var $author$project$Strings$Translations$total_delegatees = function (lang) {
	switch (lang) {
		case 0:
			return 'Total Delegatees';
		case 1:
			return 'Delegados totales';
		default:
			return '总代表';
	}
};
var $author$project$Strings$Translations$total_delegators = function (lang) {
	switch (lang) {
		case 0:
			return 'Total Delegators';
		case 1:
			return 'Delegadores totales';
		default:
			return '总代表';
	}
};
var $author$project$Strings$Translations$votes_delegated = function (lang) {
	switch (lang) {
		case 0:
			return 'Votes Delegated';
		case 1:
			return 'Voto delegado';
		default:
			return '委托投票';
	}
};
var $author$project$Governance$Home$overviewHeader = F2(
	function (userLanguage, model) {
		var _v0 = function () {
			var _v1 = model.bO;
			if (!_v1.$) {
				var govHistory = _v1.a;
				return {
					cr: $elm$core$String$fromInt(govHistory.hJ),
					cs: $elm$core$String$fromInt(govHistory.hK),
					dd: $elm$core$String$fromInt(govHistory.g8),
					dF: A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, true, govHistory.hZ)
				};
			} else {
				return {cr: '...', cs: '...', dd: '...', dF: '...'};
			}
		}();
		var delegatorsString = _v0.cs;
		var delegateesString = _v0.cr;
		var proposalsString = _v0.dd;
		var votesString = _v0.dF;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('dashboard-overview'),
					$author$project$Utils$CompoundHtmlAttributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3 col-xs-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('panel dark')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('headline')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(votesString)
												])),
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$votes_delegated(userLanguage))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3 col-xs-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('panel dark')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('headline')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(delegatorsString)
												])),
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$total_delegators(userLanguage))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3 col-xs-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('panel dark')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('headline')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(delegateesString)
												])),
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$total_delegatees(userLanguage))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3 col-xs-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('panel dark')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('content')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('headline')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(proposalsString)
												])),
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$proposals_created(userLanguage))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Governance$CommonViews$DelegateSummary = F7(
	function (address, display_name, image_url, votes, vote_weight, proposals_created, rank) {
		return {dL: address, d6: display_name, em: image_url, g8: proposals_created, ha: rank, hX: vote_weight, hY: votes};
	});
var $author$project$Governance$CommonViews$delegateSummaryRow = F2(
	function (_v0, delegateSummary) {
		var mobileDisplayName = A2(
			$elm$core$Maybe$withDefault,
			A3($author$project$Eth$Ethereum$shortenedAddressString, 4, 4, delegateSummary.dL),
			delegateSummary.d6);
		var displayName = A2($elm$core$Maybe$withDefault, delegateSummary.dL, delegateSummary.d6);
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary'),
				A2(
					$author$project$Utils$CompoundHtmlAttributes$href,
					0,
					$author$project$LandingSite$Page$getHrefUrl(
						$author$project$LandingSite$Page$GovernanceAccountProfile(delegateSummary.dL)))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-10 col-sm-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details__rank')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(delegateSummary.ha))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details__icon')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details__display-name mobile-hide')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(displayName)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary__details__display-name delegatee-summary__details__display-name--mobile')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(mobileDisplayName)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$NumberFormatter$formatTokenBalance(delegateSummary.hY))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$NumberFormatter$formatPercentage(delegateSummary.hX))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(delegateSummary.g8))
						]))
				]));
	});
var $author$project$Strings$Translations$no_top_addresses = function (lang) {
	switch (lang) {
		case 0:
			return 'No votes have been delegated.';
		case 1:
			return 'No se han delegado votos.';
		default:
			return '没有投票被委派。';
	}
};
var $author$project$Governance$CommonViews$noDelegateSummaryRow = function (userLanguage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$class('delegatee-summary delegatee-summary--empty')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Strings$Translations$no_top_addresses(userLanguage))
					]))
			]));
};
var $author$project$Strings$Translations$top_addresses_by_voting_weight = function (lang) {
	switch (lang) {
		case 0:
			return 'Top Addresses by Voting Weight';
		case 1:
			return 'Direcciones principales por peso de votación';
		default:
			return '投票权最重要的地址';
	}
};
var $author$project$Strings$Translations$view_leaderboard = function (lang) {
	switch (lang) {
		case 0:
			return 'View Leaderboard';
		case 1:
			return 'Ver tabla de clasificación';
		default:
			return '查看排行榜';
	}
};
var $author$project$Strings$Translations$vote_weight = function (lang) {
	switch (lang) {
		case 0:
			return 'Vote Weight';
		case 1:
			return 'Peso del voto';
		default:
			return '投票权重';
	}
};
var $author$project$Governance$Home$topAddressesPane = F2(
	function (userLanguage, model) {
		var columnHeaders = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__labels')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-10 col-sm-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$rank(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$votes(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$vote_weight(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$proposals_created(userLanguage))
								]))
						]))
				]));
		var topFiveAddressRowsAndViewAll = function () {
			var _v0 = model.bU;
			if (!_v0.$) {
				var topDelegates = _v0.a;
				var importantDelegates = A2(
					$elm$core$List$map,
					$author$project$Governance$CommonViews$delegateSummaryRow(userLanguage),
					A2(
						$elm$core$List$filterMap,
						function (compAccount) {
							var _v1 = compAccount.ha;
							if (!_v1.$) {
								var actualRank = _v1.a;
								return $elm$core$Maybe$Just(
									A7($author$project$Governance$CommonViews$DelegateSummary, compAccount.dL, compAccount.d6, compAccount.em, compAccount.hY, compAccount.hX, compAccount.g8, actualRank));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						topDelegates.fK));
				return ($elm$core$List$length(importantDelegates) > 0) ? _List_fromArray(
					[
						columnHeaders,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('top-addresses')
							]),
						importantDelegates),
						A2(
						$elm$html$Html$a,
						A2(
							$elm$core$List$cons,
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer'),
							A2(
								$author$project$Utils$CompoundHtmlAttributes$href,
								0,
								$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceLeaderboard))),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$view_leaderboard(userLanguage))
							]))
					]) : _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('top-addresses')
							]),
						_List_fromArray(
							[
								$author$project$Governance$CommonViews$noDelegateSummaryRow(userLanguage)
							]))
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('top-addresses-pane')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$top_addresses_by_voting_weight(userLanguage))
										]))
								])),
						topFiveAddressRowsAndViewAll))
				]));
	});
var $author$project$Governance$Home$view = F3(
	function (userLanguage, maybeCurrentTime, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('Dashboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container container--governance')
								]),
							_List_fromArray(
								[
									A2($author$project$Governance$Home$overviewHeader, userLanguage, model)
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container container--governance')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('content')
										]),
									_List_fromArray(
										[
											A3($author$project$Governance$Home$importantProposalsPane, userLanguage, maybeCurrentTime, model),
											A2($author$project$Governance$Home$topAddressesPane, userLanguage, model)
										]))
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$addresses_by_voting_weight = function (lang) {
	switch (lang) {
		case 0:
			return 'Addresses by Voting Weight';
		case 1:
			return 'Direcciones por peso de votación';
		default:
			return '投票权地址';
	}
};
var $author$project$Governance$Leaderboard$leaderboardAddressesPane = F2(
	function (userLanguage, model) {
		var delegateeAddressRows = function () {
			var _v0 = model.bT;
			if (!_v0.$) {
				var topDelegates = _v0.a;
				return A2(
					$elm$core$List$map,
					$author$project$Governance$CommonViews$delegateSummaryRow(userLanguage),
					A2(
						$elm$core$List$filterMap,
						function (compAccount) {
							var _v1 = compAccount.ha;
							if (!_v1.$) {
								var actualRank = _v1.a;
								return $elm$core$Maybe$Just(
									A7($author$project$Governance$CommonViews$DelegateSummary, compAccount.dL, compAccount.d6, compAccount.em, compAccount.hY, compAccount.hX, compAccount.g8, actualRank));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						topDelegates.fK));
			} else {
				return _List_Nil;
			}
		}();
		var columnHeaders = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__labels')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-10 col-sm-6')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$rank(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$votes(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$vote_weight(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-2 text-right mobile-hide')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$proposals_created(userLanguage))
								]))
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('top-addresses-pane')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$addresses_by_voting_weight(userLanguage))
										]))
								])),
							columnHeaders,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('top-addresses')
								]),
							delegateeAddressRows)
						]))
				]));
	});
var $author$project$Governance$Leaderboard$view = F2(
	function (userLanguage, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('Leaderboard')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container container--governance')
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Governance$CommonViews$pageHeader,
									$author$project$Strings$Translations$overview(userLanguage),
									$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceHome),
									A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Strings$Translations$leaderboard(userLanguage))
											])),
									$elm$core$Maybe$Nothing)
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container container--governance')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('content')
										]),
									_List_fromArray(
										[
											A2($author$project$Governance$Leaderboard$leaderboardAddressesPane, userLanguage, model)
										]))
								]))
						]))
				]));
	});
var $author$project$Governance$ProposalDetail$actionRow = F2(
	function (actionNumber, title) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('details-panel__action-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('details-panel__action-row__number')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$elm$core$String$fromInt(actionNumber))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('details-panel__action-row__title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						]))
				]));
	});
var $author$project$Governance$ProposalDetail$detailsPanel = F2(
	function (userLanguage, _v0) {
		var maybeProposalDetail = _v0.C;
		var _v1 = function () {
			if (!maybeProposalDetail.$) {
				var proposalDetail = maybeProposalDetail.a;
				return {
					fL: A2(
						$elm$core$List$indexedMap,
						F2(
							function (index, action) {
								return A2($author$project$Governance$ProposalDetail$actionRow, index + 1, action.hz);
							}),
						proposalDetail.fL),
					c7: A2($elm$core$String$split, '\n', proposalDetail.d5)
				};
			} else {
				return {
					fL: _List_Nil,
					c7: _List_fromArray(
						['Loading...'])
				};
			}
		}();
		var paragraphs = _v1.c7;
		var actions = _v1.fL;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-md-6 details-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$details(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('details-panel__actions')
								]),
							actions),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('details-panel__description')
								]),
							A2(
								$elm$core$List$map,
								function (pg) {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('details-panel__description__paragraph')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(pg)
											]));
								},
								paragraphs))
						]))
				]));
	});
var $author$project$Governance$ProposalDetail$placeholderLoadingProposal = function (targetProposalId) {
	return {
		fL: _List_Nil,
		dM: $author$project$Decimal$zero,
		d5: '',
		ec: $author$project$Decimal$zero,
		el: targetProposalId,
		g9: {
			dJ: $elm$core$Maybe$Nothing,
			dL: ' ...',
			d6: $elm$core$Maybe$Just('...'),
			em: $elm$core$Maybe$Nothing
		},
		fj: _List_Nil,
		hz: 'Loading...'
	};
};
var $author$project$Strings$Translations$proposal_state_created = function (lang) {
	switch (lang) {
		case 0:
			return 'Created';
		case 1:
			return 'Creado';
		default:
			return '已建立';
	}
};
var $author$project$Strings$Translations$proposal_state_succeeded = function (lang) {
	switch (lang) {
		case 0:
			return 'Succeeded';
		case 1:
			return 'Triunfó';
		default:
			return '成功';
	}
};
var $author$project$Governance$ProposalDetail$stateTimeFormatter = A2(
	$ryannhg$date_format$DateFormat$format,
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$monthNameFull,
			$ryannhg$date_format$DateFormat$text(' '),
			$ryannhg$date_format$DateFormat$dayOfMonthSuffix,
			$ryannhg$date_format$DateFormat$text(', '),
			$ryannhg$date_format$DateFormat$yearNumber,
			$ryannhg$date_format$DateFormat$text(' – '),
			$ryannhg$date_format$DateFormat$hourNumber,
			$ryannhg$date_format$DateFormat$text(':'),
			$ryannhg$date_format$DateFormat$minuteFixed,
			$ryannhg$date_format$DateFormat$amPmLowercase
		]),
	$elm$time$Time$utc);
var $author$project$Governance$ProposalDetail$historyStateRow = F4(
	function (userLanguage, network, maybeCurrentState, historyState) {
		var timestamp = $author$project$Governance$ProposalDetail$stateTimeFormatter(historyState.hk);
		var maybeState = A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.fi;
			},
			maybeCurrentState);
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(historyState.fi, maybeState);
			switch (_v1.a) {
				case 0:
					if ((!_v1.b.$) && (!_v1.b.a)) {
						var _v2 = _v1.a;
						var _v3 = _v1.b.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_pending(userLanguage),
							'active');
					} else {
						var _v4 = _v1.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_created(userLanguage),
							'inactive-succeeded');
					}
				case 1:
					if ((!_v1.b.$) && (_v1.b.a === 1)) {
						var _v5 = _v1.a;
						var _v6 = _v1.b.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_active(userLanguage),
							'active');
					} else {
						var _v7 = _v1.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_active(userLanguage),
							'inactive-succeeded');
					}
				case 2:
					if ((!_v1.b.$) && (_v1.b.a === 6)) {
						var _v8 = _v1.a;
						var _v9 = _v1.b.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_succeeded(userLanguage),
							'inactive-succeeded');
					} else {
						var _v10 = _v1.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_succeeded(userLanguage),
							'active');
					}
				case 3:
					var _v11 = _v1.a;
					return _Utils_Tuple2(
						$author$project$Strings$Translations$proposal_state_failed(userLanguage),
						'failed');
				case 4:
					if ((!_v1.b.$) && (_v1.b.a === 6)) {
						var _v12 = _v1.a;
						var _v13 = _v1.b.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_queued(userLanguage),
							'inactive-succeeded');
					} else {
						var _v14 = _v1.a;
						return _Utils_Tuple2(
							$author$project$Strings$Translations$proposal_state_queued(userLanguage),
							'active');
					}
				case 5:
					var _v15 = _v1.a;
					return _Utils_Tuple2(
						$author$project$Strings$Translations$proposal_state_executed(userLanguage),
						'succeeded');
				case 6:
					var _v16 = _v1.a;
					return _Utils_Tuple2(
						$author$project$Strings$Translations$proposal_state_canceled(userLanguage),
						'failed');
				default:
					var _v17 = _v1.a;
					return _Utils_Tuple2(
						$author$project$Strings$Translations$proposal_state_expired(userLanguage),
						'failed');
			}
		}();
		var stateName = _v0.a;
		var pointClass = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('history-panel__time-line__point history-panel__time-line__point--' + pointClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('history-panel__time-line__point__content')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('history-panel__time-line__point__title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(stateName)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('history-panel__time-line__point__timestamp')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(timestamp)
										]))
								])),
						function () {
							var _v18 = historyState.hQ;
							if (!_v18.$) {
								var stateTrxHash = _v18.a;
								return _List_fromArray(
									[
										A4(
										$author$project$Eth$Ethereum$etherscanLink,
										$elm$core$Maybe$Just(network),
										$author$project$Eth$Ethereum$TransactionHash(stateTrxHash),
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('external-link')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link line-icon--external-link--green')
													]),
												_List_Nil)
											]))
									]);
							} else {
								return _List_Nil;
							}
						}()))
				]));
	});
var $author$project$Strings$Translations$proposal_history = function (lang) {
	switch (lang) {
		case 0:
			return 'Proposal History';
		case 1:
			return 'Historial de propuestas';
		default:
			return '提案历史';
	}
};
var $author$project$Governance$ProposalDetail$proposalHistoryPanel = F3(
	function (userLanguage, network, _v0) {
		var maybeProposalDetail = _v0.C;
		var statePoints = function () {
			if (!maybeProposalDetail.$) {
				var states = maybeProposalDetail.a.fj;
				var currentState = $elm$core$List$head(
					$elm$core$List$reverse(states));
				return A2(
					$elm$core$List$map,
					A3($author$project$Governance$ProposalDetail$historyStateRow, userLanguage, network, currentState),
					states);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6 history-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$proposal_history(userLanguage))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('history-panel__time-line ')
								]),
							statePoints)
						]))
				]));
	});
var $author$project$Governance$ProposalDetail$proposerPane = F3(
	function (_v0, targetProposalId, _v1) {
		var maybeProposalDetail = _v1.C;
		var activeProposer = function () {
			if (!maybeProposalDetail.$) {
				var proposalDetail = maybeProposalDetail.a;
				return proposalDetail.g9;
			} else {
				return $author$project$Governance$ProposalDetail$placeholderLoadingProposal(targetProposalId).g9;
			}
		}();
		var friendlyDisplayName = A2(
			$elm$core$Maybe$withDefault,
			A3($author$project$Eth$Ethereum$shortenedAddressString, 4, 4, activeProposer.dL),
			activeProposer.d6);
		var profileImageUrl = A2($elm$core$Maybe$withDefault, '', activeProposer.em);
		return A2(
			$elm$html$Html$a,
			A2(
				$elm$core$List$cons,
				$author$project$Utils$CompoundHtmlAttributes$class('proposer-pane'),
				A2(
					$author$project$Utils$CompoundHtmlAttributes$href,
					0,
					$author$project$LandingSite$Page$getHrefUrl(
						$author$project$LandingSite$Page$GovernanceAccountProfile(activeProposer.dL)))),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$object,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposer-pane__img'),
							$author$project$Utils$CompoundHtmlAttributes$data(profileImageUrl)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$src('/images/icn-default-avatar-large.svg')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposer-pane__details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposer-pane__details__display-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(friendlyDisplayName)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposer-pane__details__address')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A3($author$project$Eth$Ethereum$shortenedAddressString, 4, 4, activeProposer.dL))
								]))
						]))
				]));
	});
var $author$project$Governance$ProposalDetail$ForSelf = $elm$core$Basics$identity;
var $author$project$Governance$ProposalDetail$ShowVotesModal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Strings$Translations$view_all = function (lang) {
	switch (lang) {
		case 0:
			return 'View All';
		case 1:
			return 'Ver todo';
		default:
			return '查看全部';
	}
};
var $author$project$Governance$ProposalDetail$voteRow = F2(
	function (name, votes) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__vote-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-left')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-right')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$NumberFormatter$formatTokenBalance(votes))
						]))
				]));
	});
var $author$project$Governance$ProposalDetail$voteTotalsAndRowsContent = F4(
	function (userLanguage, isForVotes, votesPercentage, voters) {
		var votersRows = A2(
			$elm$core$List$map,
			function (voteReceipt) {
				var friendlyDisplayName = A2(
					$elm$core$Maybe$withDefault,
					A3($author$project$Eth$Ethereum$shortenedAddressString, 4, 4, voteReceipt.fC.dL),
					voteReceipt.fC.d6);
				return A2($author$project$Governance$ProposalDetail$voteRow, friendlyDisplayName, voteReceipt.hY);
			},
			voters);
		var votePanelHeaders = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__labels')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-left')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$address(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$votes(userLanguage))
								]))
						]))
				]));
		var _v0 = isForVotes ? _Utils_Tuple2(
			$author$project$Strings$Translations$for(userLanguage),
			'--for') : _Utils_Tuple2(
			$author$project$Strings$Translations$against(userLanguage),
			'--against');
		var headerText = _v0.a;
		var barFillClass = _v0.b;
		return _Utils_ap(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header votes-panel__header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__header__title-bar')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(headerText)
										])),
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(votesPercentage)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__header__vote-bar')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('votes-panel__header__vote-bar__fill votes-panel__header__vote-bar__fill' + barFillClass),
											A2($author$project$Utils$CompoundHtmlAttributes$style, 'width', votesPercentage)
										]),
									_List_Nil)
								]))
						])),
					votePanelHeaders
				]),
			votersRows);
	});
var $author$project$Governance$ProposalDetail$voteOverview = F2(
	function (userLanguage, _v0) {
		var maybeProposalDetail = _v0.C;
		var maybeForVoteReceipts = _v0.a7;
		var maybeAgainstVoteReceipts = _v0.a6;
		var _v1 = function () {
			var _v2 = _Utils_Tuple2(maybeForVoteReceipts, maybeAgainstVoteReceipts);
			if ((!_v2.a.$) && (!_v2.b.$)) {
				var forVoteReceipts = _v2.a.a;
				var againstVoteReceipts = _v2.b.a;
				var _v3 = _Utils_Tuple2(
					A2($elm$core$List$take, 3, forVoteReceipts.T),
					($elm$core$List$length(forVoteReceipts.T) > 3) ? A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer'),
								$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
								$author$project$Governance$ProposalDetail$ShowVotesModal(true))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$view_all(userLanguage))
							])) : $elm$html$Html$text(''));
				var forTop3 = _v3.a;
				var forVotesViewAll = _v3.b;
				var _v4 = _Utils_Tuple2(
					A2($elm$core$List$take, 3, againstVoteReceipts.T),
					($elm$core$List$length(againstVoteReceipts.T) > 3) ? A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__footer'),
								$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
								$author$project$Governance$ProposalDetail$ShowVotesModal(false))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$view_all(userLanguage))
							])) : $elm$html$Html$text(''));
				var againstTop3 = _v4.a;
				var againstVotesViewAll = _v4.b;
				return {
					ce: _List_fromArray(
						[againstVotesViewAll]),
					cf: againstTop3,
					cA: _List_fromArray(
						[forVotesViewAll]),
					cB: forTop3
				};
			} else {
				return {ce: _List_Nil, cf: _List_Nil, cA: _List_Nil, cB: _List_Nil};
			}
		}();
		var forVotesTop3 = _v1.cB;
		var forVotesShowAll = _v1.cA;
		var againstVotesTop3 = _v1.cf;
		var againstVotesShowAll = _v1.ce;
		var _v5 = function () {
			if (!maybeProposalDetail.$) {
				var proposalDetail = maybeProposalDetail.a;
				var totalVotes = A2($author$project$Decimal$add, proposalDetail.ec, proposalDetail.dM);
				return {
					cd: $author$project$Utils$NumberFormatter$formatPercentage(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Decimal$zero,
							A2($author$project$Decimal$fastdiv, proposalDetail.dM, totalVotes))),
					cz: $author$project$Utils$NumberFormatter$formatPercentage(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$Decimal$zero,
							A2($author$project$Decimal$fastdiv, proposalDetail.ec, totalVotes)))
				};
			} else {
				return {
					cd: $author$project$Utils$NumberFormatter$formatPercentage($author$project$Decimal$zero),
					cz: $author$project$Utils$NumberFormatter$formatPercentage($author$project$Decimal$zero)
				};
			}
		}();
		var forVotesPercentage = _v5.cz;
		var againstVotesPercentage = _v5.cd;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-6 votes-panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
								]),
							_Utils_ap(
								A4($author$project$Governance$ProposalDetail$voteTotalsAndRowsContent, userLanguage, true, forVotesPercentage, forVotesTop3),
								forVotesShowAll))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-6 votes-panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
								]),
							_Utils_ap(
								A4($author$project$Governance$ProposalDetail$voteTotalsAndRowsContent, userLanguage, false, againstVotesPercentage, againstVotesTop3),
								againstVotesShowAll))
						]))
				]));
	});
var $author$project$Governance$ProposalDetail$DismissVotesModal = {$: 4};
var $author$project$Strings$Translations$against_votes = function (lang) {
	switch (lang) {
		case 0:
			return 'Against Votes';
		case 1:
			return 'Contra los votos';
		default:
			return '反对投票';
	}
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Strings$Translations$for_votes = function (lang) {
	switch (lang) {
		case 0:
			return 'For Votes';
		case 1:
			return 'Para los votos';
		default:
			return '投票';
	}
};
var $author$project$Governance$ProposalDetail$votersModalView = F2(
	function (userLanguage, _v0) {
		var shownVotesModal = _v0.bf;
		if (!shownVotesModal.$) {
			var showForVotes = shownVotesModal.a.dm;
			var proposalDetail = shownVotesModal.a.db;
			var votersList = shownVotesModal.a.dE;
			var totalVotes = A2($author$project$Decimal$add, proposalDetail.ec, proposalDetail.dM);
			var _v2 = showForVotes ? _Utils_Tuple2(
				$author$project$Strings$Translations$for_votes(userLanguage) + (' – ' + $author$project$Utils$NumberFormatter$formatTokenBalance(proposalDetail.ec)),
				$author$project$Utils$NumberFormatter$formatPercentage(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Decimal$zero,
						A2($author$project$Decimal$fastdiv, proposalDetail.ec, totalVotes)))) : _Utils_Tuple2(
				$author$project$Strings$Translations$against_votes(userLanguage) + (' – ' + $author$project$Utils$NumberFormatter$formatTokenBalance(proposalDetail.dM)),
				$author$project$Utils$NumberFormatter$formatPercentage(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Decimal$zero,
						A2($author$project$Decimal$fastdiv, proposalDetail.dM, totalVotes))));
			var headerText = _v2.a;
			var votesPercentage = _v2.b;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('cover active'),
								$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation($author$project$Governance$ProposalDetail$DismissVotesModal)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('container-large')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('accent neutral')
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('panel')
									]),
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('header')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('title')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(headerText)
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$author$project$Utils$CompoundHtmlAttributes$class('close-x borrow-interface-only')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation($author$project$Governance$ProposalDetail$DismissVotesModal)
															]),
														_List_Nil)
													]))
											])),
									A4($author$project$Governance$ProposalDetail$voteTotalsAndRowsContent, userLanguage, showForVotes, votesPercentage, votersList.T)))
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Governance$ProposalDetail$view = F6(
	function (userLanguage, network, backPage, targetProposalId, maybeCurrentTime, model) {
		var maybeProposalDetail = model.C;
		var activeProposal = function () {
			if (!maybeProposalDetail.$) {
				var proposalDetail = maybeProposalDetail.a;
				return proposalDetail;
			} else {
				return $author$project$Governance$ProposalDetail$placeholderLoadingProposal(targetProposalId);
			}
		}();
		var _v0 = A2($author$project$LandingSite$Page$getInPageBackTitleHref, userLanguage, backPage);
		var inPageHeaderTitle = _v0.a;
		var inPageHeaderHref = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('Proposal-Detail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container container--governance')
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Governance$CommonViews$pageHeader,
									inPageHeaderTitle,
									inPageHeaderHref,
									A4($author$project$Governance$CommonViews$proposalContentView, userLanguage, maybeCurrentTime, activeProposal, true),
									$elm$core$Maybe$Just(
										A3($author$project$Governance$ProposalDetail$proposerPane, userLanguage, targetProposalId, model)))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container container--governance')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('content')
										]),
									_List_fromArray(
										[
											A2($author$project$Governance$ProposalDetail$voteOverview, userLanguage, model),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('row')
												]),
											_List_fromArray(
												[
													A2($author$project$Governance$ProposalDetail$detailsPanel, userLanguage, model),
													A3($author$project$Governance$ProposalDetail$proposalHistoryPanel, userLanguage, network, model)
												]))
										]))
								]))
						])),
					A2($author$project$Governance$ProposalDetail$votersModalView, userLanguage, model)
				]));
	});
var $author$project$Governance$ProposalOverview$ForSelf = $elm$core$Basics$identity;
var $author$project$Governance$ProposalOverview$PagerNext = {$: 2};
var $author$project$Governance$ProposalOverview$PagerPrevious = {$: 1};
var $author$project$Strings$Translations$all_proposals = function (lang) {
	switch (lang) {
		case 0:
			return 'All Proposals';
		case 1:
			return 'Todas las propuestas';
		default:
			return '所有提案';
	}
};
var $author$project$Governance$ProposalOverview$allProposalsPane = F3(
	function (userLanguage, maybeCurrentTime, _v0) {
		var currentPageNumber = _v0.as;
		var maybeTotalProposals = _v0.a8;
		var proposalsPageMap = _v0.aH;
		var totalPages = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Maybe$map,
				function (totalProposals) {
					return $elm$core$Basics$ceiling(totalProposals / $author$project$Governance$ProposalOverview$desiredPageSize);
				},
				maybeTotalProposals));
		var proposalsForPage = function () {
			var _v1 = A2($elm$core$Dict$get, currentPageNumber, proposalsPageMap);
			if (!_v1.$) {
				var pageProposals = _v1.a;
				var proposalsToShow = A2(
					$elm$core$List$map,
					A2($author$project$Governance$CommonViews$proposalRow, userLanguage, maybeCurrentTime),
					pageProposals);
				return ($elm$core$List$length(proposalsToShow) > 0) ? proposalsToShow : _List_fromArray(
					[
						$author$project$Governance$CommonViews$noProposalsRow(userLanguage)
					]);
			} else {
				return _List_Nil;
			}
		}();
		var pagerFooter = function () {
			if (totalPages > 1) {
				var prevButton = (currentPageNumber > 1) ? A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__previous'),
							$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation($author$project$Governance$ProposalOverview$PagerPrevious)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$prev(userLanguage))
								]))
						])) : A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]));
				var pagerIndicator = A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__indicator')
						]),
					A2(
						$elm$core$List$map,
						function (i) {
							var activeClass = _Utils_eq(currentPageNumber, i) ? ' governance-panel__pager__indicator__text--active' : '';
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__indicator__text' + activeClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$elm$core$String$fromInt(i))
									]));
						},
						A2($elm$core$List$range, 1, totalPages)));
				var nextButton = (_Utils_cmp(currentPageNumber, totalPages) < 0) ? A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager__next'),
							$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation($author$project$Governance$ProposalOverview$PagerNext)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$next(userLanguage))
								]))
						])) : A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__pager')
						]),
					_List_fromArray(
						[prevButton, pagerIndicator, nextButton]));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('governance-panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('governance-panel__header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$all_proposals(userLanguage))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposals')
						]),
					proposalsForPage),
					pagerFooter
				]));
	});
var $author$project$Strings$Translations$governance_proposals = function (lang) {
	switch (lang) {
		case 0:
			return 'Governance Proposals';
		case 1:
			return 'Propuestas de gobierno';
		default:
			return '治理方案';
	}
};
var $author$project$Governance$ProposalOverview$overviewHeader = function (userLanguage) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$class('proposal-overview')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('proposal-overview__header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Strings$Translations$governance_proposals(userLanguage))
					]))
			]));
};
var $author$project$Governance$ProposalOverview$ActiveProposal = 0;
var $author$project$Governance$ProposalOverview$FailedProposal = 2;
var $author$project$Governance$ProposalOverview$PassedProposal = 1;
var $author$project$Governance$ProposalOverview$buildDataset = F3(
	function (activeCount, passedCount, failedCount) {
		var total = (activeCount + passedCount) + failedCount;
		return _List_fromArray(
			[
				{aP: activeCount / total},
				{aP: passedCount / total},
				{aP: failedCount / total}
			]);
	});
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{g: nodeList, e: nodeListSize, f: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $author$project$Charty$Color$defaultPalette = $elm$core$Array$fromList(
	_List_fromArray(
		['#9669ED', '#00D395', '#657786']));
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $author$project$Charty$Color$assignDefaults = function (dataset) {
	var colorCount = $elm$core$Array$length($author$project$Charty$Color$defaultPalette);
	var color = function (index) {
		var _v0 = A2(
			$elm$core$Array$get,
			A2($elm$core$Basics$modBy, colorCount, index),
			$author$project$Charty$Color$defaultPalette);
		if (_v0.$ === 1) {
			return '#00D395';
		} else {
			var x = _v0.a;
			return x;
		}
	};
	return A2(
		$elm$core$List$indexedMap,
		F2(
			function (i, series) {
				return _Utils_Tuple2(
					color(i),
					series);
			}),
		dataset);
};
var $author$project$Charty$PieChart$defaults = {
	dR: 'transparent',
	cj: $author$project$Charty$Color$assignDefaults,
	cW: $elm$core$Maybe$Just(8)
};
var $author$project$Governance$ProposalOverview$getOverviewStateForProposal = function (proposal) {
	var maybeCurrentState = $elm$core$List$head(
		$elm$core$List$reverse(proposal.fj));
	if (!maybeCurrentState.$) {
		var currentState = maybeCurrentState.a;
		var _v1 = currentState.fi;
		switch (_v1) {
			case 0:
				return 0;
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 1;
			case 5:
				return 1;
			case 6:
				return 2;
			default:
				return 2;
		}
	} else {
		return 2;
	}
};
var $author$project$Charty$PieChart$accumulateStart = F2(
	function (start, slices) {
		if (!slices.b) {
			return _List_Nil;
		} else {
			var s = slices.a;
			var ss = slices.b;
			return A2(
				$elm$core$List$cons,
				_Utils_Tuple2(start, s),
				A2($author$project$Charty$PieChart$accumulateStart, start + s.bd, ss));
		}
	});
var $elm$core$Basics$cos = _Basics_cos;
var $elm$core$Basics$pi = _Basics_pi;
var $elm$core$Basics$sin = _Basics_sin;
var $author$project$Charty$PieChart$circumferencePoint = function (percentage) {
	var ang = (percentage * (2 * $elm$core$Basics$pi)) / 100;
	return _Utils_Tuple2(
		70 * (1 + $elm$core$Basics$sin(ang)),
		70 * (1 - $elm$core$Basics$cos(ang)));
};
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $author$project$Charty$PieChart$drawSlice = F3(
	function (config, start, slice) {
		var largeArc = (slice.bd <= 50) ? '0' : '1';
		var _v0 = $author$project$Charty$PieChart$circumferencePoint(
			start + A2($elm$core$Basics$min, 99.9999, slice.bd));
		var x2 = _v0.a;
		var y2 = _v0.b;
		var _v1 = $author$project$Charty$PieChart$circumferencePoint(start);
		var x1 = _v1.a;
		var y1 = _v1.b;
		var pathDefinition = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$concat,
			$elm$core$String$join(' '))(
			_List_fromArray(
				[
					_List_fromArray(
					['M 70 70']),
					_List_fromArray(
					[
						'L ',
						$elm$core$String$fromFloat(x1),
						$elm$core$String$fromFloat(y1)
					]),
					_List_fromArray(
					['A 70 70 0', largeArc, '1']),
					_List_fromArray(
					[
						$elm$core$String$fromFloat(x2),
						$elm$core$String$fromFloat(y2)
					]),
					_List_fromArray(
					['Z'])
				]));
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d(pathDefinition),
					$elm$svg$Svg$Attributes$stroke('transparent'),
					$elm$svg$Svg$Attributes$fill(slice.ci)
				]),
			_List_Nil);
	});
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $author$project$Charty$PieChart$uncurry = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2(f, a, b);
	});
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Charty$PieChart$drawSlices = F2(
	function (config, slices) {
		return A2(
			$elm$svg$Svg$svg,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$viewBox('0 0 140 140'),
					$elm$svg$Svg$Attributes$width('100%')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Charty$PieChart$uncurry(
					$author$project$Charty$PieChart$drawSlice(config)),
				A2($author$project$Charty$PieChart$accumulateStart, 0, slices)));
	});
var $author$project$Charty$PieChart$sumValues = A2(
	$elm$core$List$foldr,
	F2(
		function (_v0, s) {
			var value = _v0.aP;
			return value + s;
		}),
	0);
var $author$project$Charty$PieChart$normalize = function (dataset) {
	var sum = $author$project$Charty$PieChart$sumValues(dataset);
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var value = _v0.aP;
			return {aP: (100 * value) / sum};
		},
		dataset);
};
var $author$project$Charty$PieChart$truncate = F2(
	function (maxGroupCount, dataset) {
		if (maxGroupCount.$ === 1) {
			return dataset;
		} else {
			var n = maxGroupCount.a;
			var _v1 = A2($elm$core$List$drop, n - 1, dataset);
			if (!_v1.b) {
				return dataset;
			} else {
				if (!_v1.b.b) {
					return dataset;
				} else {
					var rest = _v1;
					return _Utils_ap(
						A2($elm$core$List$take, n - 1, dataset),
						_List_fromArray(
							[
								{
								aP: $author$project$Charty$PieChart$sumValues(rest)
							}
							]));
				}
			}
		}
	});
var $author$project$Charty$PieChart$preprocess = F2(
	function (config, dataset) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var color = _v0.a;
				var value = _v0.b.aP;
				return {ci: color, bd: value};
			},
			config.cj(
				A2(
					$author$project$Charty$PieChart$truncate,
					config.cW,
					$author$project$Charty$PieChart$normalize(dataset))));
	});
var $author$project$Charty$PieChart$view = F2(
	function (config, dataset) {
		var slices = A2($author$project$Charty$PieChart$preprocess, config, dataset);
		return A2($author$project$Charty$PieChart$drawSlices, config, slices);
	});
var $author$project$Governance$ProposalOverview$proposalsPieChart = F2(
	function (userLanguage, _v0) {
		var maybeTotalProposals = _v0.a8;
		var proposalsPageMap = _v0.aH;
		var totalProposalsText = A2(
			$elm$core$Maybe$withDefault,
			'0',
			A2($elm$core$Maybe$map, $elm$core$String$fromInt, maybeTotalProposals));
		var _v1 = function () {
			var _v2 = _Utils_Tuple2(
				maybeTotalProposals,
				A2($elm$core$Dict$get, 1, proposalsPageMap));
			if ((!_v2.a.$) && (!_v2.b.$)) {
				var totalProposals = _v2.a.a;
				var firstPageProposals = _v2.b.a;
				if (_Utils_cmp(totalProposals, $author$project$Governance$ProposalOverview$desiredPageSize) < 1) {
					var filterFunction = F2(
						function (desiredOverviewState, proposal) {
							return _Utils_eq(
								$author$project$Governance$ProposalOverview$getOverviewStateForProposal(proposal),
								desiredOverviewState) ? $elm$core$Maybe$Just(proposal) : $elm$core$Maybe$Nothing;
						});
					var passedProposals = $elm$core$List$length(
						A2(
							$elm$core$List$filterMap,
							filterFunction(1),
							firstPageProposals));
					var failedProposals = $elm$core$List$length(
						A2(
							$elm$core$List$filterMap,
							filterFunction(2),
							firstPageProposals));
					var activeProposals = $elm$core$List$length(
						A2(
							$elm$core$List$filterMap,
							filterFunction(0),
							firstPageProposals));
					return _Utils_Tuple2(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposals-pie-chart')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Charty$PieChart$view,
									$author$project$Charty$PieChart$defaults,
									A3($author$project$Governance$ProposalOverview$buildDataset, activeProposals, passedProposals, failedProposals))
								])),
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal-pie-labels')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('active')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$proposal_state_active(userLanguage))
										])),
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('passed')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$proposal_state_passed(userLanguage))
										])),
									A2(
									$elm$html$Html$label,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('failed')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$proposal_state_failed(userLanguage))
										]))
								])));
				} else {
					return _Utils_Tuple2(
						$elm$html$Html$text(''),
						$elm$html$Html$text(''));
				}
			} else {
				return _Utils_Tuple2(
					$elm$html$Html$text(''),
					$elm$html$Html$text(''));
			}
		}();
		var pieChart = _v1.a;
		var pieLabels = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('proposals-pie-view')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('proposal-pie-wrapper')
						]),
					_List_fromArray(
						[
							pieChart,
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('proposal-pie-description')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('headline')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(totalProposalsText)
										]))
								]))
						])),
					pieLabels
				]));
	});
var $author$project$Governance$ProposalOverview$view = F3(
	function (userLanguage, maybeCurrentTime, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('ProposalOverview')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container container--governance')
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Governance$CommonViews$pageHeader,
									$author$project$Strings$Translations$overview(userLanguage),
									$author$project$LandingSite$Page$getHrefUrl($author$project$LandingSite$Page$GovernanceHome),
									$author$project$Governance$ProposalOverview$overviewHeader(userLanguage),
									$elm$core$Maybe$Just(
										A2($author$project$Governance$ProposalOverview$proposalsPieChart, userLanguage, model)))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container container--governance')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('content')
										]),
									_List_fromArray(
										[
											A3($author$project$Governance$ProposalOverview$allProposalsPane, userLanguage, maybeCurrentTime, model)
										]))
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$about_page_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The majority of cryptocurrencies sit idle on exchanges and in wallets, without yielding interest. We\'re on a mission to change that.';
		case 1:
			return 'La mayoría de las criptomonedas permanecen inactivas en los intercambios y en las billeteras, sin generar interés. Estamos en una misión para cambiar eso.';
		default:
			return '大多数加密货币闲置在交易所与钱包中，没有利息。我们的使命就是改变这种状况。';
	}
};
var $author$project$Strings$Translations$adam_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Previously led developer relations at PubNub. Software engineer. Growth hacker.';
		case 1:
			return 'Anteriormente lideró las relaciones con los desarrolladores en PubNub. Ingeniero de software. Hacker de crecimiento.';
		default:
			return '曾在PubNub领导开发人员关系。软件工程师。成长型黑客。';
	}
};
var $author$project$Strings$Translations$application_lead = function (lang) {
	switch (lang) {
		case 0:
			return 'Application Lead';
		case 1:
			return 'Solicitud de plomo';
		default:
			return '应用程序主管';
	}
};
var $author$project$Strings$Translations$business_development = function (lang) {
	switch (lang) {
		case 0:
			return 'Business Development';
		case 1:
			return 'Desarrollo de negocios';
		default:
			return '业务发展';
	}
};
var $author$project$Strings$Translations$calvin_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Previously analytics at Gusto, advisor to digital currency startups at Promontory, long-time crypto investor.';
		case 1:
			return 'Anteriormente analítica en Gusto, asesor de nuevas empresas de moneda digital en Promontory, inversor criptográfico de larga data.';
		default:
			return 'Gusto 的前分析师，是 Promontory 数字货币初创公司的顾问，长期从事数字资产的投资。';
	}
};
var $author$project$Strings$Translations$ceo = function (lang) {
	switch (lang) {
		case 0:
			return 'CEO';
		case 1:
			return 'CEO';
		default:
			return 'CEO';
	}
};
var $author$project$Strings$Translations$coburn_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Experienced web stack engineer from The RealReal; previously an attorney.';
		case 1:
			return 'Ingeniero experimentado en web stack de The RealReal; Anteriormente un abogado.';
		default:
			return '来自 RealReal 的经验丰富的 web 堆栈工程师；以前是一位律师。';
	}
};
var $author$project$Strings$Translations$cto = function (lang) {
	switch (lang) {
		case 0:
			return 'CTO';
		case 1:
			return 'CTO';
		default:
			return 'CTO';
	}
};
var $author$project$Strings$Translations$date_february_2019 = function (lang) {
	switch (lang) {
		case 0:
			return 'February 2019';
		case 1:
			return 'Febrero 2019';
		default:
			return '2019 年 2 月';
	}
};
var $author$project$Strings$Translations$date_july_2019 = function (lang) {
	switch (lang) {
		case 0:
			return 'July 2019';
		case 1:
			return 'Julio 2019';
		default:
			return '2019 年 7 月';
	}
};
var $author$project$Strings$Translations$date_june_2019 = function (lang) {
	switch (lang) {
		case 0:
			return 'June 2019';
		case 1:
			return 'Junio 2019';
		default:
			return '2019 年 6 月';
	}
};
var $author$project$Strings$Translations$date_may_2018 = function (lang) {
	switch (lang) {
		case 0:
			return 'May 2018';
		case 1:
			return 'Mayo 2018';
		default:
			return '2018 年 5 月';
	}
};
var $author$project$Strings$Translations$date_nov_2018 = function (lang) {
	switch (lang) {
		case 0:
			return 'November 2018';
		case 1:
			return 'Noviembre 2018';
		default:
			return '2018 年 11 月';
	}
};
var $author$project$Strings$Translations$date_nov_2019 = function (lang) {
	switch (lang) {
		case 0:
			return 'November 2019';
		case 1:
			return 'Noviembre 2019';
		default:
			return '2019年十一月';
	}
};
var $author$project$Strings$Translations$date_september_2018 = function (lang) {
	switch (lang) {
		case 0:
			return 'September 2018';
		case 1:
			return 'Septiembre 2018';
		default:
			return '2018 年 9 月';
	}
};
var $author$project$Strings$Translations$developer_relations_lead = function (lang) {
	switch (lang) {
		case 0:
			return 'Developer Relations Lead';
		case 1:
			return 'Líder de Relaciones con Desarrolladores';
		default:
			return '开发人员关系主管';
	}
};
var $author$project$Strings$Translations$general_counsel = function (lang) {
	switch (lang) {
		case 0:
			return 'General Counsel';
		case 1:
			return 'Consejero general';
		default:
			return '法律顾问';
	}
};
var $author$project$Strings$Translations$geoff_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Maintainer of Exthereum, technology founder of two startups, led Core Services at Postmates.';
		case 1:
			return 'Mantenedor de Exthereum, fundador de tecnología de dos nuevas empresas, dirigió Core Services en Postmates.';
		default:
			return 'Ethereum 的维护者，两家初创公司的技术创始人，领导着 Postmates 的核心服务。';
	}
};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Strings$Translations$head_of_design = function (lang) {
	switch (lang) {
		case 0:
			return 'Head of Design';
		case 1:
			return 'Jefe de diseño';
		default:
			return '首席设计师';
	}
};
var $author$project$Strings$Translations$head_of_talent = function (lang) {
	switch (lang) {
		case 0:
			return 'Head of Talent';
		case 1:
			return 'Liderazgo de personas';
		default:
			return '人力资源主管';
	}
};
var $author$project$Strings$Translations$help_build = function (lang) {
	switch (lang) {
		case 0:
			return 'Help build the future of finance';
		case 1:
			return 'Ayuda a construir el futuro de las finanzas';
		default:
			return '帮助建设金融的未来';
	}
};
var $author$project$Strings$Translations$jake_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Lawyer. Twitter pro. Former litigator and compliance counsel at Kobre & Kim and Baker McKenzie.';
		case 1:
			return 'Abogado. Twitter pro. Ex abogado litigante y consejero de cumplimiento en Kobre &amp; Kim y Baker McKenzie.';
		default:
			return '律师。Twitter pro。曾在 Kobre & Kim & Baker McKenzie 担任诉讼律师和合规律师。';
	}
};
var $author$project$Strings$Translations$jared_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Diverse background in distributed systems; previously Nokia Research, AdRoll, Caffeine, et al.';
		case 1:
			return 'Diversos antecedentes en sistemas distribuidos; anteriormente Nokia Research, AdRoll, Caffeine, et al.';
		default:
			return '具有丰富分布式系统背景；前诺基亚研究员，AdRoll， Caffeine 等。';
	}
};
var $author$project$Strings$Translations$jayson_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Led product design for Coinbase Pro and Coinbase Custody; previously Otto / Uber Freight, agencies.';
		case 1:
			return 'Diseño de producto dirigido para Coinbase Pro y Coinbase Custody; anteriormente Otto / Uber Freight, agencias.';
		default:
			return '为 Coinbase Pro 和 Coinbase 托管主导产品设计；前奥托/优步货运代理。';
	}
};
var $author$project$Strings$Translations$join_us = function (lang) {
	switch (lang) {
		case 0:
			return 'Join us';
		case 1:
			return 'Únete a nosotros';
		default:
			return '加入我们';
	}
};
var $author$project$Strings$Translations$kway_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Experienced team-builder and recruiting lead.';
		case 1:
			return 'Experimentado creador de equipos y líder de reclutamiento.';
		default:
			return '经验丰富的团队建设者和招聘主管。';
	}
};
var $author$project$Strings$Translations$max_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Open finance enthusiast. Former co-founder of Marble Protocol. Economics at Stanford.';
		case 1:
			return 'Entusiasta de las finanzas abiertas. Ex cofundador de Marble Protocol. Economía en Stanford.';
		default:
			return '开放金融爱好者。Marble 协议的前联合创始人。斯坦福大学经济学。';
	}
};
var $author$project$Strings$Translations$mykel_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Full stack engineer. Former co-founder of Marble Protocol and Haywheel (YC S16).';
		case 1:
			return 'Ingeniero de pila completa. Ex cofundador de Marble Protocol y Haywheel (YC S16).';
		default:
			return '全栈工程师。Marble 协议和 Haywheel (YC S16) 的前联合创始人。';
	}
};
var $author$project$Strings$Translations$nick_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Previously led business development and fundraising initiatives at Pantera Capital. Economics at UCSB.';
		case 1:
			return 'Anteriormente dirigió iniciativas de desarrollo de negocios y recaudación de fondos en Pantera Capital. Economía en UCSB.';
		default:
			return '曾在Pantera Capital领导业务发展和筹款计划。 UCSB经济学。';
	}
};
var $author$project$Strings$Translations$our_team = function (lang) {
	switch (lang) {
		case 0:
			return 'Our Team';
		case 1:
			return 'Nuestro equipo';
		default:
			return '我们的团队';
	}
};
var $author$project$Strings$Translations$press_compound_adds_wbtc = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound adds WBTC after users ‘overwhelmingly’ vote yes on the token';
		case 1:
			return 'Compound agrega WBTC después de que los usuarios voten &quot;abrumadoramente&quot; sí al token';
		default:
			return '在用户以压倒性优势对代币投赞成票后，Compound 添加了 WBTC';
	}
};
var $author$project$Strings$Translations$press_compound_lets_you_holdl_and_earn = function (lang) {
	switch (lang) {
		case 0:
			return 'Crypto Money Market Compound Lets You HODL and Earn';
		case 1:
			return 'Crypto Money Market Compound Lets You HODL and Earn ';
		default:
			return '加密货币市场 Compound 让您 HODL 和赚钱';
	}
};
var $author$project$Strings$Translations$press_compound_partners_for_v2_launch = function (lang) {
	switch (lang) {
		case 0:
			return 'DeFi Pioneer Compound Partners With Coinbase Wallet, Zerion for V2 Launch';
		case 1:
			return 'DeFi Pioneer Compound se asocia con Coinbase Wallet, Zerion para el lanzamiento de V2';
		default:
			return 'DeFi 先锋 Compound 与 Coinbase 钱包合作，为 V2 推出 Zerion';
	}
};
var $author$project$Strings$Translations$press_compound_the_block_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound, the decentralized money market protocol';
		case 1:
			return 'Compound, el protocolo descentralizado del mercado monetario';
		default:
			return 'Compound，去中心化货币市场协议';
	}
};
var $author$project$Strings$Translations$press_latest_threat_to_crypto_prices = function (lang) {
	switch (lang) {
		case 0:
			return 'The Latest Threat to Crypto Prices? The Federal Reserve';
		case 1:
			return '¿La última amenaza para los precios criptográficos? La reserva Federal';
		default:
			return '加密货币价格面临的最新威胁是什么？美国联邦储备理事会';
	}
};
var $author$project$Strings$Translations$press_money_markets_in_the_works = function (lang) {
	switch (lang) {
		case 0:
			return 'Money Markets for Crypto Assets Are in the Works';
		case 1:
			return 'Mercados de dinero para activos criptográficos están en proceso';
		default:
			return '加密资产的货币市场正在酝酿之中';
	}
};
var $author$project$Strings$Translations$press_put_your_bitcoins_in = function (lang) {
	switch (lang) {
		case 0:
			return 'Put Your Bitcoins in the Money Market';
		case 1:
			return 'Ponga sus Bitcoins en el mercado monetario';
		default:
			return '把你的比特币投入货币市场';
	}
};
var $author$project$Strings$Translations$press_raises_25 = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound Raises $25 Million to Expand Crypto Lending';
		case 1:
			return 'El compuesto recauda $ 25 millones para ampliar los préstamos criptográficos';
		default:
			return '复合筹集2500万美元以扩大加密贷款';
	}
};
var $author$project$Strings$Translations$press_why_stablecoins_standout = function (lang) {
	switch (lang) {
		case 0:
			return 'Why Stablecoins Stand Out in the Cryptocurrency World';
		case 1:
			return '¿Por qué Stablecoins se destaca en el mundo de las criptomonedas?';
		default:
			return '为什么稳定币在加密货币世界中脱颖而出';
	}
};
var $author$project$Strings$Translations$recent_press = function (lang) {
	switch (lang) {
		case 0:
			return 'Recent Press';
		case 1:
			return 'Prensa reciente';
		default:
			return '近期新闻';
	}
};
var $author$project$Strings$Translations$robert_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Chartered Financial Analyst, former economist, and founder of two software startups.';
		case 1:
			return 'Analista financiero colegiado, ex economista y fundador de dos nuevas empresas de software.';
		default:
			return '特许金融分析师，前经济学家，两家软件初创公司的创始人。';
	}
};
var $author$project$Strings$Translations$senior_engineer = function (lang) {
	switch (lang) {
		case 0:
			return 'Senior Engineer';
		case 1:
			return 'Ingeniero senior';
		default:
			return '高级工程师';
	}
};
var $author$project$Strings$Translations$software_engineer = function (lang) {
	switch (lang) {
		case 0:
			return 'Software Engineer';
		case 1:
			return 'Ingeniero de software';
		default:
			return '软件工程师';
	}
};
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Strings$Translations$strategy_lead = function (lang) {
	switch (lang) {
		case 0:
			return 'Strategy Lead';
		case 1:
			return 'Jefe de estrategia';
		default:
			return '战略主管';
	}
};
var $author$project$LandingSite$About$teamMember = F4(
	function (imgSrc, name, title, description) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3 col-xs-12')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('member-img'),
									$author$project$Utils$CompoundHtmlAttributes$src(imgSrc)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$h4,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(name)
								])),
							A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('description')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(description)
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$torrey_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Led mobile development at Postmates, Kahuna, and Aha Mobile.';
		case 1:
			return 'Lideró el desarrollo móvil en Postmates, Kahuna y Aha Mobile.';
		default:
			return '负责 Postmates、Kahuna 和 Aha mobile 的移动端开发。';
	}
};
var $author$project$Strings$Translations$we_are_compound = function (lang) {
	switch (lang) {
		case 0:
			return 'We\'re Compound';
		case 1:
			return 'Somos Compound';
		default:
			return '我们是 Compound';
	}
};
var $author$project$LandingSite$About$view = F2(
	function (userLanguage, model) {
		var jobs = function () {
			var _v0 = model.bL;
			if (!_v0.$) {
				var responseJobs = _v0.a;
				return responseJobs;
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('landing-overview'),
							$author$project$Utils$CompoundHtmlAttributes$class('light')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-8 text-left we-are-compound')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('label big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$we_are_compound(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$about_page_description(userLanguage))
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('team')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('our-team')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$our_team(userLanguage))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row members')
										]),
									_List_fromArray(
										[
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_robert.jpg',
											'Robert Leshner',
											$author$project$Strings$Translations$ceo(userLanguage),
											$author$project$Strings$Translations$robert_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_geoff.jpg',
											'Geoffrey Hayes',
											$author$project$Strings$Translations$cto(userLanguage),
											$author$project$Strings$Translations$geoff_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_torrey.jpg',
											'Torrey Atcitty',
											$author$project$Strings$Translations$application_lead(userLanguage),
											$author$project$Strings$Translations$torrey_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_calvin.jpg',
											'Calvin Liu',
											$author$project$Strings$Translations$strategy_lead(userLanguage),
											$author$project$Strings$Translations$calvin_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_coburn.jpg',
											'Coburn Berry',
											$author$project$Strings$Translations$software_engineer(userLanguage),
											$author$project$Strings$Translations$coburn_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_jared.jpg',
											'Jared Flatow',
											$author$project$Strings$Translations$senior_engineer(userLanguage),
											$author$project$Strings$Translations$jared_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_jayson.jpg',
											'Jayson Hobby',
											$author$project$Strings$Translations$head_of_design(userLanguage),
											$author$project$Strings$Translations$jayson_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_jake.jpeg',
											'Jake Chervinsky',
											$author$project$Strings$Translations$general_counsel(userLanguage),
											$author$project$Strings$Translations$jake_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_max.jpg',
											'Max Wolff',
											$author$project$Strings$Translations$software_engineer(userLanguage),
											$author$project$Strings$Translations$max_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_mykel.jpg',
											'Mykel Pereira',
											$author$project$Strings$Translations$software_engineer(userLanguage),
											$author$project$Strings$Translations$mykel_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_kway.jpg',
											'Kway Ohene',
											$author$project$Strings$Translations$head_of_talent(userLanguage),
											$author$project$Strings$Translations$kway_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_adam.jpg',
											'Adam Bavosa',
											$author$project$Strings$Translations$developer_relations_lead(userLanguage),
											$author$project$Strings$Translations$adam_description(userLanguage)),
											A4(
											$author$project$LandingSite$About$teamMember,
											'images/team_nick.jpg',
											'Nick Martitsch',
											$author$project$Strings$Translations$business_development(userLanguage),
											$author$project$Strings$Translations$nick_description(userLanguage))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('dot-grid-left')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('dot-grid-right')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('jobs')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-5 text-left')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('label big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$join_us(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$help_build(userLanguage))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-12 jobs')
												]),
											A2(
												$elm$core$List$concatMap,
												function (job) {
													return _List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$id('line')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$class('job-item'),
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																	]),
																A2($author$project$Utils$CompoundHtmlAttributes$href, 2, job.hU)),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('job-details-section')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$h3,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('job-title')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(job.hz)
																				])),
																			A2(
																			$elm$html$Html$h3,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('job-location')
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(job.gJ.dL.fP)
																				]))
																		])),
																	A2(
																	$elm$html$Html$span,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('arrow big green')
																		]),
																	_List_Nil)
																]))
														]);
												},
												A2(
													$elm$core$List$sortBy,
													function ($) {
														return $.hz;
													},
													jobs)))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('press')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 text-left')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('press-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$recent_press(userLanguage))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-8 col-xs-12')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://fortune.com/2019/11/14/crypto-interest-startup-compound-decentralized-finance/')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_fortune.png')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_raises_25(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_nov_2019(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://finance.yahoo.com/news/compound-adds-wbtc-users-overwhelmingly-231701877.html')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_yahoo.png')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_compound_adds_wbtc(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_july_2019(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.wsj.com/articles/why-stablecoins-stand-out-in-the-cryptocurrency-world-11560218460')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_wsj.jpg')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_why_stablecoins_standout(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_june_2019(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.theblockcrypto.com/2019/02/26/compound-the-decentralized-money-market-protocol/')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_theblock.png')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_compound_the_block_description(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_february_2019(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'http://fortune.com/2018/11/03/crypto-interest-rates/')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_fortune.png')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_latest_threat_to_crypto_prices(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_nov_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.coindesk.com/crypto-money-market-compound-lets-you-hodl-and-earn-interest/')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_coindesk.png')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_compound_lets_you_holdl_and_earn(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_september_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.coindesk.com/defi-pioneer-compound-partners-with-coinbase-wallet-zerion-for-v2-launch')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_coindesk.png')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_compound_partners_for_v2_launch(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_may_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.bloomberg.com/view/articles/2018-05-17/put-your-bitcoins-in-the-money-market')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_bloomberg.jpeg')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_put_your_bitcoins_in(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_may_2018(userLanguage))
																		]))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$id('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('press-item')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.wsj.com/articles/money-markets-for-crypto-assets-are-in-the-works-1526470201')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$src('/images/press_wsj.jpg')
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('title-section')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('title')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$press_money_markets_in_the_works(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$label,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('date')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$date_may_2018(userLanguage))
																		]))
																]))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$LandingSite$CTokens$ForSelf = function (a) {
	return {$: 0, a: a};
};
var $author$project$LandingSite$CTokens$SelectCToken = function (a) {
	return {$: 5, a: a};
};
var $author$project$LandingSite$CTokens$SelectCodeSnippet = function (a) {
	return {$: 3, a: a};
};
var $author$project$LandingSite$CTokens$ToggleAccordianAtIndex = function (a) {
	return {$: 2, a: a};
};
var $author$project$LandingSite$CTokens$ToggleDropdown = function (a) {
	return {$: 4, a: a};
};
var $author$project$Strings$Translations$api = function (lang) {
	switch (lang) {
		case 0:
			return 'API';
		case 1:
			return 'API';
		default:
			return 'API';
	}
};
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Utils$Graph$buildGraphData = F3(
	function (cTokenAddress, interestRateDataMap, formatter) {
		var _v0 = A2(
			$elm$core$Dict$get,
			$author$project$Eth$Ethereum$getContractAddressString(cTokenAddress),
			interestRateDataMap);
		if (!_v0.$) {
			var interestRateData = _v0.a;
			var tupleFirstComparison = F2(
				function (a, b) {
					return A2($elm$core$Basics$compare, a.a, b.a);
				});
			return A2(
				$elm$core$List$sortWith,
				tupleFirstComparison,
				A2(
					$elm$core$List$map,
					function (_v1) {
						var k = _v1.a;
						var v = _v1.b;
						return _Utils_Tuple2(
							k,
							$author$project$Decimal$toFloat(
								formatter(v)));
					},
					$elm$core$Dict$toList(interestRateData)));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Strings$Translations$build_with = function (lang) {
	switch (lang) {
		case 0:
			return 'Build with cTokens';
		case 1:
			return 'Construir con cTokens';
		default:
			return '使用 cTokens 构建';
	}
};
var $author$project$Strings$Translations$build_with_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Help create the new open financial system.';
		case 1:
			return 'Ayuda a crear el nuevo sistema financiero abierto.';
		default:
			return '帮助创建新的开放式金融系统。';
	}
};
var $author$project$Strings$Translations$c_tokens_api_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The cToken API retrieves information for all cTokens. You can use this API to pull data about all cTokens:';
		case 1:
			return 'La API de cToken recupera información para todos los cTokens. Puede usar esta API para extraer datos sobre todos los cTokens:';
		default:
			return 'cToken API 检索所有 cTokens 的信息。您可以使用此 API 来提取有关所有 cTokens 的数据：';
	}
};
var $elm$html$Html$code = _VirtualDom_node('code');
var $author$project$Strings$Translations$erc_20 = function (lang) {
	switch (lang) {
		case 0:
			return 'ERC-20';
		case 1:
			return 'ERC-20';
		default:
			return 'ERC-20';
	}
};
var $author$project$Strings$Translations$erc_20_description = function (lang) {
	switch (lang) {
		case 0:
			return 'cTokens conform to the ERC-20 standard, and work just like other assets.';
		case 1:
			return 'Los cTokens cumplen con el estándar ERC-20 y funcionan igual que otros activos.';
		default:
			return 'cTokens 符合 ERC-20 标准，就像其他资产一样工作。';
	}
};
var $author$project$Strings$Translations$error_code = function (lang) {
	switch (lang) {
		case 0:
			return 'Error Code.';
		case 1:
			return 'Código de error.';
		default:
			return '错误代码。';
	}
};
var $author$project$LandingSite$CTokens$Datum = F2(
	function (block_timestamp, rate) {
		return {fV: block_timestamp, e0: rate};
	});
var $author$project$LandingSite$CTokens$GraphPointHover = function (a) {
	return {$: 1, a: a};
};
var $author$project$LineChart$Container$Margin = F4(
	function (top, right, bottom, left) {
		return {fY: bottom, gL: left, hg: right, hG: top};
	});
var $author$project$Internal$Container$Config = $elm$core$Basics$identity;
var $author$project$Internal$Container$custom = $elm$core$Basics$identity;
var $author$project$LineChart$Container$custom = $author$project$Internal$Container$custom;
var $author$project$Internal$Container$Relative = 1;
var $author$project$Internal$Container$relative = 1;
var $author$project$LineChart$Container$relative = $author$project$Internal$Container$relative;
var $author$project$LandingSite$CTokens$containerConfig = $author$project$LineChart$Container$custom(
	{
		bu: _List_Nil,
		bv: _List_Nil,
		el: 'line-chart-area',
		bM: A4($author$project$LineChart$Container$Margin, 15, -20, -10, -20),
		ak: $author$project$LineChart$Container$relative
	});
var $author$project$Internal$Junk$Config = $elm$core$Basics$identity;
var $author$project$Internal$Junk$custom = function (func) {
	return F3(
		function (_v0, _v1, _v2) {
			return func;
		});
};
var $author$project$LineChart$Junk$custom = $author$project$Internal$Junk$custom;
var $author$project$Internal$Dots$Config = $elm$core$Basics$identity;
var $author$project$Internal$Dots$customAny = $elm$core$Basics$identity;
var $author$project$LineChart$Dots$customAny = $author$project$Internal$Dots$customAny;
var $author$project$LandingSite$CTokens$dotIsHovered = F2(
	function (maybeHoveredPointXValue, datum) {
		if (!maybeHoveredPointXValue.$) {
			var hoveredPointXValue = maybeHoveredPointXValue.a;
			return _Utils_eq(hoveredPointXValue, datum.fV);
		} else {
			return false;
		}
	});
var $author$project$Internal$Dots$Empty = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Dots$Style = $elm$core$Basics$identity;
var $author$project$Internal$Dots$style = F2(
	function (radius, variety) {
		return {de: radius, dD: variety};
	});
var $author$project$Internal$Dots$empty = F2(
	function (radius, border) {
		return A2(
			$author$project$Internal$Dots$style,
			radius,
			$author$project$Internal$Dots$Empty(border));
	});
var $author$project$LineChart$Dots$empty = $author$project$Internal$Dots$empty;
var $author$project$LandingSite$CTokens$customDotsConfig = function (maybeHoveredPointXValue) {
	var styleHover = A2($author$project$LineChart$Dots$empty, 4, 2);
	var styleDefault = A2($author$project$LineChart$Dots$empty, 0, 0);
	var styleIndividual = function (datum) {
		return A2($author$project$LandingSite$CTokens$dotIsHovered, maybeHoveredPointXValue, datum) ? styleHover : styleDefault;
	};
	var styleLegend = function (data) {
		return A2(
			$elm$core$List$any,
			$author$project$LandingSite$CTokens$dotIsHovered(maybeHoveredPointXValue),
			data) ? styleHover : styleDefault;
	};
	return $author$project$LineChart$Dots$customAny(
		{cN: styleIndividual, cQ: styleLegend});
};
var $author$project$Internal$Area$None = {$: 0};
var $author$project$Internal$Area$none = $author$project$Internal$Area$None;
var $author$project$LineChart$Area$default = $author$project$Internal$Area$none;
var $author$project$Internal$Axis$Intersection$Config = $elm$core$Basics$identity;
var $author$project$Internal$Data$Point = F2(
	function (x, y) {
		return {v: x, w: y};
	});
var $author$project$Internal$Axis$Intersection$custom = F2(
	function (toX, toY) {
		return function (_v0) {
			var x = _v0.v;
			var y = _v0.w;
			return A2(
				$author$project$Internal$Data$Point,
				toX(x),
				toY(y));
		};
	});
var $author$project$Internal$Axis$Intersection$default = A2(
	$author$project$Internal$Axis$Intersection$custom,
	function ($) {
		return $.bW;
	},
	function ($) {
		return $.bW;
	});
var $author$project$LineChart$Axis$Intersection$default = $author$project$Internal$Axis$Intersection$default;
var $author$project$Internal$Junk$Layers = F3(
	function (below, above, html) {
		return {cc: above, aS: below, gz: html};
	});
var $author$project$Internal$Junk$none = F4(
	function (_v0, _v1, _v2, _v3) {
		return A3($author$project$Internal$Junk$Layers, _List_Nil, _List_Nil, _List_Nil);
	});
var $author$project$LineChart$Junk$default = $author$project$Internal$Junk$none;
var $author$project$Internal$Grid$Dots = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Internal$Grid$dots = $author$project$Internal$Grid$Dots;
var $author$project$LineChart$Grid$dots = $author$project$Internal$Grid$dots;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {d2: d, eK: m, fG: y};
			}
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		c6: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		fG: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.fG, 0, date.c6);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.d2;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.eK;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.c6;
	});
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		fD: 1 + (((rd - week1Day1) / 7) | 0),
		fE: wy,
		h_: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.fD;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.fE;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.bY(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.c2(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.bY(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.cq(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.an(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.an(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.an(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.dG(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.an(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.an(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {d_: col, f9: contextStack, eV: problem, e7: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.e7, s.d_, x, s.b));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.eO, s.e7, s.d_, s.hj);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{d_: newCol, b: s.b, d: s.d, eO: newOffset, e7: newRow, hj: s.hj});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.eO, s.hj);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{d_: 1, b: s.b, d: s.d, eO: s.eO + 1, e7: s.e7 + 1, hj: s.hj}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{d_: s.d_ + 1, b: s.b, d: s.d, eO: newOffset, e7: s.e7, hj: s.hj}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.hj);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.eO, offset) < 0,
					0,
					{d_: col, b: s0.b, d: s0.d, eO: offset, e7: row, hj: s0.hj});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.eO, s.e7, s.d_, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.eO, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.eO, s1.eO, s0.hj),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.hj),
			s.eO) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {d_: col, eV: problem, e7: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.e7, p.d_, p.eV);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{d_: 1, b: _List_Nil, d: 1, eO: 0, e7: 1, hj: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	cq: $justinmimbs$date$Date$withOrdinalSuffix,
	c2: $justinmimbs$date$Date$monthToName,
	bY: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	dG: $justinmimbs$date$Date$weekdayToName,
	an: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $author$project$Internal$Events$Config = $elm$core$Basics$identity;
var $author$project$Internal$Events$custom = $elm$core$Basics$identity;
var $author$project$Internal$Events$Decoder = $elm$core$Basics$identity;
var $author$project$Internal$Coordinate$lengthX = function (system) {
	return A2($elm$core$Basics$max, 1, (system.bJ.ak.fF - system.bJ.bM.gL) - system.bJ.bM.hg);
};
var $author$project$Internal$Coordinate$reachX = function (system) {
	var diff = system.v.bN - system.v.bW;
	return (diff > 0) ? diff : 1;
};
var $author$project$LineChart$Coordinate$scaleSvgX = F2(
	function (system, value) {
		return (value * $author$project$Internal$Coordinate$lengthX(system)) / $author$project$Internal$Coordinate$reachX(system);
	});
var $author$project$LineChart$Coordinate$toSvgX = F2(
	function (system, value) {
		return A2($author$project$LineChart$Coordinate$scaleSvgX, system, value - system.v.bW) + system.bJ.bM.gL;
	});
var $author$project$Internal$Events$distanceX = F3(
	function (system, searched, dot) {
		return $elm$core$Basics$abs(
			A2($author$project$LineChart$Coordinate$toSvgX, system, dot.v) - A2($author$project$LineChart$Coordinate$toSvgX, system, searched.v));
	});
var $author$project$Internal$Events$getNearestXHelp = F3(
	function (points, system, searched) {
		var distanceX_ = A2($author$project$Internal$Events$distanceX, system, searched);
		var getClosest = F2(
			function (point, allClosest) {
				var _v0 = $elm$core$List$head(allClosest);
				if (!_v0.$) {
					var closest = _v0.a;
					return _Utils_eq(closest.g5.v, point.g5.v) ? A2($elm$core$List$cons, point, allClosest) : ((_Utils_cmp(
						distanceX_(closest.g5),
						distanceX_(point.g5)) > 0) ? _List_fromArray(
						[point]) : allClosest);
				} else {
					return _List_fromArray(
						[point]);
				}
			});
		return A3($elm$core$List$foldl, getClosest, _List_Nil, points);
	});
var $author$project$LineChart$Coordinate$scaleDataX = F2(
	function (system, value) {
		return (value * $author$project$Internal$Coordinate$reachX(system)) / $author$project$Internal$Coordinate$lengthX(system);
	});
var $author$project$LineChart$Coordinate$toDataX = F2(
	function (system, value) {
		return system.v.bW + A2($author$project$LineChart$Coordinate$scaleDataX, system, value - system.bJ.bM.gL);
	});
var $author$project$Internal$Coordinate$lengthY = function (system) {
	return A2($elm$core$Basics$max, 1, (system.bJ.ak.eh - system.bJ.bM.fY) - system.bJ.bM.hG);
};
var $author$project$Internal$Coordinate$reachY = function (system) {
	var diff = system.w.bN - system.w.bW;
	return (diff > 0) ? diff : 1;
};
var $author$project$LineChart$Coordinate$scaleDataY = F2(
	function (system, value) {
		return (value * $author$project$Internal$Coordinate$reachY(system)) / $author$project$Internal$Coordinate$lengthY(system);
	});
var $author$project$LineChart$Coordinate$toDataY = F2(
	function (system, value) {
		return system.w.bN - A2($author$project$LineChart$Coordinate$scaleDataY, system, value - system.bJ.bM.hG);
	});
var $author$project$LineChart$Coordinate$toData = F2(
	function (system, point) {
		return {
			v: A2($author$project$LineChart$Coordinate$toDataX, system, point.v),
			w: A2($author$project$LineChart$Coordinate$toDataY, system, point.w)
		};
	});
var $author$project$Internal$Events$getNearestX = F3(
	function (points, system, searchedSvg) {
		var searched = A2($author$project$LineChart$Coordinate$toData, system, searchedSvg);
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.hV;
			},
			A3($author$project$Internal$Events$getNearestXHelp, points, system, searched));
	});
var $author$project$Internal$Events$Event = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$svg$Svg$Events$on = $elm$html$Html$Events$on;
var $author$project$Internal$Events$onMouseLeave = function (msg) {
	return A2(
		$author$project$Internal$Events$Event,
		false,
		F2(
			function (_v0, _v1) {
				return A2(
					$elm$svg$Svg$Events$on,
					'mouseleave',
					$elm$json$Json$Decode$succeed(msg));
			}));
};
var $author$project$Internal$Events$Options = F3(
	function (stopPropagation, preventDefault, catchOutsideChart) {
		return {dY: catchOutsideChart, da: preventDefault, du: stopPropagation};
	});
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $elm$svg$Svg$Events$custom = $elm$html$Html$Events$custom;
var $author$project$Internal$Events$map = F2(
	function (f, _v0) {
		var a = _v0;
		return F3(
			function (ps, s, p) {
				return f(
					A3(a, ps, s, p));
			});
	});
var $author$project$LineChart$Coordinate$Point = F2(
	function (x, y) {
		return {v: x, w: y};
	});
var $debois$elm_dom$DOM$offsetHeight = A2($elm$json$Json$Decode$field, 'offsetHeight', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetLeft = A2($elm$json$Json$Decode$field, 'offsetLeft', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetParent = F2(
	function (x, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					'offsetParent',
					$elm$json$Json$Decode$null(x)),
					A2($elm$json$Json$Decode$field, 'offsetParent', decoder)
				]));
	});
var $debois$elm_dom$DOM$offsetTop = A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$scrollLeft = A2($elm$json$Json$Decode$field, 'scrollLeft', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$scrollTop = A2($elm$json$Json$Decode$field, 'scrollTop', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$position = F2(
	function (x, y) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				var x_ = _v0.a;
				var y_ = _v0.b;
				return A2(
					$debois$elm_dom$DOM$offsetParent,
					_Utils_Tuple2(x_, y_),
					A2($debois$elm_dom$DOM$position, x_, y_));
			},
			A5(
				$elm$json$Json$Decode$map4,
				F4(
					function (scrollLeftP, scrollTopP, offsetLeftP, offsetTopP) {
						return _Utils_Tuple2((x + offsetLeftP) - scrollLeftP, (y + offsetTopP) - scrollTopP);
					}),
				$debois$elm_dom$DOM$scrollLeft,
				$debois$elm_dom$DOM$scrollTop,
				$debois$elm_dom$DOM$offsetLeft,
				$debois$elm_dom$DOM$offsetTop));
	});
var $debois$elm_dom$DOM$boundingClientRect = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (_v0, width, height) {
			var x = _v0.a;
			var y = _v0.b;
			return {eh: height, gL: x, hG: y, fF: width};
		}),
	A2($debois$elm_dom$DOM$position, 0, 0),
	$debois$elm_dom$DOM$offsetWidth,
	$debois$elm_dom$DOM$offsetHeight);
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $debois$elm_dom$DOM$parentElement = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'parentElement', decoder);
};
function $author$project$Internal$Events$cyclic$position() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$debois$elm_dom$DOM$boundingClientRect,
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return $debois$elm_dom$DOM$parentElement(
						$author$project$Internal$Events$cyclic$position());
				})
			]));
}
var $author$project$Internal$Events$position = $author$project$Internal$Events$cyclic$position();
$author$project$Internal$Events$cyclic$position = function () {
	return $author$project$Internal$Events$position;
};
var $debois$elm_dom$DOM$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $author$project$Internal$Events$toJsonDecoder = F4(
	function (options, data, system, _v0) {
		var decoder = _v0;
		var withOptions = function (msg) {
			return {gN: msg, da: options.da, du: options.du};
		};
		var handle = F3(
			function (mouseX, mouseY, _v1) {
				var left = _v1.gL;
				var top = _v1.hG;
				var height = _v1.eh;
				var width = _v1.fF;
				var y = mouseY - top;
				var x = mouseX - left;
				var widthPercent = width / system.bJ.ak.fF;
				var newSize = {eh: height, fF: width};
				var heightPercent = height / system.bJ.ak.eh;
				var newMargin = {fY: system.bJ.bM.fY * heightPercent, gL: system.bJ.bM.gL * widthPercent, hg: system.bJ.bM.hg * widthPercent, hG: system.bJ.bM.hG * heightPercent};
				var newSystem = _Utils_update(
					system,
					{
						bJ: {bM: newMargin, ak: newSize}
					});
				return A3(
					decoder,
					data,
					newSystem,
					A2($author$project$LineChart$Coordinate$Point, x, y));
			});
		return A2(
			$elm$json$Json$Decode$map,
			withOptions,
			A4(
				$elm$json$Json$Decode$map3,
				handle,
				A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
				A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float),
				$debois$elm_dom$DOM$target($author$project$Internal$Events$position)));
	});
var $author$project$Internal$Events$on = F3(
	function (event, toMsg, decoder) {
		return A2(
			$author$project$Internal$Events$Event,
			false,
			F2(
				function (data, system) {
					var defaultOptions = A3($author$project$Internal$Events$Options, false, false, false);
					return A2(
						$elm$svg$Svg$Events$custom,
						event,
						A4(
							$author$project$Internal$Events$toJsonDecoder,
							defaultOptions,
							data,
							system,
							A2($author$project$Internal$Events$map, toMsg, decoder)));
				}));
	});
var $author$project$Internal$Events$onMouseMove = $author$project$Internal$Events$on('mousemove');
var $author$project$Internal$Events$hoverMany = function (msg) {
	return $author$project$Internal$Events$custom(
		_List_fromArray(
			[
				A2($author$project$Internal$Events$onMouseMove, msg, $author$project$Internal$Events$getNearestX),
				$author$project$Internal$Events$onMouseLeave(
				msg(_List_Nil))
			]));
};
var $author$project$LineChart$Events$hoverMany = $author$project$Internal$Events$hoverMany;
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$scaleFrom255 = function (c) {
	return c / 255;
};
var $avh4$elm_color$Color$rgb255 = F3(
	function (r, g, b) {
		return A4(
			$avh4$elm_color$Color$RgbaSpace,
			$avh4$elm_color$Color$scaleFrom255(r),
			$avh4$elm_color$Color$scaleFrom255(g),
			$avh4$elm_color$Color$scaleFrom255(b),
			1.0);
	});
var $author$project$LineChart$Colors$label = A3($avh4$elm_color$Color$rgb255, 144, 164, 174);
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $elm$svg$Svg$tspan = $elm$svg$Svg$trustedNode('tspan');
var $author$project$Internal$Svg$label = F2(
	function (color, string) {
		return A2(
			$elm$svg$Svg$text_,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$fill(color),
					$elm$svg$Svg$Attributes$style('pointer-events: none;')
				]),
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$tspan,
					_List_Nil,
					_List_fromArray(
						[
							$elm$svg$Svg$text(string)
						]))
				]));
	});
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $author$project$LineChart$Junk$label = function (color) {
	return $author$project$Internal$Svg$label(
		$avh4$elm_color$Color$toCssString(color));
};
var $author$project$Internal$Svg$Transfrom = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$LineChart$Coordinate$scaleSvgY = F2(
	function (system, value) {
		return (value * $author$project$Internal$Coordinate$lengthY(system)) / $author$project$Internal$Coordinate$reachY(system);
	});
var $author$project$LineChart$Coordinate$toSvgY = F2(
	function (system, value) {
		return A2($author$project$LineChart$Coordinate$scaleSvgY, system, system.w.bN - value) + system.bJ.bM.hG;
	});
var $author$project$Internal$Svg$move = F3(
	function (system, x, y) {
		return A2(
			$author$project$Internal$Svg$Transfrom,
			A2($author$project$LineChart$Coordinate$toSvgX, system, x),
			A2($author$project$LineChart$Coordinate$toSvgY, system, y));
	});
var $author$project$LineChart$Junk$move = $author$project$Internal$Svg$move;
var $author$project$Internal$Svg$offset = F2(
	function (x, y) {
		return A2($author$project$Internal$Svg$Transfrom, x, y);
	});
var $author$project$LineChart$Junk$offset = $author$project$Internal$Svg$offset;
var $author$project$Internal$Svg$addPosition = F2(
	function (_v0, _v1) {
		var x = _v0.a;
		var y = _v0.b;
		var xf = _v1.a;
		var yf = _v1.b;
		return A2($author$project$Internal$Svg$Transfrom, xf + x, yf + y);
	});
var $author$project$Internal$Svg$toPosition = A2(
	$elm$core$List$foldr,
	$author$project$Internal$Svg$addPosition,
	A2($author$project$Internal$Svg$Transfrom, 0, 0));
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $author$project$Internal$Svg$transform = function (translations) {
	var _v0 = $author$project$Internal$Svg$toPosition(translations);
	var x = _v0.a;
	var y = _v0.b;
	return $elm$svg$Svg$Attributes$transform(
		'translate(' + ($elm$core$String$fromFloat(x) + (', ' + ($elm$core$String$fromFloat(y) + ')'))));
};
var $author$project$LineChart$Junk$transform = $author$project$Internal$Svg$transform;
var $author$project$LineChart$Junk$labelAt = F8(
	function (system, x, y, xo, yo, anchor, color, text) {
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$author$project$LineChart$Junk$transform(
					_List_fromArray(
						[
							A3($author$project$LineChart$Junk$move, system, x, y),
							A2($author$project$LineChart$Junk$offset, xo, yo)
						])),
					$elm$svg$Svg$Attributes$style('text-anchor: ' + (anchor + ';'))
				]),
			_List_fromArray(
				[
					A2($author$project$LineChart$Junk$label, color, text)
				]));
	});
var $author$project$Internal$Interpolation$Linear = 0;
var $author$project$LineChart$Interpolation$linear = 0;
var $author$project$Internal$Axis$Config = $elm$core$Basics$identity;
var $author$project$Internal$Axis$custom = $elm$core$Basics$identity;
var $author$project$Internal$Axis$Ticks$Config = $elm$core$Basics$identity;
var $author$project$Internal$Axis$Ticks$custom = $elm$core$Basics$identity;
var $author$project$Internal$Axis$Title$Config = $elm$core$Basics$identity;
var $author$project$Internal$Axis$Title$custom = F4(
	function (position, x, y, title) {
		return {
			eO: _Utils_Tuple2(x, y),
			b$: position,
			fA: title
		};
	});
var $author$project$Internal$Axis$Title$atPosition = F3(
	function (position, x, y) {
		return A2(
			$elm$core$Basics$composeL,
			A3($author$project$Internal$Axis$Title$custom, position, x, y),
			$author$project$Internal$Svg$label('inherit'));
	});
var $author$project$Internal$Axis$Title$atAxisMax = function () {
	var position = F2(
		function (data, range) {
			return range.bN;
		});
	return $author$project$Internal$Axis$Title$atPosition(position);
}();
var $author$project$Internal$Axis$Title$default = A2($author$project$Internal$Axis$Title$atAxisMax, 0, 0);
var $author$project$Internal$Axis$Line$Config = $elm$core$Basics$identity;
var $author$project$Internal$Axis$Line$custom = $elm$core$Basics$identity;
var $avh4$elm_color$Color$rgba = F4(
	function (r, g, b, a) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, a);
	});
var $author$project$LineChart$Colors$transparent = A4($avh4$elm_color$Color$rgba, 0, 0, 0, 0);
var $author$project$Internal$Axis$Line$none = $author$project$Internal$Axis$Line$custom(
	F2(
		function (_v0, _v1) {
			var min = _v1.bW;
			var max = _v1.bN;
			return {ci: $author$project$LineChart$Colors$transparent, d8: max, gn: _List_Nil, fh: min, fF: 0};
		}));
var $author$project$Internal$Axis$Range$Padded = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Internal$Axis$Range$padded = $author$project$Internal$Axis$Range$Padded;
var $author$project$Internal$Axis$none = F2(
	function (pixels_, variable_) {
		return $author$project$Internal$Axis$custom(
			{
				F: $author$project$Internal$Axis$Line$none,
				ag: pixels_,
				ai: A2($author$project$Internal$Axis$Range$padded, 20, 20),
				l: $author$project$Internal$Axis$Ticks$custom(
					F2(
						function (_v0, _v1) {
							return _List_Nil;
						})),
				hz: $author$project$Internal$Axis$Title$default(''),
				al: A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, variable_)
			});
	});
var $author$project$LineChart$Axis$none = $author$project$Internal$Axis$none;
var $author$project$Internal$Legends$None = {$: 0};
var $author$project$Internal$Legends$none = $author$project$Internal$Legends$None;
var $author$project$LineChart$Legends$none = $author$project$Internal$Legends$none;
var $author$project$Internal$Path$Line = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Path$Move = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Utils$concat = F3(
	function (first, second, third) {
		return _Utils_ap(
			first,
			_Utils_ap(second, third));
	});
var $author$project$LineChart$Colors$gray = A3($avh4$elm_color$Color$rgb255, 163, 163, 163);
var $author$project$Internal$Path$join = function (commands) {
	return A2($elm$core$String$join, ' ', commands);
};
var $author$project$Internal$Path$bool = function (bool_) {
	return bool_ ? '1' : '0';
};
var $author$project$Internal$Path$point = function (point_) {
	return $elm$core$String$fromFloat(point_.v) + (' ' + $elm$core$String$fromFloat(point_.w));
};
var $author$project$Internal$Path$points = function (points_) {
	return A2(
		$elm$core$String$join,
		',',
		A2($elm$core$List$map, $author$project$Internal$Path$point, points_));
};
var $author$project$Internal$Path$toString = function (command) {
	switch (command.$) {
		case 9:
			return 'Z';
		case 0:
			var p = command.a;
			return 'M' + $author$project$Internal$Path$point(p);
		case 1:
			var p = command.a;
			return 'L' + $author$project$Internal$Path$point(p);
		case 2:
			var x = command.a;
			return 'H' + $elm$core$String$fromFloat(x);
		case 3:
			var y = command.a;
			return 'V' + $elm$core$String$fromFloat(y);
		case 4:
			var c1 = command.a;
			var c2 = command.b;
			var p = command.c;
			return 'C' + $author$project$Internal$Path$points(
				_List_fromArray(
					[c1, c2, p]));
		case 5:
			var c1 = command.a;
			var p = command.b;
			return 'Q' + $author$project$Internal$Path$points(
				_List_fromArray(
					[c1, p]));
		case 6:
			var c1 = command.a;
			var p = command.b;
			return 'Q' + $author$project$Internal$Path$points(
				_List_fromArray(
					[c1, p]));
		case 7:
			var p = command.a;
			return 'T' + $author$project$Internal$Path$point(p);
		default:
			var rx = command.a;
			var ry = command.b;
			var xAxisRotation = command.c;
			var largeArcFlag = command.d;
			var sweepFlag = command.e;
			var p = command.f;
			return 'A' + $author$project$Internal$Path$join(
				_List_fromArray(
					[
						$elm$core$String$fromFloat(rx),
						$elm$core$String$fromFloat(ry),
						$elm$core$String$fromInt(xAxisRotation),
						$author$project$Internal$Path$bool(largeArcFlag),
						$author$project$Internal$Path$bool(sweepFlag),
						$author$project$Internal$Path$point(p)
					]));
	}
};
var $author$project$Internal$Path$Arc = F6(
	function (a, b, c, d, e, f) {
		return {$: 8, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $author$project$Internal$Path$Close = {$: 9};
var $author$project$Internal$Path$CubicBeziers = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Internal$Path$CubicBeziersShort = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Internal$Path$Horizontal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$Path$QuadraticBeziers = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Internal$Path$QuadraticBeziersShort = function (a) {
	return {$: 7, a: a};
};
var $author$project$Internal$Path$Vertical = function (a) {
	return {$: 3, a: a};
};
var $author$project$LineChart$Coordinate$toSvg = F2(
	function (system, point) {
		return {
			v: A2($author$project$LineChart$Coordinate$toSvgX, system, point.v),
			w: A2($author$project$LineChart$Coordinate$toSvgY, system, point.w)
		};
	});
var $author$project$Internal$Path$translate = F2(
	function (system, command) {
		switch (command.$) {
			case 0:
				var p = command.a;
				return $author$project$Internal$Path$Move(
					A2($author$project$LineChart$Coordinate$toSvg, system, p));
			case 1:
				var p = command.a;
				return $author$project$Internal$Path$Line(
					A2($author$project$LineChart$Coordinate$toSvg, system, p));
			case 2:
				var x = command.a;
				return $author$project$Internal$Path$Horizontal(
					A2($author$project$LineChart$Coordinate$toSvgX, system, x));
			case 3:
				var y = command.a;
				return $author$project$Internal$Path$Vertical(
					A2($author$project$LineChart$Coordinate$toSvgY, system, y));
			case 4:
				var c1 = command.a;
				var c2 = command.b;
				var p = command.c;
				return A3(
					$author$project$Internal$Path$CubicBeziers,
					A2($author$project$LineChart$Coordinate$toSvg, system, c1),
					A2($author$project$LineChart$Coordinate$toSvg, system, c2),
					A2($author$project$LineChart$Coordinate$toSvg, system, p));
			case 5:
				var c1 = command.a;
				var p = command.b;
				return A2(
					$author$project$Internal$Path$CubicBeziersShort,
					A2($author$project$LineChart$Coordinate$toSvg, system, c1),
					A2($author$project$LineChart$Coordinate$toSvg, system, p));
			case 6:
				var c1 = command.a;
				var p = command.b;
				return A2(
					$author$project$Internal$Path$QuadraticBeziers,
					A2($author$project$LineChart$Coordinate$toSvg, system, c1),
					A2($author$project$LineChart$Coordinate$toSvg, system, p));
			case 7:
				var p = command.a;
				return $author$project$Internal$Path$QuadraticBeziersShort(
					A2($author$project$LineChart$Coordinate$toSvg, system, p));
			case 8:
				var rx = command.a;
				var ry = command.b;
				var xAxisRotation = command.c;
				var largeArcFlag = command.d;
				var sweepFlag = command.e;
				var p = command.f;
				return A6(
					$author$project$Internal$Path$Arc,
					rx,
					ry,
					xAxisRotation,
					largeArcFlag,
					sweepFlag,
					A2($author$project$LineChart$Coordinate$toSvg, system, p));
			default:
				return $author$project$Internal$Path$Close;
		}
	});
var $author$project$Internal$Path$description = F2(
	function (system, commands) {
		return $author$project$Internal$Path$join(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Internal$Path$translate(system),
					$author$project$Internal$Path$toString),
				commands));
	});
var $author$project$Internal$Path$viewPath = function (attributes) {
	return A2($elm$svg$Svg$path, attributes, _List_Nil);
};
var $author$project$Internal$Path$view = F3(
	function (system, attributes, commands) {
		return $author$project$Internal$Path$viewPath(
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d(
						A2($author$project$Internal$Path$description, system, commands))
					])));
	});
var $author$project$Internal$Svg$vertical = F5(
	function (system, userAttributes, x, y1, y2) {
		var attributes = A3(
			$author$project$Internal$Utils$concat,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke(
					$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$gray)),
					$elm$svg$Svg$Attributes$style('pointer-events: none;')
				]),
			userAttributes,
			_List_Nil);
		return A3(
			$author$project$Internal$Path$view,
			system,
			attributes,
			_List_fromArray(
				[
					$author$project$Internal$Path$Move(
					{v: x, w: y1}),
					$author$project$Internal$Path$Line(
					{v: x, w: y1}),
					$author$project$Internal$Path$Line(
					{v: x, w: y2})
				]));
	});
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $author$project$Internal$Utils$toChartAreaId = function (id) {
	return 'chart__chart-area--' + id;
};
var $author$project$Internal$Svg$withinChartArea = function (_v0) {
	var id = _v0.el;
	return $elm$svg$Svg$Attributes$clipPath(
		'url(#' + ($author$project$Internal$Utils$toChartAreaId(id) + ')'));
};
var $author$project$LineChart$Junk$withinChartArea = $author$project$Internal$Svg$withinChartArea;
var $author$project$LineChart$Junk$verticalWithTopMargin = F4(
	function (system, attributes, x, topMarginPercent) {
		var yCalculatedMax = system.w.bN - ((system.w.bN - system.w.bW) * topMarginPercent);
		return A5(
			$author$project$Internal$Svg$vertical,
			system,
			A2(
				$elm$core$List$cons,
				$author$project$LineChart$Junk$withinChartArea(system),
				attributes),
			x,
			system.w.bW,
			yCalculatedMax);
	});
var $author$project$Internal$Line$Config = $elm$core$Basics$identity;
var $author$project$Internal$Line$Style = $elm$core$Basics$identity;
var $author$project$Internal$Line$style = F2(
	function (width, color_) {
		return {ci: color_, fF: width};
	});
var $author$project$Internal$Line$wider = function (width) {
	return function (_v0) {
		return A2($author$project$Internal$Line$style, width, $elm$core$Basics$identity);
	};
};
var $author$project$LineChart$Line$wider = $author$project$Internal$Line$wider;
var $author$project$LandingSite$CTokens$chartConfig = function (model) {
	return {
		dP: $author$project$LineChart$Area$default,
		f7: $author$project$LandingSite$CTokens$containerConfig,
		gh: $author$project$LandingSite$CTokens$customDotsConfig(model.az),
		gn: $author$project$LineChart$Events$hoverMany(
			A2($elm$core$Basics$composeL, $author$project$LandingSite$CTokens$ForSelf, $author$project$LandingSite$CTokens$GraphPointHover)),
		Z: A2($author$project$LineChart$Grid$dots, 1, $author$project$LineChart$Colors$transparent),
		eq: $author$project$LineChart$Interpolation$linear,
		aa: $author$project$LineChart$Axis$Intersection$default,
		gK: function () {
			var _v0 = model.az;
			if (_v0.$ === 1) {
				return $author$project$LineChart$Junk$default;
			} else {
				var actualHoverPointXValue = _v0.a;
				return $author$project$LineChart$Junk$custom(
					function (system) {
						var yMax = system.dI.bN;
						var xTimeString = A2(
							$justinmimbs$date$Date$format,
							'MMMM d, y',
							A2(
								$justinmimbs$date$Date$fromPosix,
								$elm$time$Time$utc,
								$elm$time$Time$millisToPosix(
									$elm$core$Basics$round(actualHoverPointXValue) * 1000)));
						var xTimeStringPixelHalfLength = $elm$core$String$length(xTimeString) * 3.8;
						var xRangeLength = system.dH.bN - system.dH.bW;
						var xHoverOriginDeltaPercent = (actualHoverPointXValue - system.dH.bW) / xRangeLength;
						var xHoverMaxDeltaPercent = (system.dH.bN - actualHoverPointXValue) / xRangeLength;
						var xOffset = (xHoverOriginDeltaPercent < 0.2) ? (((0.2 - xHoverOriginDeltaPercent) / 0.2) * xTimeStringPixelHalfLength) : ((xHoverMaxDeltaPercent < 0.2) ? ((-((0.2 - xHoverMaxDeltaPercent) / 0.2)) * xTimeStringPixelHalfLength) : 0);
						return {
							cc: _List_fromArray(
								[
									A8($author$project$LineChart$Junk$labelAt, system, actualHoverPointXValue, yMax, xOffset, -20, 'middle', $author$project$LineChart$Colors$label, xTimeString),
									A4($author$project$LineChart$Junk$verticalWithTopMargin, system, _List_Nil, actualHoverPointXValue, 0.015)
								]),
							aS: _List_Nil,
							gz: _List_Nil
						};
					});
			}
		}(),
		ex: $author$project$LineChart$Legends$none,
		a5: $author$project$LineChart$Line$wider(3),
		v: A2(
			$author$project$LineChart$Axis$none,
			1093,
			function ($) {
				return $.fV;
			}),
		w: A2(
			$author$project$LineChart$Axis$none,
			152,
			function ($) {
				return $.e0;
			})
	};
};
var $author$project$Internal$Dots$Circle = 1;
var $author$project$LineChart$Dots$circle = 1;
var $author$project$Internal$Line$Series = $elm$core$Basics$identity;
var $author$project$Internal$Line$SeriesConfig = F5(
	function (color, shape, dashing, label, data) {
		return {ci: color, d1: dashing, gc: data, ev: label, fe: shape};
	});
var $author$project$Internal$Line$line = F4(
	function (color_, shape_, label_, data_) {
		return A5($author$project$Internal$Line$SeriesConfig, color_, shape_, _List_Nil, label_, data_);
	});
var $author$project$LineChart$line = $author$project$Internal$Line$line;
var $author$project$LineChart$Colors$supply = A3($avh4$elm_color$Color$rgb255, 0, 211, 149);
var $author$project$Internal$Junk$addBelow = F2(
	function (below, layers) {
		return _Utils_update(
			layers,
			{
				aS: _Utils_ap(below, layers.aS)
			});
	});
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $author$project$LineChart$chartAreaAttributes = function (system) {
	return _List_fromArray(
		[
			$elm$svg$Svg$Attributes$x(
			$elm$core$String$fromFloat(system.bJ.bM.gL)),
			$elm$svg$Svg$Attributes$y(
			$elm$core$String$fromFloat(system.bJ.bM.hG)),
			$elm$svg$Svg$Attributes$width(
			$elm$core$String$fromFloat(
				$author$project$Internal$Coordinate$lengthX(system))),
			$elm$svg$Svg$Attributes$height(
			$elm$core$String$fromFloat(
				$author$project$Internal$Coordinate$lengthY(system)))
		]);
};
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $author$project$Internal$Events$toChartAttributes = F3(
	function (data, system, _v0) {
		var events = _v0;
		var order = function (_v1) {
			var outside = _v1.a;
			var event = _v1.b;
			return outside ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(event, data, system));
		};
		return A2($elm$core$List$filterMap, order, events);
	});
var $author$project$LineChart$chartAreaPlatform = F3(
	function (config, data, system) {
		var attributes = $elm$core$List$concat(
			_List_fromArray(
				[
					_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill('transparent')
					]),
					$author$project$LineChart$chartAreaAttributes(system),
					A3($author$project$Internal$Events$toChartAttributes, data, system, config.gn)
				]));
		return A2($elm$svg$Svg$rect, attributes, _List_Nil);
	});
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $author$project$LineChart$clipPath = function (system) {
	return A2(
		$elm$svg$Svg$clipPath,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$id(
				$author$project$Internal$Utils$toChartAreaId(system.el))
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$rect,
				$author$project$LineChart$chartAreaAttributes(system),
				_List_Nil)
			]));
};
var $author$project$Internal$Line$color = F3(
	function (_v0, _v1, data_) {
		var config = _v0;
		var line_ = _v1;
		var _v2 = config(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.hV;
				},
				data_));
		var style_ = _v2;
		return style_.ci(line_.ci);
	});
var $author$project$Internal$Container$properties = F2(
	function (f, _v0) {
		var properties_ = _v0;
		return f(properties_);
	});
var $author$project$Internal$Container$sizeStyles = F3(
	function (_v0, width, height) {
		var properties_ = _v0;
		var _v1 = properties_.ak;
		if (!_v1) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$Attributes$style,
					'height',
					$elm$core$String$fromFloat(height) + 'px'),
					A2(
					$elm$html$Html$Attributes$style,
					'width',
					$elm$core$String$fromFloat(width) + 'px')
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$LineChart$container = F4(
	function (config, _v0, junkHtml, plot) {
		var frame = _v0.bJ;
		var userAttributes = A2(
			$author$project$Internal$Container$properties,
			function ($) {
				return $.bu;
			},
			config.f7);
		var sizeStyles = A3($author$project$Internal$Container$sizeStyles, config.f7, frame.ak.fF, frame.ak.eh);
		var styles = A2(
			$elm$core$List$cons,
			A2($elm$html$Html$Attributes$style, 'position', 'relative'),
			sizeStyles);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(styles, userAttributes),
			A2($elm$core$List$cons, plot, junkHtml));
	});
var $author$project$Internal$Line$data = function (_v0) {
	var config = _v0;
	return config.gc;
};
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $author$project$Internal$Junk$getLayers = F5(
	function (series, toX, toY, system, _v0) {
		var toLayers = _v0;
		return A4(toLayers, series, toX, toY, system);
	});
var $author$project$Internal$Line$label = function (_v0) {
	var config = _v0;
	return config.ev;
};
var $author$project$Internal$Events$toContainerAttributes = F3(
	function (data, system, _v0) {
		var events = _v0;
		var order = function (_v1) {
			var outside = _v1.a;
			var event = _v1.b;
			return outside ? $elm$core$Maybe$Just(
				A2(event, data, system)) : $elm$core$Maybe$Nothing;
		};
		return A2($elm$core$List$filterMap, order, events);
	});
var $author$project$Internal$Data$Data = F3(
	function (user, point, isReal) {
		return {gI: isReal, g5: point, hV: user};
	});
var $author$project$LineChart$setY = F2(
	function (datum, y) {
		return A3(
			$author$project$Internal$Data$Data,
			datum.hV,
			A2($author$project$Internal$Data$Point, datum.g5.v, y),
			datum.gI);
	});
var $author$project$LineChart$normalize = function (datasets) {
	if (datasets.b) {
		var highest = datasets.a;
		var belows = datasets.b;
		var toPercentage = F2(
			function (highest_, datum) {
				return A2($author$project$LineChart$setY, datum, (100 * datum.g5.w) / highest_.g5.w);
			});
		return A2(
			$elm$core$List$map,
			A2($elm$core$List$map2, toPercentage, highest),
			A2($elm$core$List$cons, highest, belows));
	} else {
		return datasets;
	}
};
var $author$project$Internal$Utils$withFirst = F2(
	function (stuff, process) {
		if (stuff.b) {
			var first = stuff.a;
			var rest = stuff.b;
			return $elm$core$Maybe$Just(
				A2(process, first, rest));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$LineChart$addBelows = F2(
	function (alldata, dataBelowAll) {
		var add = F2(
			function (below, datum) {
				return A2($author$project$LineChart$setY, below, below.g5.w + datum.g5.w);
			});
		var iterate = F4(
			function (datum0, dataTop, dataBelowTop, result) {
				iterate:
				while (true) {
					var _v0 = _Utils_Tuple2(dataTop, dataBelowTop);
					if (_v0.a.b) {
						if (_v0.b.b) {
							var _v1 = _v0.a;
							var datum1 = _v1.a;
							var data = _v1.b;
							var _v2 = _v0.b;
							var datumBelow = _v2.a;
							var dataBelow = _v2.b;
							if (_Utils_cmp(datum1.g5.v, datumBelow.g5.v) > 0) {
								if (datumBelow.gI) {
									var $temp$datum0 = datum0,
										$temp$dataTop = A2($elm$core$List$cons, datum1, data),
										$temp$dataBelowTop = dataBelow,
										$temp$result = A2(
										$elm$core$List$cons,
										A2(add, datumBelow, datum0),
										result);
									datum0 = $temp$datum0;
									dataTop = $temp$dataTop;
									dataBelowTop = $temp$dataBelowTop;
									result = $temp$result;
									continue iterate;
								} else {
									var breakdata = _Utils_update(
										datum0,
										{gI: false});
									var $temp$datum0 = datum0,
										$temp$dataTop = A2($elm$core$List$cons, datum1, data),
										$temp$dataBelowTop = dataBelow,
										$temp$result = A2(
										$elm$core$List$cons,
										A2(add, datumBelow, datum0),
										result);
									datum0 = $temp$datum0;
									dataTop = $temp$dataTop;
									dataBelowTop = $temp$dataBelowTop;
									result = $temp$result;
									continue iterate;
								}
							} else {
								var $temp$datum0 = datum1,
									$temp$dataTop = data,
									$temp$dataBelowTop = A2($elm$core$List$cons, datumBelow, dataBelow),
									$temp$result = result;
								datum0 = $temp$datum0;
								dataTop = $temp$dataTop;
								dataBelowTop = $temp$dataBelowTop;
								result = $temp$result;
								continue iterate;
							}
						} else {
							var _v4 = _v0.a;
							var datum1 = _v4.a;
							var data = _v4.b;
							return result;
						}
					} else {
						if (_v0.b.b) {
							var _v3 = _v0.b;
							var datumBelow = _v3.a;
							var dataBelow = _v3.b;
							if (_Utils_cmp(datum0.g5.v, datumBelow.g5.v) < 1) {
								var $temp$datum0 = datum0,
									$temp$dataTop = _List_Nil,
									$temp$dataBelowTop = dataBelow,
									$temp$result = A2(
									$elm$core$List$cons,
									A2(add, datumBelow, datum0),
									result);
								datum0 = $temp$datum0;
								dataTop = $temp$dataTop;
								dataBelowTop = $temp$dataBelowTop;
								result = $temp$result;
								continue iterate;
							} else {
								var $temp$datum0 = datum0,
									$temp$dataTop = _List_Nil,
									$temp$dataBelowTop = dataBelow,
									$temp$result = A2($elm$core$List$cons, datumBelow, result);
								datum0 = $temp$datum0;
								dataTop = $temp$dataTop;
								dataBelowTop = $temp$dataBelowTop;
								result = $temp$result;
								continue iterate;
							}
						} else {
							return result;
						}
					}
				}
			});
		return $elm$core$List$reverse(
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$author$project$Internal$Utils$withFirst,
					alldata,
					F2(
						function (first, rest) {
							return A4(iterate, first, rest, dataBelowAll, _List_Nil);
						}))));
	});
var $author$project$LineChart$stack = function (dataset) {
	var stackBelows = F2(
		function (dataset_, result) {
			if (dataset_.b) {
				var data = dataset_.a;
				var belows = dataset_.b;
				return A2(
					stackBelows,
					belows,
					A2(
						$elm$core$List$cons,
						A3($elm$core$List$foldl, $author$project$LineChart$addBelows, data, belows),
						result));
			} else {
				return result;
			}
		});
	return $elm$core$List$reverse(
		A2(stackBelows, dataset, _List_Nil));
};
var $author$project$Internal$Axis$variable = function (_v0) {
	var config = _v0;
	return config.al;
};
var $author$project$LineChart$toDataPoints = F2(
	function (config, lines) {
		var y = $author$project$Internal$Axis$variable(config.w);
		var x = $author$project$Internal$Axis$variable(config.v);
		var addPoint = function (datum) {
			var _v1 = _Utils_Tuple2(
				x(datum),
				y(datum));
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var x_ = _v1.a.a;
					var y_ = _v1.b.a;
					return $elm$core$Maybe$Just(
						A3(
							$author$project$Internal$Data$Data,
							datum,
							A2($author$project$Internal$Data$Point, x_, y_),
							true));
				} else {
					var x_ = _v1.a.a;
					var _v2 = _v1.b;
					return $elm$core$Maybe$Just(
						A3(
							$author$project$Internal$Data$Data,
							datum,
							A2($author$project$Internal$Data$Point, x_, 0),
							false));
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					var y_ = _v1.b.a;
					return $elm$core$Maybe$Nothing;
				} else {
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return $elm$core$Maybe$Nothing;
				}
			}
		};
		var data = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Internal$Line$data,
				$elm$core$List$filterMap(addPoint)),
			lines);
		var _v0 = config.dP;
		switch (_v0.$) {
			case 0:
				return data;
			case 1:
				return data;
			case 2:
				return $author$project$LineChart$stack(data);
			default:
				return $author$project$LineChart$normalize(
					$author$project$LineChart$stack(data));
		}
	});
var $author$project$Internal$Coordinate$Frame = F2(
	function (margin, size) {
		return {bM: margin, ak: size};
	});
var $author$project$Internal$Coordinate$Size = F2(
	function (width, height) {
		return {eh: height, fF: width};
	});
var $author$project$LineChart$Coordinate$Range = F2(
	function (min, max) {
		return {bN: max, bW: min};
	});
var $author$project$Internal$Axis$Range$applyX = F2(
	function (range, system) {
		switch (range.$) {
			case 0:
				var padMin = range.a;
				var padMax = range.b;
				var _v1 = system;
				var frame = _v1.bJ;
				var _v2 = frame;
				var size = _v2.ak;
				var system_ = _Utils_update(
					system,
					{
						bJ: _Utils_update(
							frame,
							{
								ak: _Utils_update(
									size,
									{
										fF: A2($elm$core$Basics$max, 1, (size.fF - padMin) - padMax)
									})
							})
					});
				var scale = $author$project$LineChart$Coordinate$scaleDataX(system_);
				return A2(
					$author$project$LineChart$Coordinate$Range,
					system.v.bW - scale(padMin),
					system.v.bN + scale(padMax));
			case 1:
				var min = range.a;
				var max = range.b;
				return A2($author$project$LineChart$Coordinate$Range, min, max);
			default:
				var toRange = range.a;
				return toRange(system.v);
		}
	});
var $author$project$Internal$Axis$Range$applyY = F2(
	function (range, system) {
		switch (range.$) {
			case 0:
				var padMin = range.a;
				var padMax = range.b;
				var _v1 = system;
				var frame = _v1.bJ;
				var _v2 = frame;
				var size = _v2.ak;
				var system_ = _Utils_update(
					system,
					{
						bJ: _Utils_update(
							frame,
							{
								ak: _Utils_update(
									size,
									{
										eh: A2($elm$core$Basics$max, 1, (size.eh - padMin) - padMax)
									})
							})
					});
				var scale = $author$project$LineChart$Coordinate$scaleDataY(system_);
				return A2(
					$author$project$LineChart$Coordinate$Range,
					system.w.bW - scale(padMin),
					system.w.bN + scale(padMax));
			case 1:
				var min = range.a;
				var max = range.b;
				return A2($author$project$LineChart$Coordinate$Range, min, max);
			default:
				var toRange = range.a;
				return toRange(system.w);
		}
	});
var $author$project$Internal$Coordinate$ground = function (range_) {
	return _Utils_update(
		range_,
		{
			bW: A2($elm$core$Basics$min, range_.bW, 0)
		});
};
var $author$project$Internal$Area$hasArea = function (config) {
	switch (config.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		default:
			return true;
	}
};
var $author$project$Internal$Axis$pixels = function (_v0) {
	var config = _v0;
	return config.ag;
};
var $author$project$Internal$Axis$range = function (_v0) {
	var config = _v0;
	return config.ai;
};
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Internal$Coordinate$maximum = function (toValue) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(toValue),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$maximum,
			$elm$core$Maybe$withDefault(1)));
};
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Internal$Coordinate$minimum = function (toValue) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(toValue),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$minimum,
			$elm$core$Maybe$withDefault(0)));
};
var $author$project$Internal$Coordinate$range = F2(
	function (toValue, data) {
		var range_ = {
			bN: A2($author$project$Internal$Coordinate$maximum, toValue, data),
			bW: A2($author$project$Internal$Coordinate$minimum, toValue, data)
		};
		return _Utils_eq(range_.bW, range_.bN) ? _Utils_update(
			range_,
			{bN: range_.bN + 1}) : range_;
	});
var $author$project$LineChart$toSystem = F2(
	function (config, data) {
		var yRange = A2(
			$author$project$Internal$Coordinate$range,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.g5;
				},
				function ($) {
					return $.w;
				}),
			data);
		var xRange = A2(
			$author$project$Internal$Coordinate$range,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.g5;
				},
				function ($) {
					return $.v;
				}),
			data);
		var size = A2(
			$author$project$Internal$Coordinate$Size,
			$author$project$Internal$Axis$pixels(config.v),
			$author$project$Internal$Axis$pixels(config.w));
		var hasArea = $author$project$Internal$Area$hasArea(config.dP);
		var container_ = A2($author$project$Internal$Container$properties, $elm$core$Basics$identity, config.f7);
		var frame = A2($author$project$Internal$Coordinate$Frame, container_.bM, size);
		var adjustDomainRange = function (domain) {
			return hasArea ? $author$project$Internal$Coordinate$ground(domain) : domain;
		};
		var system = {
			bJ: frame,
			el: container_.el,
			v: xRange,
			dH: xRange,
			w: adjustDomainRange(yRange),
			dI: yRange
		};
		return _Utils_update(
			system,
			{
				v: A2(
					$author$project$Internal$Axis$Range$applyX,
					$author$project$Internal$Axis$range(config.v),
					system),
				w: A2(
					$author$project$Internal$Axis$Range$applyY,
					$author$project$Internal$Axis$range(config.w),
					system)
			});
	});
var $author$project$Internal$Axis$ticks = function (_v0) {
	var config = _v0;
	return config.l;
};
var $author$project$Internal$Axis$Tick$properties = function (_v0) {
	var properties_ = _v0;
	return properties_;
};
var $author$project$Internal$Axis$Ticks$ticks = F3(
	function (dataRange, range, _v0) {
		var values = _v0;
		return A2(
			$elm$core$List$map,
			$author$project$Internal$Axis$Tick$properties,
			A2(values, dataRange, range));
	});
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $author$project$Internal$Svg$gridDot = F3(
	function (radius, color, point) {
		return A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx(
					$elm$core$String$fromFloat(point.v)),
					$elm$svg$Svg$Attributes$cy(
					$elm$core$String$fromFloat(point.w)),
					$elm$svg$Svg$Attributes$r(
					$elm$core$String$fromFloat(radius)),
					$elm$svg$Svg$Attributes$fill(
					$avh4$elm_color$Color$toCssString(color))
				]),
			_List_Nil);
	});
var $author$project$Internal$Grid$viewDots = F5(
	function (system, verticals, horizontals, radius, color) {
		var dot = F2(
			function (x, y) {
				return A2(
					$author$project$LineChart$Coordinate$toSvg,
					system,
					A2($author$project$LineChart$Coordinate$Point, x, y));
			});
		var dots_ = function (g) {
			return A2(
				$elm$core$List$map,
				dot(g),
				horizontals);
		};
		var alldots = A2($elm$core$List$concatMap, dots_, verticals);
		return A2(
			$elm$core$List$map,
			A2($author$project$Internal$Svg$gridDot, radius, color),
			alldots);
	});
var $author$project$Internal$Svg$horizontal = F5(
	function (system, userAttributes, y, x1, x2) {
		var attributes = A3(
			$author$project$Internal$Utils$concat,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke(
					$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$gray)),
					$elm$svg$Svg$Attributes$style('pointer-events: none;')
				]),
			userAttributes,
			_List_Nil);
		return A3(
			$author$project$Internal$Path$view,
			system,
			attributes,
			_List_fromArray(
				[
					$author$project$Internal$Path$Move(
					{v: x1, w: y}),
					$author$project$Internal$Path$Line(
					{v: x1, w: y}),
					$author$project$Internal$Path$Line(
					{v: x2, w: y})
				]));
	});
var $author$project$Internal$Svg$horizontalGrid = F3(
	function (system, userAttributes, y) {
		var attributes = A3(
			$author$project$Internal$Utils$concat,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke(
					$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$gray)),
					$elm$svg$Svg$Attributes$style('pointer-events: none;')
				]),
			userAttributes,
			_List_Nil);
		return A5($author$project$Internal$Svg$horizontal, system, attributes, y, system.v.bW, system.v.bN);
	});
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $author$project$Internal$Svg$verticalGrid = F3(
	function (system, userAttributes, x) {
		var attributes = A3(
			$author$project$Internal$Utils$concat,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke(
					$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$gray)),
					$elm$svg$Svg$Attributes$style('pointer-events: none;')
				]),
			userAttributes,
			_List_Nil);
		return A5($author$project$Internal$Svg$vertical, system, attributes, x, system.w.bW, system.w.bN);
	});
var $author$project$Internal$Grid$viewLines = F5(
	function (system, verticals, horizontals, width, color) {
		var attributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(width)),
				$elm$svg$Svg$Attributes$stroke(
				$avh4$elm_color$Color$toCssString(color))
			]);
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				A2($author$project$Internal$Svg$horizontalGrid, system, attributes),
				horizontals),
			A2(
				$elm$core$List$map,
				A2($author$project$Internal$Svg$verticalGrid, system, attributes),
				verticals));
	});
var $author$project$Internal$Grid$view = F4(
	function (system, xAxis, yAxis, grid) {
		var hasGrid = function (tick) {
			return tick.Z ? $elm$core$Maybe$Just(tick.b$) : $elm$core$Maybe$Nothing;
		};
		var horizontals = A2(
			$elm$core$List$filterMap,
			hasGrid,
			A3(
				$author$project$Internal$Axis$Ticks$ticks,
				system.dI,
				system.w,
				$author$project$Internal$Axis$ticks(yAxis)));
		var verticals = A2(
			$elm$core$List$filterMap,
			hasGrid,
			A3(
				$author$project$Internal$Axis$Ticks$ticks,
				system.dH,
				system.v,
				$author$project$Internal$Axis$ticks(xAxis)));
		if (!grid.$) {
			var radius = grid.a;
			var color = grid.b;
			return A5($author$project$Internal$Grid$viewDots, system, verticals, horizontals, radius, color);
		} else {
			var width = grid.a;
			var color = grid.b;
			return A5($author$project$Internal$Grid$viewLines, system, verticals, horizontals, width, color);
		}
	});
var $author$project$Internal$Svg$End = 2;
var $author$project$Internal$Svg$Start = 0;
var $author$project$Internal$Svg$anchorStyle = function (anchor) {
	var anchorString = function () {
		switch (anchor) {
			case 0:
				return 'start';
			case 1:
				return 'middle';
			default:
				return 'end';
		}
	}();
	return $elm$svg$Svg$Attributes$style('text-anchor: ' + (anchorString + ';'));
};
var $author$project$Internal$Utils$viewMaybe = F2(
	function (a, view) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$svg$Svg$text(''),
			A2($elm$core$Maybe$map, view, a));
	});
var $author$project$Internal$Legends$viewFree = F5(
	function (system, placement, viewLabel, line, data) {
		var _v0 = function () {
			if (!placement) {
				return _Utils_Tuple3(data, 2, -10);
			} else {
				return _Utils_Tuple3(
					$elm$core$List$reverse(data),
					0,
					10);
			}
		}();
		var orderedPoints = _v0.a;
		var anchor = _v0.b;
		var xOffset = _v0.c;
		var transform = function (_v3) {
			var x = _v3.v;
			var y = _v3.w;
			return $author$project$Internal$Svg$transform(
				_List_fromArray(
					[
						A3($author$project$Internal$Svg$move, system, x, y),
						A2($author$project$Internal$Svg$offset, xOffset, 3)
					]));
		};
		var viewLegend = function (_v2) {
			var point = _v2.g5;
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						transform(point),
						$author$project$Internal$Svg$anchorStyle(anchor)
					]),
				_List_fromArray(
					[
						viewLabel(
						$author$project$Internal$Line$label(line))
					]));
		};
		return A2(
			$author$project$Internal$Utils$viewMaybe,
			$elm$core$List$head(orderedPoints),
			viewLegend);
	});
var $author$project$Internal$Legends$viewFrees = F3(
	function (_v0, placement, view_) {
		var system = _v0.fn;
		var lines = _v0.cS;
		var data = _v0.gc;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__legends')
				]),
			A3(
				$elm$core$List$map2,
				A3($author$project$Internal$Legends$viewFree, system, placement, view_),
				lines,
				data));
	});
var $author$project$Internal$Line$shape = function (_v0) {
	var config = _v0;
	return config.fe;
};
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $elm$svg$Svg$Attributes$strokeOpacity = _VirtualDom_attribute('stroke-opacity');
var $author$project$Internal$Dots$varietyAttributes = F2(
	function (color, variety) {
		switch (variety.$) {
			case 0:
				var width = variety.a;
				return _List_fromArray(
					[
						$elm$svg$Svg$Attributes$stroke(
						$avh4$elm_color$Color$toCssString(color)),
						$elm$svg$Svg$Attributes$strokeWidth(
						$elm$core$String$fromInt(width)),
						$elm$svg$Svg$Attributes$fill('white')
					]);
			case 2:
				var width = variety.a;
				var opacity = variety.b;
				return _List_fromArray(
					[
						$elm$svg$Svg$Attributes$stroke(
						$avh4$elm_color$Color$toCssString(color)),
						$elm$svg$Svg$Attributes$strokeWidth(
						$elm$core$String$fromInt(width)),
						$elm$svg$Svg$Attributes$strokeOpacity(
						$elm$core$String$fromFloat(opacity)),
						$elm$svg$Svg$Attributes$fill(
						$avh4$elm_color$Color$toCssString(color))
					]);
			case 1:
				var width = variety.a;
				return _List_fromArray(
					[
						$elm$svg$Svg$Attributes$stroke('white'),
						$elm$svg$Svg$Attributes$strokeWidth(
						$elm$core$String$fromInt(width)),
						$elm$svg$Svg$Attributes$fill(
						$avh4$elm_color$Color$toCssString(color))
					]);
			default:
				return _List_fromArray(
					[
						$elm$svg$Svg$Attributes$fill(
						$avh4$elm_color$Color$toCssString(color))
					]);
		}
	});
var $author$project$Internal$Dots$viewCircle = F5(
	function (events, variety, color, area, point) {
		var radius = $elm$core$Basics$sqrt(area / $elm$core$Basics$pi);
		var attributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$cx(
				$elm$core$String$fromFloat(point.v)),
				$elm$svg$Svg$Attributes$cy(
				$elm$core$String$fromFloat(point.w)),
				$elm$svg$Svg$Attributes$r(
				$elm$core$String$fromFloat(radius))
			]);
		return A2(
			$elm$svg$Svg$circle,
			_Utils_ap(
				events,
				_Utils_ap(
					attributes,
					A2($author$project$Internal$Dots$varietyAttributes, color, variety))),
			_List_Nil);
	});
var $author$project$Internal$Dots$pathPlus = F2(
	function (area, point) {
		var side = $elm$core$Basics$sqrt(area / 5);
		var r6 = side / 2;
		var r3 = side;
		var commands = _List_fromArray(
			[
				'M' + ($elm$core$String$fromFloat(point.v - r6) + (' ' + $elm$core$String$fromFloat((point.w - r3) - r6))),
				'v' + $elm$core$String$fromFloat(r3),
				'h' + $elm$core$String$fromFloat(-r3),
				'v' + $elm$core$String$fromFloat(r3),
				'h' + $elm$core$String$fromFloat(r3),
				'v' + $elm$core$String$fromFloat(r3),
				'h' + $elm$core$String$fromFloat(r3),
				'v' + $elm$core$String$fromFloat(-r3),
				'h' + $elm$core$String$fromFloat(r3),
				'v' + $elm$core$String$fromFloat(-r3),
				'h' + $elm$core$String$fromFloat(-r3),
				'v' + $elm$core$String$fromFloat(-r3),
				'h' + $elm$core$String$fromFloat(-r3),
				'v' + $elm$core$String$fromFloat(r3)
			]);
		return A2($elm$core$String$join, ' ', commands);
	});
var $author$project$Internal$Dots$viewCross = F5(
	function (events, variety, color, area, point) {
		var rotation = 'rotate(45 ' + ($elm$core$String$fromFloat(point.v) + (' ' + ($elm$core$String$fromFloat(point.w) + ')')));
		var attributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$d(
				A2($author$project$Internal$Dots$pathPlus, area, point)),
				$elm$svg$Svg$Attributes$transform(rotation)
			]);
		return A2(
			$elm$svg$Svg$path,
			_Utils_ap(
				events,
				_Utils_ap(
					attributes,
					A2($author$project$Internal$Dots$varietyAttributes, color, variety))),
			_List_Nil);
	});
var $author$project$Internal$Dots$viewDiamond = F5(
	function (events, variety, color, area, point) {
		var side = $elm$core$Basics$sqrt(area);
		var rotation = 'rotate(45 ' + ($elm$core$String$fromFloat(point.v) + (' ' + ($elm$core$String$fromFloat(point.w) + ')')));
		var attributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$x(
				$elm$core$String$fromFloat(point.v - (side / 2))),
				$elm$svg$Svg$Attributes$y(
				$elm$core$String$fromFloat(point.w - (side / 2))),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(side)),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromFloat(side)),
				$elm$svg$Svg$Attributes$transform(rotation)
			]);
		return A2(
			$elm$svg$Svg$rect,
			_Utils_ap(
				events,
				_Utils_ap(
					attributes,
					A2($author$project$Internal$Dots$varietyAttributes, color, variety))),
			_List_Nil);
	});
var $author$project$Internal$Dots$viewPlus = F5(
	function (events, variety, color, area, point) {
		var attributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$d(
				A2($author$project$Internal$Dots$pathPlus, area, point))
			]);
		return A2(
			$elm$svg$Svg$path,
			_Utils_ap(
				events,
				_Utils_ap(
					attributes,
					A2($author$project$Internal$Dots$varietyAttributes, color, variety))),
			_List_Nil);
	});
var $author$project$Internal$Dots$viewSquare = F5(
	function (events, variety, color, area, point) {
		var side = $elm$core$Basics$sqrt(area);
		var attributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$x(
				$elm$core$String$fromFloat(point.v - (side / 2))),
				$elm$svg$Svg$Attributes$y(
				$elm$core$String$fromFloat(point.w - (side / 2))),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(side)),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromFloat(side))
			]);
		return A2(
			$elm$svg$Svg$rect,
			_Utils_ap(
				events,
				_Utils_ap(
					attributes,
					A2($author$project$Internal$Dots$varietyAttributes, color, variety))),
			_List_Nil);
	});
var $elm$core$Basics$degrees = function (angleInDegrees) {
	return (angleInDegrees * $elm$core$Basics$pi) / 180;
};
var $elm$core$Basics$tan = _Basics_tan;
var $author$project$Internal$Dots$pathTriangle = F2(
	function (area, point) {
		var side = $elm$core$Basics$sqrt(
			(area * 4) / $elm$core$Basics$sqrt(3));
		var height = ($elm$core$Basics$sqrt(3) * side) / 2;
		var fromMiddle = height - (($elm$core$Basics$tan(
			$elm$core$Basics$degrees(30)) * side) / 2);
		var commands = _List_fromArray(
			[
				'M' + ($elm$core$String$fromFloat(point.v) + (' ' + $elm$core$String$fromFloat(point.w - fromMiddle))),
				'l' + ($elm$core$String$fromFloat((-side) / 2) + (' ' + $elm$core$String$fromFloat(height))),
				'h' + $elm$core$String$fromFloat(side),
				'z'
			]);
		return A2($elm$core$String$join, ' ', commands);
	});
var $author$project$Internal$Dots$viewTriangle = F5(
	function (events, variety, color, area, point) {
		var attributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$d(
				A2($author$project$Internal$Dots$pathTriangle, area, point))
			]);
		return A2(
			$elm$svg$Svg$path,
			_Utils_ap(
				events,
				_Utils_ap(
					attributes,
					A2($author$project$Internal$Dots$varietyAttributes, color, variety))),
			_List_Nil);
	});
var $author$project$Internal$Dots$viewShape = F5(
	function (system, _v0, shape, color, point) {
		var radius = _v0.de;
		var variety = _v0.dD;
		var view_ = function () {
			switch (shape) {
				case 1:
					return $author$project$Internal$Dots$viewCircle;
				case 2:
					return $author$project$Internal$Dots$viewTriangle;
				case 3:
					return $author$project$Internal$Dots$viewSquare;
				case 4:
					return $author$project$Internal$Dots$viewDiamond;
				case 5:
					return $author$project$Internal$Dots$viewCross;
				case 6:
					return $author$project$Internal$Dots$viewPlus;
				default:
					return F5(
						function (_v2, _v3, _v4, _v5, _v6) {
							return $elm$svg$Svg$text('');
						});
			}
		}();
		var size = (2 * $elm$core$Basics$pi) * radius;
		var pointSvg = A2($author$project$LineChart$Coordinate$toSvg, system, point);
		return A5(view_, _List_Nil, variety, color, size, pointSvg);
	});
var $author$project$Internal$Dots$viewSample = F5(
	function (_v0, shape, color, system, data) {
		var config = _v0;
		var _v1 = config.cQ(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.hV;
				},
				data));
		var style_ = _v1;
		return A4($author$project$Internal$Dots$viewShape, system, style_, shape, color);
	});
var $elm$svg$Svg$Attributes$fillOpacity = _VirtualDom_attribute('fill-opacity');
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $author$project$Internal$Area$opacity = function (config) {
	switch (config.$) {
		case 0:
			return 0;
		case 1:
			var opacity_ = config.a;
			return opacity_;
		case 2:
			var opacity_ = config.a;
			return opacity_;
		default:
			var opacity_ = config.a;
			return opacity_;
	}
};
var $author$project$Internal$Line$toAreaAttributes = F3(
	function (_v0, _v1, area) {
		var serie = _v0;
		var style_ = _v1;
		return _List_fromArray(
			[
				$elm$svg$Svg$Attributes$class('chart__interpolation__area__fragment'),
				$elm$svg$Svg$Attributes$fill(
				$avh4$elm_color$Color$toCssString(
					style_.ci(serie.ci)))
			]);
	});
var $elm$svg$Svg$Attributes$strokeDasharray = _VirtualDom_attribute('stroke-dasharray');
var $author$project$Internal$Line$toSeriesAttributes = F2(
	function (_v0, _v1) {
		var serie = _v0;
		var style_ = _v1;
		return _List_fromArray(
			[
				$elm$svg$Svg$Attributes$style('pointer-events: none;'),
				$elm$svg$Svg$Attributes$class('chart__interpolation__line__fragment'),
				$elm$svg$Svg$Attributes$stroke(
				$avh4$elm_color$Color$toCssString(
					style_.ci(serie.ci))),
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(style_.fF)),
				$elm$svg$Svg$Attributes$strokeDasharray(
				A2(
					$elm$core$String$join,
					' ',
					A2($elm$core$List$map, $elm$core$String$fromFloat, serie.d1))),
				$elm$svg$Svg$Attributes$fill('transparent')
			]);
	});
var $author$project$Internal$Utils$viewIf = F2(
	function (condition, view) {
		return condition ? view(0) : $elm$svg$Svg$text('');
	});
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $author$project$Internal$Line$viewSample = F5(
	function (_v0, line_, area, data_, sampleWidth) {
		var look = _v0;
		var style_ = look(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.hV;
				},
				data_));
		var sizeAttributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$x1('0'),
				$elm$svg$Svg$Attributes$y1('0'),
				$elm$svg$Svg$Attributes$x2(
				$elm$core$String$fromFloat(sampleWidth)),
				$elm$svg$Svg$Attributes$y2('0')
			]);
		var rectangleAttributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$x('0'),
				$elm$svg$Svg$Attributes$y('0'),
				$elm$svg$Svg$Attributes$height('9'),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(sampleWidth))
			]);
		var lineAttributes = A2($author$project$Internal$Line$toSeriesAttributes, line_, style_);
		var areaAttributes = A2(
			$elm$core$List$cons,
			$elm$svg$Svg$Attributes$fillOpacity(
				$elm$core$String$fromFloat(
					$author$project$Internal$Area$opacity(area))),
			A3($author$project$Internal$Line$toAreaAttributes, line_, style_, area));
		var viewRectangle = function (_v1) {
			return A2(
				$elm$svg$Svg$rect,
				_Utils_ap(areaAttributes, rectangleAttributes),
				_List_Nil);
		};
		return A2(
			$elm$svg$Svg$g,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$line,
					_Utils_ap(lineAttributes, sizeAttributes),
					_List_Nil),
					A2(
					$author$project$Internal$Utils$viewIf,
					$author$project$Internal$Area$hasArea(area),
					viewRectangle)
				]));
	});
var $author$project$Internal$Legends$viewSample = F4(
	function (_v0, sampleWidth, line, data) {
		var system = _v0.fn;
		var lineConfig = _v0.ez;
		var dotsConfig = _v0.d7;
		var area = _v0.dP;
		var shape = $author$project$Internal$Line$shape(line);
		var dotPosition = A2(
			$author$project$LineChart$Coordinate$toData,
			system,
			A2($author$project$Internal$Data$Point, sampleWidth / 2, 0));
		var color = A3($author$project$Internal$Line$color, lineConfig, line, data);
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__sample')
				]),
			_List_fromArray(
				[
					A5($author$project$Internal$Line$viewSample, lineConfig, line, area, data, sampleWidth),
					A6($author$project$Internal$Dots$viewSample, dotsConfig, shape, color, system, data, dotPosition)
				]));
	});
var $author$project$Internal$Legends$viewGrouped = F3(
	function (_arguments, sampleWidth, container) {
		var toLegend = F2(
			function (line, data) {
				return {
					ev: $author$project$Internal$Line$label(line),
					di: A4($author$project$Internal$Legends$viewSample, _arguments, sampleWidth, line, data)
				};
			});
		var legends = A3($elm$core$List$map2, toLegend, _arguments.cS, _arguments.gc);
		return A2(container, _arguments.fn, legends);
	});
var $author$project$Internal$Legends$view = function (_arguments) {
	var _v0 = _arguments.ex;
	switch (_v0.$) {
		case 1:
			var placement = _v0.a;
			var view_ = _v0.b;
			return A3($author$project$Internal$Legends$viewFrees, _arguments, placement, view_);
		case 2:
			var sampleWidth = _v0.a;
			var container = _v0.b;
			return A3(
				$author$project$Internal$Legends$viewGrouped,
				_arguments,
				sampleWidth,
				container(_arguments));
		default:
			return $elm$svg$Svg$text('');
	}
};
var $author$project$Internal$Area$opacityContainer = function (config) {
	switch (config.$) {
		case 0:
			return 1;
		case 1:
			var opacity_ = config.a;
			return 1;
		case 2:
			var opacity_ = config.a;
			return opacity_;
		default:
			var opacity_ = config.a;
			return opacity_;
	}
};
var $author$project$Internal$Utils$unzip3 = function (pairs) {
	var step = F2(
		function (_v0, _v1) {
			var a = _v0.a;
			var b = _v0.b;
			var c = _v0.c;
			var aas = _v1.a;
			var bs = _v1.b;
			var cs = _v1.c;
			return _Utils_Tuple3(
				A2($elm$core$List$cons, a, aas),
				A2($elm$core$List$cons, b, bs),
				A2($elm$core$List$cons, c, cs));
		});
	return A3(
		$elm$core$List$foldr,
		step,
		_Utils_Tuple3(_List_Nil, _List_Nil, _List_Nil),
		pairs);
};
var $elm$core$List$map3 = _List_map3;
var $author$project$Internal$Line$viewNormal = function (_v0) {
	var areas = _v0.a;
	var lines = _v0.b;
	var dots = _v0.c;
	var view_ = F3(
		function (area_, line_, dots_) {
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('chart__line')
					]),
				_List_fromArray(
					[area_, line_, dots_]));
		});
	return A4($elm$core$List$map3, view_, areas, lines, dots);
};
var $author$project$Internal$Data$isWithinRange = F2(
	function (system, point) {
		return _Utils_eq(
			A3($elm$core$Basics$clamp, system.v.bW, system.v.bN, point.v),
			point.v) && _Utils_eq(
			A3($elm$core$Basics$clamp, system.w.bW, system.w.bN, point.w),
			point.w);
	});
var $author$project$Internal$Utils$part = F4(
	function (isReal, points, current, parts) {
		part:
		while (true) {
			if (points.b) {
				var first = points.a;
				var rest = points.b;
				if (isReal(first)) {
					var $temp$isReal = isReal,
						$temp$points = rest,
						$temp$current = _Utils_ap(
						current,
						_List_fromArray(
							[first])),
						$temp$parts = parts;
					isReal = $temp$isReal;
					points = $temp$points;
					current = $temp$current;
					parts = $temp$parts;
					continue part;
				} else {
					var $temp$isReal = isReal,
						$temp$points = rest,
						$temp$current = _List_Nil,
						$temp$parts = A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							current,
							$elm$core$Maybe$Just(first)),
						parts);
					isReal = $temp$isReal;
					points = $temp$points;
					current = $temp$current;
					parts = $temp$parts;
					continue part;
				}
			} else {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(current, $elm$core$Maybe$Nothing),
					parts);
			}
		}
	});
var $author$project$Internal$Interpolation$linear = $elm$core$List$map(
	$elm$core$List$map($author$project$Internal$Path$Line));
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Internal$Interpolation$First = {$: 0};
var $author$project$Internal$Interpolation$Previous = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Interpolation$monotoneCurve = F4(
	function (point0, point1, tangent0, tangent1) {
		var dx = (point1.v - point0.v) / 3;
		return A3(
			$author$project$Internal$Path$CubicBeziers,
			{v: point0.v + dx, w: point0.w + (dx * tangent0)},
			{v: point1.v - dx, w: point1.w - (dx * tangent1)},
			point1);
	});
var $author$project$Internal$Interpolation$slope2 = F3(
	function (point0, point1, t) {
		var h = point1.v - point0.v;
		return (!(!h)) ? ((((3 * (point1.w - point0.w)) / h) - t) / 2) : t;
	});
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $author$project$Internal$Interpolation$sign = function (x) {
	return (x < 0) ? (-1) : 1;
};
var $author$project$Internal$Interpolation$toH = F2(
	function (h0, h1) {
		return (!h0) ? ((h1 < 0) ? (0 * (-1)) : h1) : h0;
	});
var $author$project$Internal$Interpolation$slope3 = F3(
	function (point0, point1, point2) {
		var h1 = point2.v - point1.v;
		var h0 = point1.v - point0.v;
		var s0h = A2($author$project$Internal$Interpolation$toH, h0, h1);
		var s0 = (point1.w - point0.w) / s0h;
		var s1h = A2($author$project$Internal$Interpolation$toH, h1, h0);
		var s1 = (point2.w - point1.w) / s1h;
		var p = ((s0 * h1) + (s1 * h0)) / (h0 + h1);
		var slope = ($author$project$Internal$Interpolation$sign(s0) + $author$project$Internal$Interpolation$sign(s1)) * A2(
			$elm$core$Basics$min,
			A2(
				$elm$core$Basics$min,
				$elm$core$Basics$abs(s0),
				$elm$core$Basics$abs(s1)),
			0.5 * $elm$core$Basics$abs(p));
		return $elm$core$Basics$isNaN(slope) ? 0 : slope;
	});
var $author$project$Internal$Interpolation$monotonePart = F2(
	function (points, _v0) {
		var tangent = _v0.a;
		var commands = _v0.b;
		var _v1 = _Utils_Tuple2(tangent, points);
		_v1$4:
		while (true) {
			if (!_v1.a.$) {
				if (_v1.b.b && _v1.b.b.b) {
					if (_v1.b.b.b.b) {
						var _v2 = _v1.a;
						var _v3 = _v1.b;
						var p0 = _v3.a;
						var _v4 = _v3.b;
						var p1 = _v4.a;
						var _v5 = _v4.b;
						var p2 = _v5.a;
						var rest = _v5.b;
						var t1 = A3($author$project$Internal$Interpolation$slope3, p0, p1, p2);
						var t0 = A3($author$project$Internal$Interpolation$slope2, p0, p1, t1);
						return A2(
							$author$project$Internal$Interpolation$monotonePart,
							A2(
								$elm$core$List$cons,
								p1,
								A2($elm$core$List$cons, p2, rest)),
							_Utils_Tuple2(
								$author$project$Internal$Interpolation$Previous(t1),
								_Utils_ap(
									commands,
									_List_fromArray(
										[
											A4($author$project$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1)
										]))));
					} else {
						var _v9 = _v1.a;
						var _v10 = _v1.b;
						var p0 = _v10.a;
						var _v11 = _v10.b;
						var p1 = _v11.a;
						var t1 = A3($author$project$Internal$Interpolation$slope3, p0, p1, p1);
						return _Utils_Tuple2(
							$author$project$Internal$Interpolation$Previous(t1),
							_Utils_ap(
								commands,
								_List_fromArray(
									[
										A4($author$project$Internal$Interpolation$monotoneCurve, p0, p1, t1, t1),
										$author$project$Internal$Path$Line(p1)
									])));
					}
				} else {
					break _v1$4;
				}
			} else {
				if (_v1.b.b && _v1.b.b.b) {
					if (_v1.b.b.b.b) {
						var t0 = _v1.a.a;
						var _v6 = _v1.b;
						var p0 = _v6.a;
						var _v7 = _v6.b;
						var p1 = _v7.a;
						var _v8 = _v7.b;
						var p2 = _v8.a;
						var rest = _v8.b;
						var t1 = A3($author$project$Internal$Interpolation$slope3, p0, p1, p2);
						return A2(
							$author$project$Internal$Interpolation$monotonePart,
							A2(
								$elm$core$List$cons,
								p1,
								A2($elm$core$List$cons, p2, rest)),
							_Utils_Tuple2(
								$author$project$Internal$Interpolation$Previous(t1),
								_Utils_ap(
									commands,
									_List_fromArray(
										[
											A4($author$project$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1)
										]))));
					} else {
						var t0 = _v1.a.a;
						var _v12 = _v1.b;
						var p0 = _v12.a;
						var _v13 = _v12.b;
						var p1 = _v13.a;
						var t1 = A3($author$project$Internal$Interpolation$slope3, p0, p1, p1);
						return _Utils_Tuple2(
							$author$project$Internal$Interpolation$Previous(t1),
							_Utils_ap(
								commands,
								_List_fromArray(
									[
										A4($author$project$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1),
										$author$project$Internal$Path$Line(p1)
									])));
					}
				} else {
					break _v1$4;
				}
			}
		}
		return _Utils_Tuple2(tangent, commands);
	});
var $author$project$Internal$Interpolation$monotoneSection = F2(
	function (points, _v0) {
		var tangent = _v0.a;
		var acc = _v0.b;
		var _v1 = function () {
			if (points.b) {
				var p0 = points.a;
				var rest = points.b;
				return A2(
					$author$project$Internal$Interpolation$monotonePart,
					A2($elm$core$List$cons, p0, rest),
					_Utils_Tuple2(
						tangent,
						_List_fromArray(
							[
								$author$project$Internal$Path$Line(p0)
							])));
			} else {
				return _Utils_Tuple2(tangent, _List_Nil);
			}
		}();
		var t0 = _v1.a;
		var commands = _v1.b;
		return _Utils_Tuple2(
			t0,
			A2($elm$core$List$cons, commands, acc));
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Internal$Interpolation$monotone = function (sections) {
	return A3(
		$elm$core$List$foldr,
		$author$project$Internal$Interpolation$monotoneSection,
		_Utils_Tuple2($author$project$Internal$Interpolation$First, _List_Nil),
		sections).b;
};
var $author$project$Internal$Interpolation$after = F2(
	function (a, b) {
		return _List_fromArray(
			[
				a,
				A2($author$project$Internal$Data$Point, b.v, a.w),
				b
			]);
	});
var $author$project$Internal$Interpolation$stepped = function (sections) {
	var expand = F2(
		function (result, section) {
			expand:
			while (true) {
				if (section.a.b) {
					if (section.a.b.b) {
						var _v1 = section.a;
						var a = _v1.a;
						var _v2 = _v1.b;
						var b = _v2.a;
						var rest = _v2.b;
						var broken = section.b;
						var $temp$result = _Utils_ap(
							result,
							A2($author$project$Internal$Interpolation$after, a, b)),
							$temp$section = _Utils_Tuple2(
							A2($elm$core$List$cons, b, rest),
							broken);
						result = $temp$result;
						section = $temp$section;
						continue expand;
					} else {
						if (!section.b.$) {
							var _v3 = section.a;
							var last = _v3.a;
							var broken = section.b.a;
							return _Utils_ap(
								result,
								_List_fromArray(
									[
										A2($author$project$Internal$Data$Point, broken.v, last.w)
									]));
						} else {
							var _v4 = section.a;
							var last = _v4.a;
							var _v5 = section.b;
							return result;
						}
					}
				} else {
					return result;
				}
			}
		});
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			expand(_List_Nil),
			$elm$core$List$map($author$project$Internal$Path$Line)),
		sections);
};
var $author$project$Internal$Interpolation$toCommands = F2(
	function (interpolation, data) {
		var pointsSections = $elm$core$List$map(
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$mapFirst(
					$elm$core$List$map(
						function ($) {
							return $.g5;
						})),
				$elm$core$Tuple$mapSecond(
					$elm$core$Maybe$map(
						function ($) {
							return $.g5;
						}))));
		var points = $elm$core$List$map(
			A2(
				$elm$core$Basics$composeR,
				$elm$core$Tuple$first,
				$elm$core$List$map(
					function ($) {
						return $.g5;
					})));
		switch (interpolation) {
			case 0:
				return $author$project$Internal$Interpolation$linear(
					points(data));
			case 1:
				return $author$project$Internal$Interpolation$monotone(
					points(data));
			default:
				return $author$project$Internal$Interpolation$stepped(
					pointsSections(data));
		}
	});
var $author$project$Internal$Area$opacitySingle = function (config) {
	switch (config.$) {
		case 0:
			return 0;
		case 1:
			var opacity_ = config.a;
			return opacity_;
		case 2:
			var opacity_ = config.a;
			return 1;
		default:
			var opacity_ = config.a;
			return 1;
	}
};
var $author$project$Internal$Path$toPoint = function (command) {
	switch (command.$) {
		case 9:
			return A2($author$project$LineChart$Coordinate$Point, 0, 0);
		case 0:
			var p = command.a;
			return p;
		case 1:
			var p = command.a;
			return p;
		case 2:
			var x = command.a;
			return A2($author$project$LineChart$Coordinate$Point, x, 0);
		case 3:
			var y = command.a;
			return A2($author$project$LineChart$Coordinate$Point, 0, y);
		case 4:
			var c1 = command.a;
			var c2 = command.b;
			var p = command.c;
			return p;
		case 5:
			var c1 = command.a;
			var p = command.b;
			return p;
		case 6:
			var c1 = command.a;
			var p = command.b;
			return p;
		case 7:
			var p = command.a;
			return p;
		default:
			var rx = command.a;
			var ry = command.b;
			var xAxisRotation = command.c;
			var largeArcFlag = command.d;
			var sweepFlag = command.e;
			var p = command.f;
			return p;
	}
};
var $author$project$Internal$Utils$towardsZero = function (_v0) {
	var max = _v0.bN;
	var min = _v0.bW;
	return A3($elm$core$Basics$clamp, min, max, 0);
};
var $author$project$Internal$Utils$last = function (list) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$drop,
			$elm$core$List$length(list) - 1,
			list));
};
var $author$project$Internal$Utils$lastSafe = F2(
	function (first, rest) {
		return A2(
			$elm$core$Maybe$withDefault,
			first,
			$author$project$Internal$Utils$last(rest));
	});
var $author$project$Internal$Utils$viewWithEdges = F2(
	function (stuff, view) {
		if (stuff.b) {
			var first = stuff.a;
			var rest = stuff.b;
			return A3(
				view,
				first,
				rest,
				A2($author$project$Internal$Utils$lastSafe, first, rest));
		} else {
			return $elm$svg$Svg$text('');
		}
	});
var $author$project$Internal$Line$viewArea = F5(
	function (_v0, line_, style_, interpolation, data_) {
		var system = _v0.fn;
		var lineConfig = _v0.ez;
		var area = _v0.dP;
		var ground = function (point) {
			return A2(
				$author$project$Internal$Data$Point,
				point.v,
				$author$project$Internal$Utils$towardsZero(system.w));
		};
		var commands = F3(
			function (first, middle, last) {
				return A3(
					$author$project$Internal$Utils$concat,
					_List_fromArray(
						[
							$author$project$Internal$Path$Move(
							ground(
								$author$project$Internal$Path$toPoint(first))),
							$author$project$Internal$Path$Line(
							$author$project$Internal$Path$toPoint(first))
						]),
					interpolation,
					_List_fromArray(
						[
							$author$project$Internal$Path$Line(
							ground(
								$author$project$Internal$Path$toPoint(last)))
						]));
			});
		var attributes = A2(
			$elm$core$List$cons,
			$author$project$LineChart$Junk$withinChartArea(system),
			A2(
				$elm$core$List$cons,
				$elm$svg$Svg$Attributes$fillOpacity(
					$elm$core$String$fromFloat(
						$author$project$Internal$Area$opacitySingle(area))),
				A3($author$project$Internal$Line$toAreaAttributes, line_, style_, area)));
		return A2(
			$author$project$Internal$Utils$viewWithEdges,
			interpolation,
			F3(
				function (first, middle, last) {
					return A3(
						$author$project$Internal$Path$view,
						system,
						attributes,
						A3(commands, first, middle, last));
				}));
	});
var $author$project$Internal$Dots$view = F2(
	function (_v0, data) {
		var system = _v0.fn;
		var dotsConfig = _v0.d7;
		var shape = _v0.fe;
		var color = _v0.ci;
		var _v1 = dotsConfig;
		var config = _v1;
		var _v2 = config.cN(data.hV);
		var style_ = _v2;
		return A5($author$project$Internal$Dots$viewShape, system, style_, shape, color, data.g5);
	});
var $author$project$Internal$Line$viewDot = F3(
	function (_arguments, _v0, _v1) {
		var lineConfig = _v0;
		var style_ = _v1;
		return $author$project$Internal$Dots$view(
			{
				ci: style_.ci(lineConfig.ci),
				d7: _arguments.d7,
				fe: lineConfig.fe,
				fn: _arguments.fn
			});
	});
var $author$project$Internal$Utils$viewWithFirst = F2(
	function (stuff, view) {
		if (stuff.b) {
			var first = stuff.a;
			var rest = stuff.b;
			return A2(view, first, rest);
		} else {
			return $elm$svg$Svg$text('');
		}
	});
var $author$project$Internal$Line$viewSeries = F5(
	function (_v0, line_, style_, interpolation, data_) {
		var system = _v0.fn;
		var lineConfig = _v0.ez;
		var attributes = A2(
			$elm$core$List$cons,
			$author$project$LineChart$Junk$withinChartArea(system),
			A2($author$project$Internal$Line$toSeriesAttributes, line_, style_));
		return A2(
			$author$project$Internal$Utils$viewWithFirst,
			data_,
			F2(
				function (first, _v1) {
					return A3(
						$author$project$Internal$Path$view,
						system,
						attributes,
						A2(
							$elm$core$List$cons,
							$author$project$Internal$Path$Move(first.g5),
							interpolation));
				}));
	});
var $author$project$Internal$Line$viewSingle = F3(
	function (_arguments, line_, data_) {
		var style_ = function (_v1) {
			var look = _v1;
			return look(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.hV;
					},
					data_));
		}(_arguments.ez);
		var sections = A4(
			$author$project$Internal$Utils$part,
			function ($) {
				return $.gI;
			},
			data_,
			_List_Nil,
			_List_Nil);
		var parts = A2($elm$core$List$map, $elm$core$Tuple$first, sections);
		var viewDots = A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__dots')
				]),
			A2(
				$elm$core$List$map,
				A3($author$project$Internal$Line$viewDot, _arguments, line_, style_),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Internal$Data$isWithinRange(_arguments.fn),
						function ($) {
							return $.g5;
						}),
					$elm$core$List$concat(parts))));
		var commands = A2($author$project$Internal$Interpolation$toCommands, _arguments.eq, sections);
		var viewAreas = function (_v0) {
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('chart__interpolation__area')
					]),
				A3(
					$elm$core$List$map2,
					A3($author$project$Internal$Line$viewArea, _arguments, line_, style_),
					commands,
					parts));
		};
		var viewSeriess = A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__interpolation__line')
				]),
			A3(
				$elm$core$List$map2,
				A3($author$project$Internal$Line$viewSeries, _arguments, line_, style_),
				commands,
				parts));
		return _Utils_Tuple3(
			A2(
				$author$project$Internal$Utils$viewIf,
				$author$project$Internal$Area$hasArea(_arguments.dP),
				viewAreas),
			viewSeriess,
			viewDots);
	});
var $author$project$Internal$Line$viewStacked = F2(
	function (area, _v0) {
		var areas = _v0.a;
		var lines = _v0.b;
		var dots = _v0.c;
		var toList = F2(
			function (l, d) {
				return _List_fromArray(
					[l, d]);
			});
		var opacity = 'opacity: ' + $elm$core$String$fromFloat(
			$author$project$Internal$Area$opacityContainer(area));
		var bottoms = $elm$core$List$concat(
			A3($elm$core$List$map2, toList, lines, dots));
		return _List_fromArray(
			[
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('chart__bottoms'),
						$elm$svg$Svg$Attributes$style(opacity)
					]),
				areas),
				A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('chart__tops')
					]),
				bottoms)
			]);
	});
var $author$project$Internal$Line$view = F3(
	function (_arguments, lines, datas) {
		var container = $elm$svg$Svg$g(
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__lines')
				]));
		var buildSeriesViews = ($author$project$Internal$Area$opacityContainer(_arguments.dP) < 1) ? $author$project$Internal$Line$viewStacked(_arguments.dP) : $author$project$Internal$Line$viewNormal;
		return container(
			buildSeriesViews(
				$author$project$Internal$Utils$unzip3(
					A3(
						$elm$core$List$map2,
						$author$project$Internal$Line$viewSingle(_arguments),
						lines,
						datas))));
	});
var $author$project$LineChart$viewBoxAttribute = function (_v0) {
	var frame = _v0.bJ;
	return $elm$svg$Svg$Attributes$viewBox(
		'0 0 ' + ($elm$core$String$fromFloat(frame.ak.fF) + (' ' + $elm$core$String$fromFloat(frame.ak.eh))));
};
var $author$project$Internal$Axis$Line$config = function (_v0) {
	var config_ = _v0;
	return config_;
};
var $author$project$Internal$Axis$Title$config = function (_v0) {
	var title = _v0;
	return title;
};
var $author$project$Internal$Axis$Intersection$getY = function (_v0) {
	var func = _v0;
	return A2(
		$elm$core$Basics$composeL,
		function ($) {
			return $.w;
		},
		func);
};
var $author$project$Internal$Axis$attributesLine = F2(
	function (system, _v0) {
		var events = _v0.gn;
		var width = _v0.fF;
		var color = _v0.ci;
		return _Utils_ap(
			events,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$strokeWidth(
					$elm$core$String$fromFloat(width)),
					$elm$svg$Svg$Attributes$stroke(
					$avh4$elm_color$Color$toCssString(color)),
					$author$project$Internal$Svg$withinChartArea(system)
				]));
	});
var $author$project$Internal$Axis$viewHorizontalAxisLine = F3(
	function (system, axisPosition, config) {
		return A5(
			$author$project$Internal$Svg$horizontal,
			system,
			A2($author$project$Internal$Axis$attributesLine, system, config),
			axisPosition,
			config.fh,
			config.d8);
	});
var $author$project$Internal$Axis$attributesTick = function (_v0) {
	var width = _v0.fF;
	var color = _v0.ci;
	return _List_fromArray(
		[
			$elm$svg$Svg$Attributes$strokeWidth(
			$elm$core$String$fromFloat(width)),
			$elm$svg$Svg$Attributes$stroke(
			$avh4$elm_color$Color$toCssString(color))
		]);
};
var $author$project$Internal$Axis$Tick$isPositive = function (direction) {
	if (direction === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Internal$Axis$lengthOfTick = function (_v0) {
	var length = _v0.cR;
	var direction = _v0.cv;
	return $author$project$Internal$Axis$Tick$isPositive(direction) ? (-length) : length;
};
var $author$project$Internal$Svg$Middle = 1;
var $author$project$Internal$Axis$viewHorizontalLabel = F4(
	function (system, _v0, position, view) {
		var direction = _v0.cv;
		var length = _v0.cR;
		var yOffset = $author$project$Internal$Axis$Tick$isPositive(direction) ? ((-5) - length) : (15 + length);
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$author$project$Internal$Svg$transform(
					_List_fromArray(
						[
							A3($author$project$Internal$Svg$move, system, position.v, position.w),
							A2($author$project$Internal$Svg$offset, 0, yOffset)
						])),
					$author$project$Internal$Svg$anchorStyle(1)
				]),
			_List_fromArray(
				[view]));
	});
var $author$project$Internal$Svg$xTick = F5(
	function (system, height, userAttributes, y, x) {
		var attributes = A3(
			$author$project$Internal$Utils$concat,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$stroke(
					$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$gray))
				]),
			userAttributes,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgX, system, x))),
					$elm$svg$Svg$Attributes$x2(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgX, system, x))),
					$elm$svg$Svg$Attributes$y1(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgY, system, y))),
					$elm$svg$Svg$Attributes$y2(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgY, system, y) + height))
				]));
		return A2($elm$svg$Svg$line, attributes, _List_Nil);
	});
var $author$project$Internal$Axis$viewHorizontalTick = F3(
	function (system, point, tick) {
		var x = point.v;
		var y = point.w;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__tick')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$Internal$Svg$xTick,
					system,
					$author$project$Internal$Axis$lengthOfTick(tick),
					$author$project$Internal$Axis$attributesTick(tick),
					y,
					x),
					A2(
					$author$project$Internal$Utils$viewMaybe,
					tick.ev,
					A3($author$project$Internal$Axis$viewHorizontalLabel, system, tick, point))
				]));
	});
var $author$project$Internal$Axis$viewHorizontalTitle = F3(
	function (system, at, _v0) {
		var title = _v0.hz;
		var position = at(
			A2(title.b$, system.dH, system.v));
		var _v1 = title.eO;
		var xOffset = _v1.a;
		var yOffset = _v1.b;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__title'),
					$author$project$Internal$Svg$transform(
					_List_fromArray(
						[
							A3($author$project$Internal$Svg$move, system, position.v, position.w),
							A2($author$project$Internal$Svg$offset, xOffset + 15, yOffset + 5)
						])),
					$author$project$Internal$Svg$anchorStyle(0)
				]),
			_List_fromArray(
				[title.fA]));
	});
var $author$project$Internal$Axis$viewHorizontal = F3(
	function (system, intersection, _v0) {
		var config = _v0;
		var viewConfig = {
			aa: A2($author$project$Internal$Axis$Intersection$getY, intersection, system),
			a5: A3($author$project$Internal$Axis$Line$config, config.F, system.dH, system.v),
			l: A3($author$project$Internal$Axis$Ticks$ticks, system.dH, system.v, config.l),
			hz: $author$project$Internal$Axis$Title$config(config.hz)
		};
		var viewAxisLine = A2($author$project$Internal$Axis$viewHorizontalAxisLine, system, viewConfig.aa);
		var at = function (x) {
			return {v: x, w: viewConfig.aa};
		};
		var viewTick = function (tick) {
			return A3(
				$author$project$Internal$Axis$viewHorizontalTick,
				system,
				at(tick.b$),
				tick);
		};
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__axis--horizontal')
				]),
			_List_fromArray(
				[
					A3($author$project$Internal$Axis$viewHorizontalTitle, system, at, viewConfig),
					viewAxisLine(viewConfig.a5),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('chart__ticks')
						]),
					A2($elm$core$List$map, viewTick, viewConfig.l))
				]));
	});
var $author$project$Internal$Axis$Intersection$getX = function (_v0) {
	var func = _v0;
	return A2(
		$elm$core$Basics$composeL,
		function ($) {
			return $.v;
		},
		func);
};
var $author$project$Internal$Axis$viewVerticalAxisLine = F3(
	function (system, axisPosition, config) {
		return A5(
			$author$project$Internal$Svg$vertical,
			system,
			A2($author$project$Internal$Axis$attributesLine, system, config),
			axisPosition,
			config.fh,
			config.d8);
	});
var $author$project$Internal$Axis$viewVerticalLabel = F4(
	function (system, _v0, position, view) {
		var direction = _v0.cv;
		var length = _v0.cR;
		var xOffset = $author$project$Internal$Axis$Tick$isPositive(direction) ? (5 + length) : ((-5) - length);
		var anchor = $author$project$Internal$Axis$Tick$isPositive(direction) ? 0 : 2;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$author$project$Internal$Svg$transform(
					_List_fromArray(
						[
							A3($author$project$Internal$Svg$move, system, position.v, position.w),
							A2($author$project$Internal$Svg$offset, xOffset, 5)
						])),
					$author$project$Internal$Svg$anchorStyle(anchor)
				]),
			_List_fromArray(
				[view]));
	});
var $author$project$Internal$Svg$yTick = F5(
	function (system, width, userAttributes, x, y) {
		var attributes = A3(
			$author$project$Internal$Utils$concat,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__tick'),
					$elm$svg$Svg$Attributes$stroke(
					$avh4$elm_color$Color$toCssString($author$project$LineChart$Colors$gray))
				]),
			userAttributes,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgX, system, x))),
					$elm$svg$Svg$Attributes$x2(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgX, system, x) - width)),
					$elm$svg$Svg$Attributes$y1(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgY, system, y))),
					$elm$svg$Svg$Attributes$y2(
					$elm$core$String$fromFloat(
						A2($author$project$LineChart$Coordinate$toSvgY, system, y)))
				]));
		return A2($elm$svg$Svg$line, attributes, _List_Nil);
	});
var $author$project$Internal$Axis$viewVerticalTick = F3(
	function (system, point, tick) {
		var x = point.v;
		var y = point.w;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__tick')
				]),
			_List_fromArray(
				[
					A5(
					$author$project$Internal$Svg$yTick,
					system,
					$author$project$Internal$Axis$lengthOfTick(tick),
					$author$project$Internal$Axis$attributesTick(tick),
					x,
					y),
					A2(
					$author$project$Internal$Utils$viewMaybe,
					tick.ev,
					A3($author$project$Internal$Axis$viewVerticalLabel, system, tick, point))
				]));
	});
var $author$project$Internal$Axis$viewVerticalTitle = F3(
	function (system, at, _v0) {
		var title = _v0.hz;
		var position = at(
			A2(title.b$, system.dI, system.w));
		var _v1 = title.eO;
		var xOffset = _v1.a;
		var yOffset = _v1.b;
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__title'),
					$author$project$Internal$Svg$transform(
					_List_fromArray(
						[
							A3($author$project$Internal$Svg$move, system, position.v, position.w),
							A2($author$project$Internal$Svg$offset, xOffset + 2, yOffset - 10)
						])),
					$author$project$Internal$Svg$anchorStyle(2)
				]),
			_List_fromArray(
				[title.fA]));
	});
var $author$project$Internal$Axis$viewVertical = F3(
	function (system, intersection, _v0) {
		var config = _v0;
		var viewConfig = {
			aa: A2($author$project$Internal$Axis$Intersection$getX, intersection, system),
			a5: A3($author$project$Internal$Axis$Line$config, config.F, system.dI, system.w),
			l: A3($author$project$Internal$Axis$Ticks$ticks, system.dI, system.w, config.l),
			hz: $author$project$Internal$Axis$Title$config(config.hz)
		};
		var viewAxisLine = A2($author$project$Internal$Axis$viewVerticalAxisLine, system, viewConfig.aa);
		var at = function (y) {
			return {v: viewConfig.aa, w: y};
		};
		var viewTick = function (tick) {
			return A3(
				$author$project$Internal$Axis$viewVerticalTick,
				system,
				at(tick.b$),
				tick);
		};
		return A2(
			$elm$svg$Svg$g,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('chart__axis--vertical')
				]),
			_List_fromArray(
				[
					A3($author$project$Internal$Axis$viewVerticalTitle, system, at, viewConfig),
					viewAxisLine(viewConfig.a5),
					A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('chart__ticks')
						]),
					A2($elm$core$List$map, viewTick, viewConfig.l))
				]));
	});
var $author$project$LineChart$viewCustom = F2(
	function (config, lines) {
		var junkLineInfo = function (line_) {
			return _Utils_Tuple3(
				A3($author$project$Internal$Line$color, config.a5, line_, _List_Nil),
				$author$project$Internal$Line$label(line_),
				$author$project$Internal$Line$data(line_));
		};
		var getJunk = A3(
			$author$project$Internal$Junk$getLayers,
			A2($elm$core$List$map, junkLineInfo, lines),
			$author$project$Internal$Axis$variable(config.v),
			$author$project$Internal$Axis$variable(config.w));
		var data = A2($author$project$LineChart$toDataPoints, config, lines);
		var dataAll = $elm$core$List$concat(data);
		var dataSafe = A2(
			$elm$core$List$map,
			$elm$core$List$filter(
				function ($) {
					return $.gI;
				}),
			data);
		var dataAllSafe = $elm$core$List$concat(dataSafe);
		var system = A2($author$project$LineChart$toSystem, config, dataAllSafe);
		var viewLines = $author$project$Internal$Line$view(
			{dP: config.dP, d7: config.gh, eq: config.eq, ez: config.a5, fn: system});
		var viewLegends = $author$project$Internal$Legends$view(
			{
				dP: config.dP,
				gc: dataSafe,
				d7: config.gh,
				ex: config.ex,
				ez: config.a5,
				cS: lines,
				fn: system,
				v: $author$project$Internal$Axis$variable(config.v),
				w: $author$project$Internal$Axis$variable(config.w)
			});
		var attributes = $elm$core$List$concat(
			_List_fromArray(
				[
					A2(
					$author$project$Internal$Container$properties,
					function ($) {
						return $.bv;
					},
					config.f7),
					A3($author$project$Internal$Events$toContainerAttributes, dataAll, system, config.gn),
					_List_fromArray(
					[
						$author$project$LineChart$viewBoxAttribute(system)
					])
				]));
		var addGrid = $author$project$Internal$Junk$addBelow(
			A4($author$project$Internal$Grid$view, system, config.v, config.w, config.Z));
		var junk = addGrid(
			A2(getJunk, system, config.gK));
		return A4(
			$author$project$LineChart$container,
			config,
			system,
			junk.gz,
			A2(
				$elm$svg$Svg$svg,
				attributes,
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$defs,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$LineChart$clipPath(system)
							])),
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('chart__junk--below')
							]),
						junk.aS),
						A2(viewLines, lines, data),
						A3($author$project$LineChart$chartAreaPlatform, config, dataAll, system),
						A3($author$project$Internal$Axis$viewHorizontal, system, config.aa, config.v),
						A3($author$project$Internal$Axis$viewVertical, system, config.aa, config.w),
						viewLegends,
						A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('chart__junk--above')
							]),
						junk.cc)
					])));
	});
var $author$project$LandingSite$CTokens$exchangeRateGraph = F3(
	function (graphModel, historicExchangeRates, model) {
		var exchangeData = A2(
			$elm$core$List$map,
			function (_v0) {
				var k = _v0.a;
				var v = _v0.b;
				return A2($author$project$LandingSite$CTokens$Datum, k, v);
			},
			historicExchangeRates);
		var chartLines = _List_fromArray(
			[
				A4($author$project$LineChart$line, $author$project$LineChart$Colors$supply, $author$project$LineChart$Dots$circle, 'Exchange', exchangeData)
			]);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('chart')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$LineChart$viewCustom,
						$author$project$LandingSite$CTokens$chartConfig(model),
						chartLines)
					]))
			]);
	});
var $author$project$Strings$Translations$interest_unique = function (lang) {
	switch (lang) {
		case 0:
			return 'Interest, unique to each asset';
		case 1:
			return 'Interés, único para cada activo';
		default:
			return '每个资产所特有的利息';
	}
};
var $author$project$Strings$Translations$interest_unique_description = function (lang) {
	switch (lang) {
		case 0:
			return 'As a market earns interest, its cToken becomes convertible into an increasing quantity of the underlying asset.';
		case 1:
			return 'A medida que un mercado gana intereses, su cToken se convierte en una cantidad creciente del activo subyacente.';
		default:
			return '当市场获得利息时，它的 cTokens 就可以转换成越来越多的基础资产。';
	}
};
var $author$project$Strings$Translations$mint = function (lang) {
	switch (lang) {
		case 0:
			return 'Mint';
		case 1:
			return 'menta';
		default:
			return '铸币';
	}
};
var $author$project$Strings$Translations$mint_amount = function (lang) {
	switch (lang) {
		case 0:
			return 'mintAmount';
		case 1:
			return 'mintAmount';
		default:
			return 'mintAmount';
	}
};
var $author$project$Strings$Translations$mint_amount_description = function (lang) {
	switch (lang) {
		case 0:
			return ' - The amount supplied, in units of the underlying asset.';
		case 1:
			return '- El importe suministrado, en unidades del activo subyacente.';
		default:
			return '- 提供的金额，以标的资产为单位。';
	}
};
var $author$project$Strings$Translations$mint_description = function (lang) {
	switch (lang) {
		case 0:
			return 'When you supply an asset to Compound, cTokens are minted. The number of cTokens minted is the amount of underlying asset being provided divided by the current Exchange Rate.';
		case 1:
			return 'Cuando suministra un activo a Compound, se emiten cTokens. El número de cTokens acuñados es la cantidad de activo subyacente que se proporciona dividido por el tipo de cambio actual.';
		default:
			return '当您向 Compound 供应资产时，cTokens 会被铸造。铸造的 cTokens 数量是提供的标的资产的数量除以当前的汇率。';
	}
};
var $author$project$Strings$Translations$msg_sender = function (lang) {
	switch (lang) {
		case 0:
			return 'msg.sender';
		case 1:
			return 'msg.sender';
		default:
			return 'msg.sender';
	}
};
var $author$project$Strings$Translations$msg_sender_description_mint = function (lang) {
	switch (lang) {
		case 0:
			return ' - The account which supplies the asset and owns the cTokens.';
		case 1:
			return '- La cuenta que suministra el activo y posee los cTokens.';
		default:
			return '- 提供资产并拥有 cTokens 的帐户。';
	}
};
var $author$project$Strings$Translations$msg_sender_description_redeem = function (lang) {
	switch (lang) {
		case 0:
			return ' - The account to which redeemed funds shall be transferred.';
		case 1:
			return '- La cuenta a la que se transferirán los fondos redimidos.';
		default:
			return '- 转换资金的账户。';
	}
};
var $author$project$Strings$Translations$need_help = function (lang) {
	switch (lang) {
		case 0:
			return 'Need help?';
		case 1:
			return '¿Necesitas ayuda?';
		default:
			return '需要帮助？';
	}
};
var $author$project$Strings$Translations$need_help_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Frequently asked questions.';
		case 1:
			return 'Preguntas frecuentes.';
		default:
			return '高频问题。';
	}
};
var $author$project$Strings$Translations$number_borrowers = function (lang) {
	switch (lang) {
		case 0:
			return '# Borrowers';
		case 1:
			return '# Prestatarios';
		default:
			return '＃ 借款人';
	}
};
var $author$project$Strings$Translations$number_suppliers = function (lang) {
	switch (lang) {
		case 0:
			return '# Suppliers';
		case 1:
			return '# Proveedores';
		default:
			return '＃供应者';
	}
};
var $author$project$Strings$Translations$redeem = function (lang) {
	switch (lang) {
		case 0:
			return 'Redeem';
		case 1:
			return 'Redimir';
		default:
			return '赎回';
	}
};
var $author$project$Strings$Translations$redeem_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The redeem function transfers the underlying asset from the money market to the user in exchange for previously minted cTokens. The amount of underlying redeemed is the number of cTokens multiplied by the current Exchange Rate. The amount redeemed must be less than the user\'s Account Liquidity and the market\'s available liquidity.';
		case 1:
			return 'La función de canje transfiere el activo subyacente del mercado monetario al usuario a cambio de cTokens previamente acuñados. La cantidad de canje subyacente es el número de cTokens multiplicado por el tipo de cambio actual. El monto redimido debe ser menor que la Liquidez de la cuenta del usuario y la liquidez disponible del mercado.';
		default:
			return '赎回功能将相关资产从货币市场转移给用户，以换取先前铸造的 cTokens。赎回的潜在金额是 cTokens 的数量乘以当前的汇率。兑换的金额必须低于用户的账户流动性和市场的可用流动性。';
	}
};
var $author$project$Strings$Translations$redeem_tokens = function (lang) {
	switch (lang) {
		case 0:
			return 'redeemTokens';
		case 1:
			return 'canjearTokens';
		default:
			return '赎回代币';
	}
};
var $author$project$Strings$Translations$redeem_tokens_description = function (lang) {
	switch (lang) {
		case 0:
			return ' - The number of cTokens to be redeemed.';
		case 1:
			return '- El número de cTokens para canjear.';
		default:
			return '- 要兑换的 cTokens 数量。';
	}
};
var $author$project$Strings$Translations$return = function (lang) {
	switch (lang) {
		case 0:
			return 'RETURN';
		case 1:
			return 'REGRESO';
		default:
			return '返回';
	}
};
var $author$project$Strings$Translations$return_description = function (lang) {
	switch (lang) {
		case 0:
			return ' - 0 on success, otherwise an ';
		case 1:
			return '- 0 en caso de éxito, de lo contrario un';
		default:
			return '- 成功时为0，否则为';
	}
};
var $author$project$Strings$Translations$token_address = function (lang) {
	switch (lang) {
		case 0:
			return 'Token Address';
		case 1:
			return 'Dirección de token';
		default:
			return '代币地址';
	}
};
var $author$project$Strings$Translations$tokenized_balance = function (lang) {
	switch (lang) {
		case 0:
			return 'Portable Balances';
		case 1:
			return 'Balance Tokenizado';
		default:
			return 'Token 化余额';
	}
};
var $author$project$Strings$Translations$tokenized_balance_description = function (lang) {
	switch (lang) {
		case 0:
			return 'cTokens represent your balance in the protocol, and accrue interest over time.';
		case 1:
			return 'Los cTokens representan su saldo en el protocolo y generan intereses con el tiempo.';
		default:
			return 'cTokens 表示协议中的余额，并随着时间的推移产生利息。';
	}
};
var $author$project$Strings$Translations$total_supply = function (lang) {
	switch (lang) {
		case 0:
			return 'Total Supply';
		case 1:
			return 'Suministro total';
		default:
			return '总供应';
	}
};
var $author$project$Strings$Translations$useful_collateral = function (lang) {
	switch (lang) {
		case 0:
			return 'Useful Collateral';
		case 1:
			return 'Colateral útil';
		default:
			return '有用的抵押品';
	}
};
var $author$project$Strings$Translations$useful_collateral_description = function (lang) {
	switch (lang) {
		case 0:
			return 'By holding or receiving a cToken, you can borrow from the Compound protocol.';
		case 1:
			return 'Al mantener o recibir un cToken, puede tomar prestado del Protocolo Compound.';
		default:
			return '通过持有或接收 cTokens，您可以从 Compound 协议中借款。';
	}
};
var $author$project$Strings$Translations$view_all_faqs = function (lang) {
	switch (lang) {
		case 0:
			return 'View all faqs';
		case 1:
			return 'Ver todas las preguntas frecuentes';
		default:
			return '查看所有 FAQs';
	}
};
var $author$project$Strings$Translations$view_api_docs = function (lang) {
	switch (lang) {
		case 0:
			return 'View api docs';
		case 1:
			return 'Ver documentos de la API';
		default:
			return '查看 api 文档';
	}
};
var $author$project$Strings$Translations$your_balance = function (lang) {
	switch (lang) {
		case 0:
			return 'Supply assets, get cTokens.';
		case 1:
			return 'Tu saldo, tokenizado.';
		default:
			return '你的余额，Token 化。';
	}
};
var $author$project$LandingSite$CTokens$view = F5(
	function (userLanguage, maybeMainnetConfig, maybeLatestTokens, graphModel, model) {
		var latestTokens = function () {
			if (!maybeLatestTokens.$) {
				var tokens = maybeLatestTokens.a;
				return $elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (cToken) {
							return _Utils_Tuple2(
								function ($) {
									return $.fq;
								}(cToken),
								cToken);
						},
						tokens.f$));
			} else {
				return $elm$core$Dict$empty;
			}
		}();
		var maybeCToken = function () {
			var _v16 = model.aK;
			if (!_v16.$) {
				var cTokenConfig = _v16.a;
				return A2(
					$elm$core$Dict$get,
					$author$project$Eth$Ethereum$getContractAddressString(cTokenConfig.dL),
					latestTokens);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var historicExchangeRates = function () {
			var _v15 = model.aK;
			if (!_v15.$) {
				var cToken = _v15.a;
				return A3(
					$author$project$Utils$Graph$buildGraphData,
					cToken.dL,
					graphModel.go,
					function (v) {
						return v;
					});
			} else {
				return _List_Nil;
			}
		}();
		var historicExchangeRatesDict = $elm$core$Dict$fromList(historicExchangeRates);
		var maybeCurrentExchangeRate = $elm$core$List$head(
			$elm$core$List$reverse(historicExchangeRates));
		var scaledExchangeRates = A2(
			$elm$core$List$map,
			function (_v14) {
				var x = _v14.a;
				var y = _v14.b;
				return _Utils_Tuple2(x, y * 100000000.0);
			},
			historicExchangeRates);
		var loaderActive = (!$elm$core$List$length(scaledExchangeRates)) ? ' active' : '';
		var faqDisplayActive = function (index) {
			var faqState = A2($elm$core$Array$get, index, model.W);
			var faqAccordianClass = function () {
				if ((!faqState.$) && faqState.a) {
					return ' active';
				} else {
					return '';
				}
			}();
			return faqAccordianClass;
		};
		var exchangeRate = function () {
			var _v10 = model.az;
			if (!_v10.$) {
				var xValue = _v10.a;
				return A2(
					$elm$core$Maybe$andThen,
					$author$project$Decimal$fromFloat,
					A2($elm$core$Dict$get, xValue, historicExchangeRatesDict));
			} else {
				if (!maybeCurrentExchangeRate.$) {
					var _v12 = maybeCurrentExchangeRate.a;
					var rate = _v12.b;
					return $author$project$Decimal$fromFloat(rate);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}();
		var exchangeRateDisplay = function () {
			if (!exchangeRate.$) {
				var rate = exchangeRate.a;
				return A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 8, false, rate);
			} else {
				return '-';
			}
		}();
		var dropdownActiveClass = function () {
			var _v8 = model.aV;
			if (_v8) {
				return ' active';
			} else {
				return '';
			}
		}();
		var dates = A2(
			$elm$core$List$filterMap,
			function (_v7) {
				var index = _v7.a;
				var time = _v7.b;
				return ((!index) || (!A2($elm$core$Basics$modBy, 5, index + 1))) ? $elm$core$Maybe$Just(
					A2(
						$justinmimbs$date$Date$format,
						'MMMM d',
						A2(
							$justinmimbs$date$Date$fromPosix,
							$elm$time$Time$utc,
							$elm$time$Time$millisToPosix(
								$elm$core$Basics$round(time) * 1000)))) : $elm$core$Maybe$Nothing;
			},
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, _v6) {
						var time = _v6.a;
						return _Utils_Tuple2(index, time);
					}),
				historicExchangeRates));
		var withMobileHideClass = function (index) {
			var total = $elm$core$List$length(dates);
			var halfTotal = (total / 2) | 0;
			return ((!index) || (_Utils_eq(index, halfTotal) || _Utils_eq(index, total - 1))) ? '' : ' mobile-hide';
		};
		var codeSnippetClass = function (index) {
			var activeClass = _Utils_eq(index, model.br) ? ' active' : '';
			return activeClass;
		};
		var cTokens = function () {
			if (!maybeMainnetConfig.$) {
				var config = maybeMainnetConfig.a;
				return $elm$core$Dict$values(config.dU);
			} else {
				return _List_Nil;
			}
		}();
		var _v0 = function () {
			var _v1 = model.aK;
			if (!_v1.$) {
				var cToken = _v1.a;
				return {
					dL: $author$project$Eth$Ethereum$getContractAddressString(cToken.dL),
					gT: cToken.gT,
					hv: cToken.hv,
					dA: cToken.aO.hv
				};
			} else {
				return {dL: '', gT: '', hv: '', dA: ''};
			}
		}();
		var address = _v0.dL;
		var name = _v0.gT;
		var symbol = _v0.hv;
		var underlyingSymbol = _v0.dA;
		var cleanedAddress = A3($author$project$Eth$Ethereum$shortenedAddressString, 4, 4, address);
		var _v2 = function () {
			if (!maybeCToken.$) {
				var cToken = maybeCToken.a;
				return _Utils_Tuple3(
					A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, true, cToken.hN),
					$elm$core$String$fromInt(cToken.gV),
					$elm$core$String$fromInt(cToken.gW));
			} else {
				return _Utils_Tuple3('-', '-', '-');
			}
		}();
		var totalSupply = _v2.a;
		var numberOfBorrowers = _v2.b;
		var numberOfSuppliers = _v2.c;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$LandingSite$CTokens$ForSelf(
						$author$project$LandingSite$CTokens$ToggleDropdown(false)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('cToken-overview')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('pattern-header')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('cDai')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('cWbtc')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('cEth')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('cZrx')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('cUsdc')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('cRep')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-8 col-sm-3 text-left')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('overview-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$your_balance(userLanguage))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row cToken-points')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-4 text-left description-card')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('icon token')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('description-card-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$tokenized_balance(userLanguage))
														])),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('description-card-text')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$tokenized_balance_description(userLanguage))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-4 text-left description-card')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('icon eth')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('description-card-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$erc_20(userLanguage))
														])),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('description-card-text')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$erc_20_description(userLanguage))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-4 text-left description-card')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('icon block')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('description-card-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$useful_collateral(userLanguage))
														])),
													A2(
													$elm$html$Html$p,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('description-card-text')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$useful_collateral_description(userLanguage))
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('cToken-info')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-2')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-8 text-left')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$interest_unique(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('header-description')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$interest_unique_description(userLanguage))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('graph-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('cToken-graph')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('graph-content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('graph-header')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('ctoken ctoken--' + symbol)
																		]),
																	_List_Nil),
																	A2(
																	$elm$html$Html$h4,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('token-name')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(name)
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('dropdown'),
																			$author$project$Utils$CompoundHtmlAttributes$onClickStopPropagation(
																			$author$project$LandingSite$CTokens$ForSelf(
																				$author$project$LandingSite$CTokens$ToggleDropdown(!model.aV)))
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('dropdown__selected')
																				]),
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							$author$project$Utils$CompoundHtmlAttributes$class('ctoken ctoken--small ctoken--' + symbol)
																						]),
																					_List_Nil),
																					A2(
																					$elm$html$Html$p,
																					_List_fromArray(
																						[
																							$author$project$Utils$CompoundHtmlAttributes$class('small')
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text(symbol)
																						]))
																				])),
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('dropdown__options ' + dropdownActiveClass)
																				]),
																			A2(
																				$elm$core$List$map,
																				function (cToken) {
																					return A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$author$project$Utils$CompoundHtmlAttributes$class('dropdown__option'),
																								$elm$html$Html$Events$onClick(
																								$author$project$LandingSite$CTokens$ForSelf(
																									$author$project$LandingSite$CTokens$SelectCToken(cToken)))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$author$project$Utils$CompoundHtmlAttributes$class('ctoken ctoken--small ctoken--' + cToken.hv)
																									]),
																								_List_Nil),
																								A2(
																								$elm$html$Html$p,
																								_List_fromArray(
																									[
																										$author$project$Utils$CompoundHtmlAttributes$class('small')
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text(cToken.hv)
																									]))
																							]));
																				},
																				A2(
																					$elm$core$List$sortBy,
																					function ($) {
																						return $.hv;
																					},
																					cTokens)))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('chart-header')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('exchange-rate')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$h4,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(exchangeRateDisplay)
																				])),
																			A2(
																			$elm$html$Html$label,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(underlyingSymbol)
																				]))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('line-chart')
																]),
															_Utils_ap(
																_List_Nil,
																A3($author$project$LandingSite$CTokens$exchangeRateGraph, graphModel, scaledExchangeRates, model))),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('chart-footer')
																]),
															A2(
																$elm$core$List$indexedMap,
																F2(
																	function (index, date) {
																		return A2(
																			$elm$html$Html$p,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class(
																					'small' + withMobileHideClass(index))
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text(date)
																				]));
																	}),
																dates)),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('graph-footer')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('total-supply')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$label,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$total_supply(userLanguage))
																				])),
																			A2(
																			$elm$html$Html$h4,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(totalSupply)
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('suppliers')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$label,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$number_suppliers(userLanguage))
																				])),
																			A2(
																			$elm$html$Html$h4,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(numberOfSuppliers)
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('borrowers')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$label,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$number_borrowers(userLanguage))
																				])),
																			A2(
																			$elm$html$Html$h4,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(numberOfBorrowers)
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('smart-contract')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$label,
																			_List_Nil,
																			_List_fromArray(
																				[
																					$elm$html$Html$text(
																					$author$project$Strings$Translations$token_address(userLanguage))
																				])),
																			A2(
																			$elm$html$Html$a,
																			_Utils_ap(
																				_List_fromArray(
																					[
																						$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																					]),
																				A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://etherscan.io/token/' + address)),
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$h4,
																					_List_fromArray(
																						[
																							$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
																						]),
																					_List_fromArray(
																						[
																							$elm$html$Html$text(cleanedAddress)
																						]))
																				]))
																		]))
																]))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row faq-section')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-3')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$need_help(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('faq-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$need_help_description(userLanguage))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																	]),
																A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/faq-1a2636713b69')),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$view_all_faqs(userLanguage))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
																	$author$project$Utils$CompoundHtmlAttributes$class('arrow')
																]),
															_List_Nil)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-1')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-8 faqs')
												]),
											_Utils_ap(
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$id('line')
															]),
														_List_Nil)
													]),
												$elm$core$List$concat(
													A2(
														$elm$core$List$indexedMap,
														F2(
															function (index, _v4) {
																var header = _v4.a;
																var content = _v4.b;
																return _List_fromArray(
																	[
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$author$project$Utils$CompoundHtmlAttributes$class('faq-item')
																			]),
																		_List_fromArray(
																			[
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$author$project$Utils$CompoundHtmlAttributes$class('faq-item-header'),
																						$elm$html$Html$Events$onClick(
																						$author$project$LandingSite$CTokens$ForSelf(
																							$author$project$LandingSite$CTokens$ToggleAccordianAtIndex(index)))
																					]),
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$h3,
																						_List_fromArray(
																							[
																								$author$project$Utils$CompoundHtmlAttributes$class('faq-item-text')
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text(header)
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$author$project$Utils$CompoundHtmlAttributes$class(
																								'plus' + faqDisplayActive(index))
																							]),
																						_List_fromArray(
																							[
																								A2($elm$html$Html$span, _List_Nil, _List_Nil),
																								A2($elm$html$Html$span, _List_Nil, _List_Nil)
																							]))
																					])),
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$author$project$Utils$CompoundHtmlAttributes$class(
																						'faq-item-description' + faqDisplayActive(index))
																					]),
																				content)
																			])),
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$author$project$Utils$CompoundHtmlAttributes$id('line')
																			]),
																		_List_Nil)
																	]);
															}),
														$author$project$LandingSite$CTokens$accordianData(userLanguage)))))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('cToken-build')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-4')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$build_with(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('build-header')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$build_with_description(userLanguage))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																	]),
																A2(
																	$author$project$Utils$CompoundHtmlAttributes$href,
																	0,
																	$author$project$LandingSite$Page$getHrefUrl(
																		A2($author$project$LandingSite$Page$Developers, 0, $elm$core$Maybe$Nothing)))),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$view_api_docs(userLanguage))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
																	$author$project$Utils$CompoundHtmlAttributes$class('arrow')
																]),
															_List_Nil)
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('illo-ctoken')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-0 col-sm-1')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-10 code-section')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('code-section-headers')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class(
																	'medium' + codeSnippetClass(0)),
																	$elm$html$Html$Events$onClick(
																	$author$project$LandingSite$CTokens$ForSelf(
																		$author$project$LandingSite$CTokens$SelectCodeSnippet(0)))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$mint(userLanguage))
																])),
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class(
																	'medium' + codeSnippetClass(1)),
																	$elm$html$Html$Events$onClick(
																	$author$project$LandingSite$CTokens$ForSelf(
																		$author$project$LandingSite$CTokens$SelectCodeSnippet(1)))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$redeem(userLanguage))
																])),
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class(
																	'medium' + codeSnippetClass(2)),
																	$elm$html$Html$Events$onClick(
																	$author$project$LandingSite$CTokens$ForSelf(
																		$author$project$LandingSite$CTokens$SelectCodeSnippet(2)))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$api(userLanguage))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('line')
														]),
													_List_Nil),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('code-section-content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class(
																	'slide' + codeSnippetClass(0))
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$p,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$mint_description(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('code')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('line-numbers')
																				]),
																			_List_fromArray(
																				[
																					A2($elm$html$Html$span, _List_Nil, _List_Nil)
																				])),
																			A2(
																			$elm$html$Html$pre,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$code,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$author$project$Utils$CompoundHtmlAttributes$class('code-line')
																								]),
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('function')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token function')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('mint')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('(')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token type')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('uint')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token argument')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('mintAmount')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(')')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('returns')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('(')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token type')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('uint')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(')')
																										]))
																								]))
																						]))
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('code-values')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$ul,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$li,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('value')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$msg_sender(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('description')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$msg_sender_description_mint(userLanguage))
																										]))
																								]))
																						])),
																					A2(
																					$elm$html$Html$li,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('value')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$mint_amount(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('description')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$mint_amount_description(userLanguage))
																										]))
																								]))
																						])),
																					A2(
																					$elm$html$Html$li,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('value')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$return(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('description')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$return_description(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$a,
																									A2(
																										$author$project$Utils$CompoundHtmlAttributes$href,
																										0,
																										$author$project$LandingSite$Page$getHrefUrl(
																											A2(
																												$author$project$LandingSite$Page$Developers,
																												1,
																												$elm$core$Maybe$Just('ctoken-error-codes')))),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$error_code(userLanguage))
																										]))
																								]))
																						]))
																				]))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class(
																	'slide' + codeSnippetClass(1))
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$p,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$redeem_description(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('code')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('line-numbers')
																				]),
																			_List_fromArray(
																				[
																					A2($elm$html$Html$span, _List_Nil, _List_Nil)
																				])),
																			A2(
																			$elm$html$Html$pre,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$code,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$author$project$Utils$CompoundHtmlAttributes$class('code-line')
																								]),
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('function')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token function')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('redeem')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('(')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token type')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('uint')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token argument')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('redeemTokens')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(')')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token keyword')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('returns')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(' ')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('(')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token type')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('uint')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(')')
																										]))
																								]))
																						]))
																				]))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('code-values')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$ul,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$li,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('value')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$msg_sender(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('description')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$msg_sender_description_redeem(userLanguage))
																										]))
																								]))
																						])),
																					A2(
																					$elm$html$Html$li,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('value')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$redeem_tokens(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('description')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$redeem_tokens_description(userLanguage))
																										]))
																								]))
																						])),
																					A2(
																					$elm$html$Html$li,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$p,
																							_List_Nil,
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('value')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$return(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('description')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$return_description(userLanguage))
																										])),
																									A2(
																									$elm$html$Html$a,
																									A2(
																										$author$project$Utils$CompoundHtmlAttributes$href,
																										0,
																										$author$project$LandingSite$Page$getHrefUrl(
																											A2(
																												$author$project$LandingSite$Page$Developers,
																												1,
																												$elm$core$Maybe$Just('ctoken-error-codes')))),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(
																											$author$project$Strings$Translations$error_code(userLanguage))
																										]))
																								]))
																						]))
																				]))
																		]))
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class(
																	'slide' + codeSnippetClass(2))
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$p,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			$author$project$Strings$Translations$c_tokens_api_description(userLanguage))
																		])),
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('code')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$author$project$Utils$CompoundHtmlAttributes$class('line-numbers')
																				]),
																			_List_fromArray(
																				[
																					A2($elm$html$Html$span, _List_Nil, _List_Nil)
																				])),
																			A2(
																			$elm$html$Html$pre,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$code,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$author$project$Utils$CompoundHtmlAttributes$class('code-line')
																								]),
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token comment')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('// Retreives list all cTokens')
																										]))
																								])),
																							A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$author$project$Utils$CompoundHtmlAttributes$class('code-line')
																								]),
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token function')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('fetch')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('(')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token string')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('\'https://api.compound.finance/api/v2/ctoken\'')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(')')
																										])),
																									A2(
																									$elm$html$Html$span,
																									_List_fromArray(
																										[
																											$author$project$Utils$CompoundHtmlAttributes$class('token punctuation')
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text(';')
																										]))
																								]))
																						]))
																				]))
																		]))
																]))
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$LandingSite$Developers$ToggleMobileNavMsg = function (a) {
	return {$: 4, a: a};
};
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.eO, s.e7, s.d_, s.hj);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.b)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.eO, newOffset) < 0,
			0,
			{d_: newCol, b: s.b, d: s.d, eO: newOffset, e7: newRow, hj: s.hj});
	};
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$comment = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($hecrj$html_parser$Html$Parser$Comment),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $elm$core$Char$fromCode = _Char_fromCode;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {d_: s.d_ + (newOffset - s.eO), b: s.b, d: s.d, eO: newOffset, e7: s.e7, hj: s.hj};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.eO, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.hj);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.e7, s.d_ - (floatOffset + s.eO), invalid, s.b));
		} else {
			if (_Utils_eq(s.eO, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.eO, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.eO, floatOffset, s.hj));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.eO, s.hj)) {
			var zeroOffset = s.eO + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.hj) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.gG,
				c.gv,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.hj),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.hj) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.gG,
				c.gX,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.hj),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.hj) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.gG,
				c.fT,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.hj),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.gG,
				c.eb,
				c.gD,
				c.gt,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.gG,
				c.eb,
				c.gD,
				c.gt,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.eO, s.hj),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				fT: $elm$core$Result$Err(invalid),
				eb: expecting,
				gt: $elm$core$Result$Err(invalid),
				gv: $elm$core$Result$Err(invalid),
				gD: $elm$core$Result$Ok($elm$core$Basics$identity),
				gG: invalid,
				gX: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$SyntaxHighlight$HCode = $elm$core$Basics$identity;
var $author$project$SyntaxHighlight$Style$Style1 = 2;
var $author$project$SyntaxHighlight$Style$Style2 = 3;
var $author$project$SyntaxHighlight$Style$Style3 = 4;
var $author$project$SyntaxHighlight$Style$Style4 = 5;
var $author$project$SyntaxHighlight$Style$Style5 = 6;
var $author$project$SyntaxHighlight$Style$Style6 = 7;
var $author$project$SyntaxHighlight$Style$Style7 = 8;
var $author$project$SyntaxHighlight$Language$Javascript$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'js-n');
		case 1:
			return _Utils_Tuple2(3, 'js-s');
		case 2:
			return _Utils_Tuple2(4, 'js-k');
		case 3:
			return _Utils_Tuple2(5, 'js-dk');
		case 4:
			return _Utils_Tuple2(6, 'js-fe');
		case 5:
			return _Utils_Tuple2(6, 'js-f');
		case 6:
			return _Utils_Tuple2(7, 'js-lk');
		case 7:
			return _Utils_Tuple2(8, 'js-p');
		default:
			return _Utils_Tuple2(6, 'js-ce');
	}
};
var $author$project$SyntaxHighlight$Line$Helpers$newLine = function (fragments) {
	return {gu: fragments, gx: $elm$core$Maybe$Nothing};
};
var $author$project$SyntaxHighlight$Language$Type$LineBreak = {$: 2};
var $author$project$SyntaxHighlight$Style$Comment = 1;
var $author$project$SyntaxHighlight$Style$Default = 0;
var $author$project$SyntaxHighlight$Line$Helpers$toFragment = F2(
	function (toStyle, _v0) {
		var syntax = _v0.a;
		var text = _v0.b;
		switch (syntax.$) {
			case 0:
				return {fO: '', hc: 0, hx: text};
			case 1:
				return {fO: '', hc: 1, hx: text};
			case 2:
				return {fO: '', hc: 0, hx: text};
			default:
				var c = syntax.a;
				var _v2 = toStyle(c);
				var requiredStyle = _v2.a;
				var additionalClass = _v2.b;
				return {fO: additionalClass, hc: requiredStyle, hx: text};
		}
	});
var $author$project$SyntaxHighlight$Line$Helpers$toLinesHelp = F3(
	function (toStyle, _v0, _v1) {
		var syntax = _v0.a;
		var text = _v0.b;
		var lines = _v1.a;
		var fragments = _v1.b;
		var maybeLastSyntax = _v1.c;
		if (_Utils_eq(syntax, $author$project$SyntaxHighlight$Language$Type$LineBreak)) {
			return _Utils_Tuple3(
				A2(
					$elm$core$List$cons,
					$author$project$SyntaxHighlight$Line$Helpers$newLine(fragments),
					lines),
				_List_fromArray(
					[
						A2(
						$author$project$SyntaxHighlight$Line$Helpers$toFragment,
						toStyle,
						_Utils_Tuple2(syntax, text))
					]),
				$elm$core$Maybe$Nothing);
		} else {
			if (_Utils_eq(
				$elm$core$Maybe$Just(syntax),
				maybeLastSyntax)) {
				if (fragments.b) {
					var headFrag = fragments.a;
					var tailFrags = fragments.b;
					return _Utils_Tuple3(
						lines,
						A2(
							$elm$core$List$cons,
							_Utils_update(
								headFrag,
								{
									hx: _Utils_ap(text, headFrag.hx)
								}),
							tailFrags),
						maybeLastSyntax);
				} else {
					return _Utils_Tuple3(
						lines,
						A2(
							$elm$core$List$cons,
							A2(
								$author$project$SyntaxHighlight$Line$Helpers$toFragment,
								toStyle,
								_Utils_Tuple2(syntax, text)),
							fragments),
						maybeLastSyntax);
				}
			} else {
				return _Utils_Tuple3(
					lines,
					A2(
						$elm$core$List$cons,
						A2(
							$author$project$SyntaxHighlight$Line$Helpers$toFragment,
							toStyle,
							_Utils_Tuple2(syntax, text)),
						fragments),
					$elm$core$Maybe$Just(syntax));
			}
		}
	});
var $author$project$SyntaxHighlight$Line$Helpers$toLines = F2(
	function (toStyle, revTokens) {
		return function (_v0) {
			var lines = _v0.a;
			var frags = _v0.b;
			return A2(
				$elm$core$List$cons,
				$author$project$SyntaxHighlight$Line$Helpers$newLine(frags),
				lines);
		}(
			A3(
				$elm$core$List$foldl,
				$author$project$SyntaxHighlight$Line$Helpers$toLinesHelp(toStyle),
				_Utils_Tuple3(_List_Nil, _List_Nil, $elm$core$Maybe$Nothing),
				revTokens));
	});
var $author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile = function (isNotRelevant) {
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf(isNotRelevant)),
		$elm$parser$Parser$chompWhile(isNotRelevant));
};
var $author$project$SyntaxHighlight$Language$Type$Normal = {$: 0};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$SyntaxHighlight$Language$Javascript$groupSet = $elm$core$Set$fromList(
	_List_fromArray(
		['{', '}', '(', ')', '[', ']', ',', ';', '.']));
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $author$project$SyntaxHighlight$Language$Javascript$isGroupChar = function (c) {
	return A2($elm$core$Set$member, c, $author$project$SyntaxHighlight$Language$Javascript$groupSet);
};
var $author$project$SyntaxHighlight$Language$Javascript$groupChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, b);
	},
	$elm$parser$Parser$getChompedString(
		$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Javascript$isGroupChar)));
var $author$project$SyntaxHighlight$Language$Javascript$isCommentChar = function (c) {
	return c === '/';
};
var $author$project$SyntaxHighlight$Language$Javascript$operatorSet = $elm$core$Set$fromList(
	_List_fromArray(
		['+', '-', '*', '/', '=', '!', '<', '>', '&', '|', '?', '^', ':', '~', '%']));
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$core$Set$union = F2(
	function (_v0, _v1) {
		var dict1 = _v0;
		var dict2 = _v1;
		return A2($elm$core$Dict$union, dict1, dict2);
	});
var $author$project$SyntaxHighlight$Language$Javascript$punctuactorSet = A2($elm$core$Set$union, $author$project$SyntaxHighlight$Language$Javascript$operatorSet, $author$project$SyntaxHighlight$Language$Javascript$groupSet);
var $author$project$SyntaxHighlight$Language$Javascript$isPunctuaction = function (c) {
	return A2($elm$core$Set$member, c, $author$project$SyntaxHighlight$Language$Javascript$punctuactorSet);
};
var $author$project$SyntaxHighlight$Language$Javascript$isStringLiteralChar = function (c) {
	return (c === '\"') || ((c === '\'') || (c === '`'));
};
var $author$project$SyntaxHighlight$Language$Helpers$isLineBreak = function (c) {
	return c === '\n';
};
var $author$project$SyntaxHighlight$Language$Helpers$isSpace = function (c) {
	return (c === ' ') || (c === '\t');
};
var $author$project$SyntaxHighlight$Language$Helpers$isWhitespace = function (c) {
	return $author$project$SyntaxHighlight$Language$Helpers$isSpace(c) || $author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c);
};
var $author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar = function (c) {
	return !($author$project$SyntaxHighlight$Language$Javascript$isPunctuaction(c) || ($author$project$SyntaxHighlight$Language$Javascript$isStringLiteralChar(c) || ($author$project$SyntaxHighlight$Language$Javascript$isCommentChar(c) || $author$project$SyntaxHighlight$Language$Helpers$isWhitespace(c))));
};
var $author$project$SyntaxHighlight$Language$Type$C = function (a) {
	return {$: 3, a: a};
};
var $author$project$SyntaxHighlight$Language$Javascript$DeclarationKeyword = 3;
var $author$project$SyntaxHighlight$Language$Javascript$Function = 5;
var $author$project$SyntaxHighlight$Language$Javascript$Keyword = 2;
var $author$project$SyntaxHighlight$Language$Javascript$LiteralKeyword = 6;
var $author$project$SyntaxHighlight$Language$Javascript$Param = 7;
var $author$project$SyntaxHighlight$Language$Javascript$ClassExtends = 8;
var $author$project$SyntaxHighlight$Language$Type$Comment = {$: 1};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $author$project$SyntaxHighlight$Language$Helpers$thenChompWhile = F2(
	function (isNotRelevant, previousParser) {
		return A2(
			$elm$parser$Parser$ignorer,
			previousParser,
			$elm$parser$Parser$chompWhile(isNotRelevant));
	});
var $author$project$SyntaxHighlight$Language$Javascript$inlineComment = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Comment, b)
			]);
	},
	$elm$parser$Parser$getChompedString(
		A2(
			$author$project$SyntaxHighlight$Language$Helpers$thenChompWhile,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$SyntaxHighlight$Language$Helpers$isLineBreak),
			$elm$parser$Parser$symbol('//'))));
var $author$project$SyntaxHighlight$Language$Helpers$addThen = F3(
	function (f, list, plist) {
		return A2(
			$elm$parser$Parser$andThen,
			function (n) {
				return f(
					_Utils_ap(n, list));
			},
			plist);
	});
var $author$project$SyntaxHighlight$Language$Helpers$consThen = F3(
	function (f, list, pn) {
		return A2(
			$elm$parser$Parser$andThen,
			function (n) {
				return f(
					A2($elm$core$List$cons, n, list));
			},
			pn);
	});
var $author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable = F2(
	function (options, revAList) {
		var defaultMap = options.d4;
		var isNotRelevant = options.es;
		var end = options.d8;
		var innerParsers = options.ep;
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$cons,
							defaultMap(end),
							revAList)),
					$elm$parser$Parser$symbol(end)),
					A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(revAList),
					$elm$parser$Parser$end),
					A3(
					$author$project$SyntaxHighlight$Language$Helpers$addThen,
					$author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					$elm$parser$Parser$oneOf(innerParsers)),
					A3(
					$author$project$SyntaxHighlight$Language$Helpers$consThen,
					$author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					A2(
						$elm$parser$Parser$map,
						defaultMap,
						$elm$parser$Parser$getChompedString(
							A2(
								$author$project$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$always(true))))))
				]));
	});
var $author$project$SyntaxHighlight$Language$Helpers$delimitedNestable = F3(
	function (nestLevel, options, revAList) {
		var defaultMap = options.d4;
		var isNotRelevant = options.es;
		var start = options.fh;
		var end = options.d8;
		var innerParsers = options.ep;
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$andThen,
					function (n) {
						return (nestLevel === 1) ? $elm$parser$Parser$succeed(n) : A3($author$project$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel - 1, options, n);
					},
					A2(
						$elm$parser$Parser$map,
						$elm$core$Basics$always(
							A2(
								$elm$core$List$cons,
								defaultMap(end),
								revAList)),
						$elm$parser$Parser$symbol(end))),
					A3(
					$author$project$SyntaxHighlight$Language$Helpers$consThen,
					A2($author$project$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel + 1, options),
					revAList,
					A2(
						$elm$parser$Parser$map,
						defaultMap,
						$elm$parser$Parser$getChompedString(
							A2(
								$author$project$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								$elm$parser$Parser$symbol(start))))),
					A3(
					$author$project$SyntaxHighlight$Language$Helpers$addThen,
					$author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options),
					revAList,
					$elm$parser$Parser$oneOf(innerParsers)),
					A2(
					$elm$parser$Parser$map,
					$elm$core$Basics$always(revAList),
					$elm$parser$Parser$end),
					A3(
					$author$project$SyntaxHighlight$Language$Helpers$consThen,
					A2($author$project$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel, options),
					revAList,
					A2(
						$elm$parser$Parser$map,
						defaultMap,
						$elm$parser$Parser$getChompedString(
							A2(
								$author$project$SyntaxHighlight$Language$Helpers$thenChompWhile,
								isNotRelevant,
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$always(true))))))
				]));
	});
var $author$project$SyntaxHighlight$Language$Helpers$delimitedHelp = F2(
	function (options, revAList) {
		var start = options.fh;
		var end = options.d8;
		var isNotRelevant = options.es;
		var _v0 = _Utils_Tuple2(
			$elm$core$String$uncons(options.fh),
			$elm$core$String$uncons(options.d8));
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			return $elm$parser$Parser$problem('Trying to parse a delimited helper, but the start token cannot be an empty string!');
		} else {
			if (_v0.b.$ === 1) {
				var _v2 = _v0.b;
				return $elm$parser$Parser$problem('Trying to parse a delimited helper, but the end token cannot be an empty string!');
			} else {
				var _v3 = _v0.a.a;
				var startChar = _v3.a;
				var _v4 = _v0.b.a;
				var endChar = _v4.a;
				return options.er ? A3(
					$author$project$SyntaxHighlight$Language$Helpers$delimitedNestable,
					1,
					_Utils_update(
						options,
						{
							es: function (c) {
								return isNotRelevant(c) && ((!_Utils_eq(c, startChar)) && (!_Utils_eq(c, endChar)));
							}
						}),
					revAList) : A2(
					$author$project$SyntaxHighlight$Language$Helpers$delimitedUnnestable,
					_Utils_update(
						options,
						{
							es: function (c) {
								return isNotRelevant(c) && (!_Utils_eq(c, endChar));
							}
						}),
					revAList);
			}
		}
	});
var $author$project$SyntaxHighlight$Language$Helpers$delimited = function (options) {
	var start = options.fh;
	var isNotRelevant = options.es;
	var defaultMap = options.d4;
	return A2(
		$elm$parser$Parser$andThen,
		function (n) {
			return A2(
				$author$project$SyntaxHighlight$Language$Helpers$delimitedHelp,
				options,
				_List_fromArray(
					[n]));
		},
		A2(
			$elm$parser$Parser$map,
			$elm$core$Basics$always(
				defaultMap(start)),
			$elm$parser$Parser$symbol(start)));
};
var $author$project$SyntaxHighlight$Language$Javascript$lineBreakList = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _List_fromArray(
			[
				_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$LineBreak, '\n')
			]);
	},
	$elm$parser$Parser$symbol('\n'));
var $author$project$SyntaxHighlight$Language$Javascript$multilineComment = $author$project$SyntaxHighlight$Language$Helpers$delimited(
	{
		d4: function (b) {
			return _Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Comment, b);
		},
		d8: '*/',
		ep: _List_fromArray(
			[$author$project$SyntaxHighlight$Language$Javascript$lineBreakList]),
		er: false,
		es: function (c) {
			return !$author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c);
		},
		fh: '/*'
	});
var $author$project$SyntaxHighlight$Language$Javascript$comment = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$author$project$SyntaxHighlight$Language$Javascript$inlineComment, $author$project$SyntaxHighlight$Language$Javascript$multilineComment]));
var $author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Helpers$isSpace))),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$author$project$SyntaxHighlight$Language$Javascript$lineBreakList),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$author$project$SyntaxHighlight$Language$Javascript$comment)
			]));
};
var $author$project$SyntaxHighlight$Language$Javascript$classExtendsLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(8),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Javascript$classDeclarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$andThen,
				function (n) {
					return (n === 'extends') ? A2(
						$elm$parser$Parser$map,
						$elm$parser$Parser$Loop,
						A2(
							$elm$parser$Parser$loop,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$author$project$SyntaxHighlight$Language$Type$C(2),
									n),
								revTokens),
							$author$project$SyntaxHighlight$Language$Javascript$classExtendsLoop)) : $elm$parser$Parser$succeed(
						$elm$parser$Parser$Loop(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$author$project$SyntaxHighlight$Language$Type$C(5),
									n),
								revTokens)));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Javascript$argLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(7),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return !($author$project$SyntaxHighlight$Language$Javascript$isCommentChar(c) || ($author$project$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ((c === ',') || (c === ')'))));
						}))),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return (c === '/') || (c === ',');
						}))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Javascript$functionDeclarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(5),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar))),
				A2(
				$elm$parser$Parser$map,
				function (_v0) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(2),
								'*'),
							revTokens));
				},
				$elm$parser$Parser$symbol('*')),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (_v1) {
						return A2(
							$elm$parser$Parser$loop,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, '('),
								revTokens),
							$author$project$SyntaxHighlight$Language$Javascript$argLoop);
					},
					$elm$parser$Parser$symbol('('))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Javascript$FunctionEval = 4;
var $author$project$SyntaxHighlight$Language$Javascript$functionEvalLoop = F3(
	function (identifier, revTokens, thisRevToken) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(thisRevToken),
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return $elm$parser$Parser$Done(
							_Utils_ap(
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, '('),
									thisRevToken),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										$author$project$SyntaxHighlight$Language$Type$C(4),
										identifier),
									revTokens)));
					},
					$elm$parser$Parser$symbol('(')),
					$elm$parser$Parser$succeed(
					$elm$parser$Parser$Done(
						_Utils_ap(
							thisRevToken,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, identifier),
								revTokens))))
				]));
	});
var $author$project$SyntaxHighlight$Language$Javascript$declarationKeywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['var', 'const', 'let']));
var $author$project$SyntaxHighlight$Language$Javascript$isDeclarationKeyword = function (str) {
	return A2($elm$core$Set$member, str, $author$project$SyntaxHighlight$Language$Javascript$declarationKeywordSet);
};
var $author$project$SyntaxHighlight$Language$Javascript$keywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['await', 'break', 'do', 'instanceof', 'typeof', 'case', 'else', 'new', 'catch', 'finally', 'return', 'void', 'continue', 'for', 'switch', 'while', 'debugger', 'this', 'with', 'default', 'if', 'throw', 'delete', 'in', 'try', 'enum', 'extends', 'export', 'import', 'implements', 'private', 'public', 'yield', 'interface', 'package', 'protected']));
var $author$project$SyntaxHighlight$Language$Javascript$isKeyword = function (str) {
	return A2($elm$core$Set$member, str, $author$project$SyntaxHighlight$Language$Javascript$keywordSet);
};
var $author$project$SyntaxHighlight$Language$Javascript$literalKeywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['true', 'false', 'null', 'undefined', 'NaN', 'Infinity']));
var $author$project$SyntaxHighlight$Language$Javascript$isLiteralKeyword = function (str) {
	return A2($elm$core$Set$member, str, $author$project$SyntaxHighlight$Language$Javascript$literalKeywordSet);
};
var $author$project$SyntaxHighlight$Language$Javascript$keywordParser = F2(
	function (revTokens, n) {
		return ((n === 'function') || (n === 'static')) ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens),
			$author$project$SyntaxHighlight$Language$Javascript$functionDeclarationLoop) : ((n === 'class') ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens),
			$author$project$SyntaxHighlight$Language$Javascript$classDeclarationLoop) : (((n === 'this') || (n === 'super')) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(7),
					n),
				revTokens)) : ((n === 'constructor') ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(5),
					n),
				revTokens),
			$author$project$SyntaxHighlight$Language$Javascript$functionDeclarationLoop) : ($author$project$SyntaxHighlight$Language$Javascript$isKeyword(n) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(2),
					n),
				revTokens)) : ($author$project$SyntaxHighlight$Language$Javascript$isDeclarationKeyword(n) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens)) : ($author$project$SyntaxHighlight$Language$Javascript$isLiteralKeyword(n) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(6),
					n),
				revTokens)) : A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			A2($author$project$SyntaxHighlight$Language$Javascript$functionEvalLoop, n, revTokens))))))));
	});
var $author$project$SyntaxHighlight$Language$Javascript$Number = 0;
var $elm$parser$Parser$ExpectingKeyword = function (a) {
	return {$: 9, a: a};
};
var $elm$parser$Parser$Advanced$keyword = function (_v0) {
	var kwd = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(kwd);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, kwd, s.eO, s.e7, s.d_, s.hj);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return (_Utils_eq(newOffset, -1) || (0 <= A3(
			$elm$parser$Parser$Advanced$isSubChar,
			function (c) {
				return $elm$core$Char$isAlphaNum(c) || (c === '_');
			},
			newOffset,
			s.hj))) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{d_: newCol, b: s.b, d: s.d, eO: newOffset, e7: newRow, hj: s.hj});
	};
};
var $elm$parser$Parser$keyword = function (kwd) {
	return $elm$parser$Parser$Advanced$keyword(
		A2(
			$elm$parser$Parser$Advanced$Token,
			kwd,
			$elm$parser$Parser$ExpectingKeyword(kwd)));
};
var $elm$parser$Parser$ExpectingBinary = {$: 4};
var $elm$parser$Parser$ExpectingFloat = {$: 5};
var $elm$parser$Parser$ExpectingHex = {$: 2};
var $elm$parser$Parser$ExpectingNumber = {$: 6};
var $elm$parser$Parser$ExpectingOctal = {$: 3};
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$parser$Parser$number = function (i) {
	return $elm$parser$Parser$Advanced$number(
		{
			fT: A2($elm$core$Result$fromMaybe, $elm$parser$Parser$ExpectingBinary, i.fT),
			eb: $elm$parser$Parser$ExpectingNumber,
			gt: A2($elm$core$Result$fromMaybe, $elm$parser$Parser$ExpectingFloat, i.gt),
			gv: A2($elm$core$Result$fromMaybe, $elm$parser$Parser$ExpectingHex, i.gv),
			gD: A2($elm$core$Result$fromMaybe, $elm$parser$Parser$ExpectingInt, i.gD),
			gG: $elm$parser$Parser$ExpectingNumber,
			gX: A2($elm$core$Result$fromMaybe, $elm$parser$Parser$ExpectingOctal, i.gX)
		});
};
var $author$project$SyntaxHighlight$Language$Helpers$num = $elm$parser$Parser$number(
	{
		fT: $elm$core$Maybe$Just(
			function (_v0) {
				return 0;
			}),
		gt: $elm$core$Maybe$Just(
			function (_v1) {
				return 0;
			}),
		gv: $elm$core$Maybe$Just(
			function (_v2) {
				return 0;
			}),
		gD: $elm$core$Maybe$Just(
			function (_v3) {
				return 0;
			}),
		gX: $elm$core$Maybe$Just(
			function (_v4) {
				return 0;
			})
	});
var $author$project$SyntaxHighlight$Language$Helpers$negativeNumber = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$symbol('-')),
	$author$project$SyntaxHighlight$Language$Helpers$num);
var $author$project$SyntaxHighlight$Language$Helpers$positiveNumber = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return 0;
	},
	$author$project$SyntaxHighlight$Language$Helpers$num);
var $author$project$SyntaxHighlight$Language$Helpers$number = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$map,
			function (_v0) {
				return 0;
			},
			$elm$parser$Parser$keyword('0x...')),
			A2(
			$elm$parser$Parser$map,
			function (_v1) {
				return 0;
			},
			$elm$parser$Parser$keyword('0xMyAccount')),
			A2(
			$elm$parser$Parser$map,
			function (_v2) {
				return 0;
			},
			$elm$parser$Parser$keyword('0xLiquidator')),
			A2(
			$elm$parser$Parser$map,
			function (_v3) {
				return 0;
			},
			$elm$parser$Parser$keyword('0xBorrower')),
			A2(
			$elm$parser$Parser$map,
			function (_v4) {
				return 0;
			},
			$elm$parser$Parser$keyword('0xPayer')),
			A2(
			$elm$parser$Parser$map,
			function (_v5) {
				return 0;
			},
			$elm$parser$Parser$keyword('0xToken')),
			$author$project$SyntaxHighlight$Language$Helpers$negativeNumber,
			$elm$parser$Parser$backtrackable($author$project$SyntaxHighlight$Language$Helpers$positiveNumber)
		]));
var $author$project$SyntaxHighlight$Language$Javascript$number = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$author$project$SyntaxHighlight$Language$Type$C(0),
			b);
	},
	$elm$parser$Parser$getChompedString($author$project$SyntaxHighlight$Language$Helpers$number));
var $author$project$SyntaxHighlight$Language$Javascript$isOperatorChar = function (c) {
	return A2($elm$core$Set$member, c, $author$project$SyntaxHighlight$Language$Javascript$operatorSet);
};
var $author$project$SyntaxHighlight$Language$Javascript$operatorChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$author$project$SyntaxHighlight$Language$Type$C(2),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Javascript$isOperatorChar)));
var $author$project$SyntaxHighlight$Language$Javascript$String = 1;
var $author$project$SyntaxHighlight$Language$Helpers$isEscapable = function (c) {
	return c === '\\';
};
var $author$project$SyntaxHighlight$Language$Helpers$escapableSet = $elm$core$Set$fromList(
	_List_fromArray(
		['\'', '\"', '\\', 'n', 'r', 't', 'b', 'f', 'v']));
var $author$project$SyntaxHighlight$Language$Helpers$isEscapableChar = function (c) {
	return A2($elm$core$Set$member, c, $author$project$SyntaxHighlight$Language$Helpers$escapableSet);
};
var $author$project$SyntaxHighlight$Language$Helpers$escapable = A2(
	$elm$parser$Parser$ignorer,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed(0),
		$elm$parser$Parser$backtrackable(
			$elm$parser$Parser$symbol('\\'))),
	$elm$parser$Parser$chompIf($author$project$SyntaxHighlight$Language$Helpers$isEscapableChar));
var $author$project$SyntaxHighlight$Language$Javascript$jsEscapable = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$SyntaxHighlight$Language$Type$C(6),
				b)
			]);
	},
	$elm$parser$Parser$getChompedString($author$project$SyntaxHighlight$Language$Helpers$escapable));
var $author$project$SyntaxHighlight$Language$Javascript$quoteDelimiter = {
	d4: function (b) {
		return _Utils_Tuple2(
			$author$project$SyntaxHighlight$Language$Type$C(1),
			b);
	},
	d8: '\'',
	ep: _List_fromArray(
		[$author$project$SyntaxHighlight$Language$Javascript$lineBreakList, $author$project$SyntaxHighlight$Language$Javascript$jsEscapable]),
	er: false,
	es: function (c) {
		return !($author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $author$project$SyntaxHighlight$Language$Helpers$isEscapable(c));
	},
	fh: '\''
};
var $author$project$SyntaxHighlight$Language$Javascript$doubleQuote = $author$project$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$author$project$SyntaxHighlight$Language$Javascript$quoteDelimiter,
		{d8: '\"', fh: '\"'}));
var $author$project$SyntaxHighlight$Language$Javascript$quote = $author$project$SyntaxHighlight$Language$Helpers$delimited($author$project$SyntaxHighlight$Language$Javascript$quoteDelimiter);
var $author$project$SyntaxHighlight$Language$Javascript$templateString = $author$project$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$author$project$SyntaxHighlight$Language$Javascript$quoteDelimiter,
		{
			d8: '`',
			ep: _List_fromArray(
				[$author$project$SyntaxHighlight$Language$Javascript$lineBreakList, $author$project$SyntaxHighlight$Language$Javascript$jsEscapable]),
			es: function (c) {
				return !($author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $author$project$SyntaxHighlight$Language$Helpers$isEscapable(c));
			},
			fh: '`'
		}));
var $author$project$SyntaxHighlight$Language$Javascript$stringLiteral = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$author$project$SyntaxHighlight$Language$Javascript$quote, $author$project$SyntaxHighlight$Language$Javascript$doubleQuote, $author$project$SyntaxHighlight$Language$Javascript$templateString]));
var $author$project$SyntaxHighlight$Language$Javascript$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Javascript$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(s, revTokens));
				},
				$author$project$SyntaxHighlight$Language$Javascript$stringLiteral),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, s, revTokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$author$project$SyntaxHighlight$Language$Javascript$operatorChar, $author$project$SyntaxHighlight$Language$Javascript$groupChar, $author$project$SyntaxHighlight$Language$Javascript$number]))),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					$author$project$SyntaxHighlight$Language$Javascript$keywordParser(revTokens),
					$elm$parser$Parser$getChompedString(
						$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Javascript$isIdentifierNameChar)))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Javascript$toRevTokens = A2($elm$parser$Parser$loop, _List_Nil, $author$project$SyntaxHighlight$Language$Javascript$mainLoop);
var $author$project$SyntaxHighlight$Language$Javascript$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($author$project$SyntaxHighlight$Language$Javascript$toRevTokens),
	$elm$core$Result$map(
		$author$project$SyntaxHighlight$Line$Helpers$toLines($author$project$SyntaxHighlight$Language$Javascript$syntaxToStyle)));
var $author$project$SyntaxHighlight$javascript = A2(
	$elm$core$Basics$composeR,
	$author$project$SyntaxHighlight$Language$Javascript$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $author$project$SyntaxHighlight$Line$Add = 1;
var $author$project$SyntaxHighlight$Line$Del = 2;
var $author$project$SyntaxHighlight$Line$Normal = 0;
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $author$project$SyntaxHighlight$View$requiredStyleToString = function (required) {
	return 'elmsh' + function () {
		switch (required) {
			case 0:
				return '0';
			case 1:
				return '-comm';
			case 2:
				return '1';
			case 3:
				return '2';
			case 4:
				return '3';
			case 5:
				return '4';
			case 6:
				return '5';
			case 7:
				return '6';
			default:
				return '7';
		}
	}();
};
var $author$project$SyntaxHighlight$View$fragmentView = function (_v0) {
	var text = _v0.hx;
	var requiredStyle = _v0.hc;
	var additionalClass = _v0.fO;
	return ((!requiredStyle) && $elm$core$String$isEmpty(additionalClass)) ? $elm$html$Html$text(text) : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2(
						$author$project$SyntaxHighlight$View$requiredStyleToString(requiredStyle),
						!(!requiredStyle)),
						_Utils_Tuple2('elmsh-' + additionalClass, additionalClass !== '')
					]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
};
var $author$project$SyntaxHighlight$View$lineView = F3(
	function (start, index, _v0) {
		var fragments = _v0.gu;
		var highlight = _v0.gx;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('elmsh-line', true),
							_Utils_Tuple2(
							'elmsh-hl',
							_Utils_eq(
								highlight,
								$elm$core$Maybe$Just(0))),
							_Utils_Tuple2(
							'elmsh-add',
							_Utils_eq(
								highlight,
								$elm$core$Maybe$Just(1))),
							_Utils_Tuple2(
							'elmsh-del',
							_Utils_eq(
								highlight,
								$elm$core$Maybe$Just(2)))
						])),
					A2(
					$elm$html$Html$Attributes$attribute,
					'data-elmsh-lc',
					$elm$core$String$fromInt(start + index))
				]),
			A2($elm$core$List$map, $author$project$SyntaxHighlight$View$fragmentView, fragments));
	});
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $author$project$SyntaxHighlight$View$toInlineHtml = function (lines) {
	return A2(
		$elm$html$Html$code,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('elmsh')
			]),
		$elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var highlight = _v0.gx;
					var fragments = _v0.gu;
					return _Utils_eq(highlight, $elm$core$Maybe$Nothing) ? A2($elm$core$List$map, $author$project$SyntaxHighlight$View$fragmentView, fragments) : _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'elmsh-hl',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(0))),
											_Utils_Tuple2(
											'elmsh-add',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(1))),
											_Utils_Tuple2(
											'elmsh-del',
											_Utils_eq(
												highlight,
												$elm$core$Maybe$Just(2)))
										]))
								]),
							A2($elm$core$List$map, $author$project$SyntaxHighlight$View$fragmentView, fragments))
						]);
				},
				lines)));
};
var $author$project$SyntaxHighlight$View$toBlockHtml = F2(
	function (maybeStart, lines) {
		if (maybeStart.$ === 1) {
			return A2(
				$elm$html$Html$pre,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('elmsh')
					]),
				_List_fromArray(
					[
						$author$project$SyntaxHighlight$View$toInlineHtml(lines)
					]));
		} else {
			var start = maybeStart.a;
			return A2(
				$elm$html$Html$pre,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('elmsh')
					]),
				$elm$core$List$singleton(
					A2(
						$elm$html$Html$code,
						_List_Nil,
						A2(
							$elm$core$List$indexedMap,
							$author$project$SyntaxHighlight$View$lineView(start),
							lines))));
		}
	});
var $author$project$SyntaxHighlight$toBlockHtml = F2(
	function (maybeStart, _v0) {
		var lines = _v0;
		return A2($author$project$SyntaxHighlight$View$toBlockHtml, maybeStart, lines);
	});
var $author$project$Utils$Highlighter$highlight = function (jsCode) {
	return A2(
		$elm$core$Result$withDefault,
		A2(
			$elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(jsCode)
				])),
		A2(
			$elm$core$Result$map,
			$author$project$SyntaxHighlight$toBlockHtml(
				$elm$core$Maybe$Just(1)),
			$author$project$SyntaxHighlight$javascript(jsCode)));
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Utils$RenderHelper$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $author$project$Utils$RenderHelper$toVirtualDom = function (nodes) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$p,
			_List_Nil,
			A2($elm$core$List$map, $author$project$Utils$RenderHelper$toVirtualDomEach, nodes))
		]);
};
var $author$project$Utils$RenderHelper$toVirtualDomEach = function (node) {
	_v0$2:
	while (true) {
		switch (node.$) {
			case 1:
				if ((node.c.b && (!node.c.a.$)) && (!node.c.b.b)) {
					switch (node.a) {
						case 'code':
							var attrs = node.b;
							var _v1 = node.c;
							var s = _v1.a.a;
							return $author$project$Utils$Highlighter$highlight(s);
						case 'span':
							if (((node.b.b && (node.b.a.a === 'class')) && (node.b.a.b === 'inline-code')) && (!node.b.b.b)) {
								var _v2 = node.b;
								var _v3 = _v2.a;
								var _v4 = node.c;
								var s = _v4.a.a;
								return A3(
									$elm$html$Html$node,
									'span',
									A2(
										$elm$core$List$map,
										$author$project$Utils$RenderHelper$toAttribute,
										_List_fromArray(
											[
												_Utils_Tuple2('class', 'inline-code')
											])),
									_List_fromArray(
										[
											$elm$html$Html$text(s)
										]));
							} else {
								break _v0$2;
							}
						default:
							break _v0$2;
					}
				} else {
					break _v0$2;
				}
			case 0:
				var s = node.a;
				var _v5 = A2($elm$core$String$endsWith, '[Optional]', s) ? _Utils_Tuple2(
					'optional',
					A3($elm$core$String$replace, '[Optional]', '', s)) : _Utils_Tuple2('', s);
				var className = _v5.a;
				var sanitized = _v5.b;
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class(className)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(sanitized)
						]));
			default:
				return $elm$html$Html$text('');
		}
	}
	var name = node.a;
	var attrs = node.b;
	var children = node.c;
	return A3(
		$elm$html$Html$node,
		name,
		A2($elm$core$List$map, $author$project$Utils$RenderHelper$toAttribute, attrs),
		$author$project$Utils$RenderHelper$toVirtualDom(children));
};
var $author$project$LandingSite$DevelopersAPI$renderDescription = function (description) {
	return A2(
		$elm$core$Result$withDefault,
		A2($elm$html$Html$div, _List_Nil, _List_Nil),
		A2(
			$elm$core$Result$map,
			$elm$html$Html$div(
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('description')
					])),
			A2(
				$elm$core$Result$map,
				$author$project$Utils$RenderHelper$toVirtualDom,
				$hecrj$html_parser$Html$Parser$run(description))));
};
var $elm$html$Html$small = _VirtualDom_node('small');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$LandingSite$DevelopersAPI$renderField = function (_v0) {
	var name = _v0.gT;
	var description = _v0.d5;
	var fieldType = _v0.aX;
	return A2(
		$elm$html$Html$tr,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$small,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(fieldType)
							]))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							]))
					])),
				A2(
				$elm$html$Html$td,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$LandingSite$DevelopersAPI$renderDescription(description)
					]))
			]));
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $author$project$LandingSite$DevelopersAPI$renderMessage = function (message) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Utils$CompoundHtmlAttributes$id(message.gT)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h4,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(message.gT)
					])),
				$author$project$LandingSite$DevelopersAPI$renderDescription(message.d5),
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('api-table')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Type')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Key')
											])),
										A2(
										$elm$html$Html$th,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Description')
											]))
									]))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2($elm$core$List$map, $author$project$LandingSite$DevelopersAPI$renderField, message.bI))
					]))
			]));
};
var $author$project$LandingSite$DevelopersAPI$renderMethod = F2(
	function (messages, method) {
		var _v0 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(
				A2($elm$html$Html$div, _List_Nil, _List_Nil),
				_List_Nil),
			A2(
				$elm$core$Maybe$map,
				function (methodResponse) {
					return _Utils_Tuple2(
						$author$project$LandingSite$DevelopersAPI$renderMessage(methodResponse),
						A2(
							$elm$core$List$map,
							function ($) {
								return $.aX;
							},
							methodResponse.bI));
				},
				A2($elm$core$Dict$get, method.e6, messages)));
		var responseMessageHtml = _v0.a;
		var responseMessageFieldTypes = _v0.b;
		var _v1 = A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(
				A2($elm$html$Html$div, _List_Nil, _List_Nil),
				_List_Nil),
			A2(
				$elm$core$Maybe$map,
				function (methodRequest) {
					return _Utils_Tuple2(
						$author$project$LandingSite$DevelopersAPI$renderMessage(methodRequest),
						A2(
							$elm$core$List$map,
							function ($) {
								return $.aX;
							},
							methodRequest.bI));
				},
				A2($elm$core$Dict$get, method.e4, messages)));
		var requestMessageHtml = _v1.a;
		var requestMessageFieldTypes = _v1.b;
		var restMessagesHtml = function () {
			var usedFieldTypesSet = $elm$core$Set$fromList(
				_Utils_ap(requestMessageFieldTypes, responseMessageFieldTypes));
			var remainingMessages = A2(
				$elm$core$Dict$remove,
				method.e6,
				A2($elm$core$Dict$remove, method.e4, messages));
			var subFieldTypes = $elm$core$List$concat(
				A2(
					$elm$core$List$filterMap,
					function (message) {
						return A2($elm$core$Set$member, message.gT, usedFieldTypesSet) ? $elm$core$Maybe$Just(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.aX;
								},
								message.bI)) : $elm$core$Maybe$Nothing;
					},
					$elm$core$Dict$values(remainingMessages)));
			var fullFieldTypesSet = $elm$core$Set$fromList(
				_Utils_ap(
					requestMessageFieldTypes,
					_Utils_ap(responseMessageFieldTypes, subFieldTypes)));
			var filteredMessages = A2(
				$elm$core$List$filter,
				function (message) {
					return A2($elm$core$Set$member, message.gT, fullFieldTypesSet);
				},
				$elm$core$Dict$values(remainingMessages));
			return A2($elm$core$List$map, $author$project$LandingSite$DevelopersAPI$renderMessage, filteredMessages);
		}();
		return _Utils_ap(
			A2(
				$elm$core$List$map,
				function (rule) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('endpoint')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(rule.gP + ': ')
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(rule.g4)
									]))
							]));
				},
				method.hh),
			_List_fromArray(
				[
					requestMessageHtml,
					responseMessageHtml,
					A2($elm$html$Html$div, _List_Nil, restMessagesHtml)
				]));
	});
var $author$project$LandingSite$DevelopersAPI$serviceView = F2(
	function (messages, service) {
		var rest = $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				$author$project$LandingSite$DevelopersAPI$renderMethod(messages),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.gT;
						},
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$startsWith('post_'),
							$elm$core$Basics$not)),
					service.gQ)));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id(service.gT)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(service.gT)
							])),
						$author$project$LandingSite$DevelopersAPI$renderDescription(service.d5),
						A2($elm$html$Html$div, _List_Nil, rest)
					]))
			]);
	});
var $author$project$LandingSite$DevelopersAPI$docView = function (doc) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			$author$project$LandingSite$DevelopersAPI$serviceView(doc.eI),
			$elm$core$Dict$values(doc.fd)));
};
var $author$project$LandingSite$DevelopersAPI$docsView = F2(
	function (protoDoc, docs) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (docName) {
					var _v0 = A2($elm$core$Dict$get, docName, protoDoc);
					if (_v0.$ === 1) {
						return _List_Nil;
					} else {
						var doc = _v0.a;
						return $author$project$LandingSite$DevelopersAPI$docView(doc);
					}
				},
				docs));
	});
var $author$project$Strings$Translations$introduction = function (lang) {
	switch (lang) {
		case 0:
			return 'Introduction';
		case 1:
			return 'Introducción';
		default:
			return '介绍';
	}
};
var $author$project$LandingSite$Developers$protos = _List_fromArray(
	['account.proto', 'ctoken.proto', 'market_history_api.proto', 'governance.proto']);
var $author$project$LandingSite$Developers$apiContent = F2(
	function (userLanguage, protoDoc) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('compound-api')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('big')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Compound API')
							])),
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('subheader')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$introduction(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The Compound API input and output formats are specified by '),
								A2(
								$elm$html$Html$a,
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://developers.google.com/protocol-buffers/'),
								_List_fromArray(
									[
										$elm$html$Html$text('Protocol Buffers')
									])),
								$elm$html$Html$text(', known colloquially as protobufs. Unlike typical protobufs endpoints, the Compound endpoints support JSON for input and output in addition to the protobufs binary format. To use JSON in both the input and the output, specify the headers '),
								A3(
								$elm$html$Html$node,
								'tt',
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('\"Content-Type: application/json\"')
									])),
								$elm$html$Html$text('and '),
								A3(
								$elm$html$Html$node,
								'tt',
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('\"Accept: application/json\"')
									])),
								$elm$html$Html$text('in the request.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('API keys are currently optional, and are included in the HTTP header '),
								A3(
								$elm$html$Html$node,
								'tt',
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('compound-api-key')
									])),
								$elm$html$Html$text('; you can request keys from Compound in the #development channel of our '),
								A2(
								$elm$html$Html$a,
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://discord.gg/874ntdw'),
								_List_fromArray(
									[
										$elm$html$Html$text('Discord')
									])),
								$elm$html$Html$text(' server. In the future, API keys will be required to access the API.')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A2($author$project$LandingSite$DevelopersAPI$docsView, protoDoc, $author$project$LandingSite$Developers$protos)),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('SharedDataTypes')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Shared Data Types')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Custom data types that are shared between services.')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$id('PaginationSummary')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Pagination Summary ')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Used for paginating results.')
									])),
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('api-table')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Type')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Key')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Description')
															]))
													]))
											])),
										A2(
										$elm$html$Html$tbody,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$LandingSite$DevelopersAPI$renderField(
												{d5: 'The current page number', aX: 'uint32', aY: '', gT: 'page_number'}),
												$author$project$LandingSite$DevelopersAPI$renderField(
												{d5: 'The number of entries to show per page.', aX: 'uint32', aY: '', gT: 'page_size'}),
												$author$project$LandingSite$DevelopersAPI$renderField(
												{d5: 'The number of items matching the request across all pages.', aX: 'uint32', aY: '', gT: 'total_entries'}),
												$author$project$LandingSite$DevelopersAPI$renderField(
												{d5: 'The number of pages need to show total_entries at the given page_size.', aX: 'uint32', aY: '', gT: 'total_pages'})
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$id('Precise')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Precise ')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('For non-negative numbers only.')
									])),
								A2(
								$elm$html$Html$table,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('api-table')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$thead,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Type')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Key')
															])),
														A2(
														$elm$html$Html$th,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Description')
															]))
													]))
											])),
										A2(
										$elm$html$Html$tbody,
										_List_Nil,
										_List_fromArray(
											[
												$author$project$LandingSite$DevelopersAPI$renderField(
												{d5: 'The full UNSIGNED number in string form. max value is 2^257 - 1,aka 231584178474632390847141970017375815706539969331281128078915168015826259279871', aX: 'string', aY: '', gT: 'value'})
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$LandingSite$DevelopersAPI$listServiceView = F2(
	function (messages, service) {
		return _List_fromArray(
			[
				_Utils_Tuple2('#' + service.gT, service.gT)
			]);
	});
var $author$project$LandingSite$DevelopersAPI$navListView = function (doc) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			$author$project$LandingSite$DevelopersAPI$listServiceView(doc.eI),
			$elm$core$Dict$values(doc.fd)));
};
var $author$project$LandingSite$DevelopersAPI$navList = F2(
	function (protoDoc, docs) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (docName) {
					var _v0 = A2($elm$core$Dict$get, docName, protoDoc);
					if (_v0.$ === 1) {
						return _List_Nil;
					} else {
						var doc = _v0.a;
						return $author$project$LandingSite$DevelopersAPI$navListView(doc);
					}
				},
				docs));
	});
var $author$project$LandingSite$Developers$apiNavList = F2(
	function (userLanguage, protoDoc) {
		return _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'#compound-api',
					$author$project$Strings$Translations$introduction(userLanguage))
				]),
			_Utils_ap(
				A2($author$project$LandingSite$DevelopersAPI$navList, protoDoc, $author$project$LandingSite$Developers$protos),
				_List_fromArray(
					[
						_Utils_Tuple2('#SharedDataTypes', 'Shared Data Types')
					])));
	});
var $author$project$Strings$Translations$borrow = function (lang) {
	switch (lang) {
		case 0:
			return 'Borrow';
		case 1:
			return 'Pedir prestado';
		default:
			return '借贷';
	}
};
var $author$project$Strings$Translations$borrow_balance = function (lang) {
	switch (lang) {
		case 0:
			return 'Borrow Balance';
		case 1:
			return 'Saldo prestado';
		default:
			return '借贷余额';
	}
};
var $author$project$Strings$Translations$borrow_rate = function (lang) {
	switch (lang) {
		case 0:
			return 'Borrow Rate';
		case 1:
			return 'Tasa de préstamo';
		default:
			return '借款利率';
	}
};
var $author$project$Strings$Translations$cether = function (lang) {
	switch (lang) {
		case 0:
			return 'CEther';
		case 1:
			return 'CEther';
		default:
			return 'CEther';
	}
};
var $author$project$Strings$Translations$docs_approve_prereq_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'approve';
		case 1:
			return 'aprobar';
		default:
			return '批准';
	}
};
var $author$project$Strings$Translations$docs_approve_prereq_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ' the cToken to access their token balance.';
		case 1:
			return 'los cToken para acceder a su saldo de fichas.';
		default:
			return 'cToken访问其令牌余额。';
	}
};
var $author$project$Strings$Translations$docs_borrow_balance_account_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account which borrowed the assets.';
		case 1:
			return 'La cuenta que tomó prestados los activos.';
		default:
			return '借入资产的账户。';
	}
};
var $author$project$Strings$Translations$docs_borrow_balance_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'A user who borrows assets from the protocol is subject to accumulated interest based on the current ';
		case 1:
			return 'Un usuario que toma prestados activos del protocolo está sujeto a intereses acumulados basados en el actual';
		default:
			return '从协议借用资产的用户根据当前的累积利息';
	}
};
var $author$project$Strings$Translations$docs_borrow_balance_description_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'borrow rate';
		case 1:
			return 'tasa de préstamo';
		default:
			return '借款利率';
	}
};
var $author$project$Strings$Translations$docs_borrow_balance_description_part3 = function (lang) {
	switch (lang) {
		case 0:
			return '. Interest is accumulated every block and integrations may use this function to obtain the current value of a user\'s borrow balance with interest.';
		case 1:
			return '. Los intereses se acumulan en cada bloque y las integraciones pueden usar esta función para obtener el valor actual del saldo del préstamo de un usuario con intereses.';
		default:
			return '。每个块累积利息，并且集成可以使用该函数来获得用户的借入余额的当前值。';
	}
};
var $author$project$Strings$Translations$docs_borrow_balance_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The user\'s current borrow balance (with interest) in units of the underlying asset.';
		case 1:
			return 'El saldo actual del préstamo del usuario (con intereses) en unidades del activo subyacente.';
		default:
			return '用户以标的资产为单位的当前借入余额（有利息）。';
	}
};
var $author$project$Strings$Translations$docs_borrow_borrow_amount_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The amount of the underlying asset to be borrowed.';
		case 1:
			return 'El monto del activo subyacente a ser prestado.';
		default:
			return '要借入的标的资产的金额。';
	}
};
var $author$project$Strings$Translations$docs_borrow_description1_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The borrow function transfers an asset from the protocol to the user, and creates a borrow balance which begins accumulating interest based on the ';
		case 1:
			return 'The borrow function transfers an asset from the protocol to the user, and creates a borrow balance which begins accumulating interest based on the ';
		default:
			return 'The borrow function transfers an asset from the protocol to the user, and creates a borrow balance which begins accumulating interest based on the ';
	}
};
var $author$project$Strings$Translations$docs_borrow_description1_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'Borrow Rate';
		case 1:
			return 'Borrow Rate';
		default:
			return 'Borrow Rate';
	}
};
var $author$project$Strings$Translations$docs_borrow_description1_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ' for the asset. ';
		case 1:
			return ' for the asset.';
		default:
			return ' for the asset.';
	}
};
var $author$project$Strings$Translations$docs_borrow_description1_part4 = function (lang) {
	switch (lang) {
		case 0:
			return 'The amount borrowed must be less than the user\'s ';
		case 1:
			return 'The amount borrowed must be less than the user\'s ';
		default:
			return 'The amount borrowed must be less than the user\'s ';
	}
};
var $author$project$Strings$Translations$docs_borrow_description1_part5 = function (lang) {
	switch (lang) {
		case 0:
			return 'Account Liquidity';
		case 1:
			return 'Account Liquidity';
		default:
			return 'Account Liquidity';
	}
};
var $author$project$Strings$Translations$docs_borrow_description1_part6 = function (lang) {
	switch (lang) {
		case 0:
			return ' and the market\'s available liquidity.';
		case 1:
			return ' and the market\'s available liquidity.';
		default:
			return ' and the market\'s available liquidity.';
	}
};
var $author$project$Strings$Translations$docs_borrow_description2 = function (lang) {
	switch (lang) {
		case 0:
			return 'To borrow Ether, the borrower must be \'payable\' (solidity).';
		case 1:
			return 'To borrow Ether, the borrower must be \'payable\' (solidity).';
		default:
			return 'To borrow Ether, the borrower must be \'payable\' (solidity).';
	}
};
var $author$project$Strings$Translations$docs_borrow_msg_value_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account to which borrowed funds shall be transferred.';
		case 1:
			return 'La cuenta a la que se transferirán los fondos prestados.';
		default:
			return '借入资金的转账账户。';
	}
};
var $author$project$Strings$Translations$docs_borrow_rate_description = function (lang) {
	switch (lang) {
		case 0:
			return 'At any point in time one may query the contract to get the current borrow rate per block.';
		case 1:
			return 'En cualquier momento, se puede consultar el contrato para obtener la tasa de préstamo actual por bloque.';
		default:
			return '在任何时间点，人们都可以查询合约以获得每个区块的当前借入利率。';
	}
};
var $author$project$Strings$Translations$docs_borrow_rate_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The current borrow rate as an unsigned integer, scaled by 1e18.';
		case 1:
			return 'La tasa de préstamo actual como un entero sin signo, escalada en 1e18.';
		default:
			return '当前借入利率为无符号整数，缩小1e18。';
	}
};
var $author$project$Strings$Translations$docs_borrow_return_description = F2(
	function (lang, errorCode) {
		switch (lang) {
			case 0:
				return '0 on success, otherwise an ' + (errorCode + '');
			case 1:
				return '0 en caso de éxito, de lo contrario un ' + (errorCode + '');
			default:
				return '成功时为0，否则为' + (errorCode + '');
		}
	});
var $author$project$Strings$Translations$docs_cash_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Cash is the amount of underlying balance owned by this cToken contract. One may query the total amount of cash currently available to this market.';
		case 1:
			return 'El efectivo es la cantidad de saldo subyacente que posee este contrato de cToken. Uno puede consultar la cantidad total de efectivo actualmente disponible para este mercado.';
		default:
			return '现金是此cToken合约所拥有的相关余额金额。可以查询当前可用于该市场的现金总额。';
	}
};
var $author$project$Strings$Translations$docs_cash_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The quantity of underlying asset owned by the contract.';
		case 1:
			return 'La cantidad de activo subyacente propiedad del contrato.';
		default:
			return '合同所拥有的标的资产数量。';
	}
};
var $author$project$Strings$Translations$docs_cerc20 = function (lang) {
	switch (lang) {
		case 0:
			return 'CErc20';
		case 1:
			return 'CErc20';
		default:
			return 'CErc20';
	}
};
var $author$project$Strings$Translations$docs_ctokens_description1_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Each asset supported by the Compound Protocol is integrated through a cToken contract, which is an ';
		case 1:
			return 'Todos los activos soportados por el Protocolo Compound ahora están integrados a través de un contrato inteligente cToken, que es un';
		default:
			return '现在，Compound 协议支持的每个资产都通过 cToken 智能合约进行集成';
	}
};
var $author$project$Strings$Translations$docs_ctokens_description1_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'EIP-20';
		case 1:
			return 'EIP-20';
		default:
			return 'EIP-20';
	}
};
var $author$project$Strings$Translations$docs_ctokens_description1_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ' compliant representation of balances supplied to the protocol. By minting cTokens, users (1) earn interest through the cToken\'s exchange rate, which increases in value relative to the underlying asset, and (2) gain the ability to use cTokens as collateral.';
		case 1:
			return 'representación conforme de saldos suministrados al protocolo. Los usuarios suministran al protocolo mediante tokens de acuñación (cTokens), que aumentan estrictamente su valor en relación con su activo subyacente.';
		default:
			return '提供给协议的余额的合规表示。用户通过创建令牌（cTokens）来提供协议，该令牌相对于其基础资产的价值严格增加。';
	}
};
var $author$project$Strings$Translations$docs_ctokens_description2 = function (lang) {
	switch (lang) {
		case 0:
			return 'cTokens are the primary means of interacting with the Compound Protocol; when a user mints, redeems, borrows, repays a borrow, liquidates a borrow, or transfers cTokens, she will do so using the cToken contract.';
		case 1:
			return 'Los cTokens son la forma principal de interactuar con el Protocolo Compound. Cada contrato de cToken crea su propio mercado monetario. Cuando un usuario acuña, canjea, pide prestado, paga un préstamo, liquida un préstamo o transfiere cTokens, lo hará utilizando el contrato de cToken.';
		default:
			return 'cTokens 是与 Compound 协议交互的主要方式。每个 cToken 合约都会创建自己的货币市场。当用户吝啬，赎回，借入，偿还借款，清算借款或转让 cTokens 时，她将使用 cToken 合同进行。';
	}
};
var $author$project$Strings$Translations$docs_ctokens_description3 = function (lang) {
	switch (lang) {
		case 0:
			return 'There are currently two types of cTokens: CErc20 and CEther. Though both types expose the EIP-20 interface, CErc20 wraps an underlying ERC-20 asset, while CEther simply wraps Ether itself. As such, the core functions which involve transferring an asset into the protocol have slightly different interfaces depending on the type, each of which is shown below.';
		case 1:
			return 'Actualmente hay dos tipos de cTokens: CErc20 y CEther. Aunque ambos tipos exponen la interfaz EIP-20, CErc20 envuelve un activo ERC-20 subyacente, mientras que CEther simplemente envuelve el propio Ether. Como tal, las funciones principales que implican transferir un activo al protocolo tienen interfaces ligeramente diferentes según el tipo, cada una de las cuales se muestra a continuación.';
		default:
			return '目前有两种类型的cTokens：CErc20和CEther。虽然这两种类型都暴露了EIP-20接口，但CErc20包含了一个潜在的ERC-20资产，而CEther只是包装了Ether。因此，涉及将资产转移到协议中的核心功能根据类型具有略微不同的接口，每个接口如下所示。';
	}
};
var $author$project$Strings$Translations$docs_exchange_rate_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Each cToken is convertible into an ever increasing quantity of the underlying asset, as interest accrues in the market. The exchange rate between a cToken and the underlying asset is equal to:';
		case 1:
			return 'Cada cToken es convertible en una cantidad cada vez mayor del activo subyacente, a medida que se acumulan intereses en el mercado. El tipo de cambio entre un cToken y el activo subyacente es igual a:';
		default:
			return '随着市场利息的增加，每个cToken都可以转换为不断增加的相关资产数量。 cToken与标的资产之间的汇率等于：';
	}
};
var $author$project$Strings$Translations$docs_exchange_rate_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The current exchange rate as an unsigned integer, scaled by 1e18.';
		case 1:
			return 'El tipo de cambio actual como un entero sin signo, escalado en 1e18.';
		default:
			return '当前汇率为无符号整数，缩放1e18。';
	}
};
var $author$project$Strings$Translations$docs_liquidate_borrower_description1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The account with negative ';
		case 1:
			return 'La cuenta con negativo';
		default:
			return '负面的帐户';
	}
};
var $author$project$Strings$Translations$docs_liquidate_borrower_description2 = function (lang) {
	switch (lang) {
		case 0:
			return 'account liquidity';
		case 1:
			return 'liquidez de cuenta';
		default:
			return '账户流动性';
	}
};
var $author$project$Strings$Translations$docs_liquidate_borrower_description3 = function (lang) {
	switch (lang) {
		case 0:
			return ' that shall be liquidated.';
		case 1:
			return 'eso será liquidado.';
		default:
			return '应清算。';
	}
};
var $author$project$Strings$Translations$docs_liquidate_ctoken_collateral_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The address of the cToken currently held as collateral by a borrower, that the liquidator shall seize.';
		case 1:
			return 'La dirección de la cToken actualmente mantenida como garantía por un prestatario, que el liquidador deberá tomar.';
		default:
			return '目前作为借款人担保的cToken的地址，清算人应抓住。';
	}
};
var $author$project$Strings$Translations$docs_liquidate_description1_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'A user who has negative ';
		case 1:
			return 'Un usuario que tiene negativo';
		default:
			return '负面的用户';
	}
};
var $author$project$Strings$Translations$docs_liquidate_description1_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'account liquidity';
		case 1:
			return 'liquidez de cuenta';
		default:
			return '账户流动性';
	}
};
var $author$project$Strings$Translations$docs_liquidate_description1_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ' is subject to ';
		case 1:
			return 'está sujeta a';
		default:
			return '受制于';
	}
};
var $author$project$Strings$Translations$docs_liquidate_description1_part4 = function (lang) {
	switch (lang) {
		case 0:
			return 'liquidation';
		case 1:
			return 'liquidación';
		default:
			return '清算';
	}
};
var $author$project$Strings$Translations$docs_liquidate_description1_part5 = function (lang) {
	switch (lang) {
		case 0:
			return ' by other users of the protocol to return his/her account liquidity back to positive (i.e. above the ';
		case 1:
			return 'por otros usuarios del protocolo para devolver la liquidez de su cuenta a positivo (es decir, por encima del';
		default:
			return '协议的其他用户将他/她的账户流动性恢复为正（即高于';
	}
};
var $author$project$Strings$Translations$docs_liquidate_description1_part6 = function (lang) {
	switch (lang) {
		case 0:
			return 'collateral requirement';
		case 1:
			return 'requisito de garantía';
		default:
			return '抵押要求';
	}
};
var $author$project$Strings$Translations$docs_liquidate_description1_part7 = function (lang) {
	switch (lang) {
		case 0:
			return '). When a liquidation occurs, a liquidator may repay some or all of an outstanding borrow on behalf of a borrower and in return receive a discounted amount of collateral held by the borrower; this discount is defined as the ';
		case 1:
			return ') Cuando ocurre una liquidación, un liquidador puede pagar parte o la totalidad de un préstamo pendiente en nombre de un prestatario y, a cambio, recibir una cantidad descontada de la garantía en poder del prestatario; este descuento se define como el';
		default:
			return '）。清算发生时，清算人可以代表借款人偿还部分或全部未偿还的借款，并获得借款人持有的贴现金额的贴现;这个折扣被定义为';
	}
};
var $author$project$Strings$Translations$docs_liquidate_description1_part8 = function (lang) {
	switch (lang) {
		case 0:
			return 'liquidation incentive';
		case 1:
			return 'incentivo de liquidación';
		default:
			return '清算激励';
	}
};
var $author$project$Strings$Translations$docs_liquidate_description2_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'A liquidator may close up to a certain fixed percentage (i.e. ';
		case 1:
			return 'Un liquidador puede cerrar hasta cierto porcentaje fijo (es decir';
		default:
			return '清算人可能会达到一定的固定百分比（即';
	}
};
var $author$project$Strings$Translations$docs_liquidate_description2_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'close factor';
		case 1:
			return 'factor cercano';
		default:
			return '关闭因素';
	}
};
var $author$project$Strings$Translations$docs_liquidate_description2_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ') of any individual outstanding borrow of the underwater account. Unlike in v1, liquidators must interact with each cToken contract in which they wish to repay a borrow and seize another asset as collateral. When collateral is seized, the liquidator is transferred cTokens, which they may redeem the same as if they had supplied the asset themselves. Users must approve each cToken contract before calling liquidate (i.e. on the borrowed asset which they are repaying), as they are transferring funds into the contract.';
		case 1:
			return ') de cualquier préstamo pendiente individual de la cuenta submarina. A diferencia de v1, los liquidadores deben interactuar con cada contrato de cToken en el que desean pagar un préstamo y confiscar otro activo como garantía. Cuando se confisca la garantía, el liquidador se transfiere a cTokens, que pueden canjear igual que si hubieran suministrado el activo ellos mismos. Los usuarios deben aprobar cada contrato de cToken antes de solicitar liquidación (es decir, sobre el activo prestado que están pagando), ya que están transfiriendo fondos al contrato.';
		default:
			return '）任何个人未偿还的水下账户借款。与v1不同，清算人必须与每个cToken合约互动，他们希望在这些合同中偿还借款并扣押另一项资产作为抵押品。扣押抵押品时，清算人转让cTokens，他们可以赎回，就像他们自己提供资产一样。用户必须先批准每个cToken合同，然后才能调用清算（即他们正在偿还的借入资产），因为他们正在将资金转入合同。';
	}
};
var $author$project$Strings$Translations$docs_liquidate_description3_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Before supplying an asset, users must first ';
		case 1:
			return 'Antes de suministrar un activo, los usuarios deben primero';
		default:
			return '在提供资产之前，用户必须先行';
	}
};
var $author$project$Strings$Translations$docs_liquidate_description3_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'approve';
		case 1:
			return 'aprobar';
		default:
			return '批准';
	}
};
var $author$project$Strings$Translations$docs_liquidate_description3_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ' the cToken to access their token balance.';
		case 1:
			return 'los cToken para acceder a su saldo de fichas.';
		default:
			return 'cToken访问其令牌余额。';
	}
};
var $author$project$Strings$Translations$docs_liquidate_msg_sender_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account which shall liquidate the borrower by repaying their debt and seizing their collateral.';
		case 1:
			return 'La cuenta que liquidará al prestatario reembolsando su deuda y confiscando su garantía.';
		default:
			return '该账户将通过偿还债务和扣押其抵押品来清算借款人。';
	}
};
var $author$project$Strings$Translations$docs_liquidate_payable_borrower_description1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The account with negative ';
		case 1:
			return 'La cuenta con negativo';
		default:
			return '负面的帐户';
	}
};
var $author$project$Strings$Translations$docs_liquidate_payable_borrower_description2 = function (lang) {
	switch (lang) {
		case 0:
			return 'account liquidity';
		case 1:
			return 'liquidez de cuenta';
		default:
			return '账户流动性';
	}
};
var $author$project$Strings$Translations$docs_liquidate_payable_borrower_description3 = function (lang) {
	switch (lang) {
		case 0:
			return ' that shall be liquidated.';
		case 1:
			return 'eso será liquidado.';
		default:
			return '应清算。';
	}
};
var $author$project$Strings$Translations$docs_liquidate_payable_ctoken_collateral_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The address of the cToken currently held as collateral by a borrower, that the liquidator shall seize.';
		case 1:
			return 'La dirección de la cToken actualmente mantenida como garantía por un prestatario, que el liquidador deberá tomar.';
		default:
			return '目前作为借款人担保的cToken的地址，清算人应抓住。';
	}
};
var $author$project$Strings$Translations$docs_liquidate_payable_msg_sender_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account which shall liquidate the borrower by repaying their debt and seizing their collateral.';
		case 1:
			return 'La cuenta que liquidará al prestatario reembolsando su deuda y confiscando su garantía.';
		default:
			return '该账户将通过偿还债务和扣押其抵押品来清算借款人。';
	}
};
var $author$project$Strings$Translations$docs_liquidate_payable_msg_value_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The amount of ether to be repaid and converted into collateral, in wei.';
		case 1:
			return 'La cantidad de éter a pagar y convertir en garantía, en wei.';
		default:
			return '在魏中，要偿还并转换为抵押品的乙醚数量。';
	}
};
var $author$project$Strings$Translations$docs_liquidate_payable_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'No return, reverts on error.';
		case 1:
			return 'Sin retorno, revierte en caso de error.';
		default:
			return '没有回报，还原错误。';
	}
};
var $author$project$Strings$Translations$docs_liquidate_repay_amount_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The amount of the borrowed asset to be repaid and converted into collateral, specified in units of the underlying borrowed asset.';
		case 1:
			return 'El monto del activo prestado a ser reembolsado y convertido en garantía, especificado en unidades del activo prestado subyacente.';
		default:
			return '借入资产的偿还金额并转换为抵押品，以相关借入资产为单位。';
	}
};
var $author$project$Strings$Translations$docs_liquidate_return_description = F2(
	function (lang, errorCode) {
		switch (lang) {
			case 0:
				return '0 on success, otherwise an ' + (errorCode + '');
			case 1:
				return '0 en caso de éxito, de lo contrario un ' + (errorCode + '');
			default:
				return '成功时为0，否则为' + (errorCode + '');
		}
	});
var $author$project$Strings$Translations$docs_mint_description1_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The mint function transfers an asset into the protocol, which begins accumulating interest based on the current ';
		case 1:
			return 'La función mint transfiere un activo al mercado monetario, que comienza a acumular intereses en función de la corriente';
		default:
			return '薄荷功能将资产转移到货币市场，货币市场开始根据当前积累利息';
	}
};
var $author$project$Strings$Translations$docs_mint_description1_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ' for the asset. The user receives a quantity of cTokens equal to the underlying tokens supplied, divided by the current ';
		case 1:
			return 'para el activo El número de tokens acuñados es la cantidad de activo subyacente que se proporciona dividido por el actual';
		default:
			return '对于资产。铸造的令牌数量是提供的标的资产数量除以当前数量';
	}
};
var $author$project$Strings$Translations$docs_mint_mint_amount_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The amount of the asset to be supplied, in units of the underlying asset.';
		case 1:
			return 'El importe del activo a suministrar, en unidades del activo subyacente.';
		default:
			return '要提供的资产金额，以标的资产为单位。';
	}
};
var $author$project$Strings$Translations$docs_mint_msg_sender_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account which shall supply the asset, and own the minted cTokens.';
		case 1:
			return 'La cuenta que suministrará el activo y será propietaria de los cTokens acuñados.';
		default:
			return '应提供资产的帐户，并拥有铸造的cTokens。';
	}
};
var $author$project$Strings$Translations$docs_mint_payable_msg_sender_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account which shall supply the ether, and own the minted cTokens.';
		case 1:
			return 'La cuenta que suministrará el éter y poseerá los cTokens acuñados.';
		default:
			return '该帐户将提供以太，并拥有铸造的cTokens。';
	}
};
var $author$project$Strings$Translations$docs_mint_payable_msg_value_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The amount of ether to be supplied, in wei.';
		case 1:
			return 'La cantidad de éter a suministrar, en wei.';
		default:
			return '供给的乙醚量，以维为单位。';
	}
};
var $author$project$Strings$Translations$docs_mint_payable_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'No return, reverts on error.';
		case 1:
			return 'Sin retorno, revierte en caso de error.';
		default:
			return '没有回报，还原错误。';
	}
};
var $author$project$Strings$Translations$docs_mint_prereq_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Before supplying an asset, users must first ';
		case 1:
			return 'Antes de suministrar un activo, los usuarios deben primero';
		default:
			return '在提供资产之前，用户必须先行';
	}
};
var $author$project$Strings$Translations$docs_mint_return_description = F2(
	function (lang, errorCode) {
		switch (lang) {
			case 0:
				return '0 on success, otherwise an ' + (errorCode + '');
			case 1:
				return '0 en caso de éxito, de lo contrario un ' + (errorCode + '');
			default:
				return '成功时为0，否则为' + (errorCode + '');
		}
	});
var $author$project$Strings$Translations$docs_redeem_description1_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The redeem function converts a specified quantity of cTokens into the underlying asset, and returns them to the user. The amount of underlying tokens received is equal to the quantity of cTokens redeemed, multiplied by the current ';
		case 1:
			return 'La función de canje transfiere el activo subyacente del mercado monetario al usuario a cambio de cTokens previamente acuñados. La cantidad de redimidos subyacentes es el número de cTokens multiplicado por el actual';
		default:
			return '赎回功能将相关资产从货币市场转移给用户，以换取先前铸造的cTokens。兑换的潜在金额是cTokens乘以当前的数量';
	}
};
var $author$project$Strings$Translations$docs_redeem_description1_part3 = function (lang) {
	switch (lang) {
		case 0:
			return '. The amount redeemed must be less than the user\'s ';
		case 1:
			return '. El importe canjeado debe ser inferior al del usuario.';
		default:
			return '。兑换的金额必须少于用户的金额';
	}
};
var $author$project$Strings$Translations$docs_redeem_description1_part4 = function (lang) {
	switch (lang) {
		case 0:
			return 'Account Liquidity';
		case 1:
			return 'liquidez de cuenta';
		default:
			return '账户流动性';
	}
};
var $author$project$Strings$Translations$docs_redeem_description1_part5 = function (lang) {
	switch (lang) {
		case 0:
			return ' and the market\'s available liquidity.';
		case 1:
			return 'y la liquidez disponible del mercado.';
		default:
			return '以及市场可用的流动性。';
	}
};
var $author$project$Strings$Translations$docs_redeem_msg_sender_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account to which redeemed funds shall be transferred.';
		case 1:
			return 'La cuenta a la que se transferirán los fondos redimidos.';
		default:
			return '兑换资金的账户应转移。';
	}
};
var $author$project$Strings$Translations$docs_redeem_redeem_tokens_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The number of cTokens to be redeemed.';
		case 1:
			return 'El número de cTokens para canjear.';
		default:
			return '要兑换的cTokens数量。';
	}
};
var $author$project$Strings$Translations$docs_redeem_return_description = F2(
	function (lang, errorCode) {
		switch (lang) {
			case 0:
				return '0 on success, otherwise an ' + (errorCode + '');
			case 1:
				return '0 en caso de éxito, de lo contrario un ' + (errorCode + '');
			default:
				return '成功时为0，否则为' + (errorCode + '');
		}
	});
var $author$project$Strings$Translations$docs_redeem_underlying_description1_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The redeem underlying function converts cTokens into a specified quantity of the underlying asset, and returns them to the user. The amount of cTokens redeemed is equal to the quantity of underlying tokens received, divided by the current ';
		case 1:
			return 'La función subyacente de canje transfiere el activo subyacente del mercado monetario al usuario a cambio de cTokens previamente acuñados. El número de cTokens canjeados es la cantidad de subyacente dividido por el actual';
		default:
			return '赎回基础功能将标的资产从货币市场转移给用户，以换取先前铸造的cTokens。兑换的cTokens数量是底层数量除以当前数量';
	}
};
var $author$project$Strings$Translations$docs_redeem_underlying_description1_part3 = function (lang) {
	switch (lang) {
		case 0:
			return '. The amount redeemed must be less than the user\'s ';
		case 1:
			return '. El importe canjeado debe ser inferior al del usuario.';
		default:
			return '。兑换的金额必须少于用户的金额';
	}
};
var $author$project$Strings$Translations$docs_redeem_underlying_description1_part5 = function (lang) {
	switch (lang) {
		case 0:
			return ' and the market\'s available liquidity.';
		case 1:
			return 'y la liquidez disponible del mercado.';
		default:
			return '以及市场可用的流动性。';
	}
};
var $author$project$Strings$Translations$docs_redeem_underlying_msg_sender_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account to which redeemed funds shall be transferred.';
		case 1:
			return 'La cuenta a la que se transferirán los fondos redimidos.';
		default:
			return '兑换资金的账户应转移。';
	}
};
var $author$project$Strings$Translations$docs_redeem_underlying_redeem_amount_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The amount of underlying to be redeemed.';
		case 1:
			return 'La cantidad de subyacente que se canjeará.';
		default:
			return '要兑换的底层金额。';
	}
};
var $author$project$Strings$Translations$docs_redeem_underlying_return_description = F2(
	function (lang, errorCode) {
		switch (lang) {
			case 0:
				return '0 on success, otherwise an ' + (errorCode + '');
			case 1:
				return '0 en caso de éxito, de lo contrario un ' + (errorCode + '');
			default:
				return '成功时为0，否则为' + (errorCode + '');
		}
	});
var $author$project$Strings$Translations$docs_repay_borrow_behalf_borrower_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account which borrowed the asset to be repaid.';
		case 1:
			return 'La cuenta que tomó prestado el activo para ser reembolsado.';
		default:
			return '借入资产的账户需要偿还。';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_behalf_description1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The repay function transfers an asset into the protocol, reducing the target user\'s borrow balance.';
		case 1:
			return 'La función de reembolso transfiere un activo al mercado monetario, reduciendo el saldo del préstamo del usuario.';
		default:
			return '偿还功能将资产转移到货币市场，减少用户的借贷余额。';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_behalf_msg_sender_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account which shall repay the borrow.';
		case 1:
			return 'La cuenta que pagará el préstamo.';
		default:
			return '应偿还借款的账户。';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_behalf_payable_borrower_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account which borrowed the asset to be repaid.';
		case 1:
			return 'La cuenta que tomó prestado el activo para ser reembolsado.';
		default:
			return '借入资产的账户需要偿还。';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_behalf_payable_msg_sender_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account which shall repay the borrow.';
		case 1:
			return 'La cuenta que pagará el préstamo.';
		default:
			return '应偿还借款的账户。';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_behalf_payable_msg_value_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The amount of ether to be repaid, in wei.';
		case 1:
			return 'La cantidad de éter a pagar, en wei.';
		default:
			return '要偿还的乙醚量，以维为单位。';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_behalf_payable_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'No return, reverts on error.';
		case 1:
			return 'Sin retorno, revierte en caso de error.';
		default:
			return '没有回报，还原错误。';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_behalf_repay_amount_description1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The amount of the underlying borrowed asset to be repaid. A value of -1 (i.e. 2';
		case 1:
			return 'El monto del activo prestado subyacente a pagar. Un valor de -1 (es decir, 2';
		default:
			return '要偿还的相关借入资产的金额。值为-1（即2';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_behalf_repay_amount_description2 = function (lang) {
	switch (lang) {
		case 0:
			return '256';
		case 1:
			return '256';
		default:
			return '256';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_behalf_repay_amount_description3 = function (lang) {
	switch (lang) {
		case 0:
			return ' - 1) can be used to repay the full amount.';
		case 1:
			return '- 1) se puede utilizar para pagar el importe total.';
		default:
			return '-  1）可用于偿还全额。';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_behalf_return_description = F2(
	function (lang, errorCode) {
		switch (lang) {
			case 0:
				return '0 on success, otherwise an ' + (errorCode + '');
			case 1:
				return '0 en caso de éxito, de lo contrario un ' + (errorCode + '');
			default:
				return '成功时为0，否则为' + (errorCode + '');
		}
	});
var $author$project$Strings$Translations$docs_repay_borrow_description1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The repay function transfers an asset into the protocol, reducing the user\'s borrow balance.';
		case 1:
			return 'La función de reembolso transfiere un activo al mercado monetario, reduciendo el saldo del préstamo del usuario.';
		default:
			return '偿还功能将资产转移到货币市场，减少用户的借贷余额。';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_description2_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Before repaying an asset, users must first ';
		case 1:
			return 'Antes de suministrar un activo, los usuarios deben primero';
		default:
			return '在提供资产之前，用户必须先行';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_msg_sender_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account which borrowed the asset, and shall repay the borrow.';
		case 1:
			return 'La cuenta que tomó prestado el activo, y deberá pagar el préstamo.';
		default:
			return '借入资产的账户，应偿还借款。';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_payable_msg_sender_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account which borrowed the asset, and shall repay the borrow.';
		case 1:
			return 'La cuenta que tomó prestado el activo, y deberá pagar el préstamo.';
		default:
			return '借入资产的账户，应偿还借款。';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_payable_msg_value_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The amount of ether to be repaid, in wei.';
		case 1:
			return 'La cantidad de éter a pagar, en wei.';
		default:
			return '要偿还的乙醚量，以维为单位。';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_payable_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'No return, reverts on error.';
		case 1:
			return 'Sin retorno, revierte en caso de error.';
		default:
			return '没有回报，还原错误。';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_repay_amount_description1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The amount of the underlying borrowed asset to be repaid. A value of -1 (i.e. 2';
		case 1:
			return 'El monto del activo prestado subyacente a pagar. Un valor de -1 (es decir, 2';
		default:
			return '要偿还的相关借入资产的金额。值为-1（即2';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_repay_amount_description2 = function (lang) {
	switch (lang) {
		case 0:
			return '256';
		case 1:
			return '256';
		default:
			return '256';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_repay_amount_description3 = function (lang) {
	switch (lang) {
		case 0:
			return ' - 1) can be used to repay the full amount.';
		case 1:
			return '- 1) se puede utilizar para pagar el importe total.';
		default:
			return '-  1）可用于偿还全额。';
	}
};
var $author$project$Strings$Translations$docs_repay_borrow_return_description = F2(
	function (lang, errorCode) {
		switch (lang) {
			case 0:
				return '0 on success, otherwise an ' + (errorCode + '');
			case 1:
				return '0 en caso de éxito, de lo contrario un ' + (errorCode + '');
			default:
				return '成功时为0，否则为' + (errorCode + '');
		}
	});
var $author$project$Strings$Translations$docs_reserve_factor_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The reserve factor defines the portion of borrower interest that is converted into ';
		case 1:
			return 'El factor de reserva define la pequeña porción de interés que se acumula en';
		default:
			return '储备因子定义了累积的一小部分利息';
	}
};
var $author$project$Strings$Translations$docs_reserve_factor_description_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'reserves';
		case 1:
			return 'reservas';
		default:
			return '储量';
	}
};
var $author$project$Strings$Translations$docs_reserve_factor_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The current reserve factor as an unsigned integer, scaled by 1e18.';
		case 1:
			return 'El factor de reserva actual como un entero sin signo, escalado en 1e18.';
		default:
			return '当前保留因子为无符号整数，缩放1e18。';
	}
};
var $author$project$Strings$Translations$docs_supply_balance_underlying_account_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account to get the underlying balance of.';
		case 1:
			return 'La cuenta para obtener el saldo subyacente de.';
		default:
			return '获得底层余额的帐户。';
	}
};
var $author$project$Strings$Translations$docs_supply_balance_underlying_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The amount of underlying currently owned by the account.';
		case 1:
			return 'La cantidad de subyacente que actualmente posee la cuenta.';
		default:
			return '帐户当前拥有的基础金额。';
	}
};
var $author$project$Strings$Translations$docs_supply_rate_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'At any point in time one may query the contract to get the current supply rate per block. The supply rate is derived from the ';
		case 1:
			return 'En cualquier momento, se puede consultar el contrato para obtener la tasa de suministro actual por bloque. La tasa de suministro se deriva de la';
		default:
			return '在任何时间点，人们都可以查询合同以获得每个区块的当前供应率。供应率来自';
	}
};
var $author$project$Strings$Translations$docs_supply_rate_description_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'borrow rate';
		case 1:
			return 'tasa de préstamo';
		default:
			return '借款利率';
	}
};
var $author$project$Strings$Translations$docs_supply_rate_description_part3 = function (lang) {
	switch (lang) {
		case 0:
			return 'reserve factor';
		case 1:
			return 'factor de reserva';
		default:
			return '储备因素';
	}
};
var $author$project$Strings$Translations$docs_supply_rate_description_part4 = function (lang) {
	switch (lang) {
		case 0:
			return ' and the amount of ';
		case 1:
			return 'y la cantidad de';
		default:
			return '和金额';
	}
};
var $author$project$Strings$Translations$docs_supply_rate_description_part5 = function (lang) {
	switch (lang) {
		case 0:
			return 'total borrows';
		case 1:
			return 'préstamos totales';
		default:
			return '总借词';
	}
};
var $author$project$Strings$Translations$docs_supply_rate_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The current supply rate as an unsigned integer, scaled by 1e18.';
		case 1:
			return 'La tasa de suministro actual como un entero sin signo, escalado en 1e18.';
		default:
			return '当前供应率为无符号整数，缩放1e18。';
	}
};
var $author$project$Strings$Translations$docs_total_borrow_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Total Borrows is the amount of underlying currently loaned out by the market, and the amount upon which interest is accumulated to suppliers of the market.';
		case 1:
			return 'Total Borrows es la cantidad de subyacente prestada actualmente por el mercado, y la cantidad sobre la cual se acumulan intereses a los proveedores del mercado.';
		default:
			return '总借款是目前市场借出的基础金额，以及向市场供应商累计利息的金额。';
	}
};
var $author$project$Strings$Translations$docs_total_borrow_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The total amount of borrowed underlying, with interest.';
		case 1:
			return 'El monto total del subyacente prestado, con intereses.';
		default:
			return '借入的底层证券总额，有利息。';
	}
};
var $author$project$Strings$Translations$docs_total_reserves_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Reserves are an accounting entry in each cToken contract that represents a portion of historical interest set aside as ';
		case 1:
			return 'Las reservas son el patrimonio acumulado en el propio protocolo, para financiar su operación. Las reservas también forman parte de la';
		default:
			return '储备金是协议本身产生的权益，以便为其运作提供资金。储备也是其中的一部分';
	}
};
var $author$project$Strings$Translations$docs_total_reserves_description_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'cash';
		case 1:
			return 'efectivo';
		default:
			return '现金';
	}
};
var $author$project$Strings$Translations$docs_total_reserves_description_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ' which can be withdrawn or transferred through the protocol\'s governance. A small portion of borrower interest accrues into the protocol, determined by the ';
		case 1:
			return 'que pueden prestarse a prestatarios en el mercado. Una pequeña porción del interés del prestatario se acumula en el protocolo, determinado por el';
		default:
			return '这可能会借给市场上的借款人。借款人的一小部分利息累积到协议中，由协议确定';
	}
};
var $author$project$Strings$Translations$docs_total_reserves_description_part4 = function (lang) {
	switch (lang) {
		case 0:
			return 'reserve factor';
		case 1:
			return 'factor de reserva';
		default:
			return '储备因素';
	}
};
var $author$project$Strings$Translations$docs_total_reserves_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The total amount of reserves held in the market.';
		case 1:
			return 'La cantidad total de reservas mantenidas por el protocolo.';
		default:
			return '协议持有的储备总量。';
	}
};
var $author$project$Strings$Translations$docs_total_supply_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Total Supply is the number of tokens currently in circulation in this cToken market. It is part of the EIP-20 interface of the cToken contract.';
		case 1:
			return 'El suministro total es el número de tokens actualmente en circulación en este mercado cToken. Forma parte de la interfaz EIP-20 del contrato cToken.';
		default:
			return '总供应量是该cToken市场中目前流通的代币数量。它是cToken合同的EIP-20接口的一部分。';
	}
};
var $author$project$Strings$Translations$docs_total_supply_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The total number of tokens in circulation for the market.';
		case 1:
			return 'El número total de tokens en circulación para el mercado.';
		default:
			return '市场流通的代币总数。';
	}
};
var $author$project$Strings$Translations$docs_underlying_balance_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The user\'s underlying balance, representing their assets in the protocol, is equal to the user\'s cToken balance multiplied by the ';
		case 1:
			return 'El saldo subyacente del usuario, que representa sus activos en el protocolo, es igual al saldo cToken del usuario multiplicado por';
		default:
			return '用户的基础余额（代表其在协议中的资产）等于用户的cToken余额乘以';
	}
};
var $author$project$Strings$Translations$error_codes = function (lang) {
	switch (lang) {
		case 0:
			return 'Error codes';
		case 1:
			return 'Códigos de error';
		default:
			return '错误代码';
	}
};
var $author$project$Strings$Translations$exchange_rate = function (lang) {
	switch (lang) {
		case 0:
			return 'Exchange Rate';
		case 1:
			return 'Tipo de cambio';
		default:
			return '兑换率';
	}
};
var $author$project$Strings$Translations$get_cash = function (lang) {
	switch (lang) {
		case 0:
			return 'Get Cash';
		case 1:
			return 'Conseguir dinero en efectivo';
		default:
			return '获得现金';
	}
};
var $author$project$SyntaxHighlight$Language$Solidity$syntaxToStyle = function (syntax) {
	switch (syntax) {
		case 0:
			return _Utils_Tuple2(2, 'sol-n');
		case 1:
			return _Utils_Tuple2(3, 'sol-s');
		case 2:
			return _Utils_Tuple2(4, 'sol-k');
		case 3:
			return _Utils_Tuple2(5, 'sol-dk');
		case 4:
			return _Utils_Tuple2(6, 'sol-fe');
		case 5:
			return _Utils_Tuple2(6, 'sol-f');
		case 6:
			return _Utils_Tuple2(7, 'sol-lk');
		case 7:
			return _Utils_Tuple2(8, 'sol-p');
		default:
			return _Utils_Tuple2(6, 'sol-ce');
	}
};
var $author$project$SyntaxHighlight$Language$Solidity$groupSet = $elm$core$Set$fromList(
	_List_fromArray(
		['{', '}', '(', ')', '[', ']', ',', ';', '.']));
var $author$project$SyntaxHighlight$Language$Solidity$isGroupChar = function (c) {
	return A2($elm$core$Set$member, c, $author$project$SyntaxHighlight$Language$Solidity$groupSet);
};
var $author$project$SyntaxHighlight$Language$Solidity$groupChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, b);
	},
	$elm$parser$Parser$getChompedString(
		$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Solidity$isGroupChar)));
var $author$project$SyntaxHighlight$Language$Solidity$isCommentChar = function (c) {
	return c === '/';
};
var $author$project$SyntaxHighlight$Language$Solidity$operatorSet = $elm$core$Set$fromList(
	_List_fromArray(
		['+', '-', '*', '/', '=', '!', '<', '>', '&', '|', '?', '^', ':', '~', '%']));
var $author$project$SyntaxHighlight$Language$Solidity$punctuactorSet = A2($elm$core$Set$union, $author$project$SyntaxHighlight$Language$Solidity$operatorSet, $author$project$SyntaxHighlight$Language$Solidity$groupSet);
var $author$project$SyntaxHighlight$Language$Solidity$isPunctuaction = function (c) {
	return A2($elm$core$Set$member, c, $author$project$SyntaxHighlight$Language$Solidity$punctuactorSet);
};
var $author$project$SyntaxHighlight$Language$Solidity$isStringLiteralChar = function (c) {
	return (c === '\"') || ((c === '\'') || (c === '`'));
};
var $author$project$SyntaxHighlight$Language$Solidity$isIdentifierNameChar = function (c) {
	return !($author$project$SyntaxHighlight$Language$Solidity$isPunctuaction(c) || ($author$project$SyntaxHighlight$Language$Solidity$isStringLiteralChar(c) || ($author$project$SyntaxHighlight$Language$Solidity$isCommentChar(c) || $author$project$SyntaxHighlight$Language$Helpers$isWhitespace(c))));
};
var $author$project$SyntaxHighlight$Language$Solidity$DeclarationKeyword = 3;
var $author$project$SyntaxHighlight$Language$Solidity$Function = 5;
var $author$project$SyntaxHighlight$Language$Solidity$Keyword = 2;
var $author$project$SyntaxHighlight$Language$Solidity$LiteralKeyword = 6;
var $author$project$SyntaxHighlight$Language$Solidity$Param = 7;
var $author$project$SyntaxHighlight$Language$Solidity$ClassExtends = 8;
var $author$project$SyntaxHighlight$Language$Solidity$inlineComment = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Comment, b)
			]);
	},
	$elm$parser$Parser$getChompedString(
		A2(
			$author$project$SyntaxHighlight$Language$Helpers$thenChompWhile,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$SyntaxHighlight$Language$Helpers$isLineBreak),
			$elm$parser$Parser$symbol('//'))));
var $author$project$SyntaxHighlight$Language$Solidity$lineBreakList = A2(
	$elm$parser$Parser$map,
	function (_v0) {
		return _List_fromArray(
			[
				_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$LineBreak, '\n')
			]);
	},
	$elm$parser$Parser$symbol('\n'));
var $author$project$SyntaxHighlight$Language$Solidity$multilineComment = $author$project$SyntaxHighlight$Language$Helpers$delimited(
	{
		d4: function (b) {
			return _Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Comment, b);
		},
		d8: '*/',
		ep: _List_fromArray(
			[$author$project$SyntaxHighlight$Language$Solidity$lineBreakList]),
		er: false,
		es: function (c) {
			return !$author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c);
		},
		fh: '/*'
	});
var $author$project$SyntaxHighlight$Language$Solidity$comment = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$author$project$SyntaxHighlight$Language$Solidity$inlineComment, $author$project$SyntaxHighlight$Language$Solidity$multilineComment]));
var $author$project$SyntaxHighlight$Language$Solidity$whitespaceOrCommentStep = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Helpers$isSpace))),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$author$project$SyntaxHighlight$Language$Solidity$lineBreakList),
				A2(
				$elm$parser$Parser$map,
				function (ns) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(ns, revTokens));
				},
				$author$project$SyntaxHighlight$Language$Solidity$comment)
			]));
};
var $author$project$SyntaxHighlight$Language$Solidity$classExtendsLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Solidity$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(8),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Solidity$isIdentifierNameChar))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Solidity$classDeclarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Solidity$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$andThen,
				function (n) {
					return (n === 'extends') ? A2(
						$elm$parser$Parser$map,
						$elm$parser$Parser$Loop,
						A2(
							$elm$parser$Parser$loop,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$author$project$SyntaxHighlight$Language$Type$C(2),
									n),
								revTokens),
							$author$project$SyntaxHighlight$Language$Solidity$classExtendsLoop)) : $elm$parser$Parser$succeed(
						$elm$parser$Parser$Loop(
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									$author$project$SyntaxHighlight$Language$Type$C(5),
									n),
								revTokens)));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Solidity$isIdentifierNameChar))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Solidity$argLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Solidity$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(7),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return !($author$project$SyntaxHighlight$Language$Solidity$isCommentChar(c) || ($author$project$SyntaxHighlight$Language$Helpers$isWhitespace(c) || ((c === ',') || (c === ')'))));
						}))),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile(
						function (c) {
							return (c === '/') || (c === ',');
						}))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Solidity$functionDeclarationLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Solidity$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (b) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(5),
								b),
							revTokens));
				},
				$elm$parser$Parser$getChompedString(
					$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Solidity$isIdentifierNameChar))),
				A2(
				$elm$parser$Parser$map,
				function (_v0) {
					return $elm$parser$Parser$Loop(
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								$author$project$SyntaxHighlight$Language$Type$C(2),
								'*'),
							revTokens));
				},
				$elm$parser$Parser$symbol('*')),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					function (_v1) {
						return A2(
							$elm$parser$Parser$loop,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, '('),
								revTokens),
							$author$project$SyntaxHighlight$Language$Solidity$argLoop);
					},
					$elm$parser$Parser$symbol('('))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Solidity$FunctionEval = 4;
var $author$project$SyntaxHighlight$Language$Solidity$functionEvalLoop = F3(
	function (identifier, revTokens, thisRevToken) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$author$project$SyntaxHighlight$Language$Solidity$whitespaceOrCommentStep(thisRevToken),
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return $elm$parser$Parser$Done(
							_Utils_ap(
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, '('),
									thisRevToken),
								A2(
									$elm$core$List$cons,
									_Utils_Tuple2(
										$author$project$SyntaxHighlight$Language$Type$C(4),
										identifier),
									revTokens)));
					},
					$elm$parser$Parser$symbol('(')),
					$elm$parser$Parser$succeed(
					$elm$parser$Parser$Done(
						_Utils_ap(
							thisRevToken,
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2($author$project$SyntaxHighlight$Language$Type$Normal, identifier),
								revTokens))))
				]));
	});
var $author$project$SyntaxHighlight$Language$Solidity$declarationKeywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['var', 'const', 'let', 'uint', 'address', 'bool']));
var $author$project$SyntaxHighlight$Language$Solidity$isDeclarationKeyword = function (str) {
	return A2($elm$core$Set$member, str, $author$project$SyntaxHighlight$Language$Solidity$declarationKeywordSet);
};
var $author$project$SyntaxHighlight$Language$Solidity$keywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['assert', 'break', 'do', 'instanceof', 'typeof', 'case', 'else', 'new', 'catch', 'finally', 'return', 'void', 'continue', 'for', 'switch', 'while', 'debugger', 'this', 'with', 'default', 'if', 'throw', 'delete', 'in', 'try', 'enum', 'extends', 'export', 'import', 'implements', 'private', 'public', 'yield', 'interface', 'package', 'protected', 'require', 'Comptroller', 'CErc20', 'CEther', 'CToken', 'Erc20', 'memory']));
var $author$project$SyntaxHighlight$Language$Solidity$isKeyword = function (str) {
	return A2($elm$core$Set$member, str, $author$project$SyntaxHighlight$Language$Solidity$keywordSet);
};
var $author$project$SyntaxHighlight$Language$Solidity$literalKeywordSet = $elm$core$Set$fromList(
	_List_fromArray(
		['true', 'false', 'null', 'undefined', 'NaN', 'Infinity']));
var $author$project$SyntaxHighlight$Language$Solidity$isLiteralKeyword = function (str) {
	return A2($elm$core$Set$member, str, $author$project$SyntaxHighlight$Language$Solidity$literalKeywordSet);
};
var $author$project$SyntaxHighlight$Language$Solidity$keywordParser = F2(
	function (revTokens, n) {
		return ((n === 'function') || (n === 'static')) ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens),
			$author$project$SyntaxHighlight$Language$Solidity$functionDeclarationLoop) : ((n === 'class') ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens),
			$author$project$SyntaxHighlight$Language$Solidity$classDeclarationLoop) : (((n === 'this') || (n === 'super')) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(7),
					n),
				revTokens)) : ((n === 'constructor') ? A2(
			$elm$parser$Parser$loop,
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(5),
					n),
				revTokens),
			$author$project$SyntaxHighlight$Language$Solidity$functionDeclarationLoop) : ($author$project$SyntaxHighlight$Language$Solidity$isKeyword(n) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(2),
					n),
				revTokens)) : ($author$project$SyntaxHighlight$Language$Solidity$isDeclarationKeyword(n) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(3),
					n),
				revTokens)) : ($author$project$SyntaxHighlight$Language$Solidity$isLiteralKeyword(n) ? $elm$parser$Parser$succeed(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					$author$project$SyntaxHighlight$Language$Type$C(6),
					n),
				revTokens)) : A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			A2($author$project$SyntaxHighlight$Language$Solidity$functionEvalLoop, n, revTokens))))))));
	});
var $author$project$SyntaxHighlight$Language$Solidity$Number = 0;
var $author$project$SyntaxHighlight$Language$Solidity$number = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$author$project$SyntaxHighlight$Language$Type$C(0),
			b);
	},
	$elm$parser$Parser$getChompedString($author$project$SyntaxHighlight$Language$Helpers$number));
var $author$project$SyntaxHighlight$Language$Solidity$isOperatorChar = function (c) {
	return A2($elm$core$Set$member, c, $author$project$SyntaxHighlight$Language$Solidity$operatorSet);
};
var $author$project$SyntaxHighlight$Language$Solidity$operatorChar = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _Utils_Tuple2(
			$author$project$SyntaxHighlight$Language$Type$C(2),
			b);
	},
	$elm$parser$Parser$getChompedString(
		$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Solidity$isOperatorChar)));
var $author$project$SyntaxHighlight$Language$Solidity$String = 1;
var $author$project$SyntaxHighlight$Language$Solidity$solEscapable = A2(
	$elm$parser$Parser$map,
	function (b) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$SyntaxHighlight$Language$Type$C(6),
				b)
			]);
	},
	$elm$parser$Parser$getChompedString($author$project$SyntaxHighlight$Language$Helpers$escapable));
var $author$project$SyntaxHighlight$Language$Solidity$quoteDelimiter = {
	d4: function (b) {
		return _Utils_Tuple2(
			$author$project$SyntaxHighlight$Language$Type$C(1),
			b);
	},
	d8: '\'',
	ep: _List_fromArray(
		[$author$project$SyntaxHighlight$Language$Solidity$lineBreakList, $author$project$SyntaxHighlight$Language$Solidity$solEscapable]),
	er: false,
	es: function (c) {
		return !($author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $author$project$SyntaxHighlight$Language$Helpers$isEscapable(c));
	},
	fh: '\''
};
var $author$project$SyntaxHighlight$Language$Solidity$doubleQuote = $author$project$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$author$project$SyntaxHighlight$Language$Solidity$quoteDelimiter,
		{d8: '\"', fh: '\"'}));
var $author$project$SyntaxHighlight$Language$Solidity$quote = $author$project$SyntaxHighlight$Language$Helpers$delimited($author$project$SyntaxHighlight$Language$Solidity$quoteDelimiter);
var $author$project$SyntaxHighlight$Language$Solidity$templateString = $author$project$SyntaxHighlight$Language$Helpers$delimited(
	_Utils_update(
		$author$project$SyntaxHighlight$Language$Solidity$quoteDelimiter,
		{
			d8: '`',
			ep: _List_fromArray(
				[$author$project$SyntaxHighlight$Language$Solidity$lineBreakList, $author$project$SyntaxHighlight$Language$Solidity$solEscapable]),
			es: function (c) {
				return !($author$project$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $author$project$SyntaxHighlight$Language$Helpers$isEscapable(c));
			},
			fh: '`'
		}));
var $author$project$SyntaxHighlight$Language$Solidity$stringLiteral = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[$author$project$SyntaxHighlight$Language$Solidity$quote, $author$project$SyntaxHighlight$Language$Solidity$doubleQuote, $author$project$SyntaxHighlight$Language$Solidity$templateString]));
var $author$project$SyntaxHighlight$Language$Solidity$mainLoop = function (revTokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$author$project$SyntaxHighlight$Language$Solidity$whitespaceOrCommentStep(revTokens),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						_Utils_ap(s, revTokens));
				},
				$author$project$SyntaxHighlight$Language$Solidity$stringLiteral),
				A2(
				$elm$parser$Parser$map,
				function (s) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$List$cons, s, revTokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$author$project$SyntaxHighlight$Language$Solidity$operatorChar, $author$project$SyntaxHighlight$Language$Solidity$groupChar, $author$project$SyntaxHighlight$Language$Solidity$number]))),
				A2(
				$elm$parser$Parser$map,
				$elm$parser$Parser$Loop,
				A2(
					$elm$parser$Parser$andThen,
					$author$project$SyntaxHighlight$Language$Solidity$keywordParser(revTokens),
					$elm$parser$Parser$getChompedString(
						$author$project$SyntaxHighlight$Language$Helpers$chompIfThenWhile($author$project$SyntaxHighlight$Language$Solidity$isIdentifierNameChar)))),
				$elm$parser$Parser$succeed(
				$elm$parser$Parser$Done(revTokens))
			]));
};
var $author$project$SyntaxHighlight$Language$Solidity$toRevTokens = A2($elm$parser$Parser$loop, _List_Nil, $author$project$SyntaxHighlight$Language$Solidity$mainLoop);
var $author$project$SyntaxHighlight$Language$Solidity$toLines = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run($author$project$SyntaxHighlight$Language$Solidity$toRevTokens),
	$elm$core$Result$map(
		$author$project$SyntaxHighlight$Line$Helpers$toLines($author$project$SyntaxHighlight$Language$Solidity$syntaxToStyle)));
var $author$project$SyntaxHighlight$solidity = A2(
	$elm$core$Basics$composeR,
	$author$project$SyntaxHighlight$Language$Solidity$toLines,
	$elm$core$Result$map($elm$core$Basics$identity));
var $author$project$Utils$Highlighter$highlightSol = function (solCode) {
	return A2(
		$elm$core$Result$withDefault,
		A2(
			$elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(solCode)
				])),
		A2(
			$elm$core$Result$map,
			$author$project$SyntaxHighlight$toBlockHtml(
				$elm$core$Maybe$Just(1)),
			$author$project$SyntaxHighlight$solidity(solCode)));
};
var $author$project$Strings$Translations$liquidate_borrow = function (lang) {
	switch (lang) {
		case 0:
			return 'Liquidate Borrow';
		case 1:
			return 'Liquidar pedir prestado';
		default:
			return '清算借款';
	}
};
var $author$project$Strings$Translations$redeem_underlying = function (lang) {
	switch (lang) {
		case 0:
			return 'Redeem Underlying';
		case 1:
			return 'Canjear Subyacente';
		default:
			return '赎回基础';
	}
};
var $author$project$Strings$Translations$repay_borrow = function (lang) {
	switch (lang) {
		case 0:
			return 'Repay Borrow';
		case 1:
			return 'Pagar prestado';
		default:
			return '偿还借款';
	}
};
var $author$project$Strings$Translations$repay_borrow_behalf = function (lang) {
	switch (lang) {
		case 0:
			return 'Repay Borrow Behalf';
		case 1:
			return 'Pagar en préstamo en nombre de';
		default:
			return '偿还借款代表';
	}
};
var $author$project$Strings$Translations$reserve_factor = function (lang) {
	switch (lang) {
		case 0:
			return 'Reserve Factor';
		case 1:
			return 'Factor de reserva';
		default:
			return '储量因素';
	}
};
var $author$project$Strings$Translations$solidity = function (lang) {
	switch (lang) {
		case 0:
			return 'Solidity';
		case 1:
			return 'Solidez';
		default:
			return 'Solidity';
	}
};
var $elm$html$Html$sup = _VirtualDom_node('sup');
var $author$project$Strings$Translations$supply_rate = function (lang) {
	switch (lang) {
		case 0:
			return 'Supply Rate';
		case 1:
			return 'Tasa de suministro';
		default:
			return '供应利率';
	}
};
var $author$project$Strings$Translations$total_borrow = function (lang) {
	switch (lang) {
		case 0:
			return 'Total Borrow';
		case 1:
			return 'Préstamo total';
		default:
			return '总借贷';
	}
};
var $author$project$Strings$Translations$total_reserves = function (lang) {
	switch (lang) {
		case 0:
			return 'Total Reserves';
		case 1:
			return 'Reservas totales';
		default:
			return '总储量';
	}
};
var $author$project$Strings$Translations$underlying_balance = function (lang) {
	switch (lang) {
		case 0:
			return 'Underlying Balance';
		case 1:
			return 'Balance de suministro subyacente';
		default:
			return '供给平衡基础';
	}
};
var $author$project$LandingSite$Developers$cTokensContent = function (userLanguage) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('ctokens')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('big')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$ctokens(userLanguage))
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('subheader')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$introduction(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_ctokens_description1_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$target('_blank')
									]),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://eips.ethereum.org/EIPS/eip-20')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_ctokens_description1_part2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_ctokens_description1_part3(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_ctokens_description2(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_ctokens_description3(userLanguage))
						]))
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('mint')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$mint(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_mint_description1_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#supply-rate'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$supply_rate(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_mint_description1_part3(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#exchange-rate'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$exchange_rate(userLanguage))
								])),
							$elm$html$Html$text('.')
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function mint(uint mintAmount) returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.sender')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_mint_msg_sender_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('mintAmount')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_mint_mint_amount_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											A2($author$project$Strings$Translations$docs_mint_return_description, userLanguage, '')),
											A2(
											$elm$html$Html$a,
											A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$error_codes(userLanguage))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_mint_prereq_description_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$target('_blank')
									]),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://eips.ethereum.org/EIPS/eip-20#approve')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_approve_prereq_part2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_approve_prereq_part3(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function mint() payable'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('payable')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.value')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_mint_payable_msg_value_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.sender')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_mint_payable_msg_sender_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_mint_payable_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('Erc20 underlying = Erc20(0xToken...);     // get a handle for the underlying asset contract\nCErc20 cToken = CErc20(0x3FDA...);        // get a handle for the corresponding cToken contract\nunderlying.approve(address(cToken), 100); // approve the transfer\nassert(cToken.mint(100) == 0);            // mint the cTokens and assert there is no error'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nawait cToken.methods.mint().send({from: myAccount, value: 50});')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('redeem')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$redeem(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_redeem_description1_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#exchange-rate'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$exchange_rate(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_redeem_description1_part3(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2(
								$author$project$Utils$CompoundHtmlAttributes$href,
								0,
								$author$project$LandingSite$Page$getHrefUrl(
									A2(
										$author$project$LandingSite$Page$Developers,
										2,
										$elm$core$Maybe$Just('account-liquidity')))),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_redeem_description1_part4(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_redeem_description1_part5(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage)),
							$elm$html$Html$text(' / '),
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function redeem(uint redeemTokens) returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.sender')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_redeem_msg_sender_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('redeemTokens')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_redeem_redeem_tokens_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											A2($author$project$Strings$Translations$docs_redeem_return_description, userLanguage, '')),
											A2(
											$elm$html$Html$a,
											A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$error_codes(userLanguage))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CEther cToken = CEther(0x3FDB...);\nrequire(cToken.redeem(7) == 0, "something went wrong");'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CErc20.at(0x3FDA...);\ncToken.methods.redeem(1).send({from: ...});')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('redeem-underlying')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$redeem_underlying(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_redeem_underlying_description1_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#exchange-rate'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$exchange_rate(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_redeem_underlying_description1_part3(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2(
								$author$project$Utils$CompoundHtmlAttributes$href,
								0,
								$author$project$LandingSite$Page$getHrefUrl(
									A2(
										$author$project$LandingSite$Page$Developers,
										2,
										$elm$core$Maybe$Just('account-liquidity')))),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_redeem_description1_part4(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_redeem_underlying_description1_part5(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage)),
							$elm$html$Html$text(' / '),
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function redeemUnderlying(uint redeemAmount) returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.sender')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_redeem_underlying_msg_sender_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('redeemAmount')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_redeem_underlying_redeem_amount_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											A2($author$project$Strings$Translations$docs_redeem_underlying_return_description, userLanguage, '')),
											A2(
											$elm$html$Html$a,
											A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$error_codes(userLanguage))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CEther cToken = CEther(0x3FDB...);\nrequire(cToken.redeemUnderlying(50) == 0, "something went wrong");'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CErc20.at(0x3FDA...);\ncToken.methods.redeemUnderlying(10).send({from: ...});')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('borrow')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$borrow(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_borrow_description1_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#borrow-rate'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_borrow_description1_part2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_borrow_description1_part3(userLanguage)),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_borrow_description1_part4(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2(
								$author$project$Utils$CompoundHtmlAttributes$href,
								0,
								$author$project$LandingSite$Page$getHrefUrl(
									A2(
										$author$project$LandingSite$Page$Developers,
										2,
										$elm$core$Maybe$Just('account-liquidity')))),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_borrow_description1_part5(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_borrow_description1_part6(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_borrow_description2(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage)),
							$elm$html$Html$text(' / '),
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function borrow(uint borrowAmount) returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.sender')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_borrow_msg_value_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('borrowAmount')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_borrow_borrow_amount_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											A2($author$project$Strings$Translations$docs_borrow_return_description, userLanguage, '')),
											A2(
											$elm$html$Html$a,
											A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$error_codes(userLanguage))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CErc20 cToken = CErc20(0x3FDA...);\nrequire(cToken.borrow(100) == 0, "got collateral?");'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nawait cToken.methods.borrow(50).send({from: 0xMyAccount});')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('repay-borrow')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$repay_borrow(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_repay_borrow_description1(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function repayBorrow(uint repayAmount) returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.sender')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_repay_borrow_msg_sender_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('repayAmount')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_repay_borrow_repay_amount_description1(userLanguage)),
											A2(
											$elm$html$Html$sup,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$docs_repay_borrow_repay_amount_description2(userLanguage))
												])),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_repay_borrow_repay_amount_description3(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											A2($author$project$Strings$Translations$docs_repay_borrow_return_description, userLanguage, '')),
											A2(
											$elm$html$Html$a,
											A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$error_codes(userLanguage))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_repay_borrow_description2_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$target('_blank')
									]),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://eips.ethereum.org/EIPS/eip-20#approve')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_approve_prereq_part2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_approve_prereq_part3(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function repayBorrow() payable'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('payable')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.value')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_repay_borrow_payable_msg_value_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.sender')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_repay_borrow_payable_msg_sender_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_repay_borrow_payable_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CEther cToken = CEther(0x3FDB...);\nrequire(cToken.repayBorrow.value(100)() == 0, "transfer approved?");'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CErc20.at(0x3FDA...);\ncToken.methods.repayBorrow(10000).send({from: ...});')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('repay-borrow-behalf')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$repay_borrow_behalf(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_repay_borrow_behalf_description1(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function repayBorrowBehalf(address borrower, uint repayAmount) returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.sender')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_repay_borrow_behalf_msg_sender_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('borrower')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_repay_borrow_behalf_borrower_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('repayAmount')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_repay_borrow_behalf_repay_amount_description1(userLanguage)),
											A2(
											$elm$html$Html$sup,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$docs_repay_borrow_behalf_repay_amount_description2(userLanguage))
												])),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_repay_borrow_behalf_repay_amount_description3(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											A2($author$project$Strings$Translations$docs_repay_borrow_behalf_return_description, userLanguage, '')),
											A2(
											$elm$html$Html$a,
											A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$error_codes(userLanguage))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_repay_borrow_description2_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$target('_blank')
									]),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://eips.ethereum.org/EIPS/eip-20#approve')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_approve_prereq_part2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_approve_prereq_part3(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function repayBorrowBehalf(address borrower) payable'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('payable')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.value')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_repay_borrow_behalf_payable_msg_value_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.sender')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_repay_borrow_behalf_payable_msg_sender_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('borrower')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_repay_borrow_behalf_payable_borrower_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_repay_borrow_behalf_payable_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CEther cToken = CEther(0x3FDB...);\nrequire(cToken.repayBorrowBehalf.value(100)(0xBorrower) == 0, "transfer approved?");'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CErc20.at(0x3FDA...);\nawait cToken.methods.repayBorrowBehalf(0xBorrower, 10000).send({from: 0xPayer});')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('liquidate-borrow')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$liquidate_borrow(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_liquidate_description1_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2(
								$author$project$Utils$CompoundHtmlAttributes$href,
								0,
								$author$project$LandingSite$Page$getHrefUrl(
									A2(
										$author$project$LandingSite$Page$Developers,
										2,
										$elm$core$Maybe$Just('account-liquidity')))),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_liquidate_description1_part2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_liquidate_description1_part3(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#liquidate-borrow'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_liquidate_description1_part4(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_liquidate_description1_part5(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2(
								$author$project$Utils$CompoundHtmlAttributes$href,
								0,
								$author$project$LandingSite$Page$getHrefUrl(
									A2(
										$author$project$LandingSite$Page$Developers,
										0,
										$elm$core$Maybe$Just('collateral')))),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_liquidate_description1_part6(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_liquidate_description1_part7(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2(
								$author$project$Utils$CompoundHtmlAttributes$href,
								0,
								$author$project$LandingSite$Page$getHrefUrl(
									A2(
										$author$project$LandingSite$Page$Developers,
										0,
										$elm$core$Maybe$Just('glossary')))),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_liquidate_description1_part8(userLanguage))
								])),
							$elm$html$Html$text('.')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_liquidate_description2_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2(
								$author$project$Utils$CompoundHtmlAttributes$href,
								0,
								$author$project$LandingSite$Page$getHrefUrl(
									A2(
										$author$project$LandingSite$Page$Developers,
										0,
										$elm$core$Maybe$Just('glossary')))),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_liquidate_description2_part2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_liquidate_description2_part3(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function liquidateBorrow(address borrower, uint amount, address collateral) returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.sender')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_liquidate_msg_sender_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('borrower')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_liquidate_borrower_description1(userLanguage)),
											A2(
											$elm$html$Html$a,
											A2(
												$author$project$Utils$CompoundHtmlAttributes$href,
												0,
												$author$project$LandingSite$Page$getHrefUrl(
													A2(
														$author$project$LandingSite$Page$Developers,
														2,
														$elm$core$Maybe$Just('account-liquidity')))),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$docs_liquidate_borrower_description2(userLanguage))
												])),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_liquidate_borrower_description3(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('repayAmount')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_liquidate_repay_amount_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('cTokenCollateral')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_liquidate_ctoken_collateral_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											A2($author$project$Strings$Translations$docs_liquidate_return_description, userLanguage, '')),
											A2(
											$elm$html$Html$a,
											A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#ctoken-error-codes'),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$error_codes(userLanguage))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_liquidate_description3_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$target('_blank')
									]),
								A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://eips.ethereum.org/EIPS/eip-20#approve')),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_liquidate_description3_part2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_liquidate_description3_part3(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function liquidateBorrow(address borrower, address cTokenCollateral) payable'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('payable')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.value')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_liquidate_payable_msg_value_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.sender')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_liquidate_payable_msg_sender_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('borrower')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_liquidate_payable_borrower_description1(userLanguage)),
											A2(
											$elm$html$Html$a,
											A2(
												$author$project$Utils$CompoundHtmlAttributes$href,
												0,
												$author$project$LandingSite$Page$getHrefUrl(
													A2(
														$author$project$LandingSite$Page$Developers,
														2,
														$elm$core$Maybe$Just('account-liquidity')))),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$docs_liquidate_payable_borrower_description2(userLanguage))
												])),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_liquidate_payable_borrower_description3(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('cTokenCollateral')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_liquidate_payable_ctoken_collateral_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_liquidate_payable_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CEther cToken = CEther(0x3FDB...);\nCErc20 cTokenCollateral = CErc20(0x3FDA...);\nrequire(cToken.liquidateBorrow.value(100)(0xBorrower, cTokenCollateral) == 0, "borrower underwater??");'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CErc20.at(0x3FDA...);\nconst cTokenCollateral = CEther.at(0x3FDB...);\nawait cToken.methods.liquidateBorrow(0xBorrower, 33, cTokenCollateral).send({from: 0xLiquidator});')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('ctoken-events')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Key Events')
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('key-events-table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Event')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Description')
												]))
										]))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('event')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Mint(address minter, uint mintAmount, uint mintTokens)')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Emitted upon a successful '),
													A2(
													$elm$html$Html$a,
													A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#mint'),
													_List_fromArray(
														[
															$elm$html$Html$text('Mint')
														])),
													$elm$html$Html$text('.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('event')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Redeem(address redeemer, uint redeemAmount, uint redeemTokens)')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Emitted upon a successful '),
													A2(
													$elm$html$Html$a,
													A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#redeem'),
													_List_fromArray(
														[
															$elm$html$Html$text('Redeem')
														])),
													$elm$html$Html$text('.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('event')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Borrow(address borrower, uint borrowAmount, uint accountBorrows, uint totalBorrows)')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Emitted upon a successful '),
													A2(
													$elm$html$Html$a,
													A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#borrow'),
													_List_fromArray(
														[
															$elm$html$Html$text('Borrow')
														])),
													$elm$html$Html$text('.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('event')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('RepayBorrow(address payer, address borrower, uint repayAmount, uint accountBorrows, uint totalBorrows)')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Emitted upon a successful '),
													A2(
													$elm$html$Html$a,
													A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#repay-borrow'),
													_List_fromArray(
														[
															$elm$html$Html$text('Repay Borrow')
														])),
													$elm$html$Html$text('.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('event')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LiquidateBorrow(address liquidator, address borrower, uint repayAmount, address cTokenCollateral, uint seizeTokens)')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Emitted upon a successful '),
													A2(
													$elm$html$Html$a,
													A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#liquidate-borrow'),
													_List_fromArray(
														[
															$elm$html$Html$text('Liquidate Borrow')
														])),
													$elm$html$Html$text('.')
												]))
										]))
								]))
						]))
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('ctoken-error-codes')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Error Codes')
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('errors')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Code')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Name')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Description')
												]))
										]))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('green')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('0')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('NO_ERROR')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Not a failure.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('1')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('UNAUTHORIZED')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The sender is not authorized to perform this action.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('2')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('BAD_INPUT')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('An invalid argument was supplied by the caller.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('3')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('COMPTROLLER_REJECTION')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The action would violate the comptroller policy.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('4')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('COMPTROLLER_CALCULATION_ERROR')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('An internal calculation has failed in the comptroller.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('5')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('INTEREST_RATE_MODEL_ERROR')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The interest rate model returned an invalid value.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('6')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('INVALID_ACCOUNT_PAIR')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The specified combination of accounts is invalid.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('7')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('INVALID_CLOSE_AMOUNT_REQUESTED')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The amount to liquidate is invalid.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('8')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('INVALID_COLLATERAL_FACTOR')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The collateral factor is invalid.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('9')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MATH_ERROR')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('A math calculation error occurred.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('10')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MARKET_NOT_FRESH')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Interest has not been properly accrued.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('11')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MARKET_NOT_LISTED')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The market is not currently listed by its comptroller.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('12')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('TOKEN_INSUFFICIENT_ALLOWANCE')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('ERC-20 contract must *allow* Money Market contract to call `transferFrom`. The current allowance is either 0 or less than the requested supply, repayBorrow or liquidate amount.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('13')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('TOKEN_INSUFFICIENT_BALANCE')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Caller does not have sufficient balance in the ERC-20 contract to complete the desired action.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('14')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('TOKEN_INSUFFICIENT_CASH')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The market does not have a sufficient cash balance to complete the transaction. You may attempt this transaction again later.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('15')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('TOKEN_TRANSFER_IN_FAILED')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Failure in ERC-20 when transfering token into the market.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('16')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('TOKEN_TRANSFER_OUT_FAILED')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Failure in ERC-20 when transfering token out of the market.')
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('failure-info-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Failure Info')
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('failure-infos')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Code')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Name')
												]))
										]))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('0')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('ACCEPT_ADMIN_PENDING_ADMIN_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('1')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('ACCRUE_INTEREST_ACCUMULATED_INTEREST_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('2')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('ACCRUE_INTEREST_BORROW_RATE_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('3')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('ACCRUE_INTEREST_NEW_BORROW_INDEX_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('4')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('ACCRUE_INTEREST_NEW_TOTAL_BORROWS_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('5')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('ACCRUE_INTEREST_NEW_TOTAL_RESERVES_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('6')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('ACCRUE_INTEREST_SIMPLE_INTEREST_FACTOR_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('7')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('BORROW_ACCUMULATED_BALANCE_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('8')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('BORROW_ACCRUE_INTEREST_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('9')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('BORROW_CASH_NOT_AVAILABLE')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('10')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('BORROW_FRESHNESS_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('11')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('BORROW_NEW_TOTAL_BALANCE_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('12')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('BORROW_NEW_ACCOUNT_BORROW_BALANCE_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('13')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('BORROW_MARKET_NOT_LISTED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('14')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('BORROW_COMPTROLLER_REJECTION')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('15')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_ACCRUE_BORROW_INTEREST_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('16')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_ACCRUE_COLLATERAL_INTEREST_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('17')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_COLLATERAL_FRESHNESS_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('18')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_COMPTROLLER_REJECTION')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('19')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_COMPTROLLER_CALCULATE_AMOUNT_SEIZE_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('20')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_CLOSE_AMOUNT_IS_UINT_MAX')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('21')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_CLOSE_AMOUNT_IS_ZERO')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('22')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_FRESHNESS_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('23')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_LIQUIDATOR_IS_BORROWER')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('24')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_REPAY_BORROW_FRESH_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('25')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_SEIZE_BALANCE_INCREMENT_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('26')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_SEIZE_BALANCE_DECREMENT_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('27')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_SEIZE_COMPTROLLER_REJECTION')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('28')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_SEIZE_LIQUIDATOR_IS_BORROWER')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('29')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('LIQUIDATE_SEIZE_TOO_MUCH')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('30')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MINT_ACCRUE_INTEREST_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('31')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MINT_COMPTROLLER_REJECTION')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('32')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MINT_EXCHANGE_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('33')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MINT_EXCHANGE_RATE_READ_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('34')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MINT_FRESHNESS_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('35')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MINT_NEW_ACCOUNT_BALANCE_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('36')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MINT_NEW_TOTAL_SUPPLY_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('37')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MINT_TRANSFER_IN_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('38')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MINT_TRANSFER_IN_NOT_POSSIBLE')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('39')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REDEEM_ACCRUE_INTEREST_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('40')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REDEEM_COMPTROLLER_REJECTION')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('41')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REDEEM_EXCHANGE_TOKENS_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('42')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REDEEM_EXCHANGE_AMOUNT_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('43')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REDEEM_EXCHANGE_RATE_READ_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('44')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REDEEM_FRESHNESS_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('45')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REDEEM_NEW_ACCOUNT_BALANCE_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('46')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REDEEM_NEW_TOTAL_SUPPLY_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('47')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REDEEM_TRANSFER_OUT_NOT_POSSIBLE')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('48')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REDUCE_RESERVES_ACCRUE_INTEREST_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('49')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REDUCE_RESERVES_ADMIN_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('50')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REDUCE_RESERVES_CASH_NOT_AVAILABLE')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('51')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REDUCE_RESERVES_FRESH_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('52')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REDUCE_RESERVES_VALIDATION')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('53')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REPAY_BEHALF_ACCRUE_INTEREST_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('54')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REPAY_BORROW_ACCRUE_INTEREST_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('55')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REPAY_BORROW_ACCUMULATED_BALANCE_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('56')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REPAY_BORROW_COMPTROLLER_REJECTION')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('57')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REPAY_BORROW_FRESHNESS_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('58')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REPAY_BORROW_NEW_ACCOUNT_BORROW_BALANCE_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('59')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REPAY_BORROW_NEW_TOTAL_BALANCE_CALCULATION_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('60')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REPAY_BORROW_TRANSFER_IN_NOT_POSSIBLE')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('61')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_COLLATERAL_FACTOR_OWNER_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('62')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_COLLATERAL_FACTOR_VALIDATION')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('63')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_COMPTROLLER_OWNER_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('64')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_INTEREST_RATE_MODEL_ACCRUE_INTEREST_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('65')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_INTEREST_RATE_MODEL_FRESH_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('66')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_INTEREST_RATE_MODEL_OWNER_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('67')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_MAX_ASSETS_OWNER_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('68')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_ORACLE_MARKET_NOT_LISTED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('69')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_PENDING_ADMIN_OWNER_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('70')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_RESERVE_FACTOR_ACCRUE_INTEREST_FAILED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('71')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_RESERVE_FACTOR_ADMIN_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('72')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_RESERVE_FACTOR_FRESH_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('73')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_RESERVE_FACTOR_BOUNDS_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('74')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('TRANSFER_COMPTROLLER_REJECTION')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('75')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('TRANSFER_NOT_ALLOWED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('76')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('TRANSFER_NOT_ENOUGH')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('77')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('TRANSFER_TOO_MUCH')
														]))
												]))
										]))
								]))
						]))
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('exchange-rate')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$exchange_rate(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_exchange_rate_description(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('exchangeRate = (getCash() + totalBorrows() - totalReserves()) / totalSupply()'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage)),
							$elm$html$Html$text(' / '),
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function exchangeRateCurrent() returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_exchange_rate_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CErc20 cToken = CToken(0x3FDA...);\nuint exchangeRateMantissa = cToken.exchangeRateCurrent();'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst exchangeRate = (await cToken.methods.exchangeRateCurrent().call()) / 1e18;'),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Tip: note the use of '),
							A2(
							$elm$html$Html$code,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('call')
								])),
							$elm$html$Html$text(' vs. '),
							A2(
							$elm$html$Html$code,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('send')
								])),
							$elm$html$Html$text(' to invoke the function from off-chain without incurring gas costs.')
						]))
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('cash')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$get_cash(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cash_description(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage)),
							$elm$html$Html$text(' / '),
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function getCash() returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_cash_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CErc20 cToken = CToken(0x3FDA...);\nuint cash = cToken.getCash();'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst cash = (await cToken.methods.getCash().call());')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('total-borrows')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$total_borrow(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_total_borrow_description(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage)),
							$elm$html$Html$text(' / '),
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function totalBorrowsCurrent() returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_total_borrow_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CErc20 cToken = CToken(0x3FDA...);\nuint borrows = cToken.totalBorrowsCurrent();'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst borrows = (await cToken.methods.totalBorrowsCurrent().call());')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('borrow-balance')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$borrow_balance(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_borrow_balance_description_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#borrow-rate'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_borrow_balance_description_part2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_borrow_balance_description_part3(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage)),
							$elm$html$Html$text(' / '),
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function borrowBalanceCurrent(address account) returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('account')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_borrow_balance_account_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_borrow_balance_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CErc20 cToken = CToken(0x3FDA...);\nuint borrows = cToken.borrowBalanceCurrent(msg.caller);'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst borrows = await cToken.methods.borrowBalanceCurrent(account).call();')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('borrow-rate')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$borrow_rate(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_borrow_rate_description(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage)),
							$elm$html$Html$text(' / '),
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function borrowRatePerBlock() returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_borrow_rate_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CErc20 cToken = CToken(0x3FDA...);\nuint borrowRateMantissa = cToken.borrowRatePerBlock();'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst borrowRate = (await cToken.methods.borrowRatePerBlock().call()) / 1e18;')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('total-supply')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$total_supply(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_total_supply_description(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage)),
							$elm$html$Html$text(' / '),
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function totalSupply() returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_total_supply_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CErc20 cToken = CToken(0x3FDA...);\nuint tokens = cToken.totalSupply();'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst tokens = (await cToken.methods.totalSupply().call());')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('underlying_balance')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$underlying_balance(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_underlying_balance_description(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#exchange-rate'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$exchange_rate(userLanguage))
								])),
							$elm$html$Html$text('.')
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage)),
							$elm$html$Html$text(' / '),
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function balanceOfUnderlying(address account) returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('account')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_supply_balance_underlying_account_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_supply_balance_underlying_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CErc20 cToken = CToken(0x3FDA...);\nuint tokens = cToken.balanceOfUnderlying(msg.caller);'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst tokens = await cToken.methods.balanceOfUnderlying(account).call();')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('supply-rate')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$supply_rate(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_supply_rate_description_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#borrow-rate'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_supply_rate_description_part2(userLanguage))
								])),
							$elm$html$Html$text(', '),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#reserve-factor'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_supply_rate_description_part3(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_supply_rate_description_part4(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#total-borrows'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_supply_rate_description_part5(userLanguage))
								])),
							$elm$html$Html$text('.')
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage)),
							$elm$html$Html$text(' / '),
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function supplyRatePerBlock() returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_supply_rate_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CErc20 cToken = CToken(0x3FDA...);\nuint supplyRateMantissa = cToken.supplyRatePerBlock();'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst supplyRate = (await cToken.methods.supplyRatePerBlock().call()) / 1e18;')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('total-reserves')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$total_reserves(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_total_reserves_description_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#cash'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_total_reserves_description_part2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_total_reserves_description_part3(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#reserve-factor'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_total_reserves_description_part4(userLanguage))
								])),
							$elm$html$Html$text('.')
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage)),
							$elm$html$Html$text(' / '),
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function totalReserves() returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_total_reserves_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CErc20 cToken = CToken(0x3FDA...);\nuint reserves = cToken.totalReserves();'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst reserves = (await cToken.methods.totalReserves().call());')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('reserve-factor')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$reserve_factor(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_reserve_factor_description_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#total-reserves'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_reserve_factor_description_part2(userLanguage))
								])),
							$elm$html$Html$text('.')
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_cerc20(userLanguage)),
							$elm$html$Html$text(' / '),
							$elm$html$Html$text(
							$author$project$Strings$Translations$cether(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function reserveFactorMantissa() returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_reserve_factor_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('CErc20 cToken = CToken(0x3FDA...);\nuint reserveFactorMantissa = cToken.reserveFactorMantissa();'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const cToken = CEther.at(0x3FDB...);\nconst reserveFactor = (await cToken.methods.reserveFactorMantissa().call()) / 1e18;')
				]))
		]);
};
var $author$project$Strings$Translations$key_events = function (lang) {
	switch (lang) {
		case 0:
			return 'Key Events';
		case 1:
			return 'Eventos clave';
		default:
			return '关键事件';
	}
};
var $author$project$LandingSite$Developers$cTokensNavList = function (userLanguage) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'#ctokens',
			$author$project$Strings$Translations$introduction(userLanguage)),
			_Utils_Tuple2(
			'#mint',
			$author$project$Strings$Translations$mint(userLanguage)),
			_Utils_Tuple2(
			'#redeem',
			$author$project$Strings$Translations$redeem(userLanguage)),
			_Utils_Tuple2(
			'#redeem-underlying',
			$author$project$Strings$Translations$redeem_underlying(userLanguage)),
			_Utils_Tuple2(
			'#borrow',
			$author$project$Strings$Translations$borrow(userLanguage)),
			_Utils_Tuple2(
			'#repay-borrow',
			$author$project$Strings$Translations$repay_borrow(userLanguage)),
			_Utils_Tuple2(
			'#repay-borrow-behalf',
			$author$project$Strings$Translations$repay_borrow_behalf(userLanguage)),
			_Utils_Tuple2(
			'#liquidate-borrow',
			$author$project$Strings$Translations$liquidate_borrow(userLanguage)),
			_Utils_Tuple2(
			'#ctoken-events',
			$author$project$Strings$Translations$key_events(userLanguage)),
			_Utils_Tuple2(
			'#ctoken-error-codes',
			$author$project$Strings$Translations$error_codes(userLanguage)),
			_Utils_Tuple2(
			'#exchange-rate',
			$author$project$Strings$Translations$exchange_rate(userLanguage)),
			_Utils_Tuple2(
			'#cash',
			$author$project$Strings$Translations$get_cash(userLanguage)),
			_Utils_Tuple2(
			'#total-borrows',
			$author$project$Strings$Translations$total_borrow(userLanguage)),
			_Utils_Tuple2(
			'#borrow-balance',
			$author$project$Strings$Translations$borrow_balance(userLanguage)),
			_Utils_Tuple2(
			'#borrow-rate',
			$author$project$Strings$Translations$borrow_rate(userLanguage)),
			_Utils_Tuple2(
			'#total-supply',
			$author$project$Strings$Translations$total_supply(userLanguage)),
			_Utils_Tuple2(
			'#underlying_balance',
			$author$project$Strings$Translations$underlying_balance(userLanguage)),
			_Utils_Tuple2(
			'#supply-rate',
			$author$project$Strings$Translations$supply_rate(userLanguage)),
			_Utils_Tuple2(
			'#total-reserves',
			$author$project$Strings$Translations$total_reserves(userLanguage)),
			_Utils_Tuple2(
			'#reserve-factor',
			$author$project$Strings$Translations$reserve_factor(userLanguage))
		]);
};
var $author$project$Strings$Translations$comptroller = function (lang) {
	switch (lang) {
		case 0:
			return 'Comptroller';
		case 1:
			return 'Contralor';
		default:
			return '审计官';
	}
};
var $author$project$Strings$Translations$architecture = function (lang) {
	switch (lang) {
		case 0:
			return 'Architecture';
		case 1:
			return 'Arquitectura';
		default:
			return '建筑';
	}
};
var $author$project$Strings$Translations$close_factor = function (lang) {
	switch (lang) {
		case 0:
			return 'Close Factor';
		case 1:
			return 'Factor cerrado';
		default:
			return '关闭因素';
	}
};
var $author$project$Strings$Translations$collateral_factor = function (lang) {
	switch (lang) {
		case 0:
			return 'Collateral Factor';
		case 1:
			return 'Factor colateral';
		default:
			return '抵押因素';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_account_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account whose liquidity shall be calculated.';
		case 1:
			return 'La cuenta cuya liquidez se calculará.';
		default:
			return '应计算流动资金的账户。';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_description2 = function (lang) {
	switch (lang) {
		case 0:
			return 'Users who do not have positive account liquidity do not have the ability to withdraw or borrow any assets until they bring their account liquidity back positive by supplying more assets or paying back outstanding borrows.';
		case 1:
			return 'Los usuarios que no tienen liquidez de cuenta positiva no tienen la capacidad de retirar o pedir prestado ningún activo hasta que devuelvan la liquidez de su cuenta de manera positiva al suministrar más activos o pagar préstamos pendientes.';
		default:
			return '没有正面账户流动性的用户无法提取或借入任何资产，直到他们通过提供更多资产或偿还未偿还借款来使其账户流动性恢复正常。';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_description3 = function (lang) {
	switch (lang) {
		case 0:
			return 'Sometimes account liquidity refers to a single signed value, rather than two unsigned values - however the Compound Protocol only deals with unsigned integers. A negative value for account liquidity also means the user is subject to liquidation to bring their account liquidity back to zero.';
		case 1:
			return 'A veces, la liquidez de la cuenta se refiere a un solo valor con signo, en lugar de dos valores sin signo; sin embargo, el Protocolo Compound solo trata con números enteros sin signo. Un valor negativo para la liquidez de la cuenta también significa que el usuario está sujeto a liquidación para que la liquidez de su cuenta vuelva a cero.';
		default:
			return '有时，账户流动性是指单个有符号值，而不是两个无符号值 - 但是复合协议仅处理无符号整数。账户流动性的负值也意味着用户需要进行清算才能将其账户流动性恢复为零。';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Within the Compound Protocol, account liquidity is defined as the total estimated ether value of an account\'s collateral (supply balances multiplied by the protocol ';
		case 1:
			return 'Dentro del Protocolo Compound, la liquidez de la cuenta se define como el valor total de éter estimado de la garantía de una cuenta (saldos de suministro multiplicados por el protocolo';
		default:
			return '在复合协议中，账户流动性被定义为账户抵押品的总估计以太值（供应余额乘以协议）';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_description_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'collateral factor';
		case 1:
			return 'factor colateral';
		default:
			return '抵押因素';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_description_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ', minus the total value of that account\'s borrow balances. These values are calculated using only the markets which the account has ';
		case 1:
			return ', menos el valor total de los saldos de préstamos de esa cuenta. Estos valores se calculan utilizando solo los mercados que tiene la cuenta';
		default:
			return '减去该账户借款余额的总价值。这些值仅使用帐户所拥有的市场计算';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_description_part4 = function (lang) {
	switch (lang) {
		case 0:
			return 'entered';
		case 1:
			return 'ingresó';
		default:
			return '进入';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_description_part5 = function (lang) {
	switch (lang) {
		case 0:
			return ' into.';
		case 1:
			return 'dentro.';
		default:
			return '成。';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_return_description1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Tuple of values (error, liquidity, shortfall). The error shall be 0 on success, otherwise an ';
		case 1:
			return 'Tupla de valores (error, liquidez, déficit). El error será 0 en caso de éxito, de lo contrario un';
		default:
			return '价值元组（错误，流动性，短缺）。成功时错误应为0，否则为';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_return_description2 = function (lang) {
	switch (lang) {
		case 0:
			return 'error code';
		case 1:
			return 'código de error';
		default:
			return '错误代码';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_return_description3 = function (lang) {
	switch (lang) {
		case 0:
			return '. A non-zero liquidity value indicates the account has available ';
		case 1:
			return '. Un valor de liquidez distinto de cero indica que la cuenta tiene disponible';
		default:
			return '。非零流动性值表示该帐户可用';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_return_description4 = function (lang) {
	switch (lang) {
		case 0:
			return 'account liquidity';
		case 1:
			return 'liquidez de cuenta';
		default:
			return '账户流动性';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_return_description5 = function (lang) {
	switch (lang) {
		case 0:
			return '. A non-zero shortfall value indicates the account is currently below his/her ';
		case 1:
			return '. Un valor de déficit distinto de cero indica que la cuenta está actualmente por debajo de su cuenta.';
		default:
			return '。非零缺口值表示该帐户目前低于他/她';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_return_description6 = function (lang) {
	switch (lang) {
		case 0:
			return 'collateral requirement';
		case 1:
			return 'requisito de garantía';
		default:
			return '抵押要求';
	}
};
var $author$project$Strings$Translations$docs_account_liquidity_return_description7 = function (lang) {
	switch (lang) {
		case 0:
			return ' and is subject to liquidation. At most one of liquidity or shortfall shall be non-zero.';
		case 1:
			return 'y está sujeto a liquidación. Como máximo, uno de liquidez o déficit será distinto de cero.';
		default:
			return '并被清算。流动性或短缺中的至多一个应为非零。';
	}
};
var $author$project$Strings$Translations$docs_assets_in_account_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account whose list of entered markets shall be queried.';
		case 1:
			return 'Se consultará la cuenta cuya lista de mercados ingresados.';
		default:
			return '应查询其输入市场列表的帐户。';
	}
};
var $author$project$Strings$Translations$docs_assets_in_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Get the list of markets an account is currently entered into. In order to supply collateral or borrow in a market, it must be entered first. Entered markets count towards ';
		case 1:
			return 'Obtenga la lista de mercados en los que se ingresa actualmente una cuenta. Para suministrar garantías o préstamos en un mercado, primero debe ingresarse. Los mercados ingresados cuentan para';
		default:
			return '获取当前输入帐户的市场列表。为了提供抵押品或在市场上借款，必须先输入。进入的市场计入';
	}
};
var $author$project$Strings$Translations$docs_assets_in_description_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'account liquidity';
		case 1:
			return 'liquidez de cuenta';
		default:
			return '账户流动性';
	}
};
var $author$project$Strings$Translations$docs_assets_in_description_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ' calculations.';
		case 1:
			return 'cálculos';
		default:
			return '计算。';
	}
};
var $author$project$Strings$Translations$docs_assets_in_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The address of each market which is currently entered into.';
		case 1:
			return 'La dirección de cada mercado en el que se ingresa actualmente.';
		default:
			return '目前进入的每个市场的地址。';
	}
};
var $author$project$Strings$Translations$docs_close_factor_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The percent, ranging from 0% to 100%, of a liquidatable account\'s borrow that can be repaid in a single liquidate transaction. If a user has multiple borrowed assets, the closeFactor applies to any single borrowed asset, not the aggregated value of a user’s outstanding borrowing.';
		case 1:
			return 'El porcentaje, que va del 0% al 100%, del préstamo de una cuenta liquidable que se puede pagar en una sola transacción de liquidación. Si un usuario tiene múltiples activos prestados, closeFactor se aplica a cualquier activo prestado, no al valor agregado de los préstamos pendientes de un usuario.';
		default:
			return '可清算账户借款的百分比，范围为0％至100％，可在单一清算交易中偿还。如果用户拥有多个借入资产，则closeFactor适用于任何单个借入资产，而不是用户未偿还借入的汇总值。';
	}
};
var $author$project$Strings$Translations$docs_close_factor_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The closeFactor, scaled by 1e18, is multiplied by an outstanding borrow balance to determine how much could be closed.';
		case 1:
			return 'CloseFactor, escalado en 1e18, se multiplica por un saldo pendiente de préstamo para determinar cuánto podría cerrarse.';
		default:
			return 'closeSactor（按1e18换算）乘以未偿还的借款余额，以确定可以关闭多少。';
	}
};
var $author$project$Strings$Translations$docs_collateral_factor_ctokenaddress_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The address of the cToken to check if listed and get the collateral factor for.';
		case 1:
			return 'La dirección del cToken para verificar si aparece y obtener el factor colateral.';
		default:
			return 'cToken的地址，用于检查是否列出并获得抵押因素。';
	}
};
var $author$project$Strings$Translations$docs_collateral_factor_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Each asset has a unique collateral factor, ranging from 0% to 90%; this represents the percentage of supplied value that can be actively borrowed at any given time.';
		case 1:
			return 'Cada activo tiene un factor colateral único, que varía de 0% a 90%; Esto representa el porcentaje del valor suministrado que puede ser prestado activamente en cualquier momento.';
		default:
			return '每项资产都有独特的抵押品因素，范围从0％到90％;这表示在任何给定时间可以主动借用的供应价值百分比。';
	}
};
var $author$project$Strings$Translations$docs_collateral_factor_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Tuple of values (isListed, collateralFactorMantissa); isListed represents whether the comptroller recognizes this cToken; collateralFactorMantissa, scaled by 1e18, is multiplied by a supply balance to determine how much value can be borrowed.';
		case 1:
			return 'Tupla de valores (isListed, collateralFactorMantissa); isListed representa si el controlador reconoce este cToken; collateralFactorMantissa, escalado en 1e18, se multiplica por un saldo de oferta para determinar cuánto valor se puede pedir prestado.';
		default:
			return '值元组（isListed，collateralFactorMantissa）; isListed表示审计者是否识别出这个cToken;由1e18缩放的collateralFactorMantissa乘以供应余额以确定可以借入多少价值。';
	}
};
var $author$project$Strings$Translations$docs_comptroller_architecture_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The Comptroller is implemented as an upgradeable proxy. The Unitroller proxies all logic to the Comptroller implementation, but storage values are set on the Unitroller. To call Comptroller functions, use the Comptroller ABI on the Unitroller address.';
		case 1:
			return 'El Contralor se implementa como un proxy actualizable. Unitroller representa toda la lógica para la implementación de Comptroller, pero los valores de almacenamiento se establecen en Unitroller. Para llamar a las funciones de Contralor, use la Contraloría ABI en la dirección de Unitroller.';
		default:
			return 'Comptroller实现为可升级的代理。 Unitroller代理Comptroller实现的所有逻辑，但存储值在Unitroller上设置。要调用Comptroller函数，请在Unitroller地址上使用Comptroller ABI。';
	}
};
var $author$project$Strings$Translations$docs_comptroller_description1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The Comptroller is the risk management layer of the Compound protocol; it determines how much collateral a user is required to maintain, and whether (and by how much) a user can be liquidated. Each time a user interacts with a cToken, the Comptroller is asked to approve or deny the transaction.';
		case 1:
			return 'El Contralor es la capa de gestión de riesgos del Protocolo Compound; determina cuánta garantía debe mantener un usuario y si (y en qué medida) puede liquidarse un usuario. Cada vez que un usuario interactúa con un cToken, se le pide al Contralor que apruebe o rechace la transacción.';
		default:
			return 'Comptroller是复合协议的风险管理层;它确定了用户需要维护的抵押品数量，以及是否可以（以及多少）清算用户。每次用户与cToken交互时，都会要求Comptroller批准或拒绝该交易。';
	}
};
var $author$project$Strings$Translations$docs_comptroller_description2_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The Comptroller maps user balances to prices (via the Price Oracle) to risk weights (called ';
		case 1:
			return 'El Contralor asigna los saldos de los usuarios a los precios (a través del Precio Oracle) a las ponderaciones de riesgo (llamado';
		default:
			return 'Comptroller将用户余额映射到价格（通过Price Oracle）到风险权重（称为';
	}
};
var $author$project$Strings$Translations$docs_comptroller_description2_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'Collateral Factors';
		case 1:
			return 'Factores colaterales';
		default:
			return '抵押因素';
	}
};
var $author$project$Strings$Translations$docs_comptroller_description2_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ') to make its determinations. Users explicitly list which assets they would like included in their risk scoring, by calling ';
		case 1:
			return ') para hacer sus determinaciones. Los usuarios enumeran explícitamente qué activos les gustaría incluir en su calificación de riesgo, llamando a';
		default:
			return '）做出决定。用户通过调用明确列出他们希望在风险评分中包含哪些资产';
	}
};
var $author$project$Strings$Translations$docs_comptroller_description2_part4 = function (lang) {
	switch (lang) {
		case 0:
			return 'Enter Markets';
		case 1:
			return 'Ingrese a los mercados';
		default:
			return '进入市场';
	}
};
var $author$project$Strings$Translations$docs_comptroller_description2_part5 = function (lang) {
	switch (lang) {
		case 0:
			return ' and ';
		case 1:
			return 'y';
		default:
			return '和';
	}
};
var $author$project$Strings$Translations$docs_comptroller_description2_part6 = function (lang) {
	switch (lang) {
		case 0:
			return 'Exit Market';
		case 1:
			return 'Mercado de salida';
		default:
			return '退出市场';
	}
};
var $author$project$Strings$Translations$docs_enter_markets_ctokens_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The addresses of the cToken markets to enter.';
		case 1:
			return 'Las direcciones de los mercados de cToken para ingresar.';
		default:
			return 'cToken市场的地址将进入。';
	}
};
var $author$project$Strings$Translations$docs_enter_markets_description1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Enter into a list of markets - it is not an error to enter the same market more than once. In order to supply collateral or borrow in a market, it must be entered first.';
		case 1:
			return 'Ingrese a una lista de mercados: no es un error ingresar al mismo mercado más de una vez. Para suministrar garantías o préstamos en un mercado, primero debe ingresarse.';
		default:
			return '进入市场列表 - 不止一次进入同一市场并不是错误。为了提供抵押品或在市场上借款，必须先输入。';
	}
};
var $author$project$Strings$Translations$docs_enter_markets_msg_sender_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account which shall enter the given markets.';
		case 1:
			return 'La cuenta que ingresará a los mercados dados.';
		default:
			return '应进入特定市场的账户。';
	}
};
var $author$project$Strings$Translations$docs_enter_markets_return_description = F2(
	function (lang, errorCode) {
		switch (lang) {
			case 0:
				return 'For each market, returns an error code indicating whether or not it was entered. Each is 0 on success, otherwise an ' + (errorCode + '');
			case 1:
				return 'Para cada mercado, devuelve un código de error que indica si se ingresó o no. Cada uno es 0 en caso de éxito, de lo contrario un ' + (errorCode + '');
			default:
				return '对于每个市场，返回一个错误代码，指示是否输入了该错误代码。成功时每个都为0，否则为' + (errorCode + '');
		}
	});
var $author$project$Strings$Translations$docs_exit_market_ctoken_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The addresses of the cToken market to exit.';
		case 1:
			return 'Las direcciones del mercado de cToken para salir.';
		default:
			return '退出cToken市场的地址。';
	}
};
var $author$project$Strings$Translations$docs_exit_market_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Exit a market - it is not an error to exit a market which is not currently entered. Exited markets will not count towards account liquidity calculations.';
		case 1:
			return 'Salir de un mercado: no es un error salir de un mercado que no está ingresado actualmente. Los mercados salidos no contarán para los cálculos de liquidez de la cuenta.';
		default:
			return '退出市场 - 退出当前未进入的市场并非错误。退出市场不会计入账户流动性计算。';
	}
};
var $author$project$Strings$Translations$docs_exit_market_msg_sender_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The account which shall exit the given market.';
		case 1:
			return 'La cuenta que saldrá del mercado dado.';
		default:
			return '该账户将退出给定市场。';
	}
};
var $author$project$Strings$Translations$docs_exit_market_return_description = F2(
	function (lang, errorCode) {
		switch (lang) {
			case 0:
				return '0 on success, otherwise an ' + (errorCode + '');
			case 1:
				return '0 en caso de éxito, de lo contrario un ' + (errorCode + '');
			default:
				return '成功时为0，否则为' + (errorCode + '');
		}
	});
var $author$project$Strings$Translations$docs_liquidation_incentive_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The additional collateral given to liquidators as an incentive to perform liquidation of underwater accounts. For example, if the liquidation incentive is 1.1, liquidators receive an extra 10% of the borrowers collateral for every unit they close.';
		case 1:
			return 'La garantía adicional otorgada a los liquidadores como incentivo para realizar la liquidación de cuentas subacuáticas. Por ejemplo, si el incentivo de liquidación es 1.1, los liquidadores reciben un 10% adicional de la garantía del prestatario por cada unidad que cierran.';
		default:
			return '为清算人提供的额外抵押品，以鼓励他们进行水下账户清算。例如，如果清算激励为1.1，清算人关闭的每个单位将额外获得借款人抵押品的10％。';
	}
};
var $author$project$Strings$Translations$docs_liquidation_incentive_return_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The liquidationIncentive, scaled by 1e18, is multiplied by the closed borrow amount from the liquidator to determine how much collateral can be seized.';
		case 1:
			return 'El LiquidationIncentive, escalado en 1e18, se multiplica por el saldo de préstamo cerrado del liquidador para determinar la cantidad de garantía que puede incautarse.';
		default:
			return '将清算激励（按1e18比例缩放）乘以清算人的已关闭借贷余额，以确定可以扣押多少抵押品。';
	}
};
var $author$project$Strings$Translations$enter_markets = function (lang) {
	switch (lang) {
		case 0:
			return 'Enter Markets';
		case 1:
			return 'Ingrese a los mercados';
		default:
			return '进入市场';
	}
};
var $author$project$Strings$Translations$exit_market = function (lang) {
	switch (lang) {
		case 0:
			return 'Exit Market';
		case 1:
			return 'Mercado de salida';
		default:
			return '退出市场';
	}
};
var $author$project$Strings$Translations$get_account_liquidity = function (lang) {
	switch (lang) {
		case 0:
			return 'Get Account Liquidity';
		case 1:
			return 'Obtenga liquidez de cuenta';
		default:
			return '获得账户流动性';
	}
};
var $author$project$Strings$Translations$get_assets_in = function (lang) {
	switch (lang) {
		case 0:
			return 'Get Assets In';
		case 1:
			return 'Obtener activos en';
		default:
			return '获得资产';
	}
};
var $author$project$Strings$Translations$liquidation_incentive = function (lang) {
	switch (lang) {
		case 0:
			return 'Liquidation Incentive';
		case 1:
			return 'Incentivo de liquidación';
		default:
			return '清算激励';
	}
};
var $author$project$LandingSite$Developers$comptrollerContent = function (userLanguage) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('comptroller')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('big')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comptroller(userLanguage))
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('subheader')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$introduction(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_comptroller_description1(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_comptroller_description2_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#collateral-factor'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_comptroller_description2_part2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_comptroller_description2_part3(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#enter-markets'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_comptroller_description2_part4(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_comptroller_description2_part5(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#exit-market'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_comptroller_description2_part6(userLanguage))
								])),
							$elm$html$Html$text('.')
						]))
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('architecture')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$architecture(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_comptroller_architecture_description(userLanguage))
						]))
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('enter-markets')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$enter_markets(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_enter_markets_description1(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comptroller(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function enterMarkets(address[] calldata cTokens) returns (uint[] memory)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.sender')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_enter_markets_msg_sender_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('cTokens')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_enter_markets_ctokens_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											A2($author$project$Strings$Translations$docs_enter_markets_return_description, userLanguage, '')),
											A2(
											$elm$html$Html$a,
											A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#comptroller-error-codes'),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$error_codes(userLanguage))
												])),
											$elm$html$Html$text('.')
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('Comptroller troll = Comptroller(0xABCD...);\nCToken[] memory cTokens = new CToken[](2);\ncTokens[0] = CErc20(0x3FDA...);\ncTokens[1] = CEther(0x3FDB...);\nuint[] memory errors = troll.enterMarkets(cTokens);'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlightSol('const troll = Comptroller.at(0xABCD...);\nconst cTokens = [CErc20.at(0x3FDA...), CEther.at(0x3FDB...)];\nconst errors = await troll.methods.enterMarkets(cTokens).send({from: ...});')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('exit-market')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$exit_market(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_exit_market_description(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comptroller(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function exitMarket(address cToken) returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('msg.sender')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_exit_market_msg_sender_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('cTokens')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_exit_market_ctoken_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											A2($author$project$Strings$Translations$docs_exit_market_return_description, userLanguage, '')),
											A2(
											$elm$html$Html$a,
											A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#comptroller-error-codes'),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$error_codes(userLanguage))
												])),
											$elm$html$Html$text('.')
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('Comptroller troll = Comptroller(0xABCD...);\nuint error = troll.exitMarket(CToken(0x3FDA...));'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const troll = Comptroller.at(0xABCD...);\nconst errors = await troll.methods.exitMarket(CEther.at(0x3FDB...)).send({from: ...});')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('assets-in')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$get_assets_in(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_assets_in_description_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#account-liquidity'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_assets_in_description_part2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_assets_in_description_part3(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comptroller(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function getAssetsIn(address account) view returns (address[] memory)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('account')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_assets_in_account_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_assets_in_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('Comptroller troll = Comptroller(0xABCD...);\naddress[] memory markets = troll.getAssetsIn(0xMyAccount);'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const troll = Comptroller.at(0xABCD...);\nconst markets = await troll.methods.getAssetsIn(cTokens).call();')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('collateral-factor')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$collateral_factor(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_collateral_factor_description(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comptroller(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function markets(address cTokenAddress) view returns (bool, uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('cTokenAddress')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_collateral_factor_ctokenaddress_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_collateral_factor_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('Comptroller troll = Comptroller(0xABCD...);\n(bool isListed, uint collateralFactorMantissa) = troll.markets(0x3FDA...);'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const troll = Comptroller.at(0xABCD...);\nconst result = await troll.methods.markets(0x3FDA...).call();\nconst {0: isListed, 1: collateralFactorMantissa} = result;')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('account-liquidity')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$get_account_liquidity(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_account_liquidity_description_part1(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#collateral-factor'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_account_liquidity_description_part2(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_account_liquidity_description_part3(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#enter-markets'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_account_liquidity_description_part4(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_account_liquidity_description_part5(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_account_liquidity_description2(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_account_liquidity_description3(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comptroller(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function getAccountLiquidity(address account) view returns (uint, uint, uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('account')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_account_liquidity_account_description(userLanguage))
										])),
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_account_liquidity_return_description1(userLanguage)),
											A2(
											$elm$html$Html$a,
											A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#comptroller-error-codes'),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$docs_account_liquidity_return_description2(userLanguage))
												])),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_account_liquidity_return_description3(userLanguage)),
											A2(
											$elm$html$Html$a,
											A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#account-liquidity'),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$docs_account_liquidity_return_description4(userLanguage))
												])),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_account_liquidity_return_description5(userLanguage)),
											A2(
											$elm$html$Html$a,
											A2(
												$author$project$Utils$CompoundHtmlAttributes$href,
												0,
												$author$project$LandingSite$Page$getHrefUrl(
													A2(
														$author$project$LandingSite$Page$Developers,
														0,
														$elm$core$Maybe$Just('collateral')))),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$docs_account_liquidity_return_description6(userLanguage))
												])),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_account_liquidity_return_description7(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('Comptroller troll = Comptroller(0xABCD...);\n(uint error, uint liquidity, uint shortfall) = troll.getAccountLiquidity(msg.caller);\nrequire(error == 0, "join the Discord");\nrequire(shortfall == 0, "account underwater");\nrequire(liquidity > 0, "account has excess collateral");'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const troll = Comptroller.at(0xABCD...);\nconst result = await troll.methods.getAccountLiquidity(0xBorrower).call();\nconst {0: error, 1: liquidity, 2: shortfall} = result;')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('close-factor')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$close_factor(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_close_factor_description(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comptroller(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function closeFactorMantissa() view returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_close_factor_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('Comptroller troll = Comptroller(0xABCD...);\nuint closeFactor = troll.closeFactorMantissa();'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const troll = Comptroller.at(0xABCD...);\nconst closeFactor = await troll.methods.closeFactoreMantissa().call();')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('liquidation-incentive')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$liquidation_incentive(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$docs_liquidation_incentive_description(userLanguage))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$comptroller(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlight('function liquidationIncentiveMantissa() view returns (uint)'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('RETURN')
												])),
											$elm$html$Html$text(' : '),
											$elm$html$Html$text(
											$author$project$Strings$Translations$docs_liquidation_incentive_return_description(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$solidity(userLanguage))
						])),
					$author$project$Utils$Highlighter$highlightSol('Comptroller troll = Comptroller(0xABCD...);\nuint closeFactor = troll.liquidationIncentiveMantissa();'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Web3 1.0')
						])),
					$author$project$Utils$Highlighter$highlight('const troll = Comptroller.at(0xABCD...);\nconst closeFactor = await troll.methods.liquidationIncentiveMantissa().call();')
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('comptroller-events')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Key Events')
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('key-events-table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Event')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Description')
												]))
										]))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('event')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MarketEntered(CToken cToken, address account)')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Emitted upon a successful '),
													A2(
													$elm$html$Html$a,
													A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#enter-markets'),
													_List_fromArray(
														[
															$elm$html$Html$text('Enter Market')
														])),
													$elm$html$Html$text('.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('event')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MarketExited(CToken cToken, address account)')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Emitted upon a successful '),
													A2(
													$elm$html$Html$a,
													A2($author$project$Utils$CompoundHtmlAttributes$href, 0, '#exit-market'),
													_List_fromArray(
														[
															$elm$html$Html$text('Exit Market')
														])),
													$elm$html$Html$text('.')
												]))
										]))
								]))
						]))
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('comptroller-error-codes')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Error Codes')
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('errors')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Code')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Name')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Description')
												]))
										]))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('green')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('0')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('NO_ERROR')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Not a failure.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('1')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('UNAUTHORIZED')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The sender is not authorized to perform this action.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('2')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('COMPTROLLER_MISMATCH')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Liquidation cannot be performed in markets with different comptrollers.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('3')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('INSUFFICIENT_SHORTFALL')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The account does not have sufficient shortfall to perform this action.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('4')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('INSUFFICIENT_LIQUIDITY')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The account does not have sufficient liquidity to perform this action.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('5')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('INVALID_CLOSE_FACTOR')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The close factor is not valid.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('6')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('INVALID_COLLATERAL_FACTOR')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The collateral factor is not valid.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('7')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('INVALID_LIQUIDATION_INCENTIVE')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The liquidation incentive is invalid.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('8')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MARKET_NOT_ENTERED')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The market has not been entered by the account.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('9')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MARKET_NOT_LISTED')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The market is not currently listed by the comptroller.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('10')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MARKET_ALREADY_LISTED')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('An admin tried to list the same market more than once.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('11')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('MATH_ERROR')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('A math calculation error occurred.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('12')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('NONZERO_BORROW_BALANCE')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The action cannot be performed since the account carries a borrow balance.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('13')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('PRICE_ERROR')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The comptroller could not obtain a required price of an asset.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('14')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('REJECTION')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The comptroller rejects the action requested by the market.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('15')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SNAPSHOT_ERROR')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('The comptroller could not get the account borrows and exchange rate from the market.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('16')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('TOO_MANY_ASSETS')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Attempted to enter more markets than are currently supported.')
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('17')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('TOO_MUCH_REPAY')
														]))
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Attempted to repay more than is allowed by the protocol.')
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('failure-info-header')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Failure Info')
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('failure-infos')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Code')
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Name')
												]))
										]))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('0')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('ACCEPT_ADMIN_PENDING_ADMIN_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('1')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('ACCEPT_PENDING_IMPLEMENTATION_ADDRESS_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('2')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('EXIT_MARKET_BALANCE_OWED')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('3')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('EXIT_MARKET_REJECTION')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('4')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_CLOSE_FACTOR_OWNER_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('5')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_CLOSE_FACTOR_VALIDATION')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('6')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_COLLATERAL_FACTOR_OWNER_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('7')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_COLLATERAL_FACTOR_NO_EXISTS')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('8')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_COLLATERAL_FACTOR_VALIDATION')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('9')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_COLLATERAL_FACTOR_WITHOUT_PRICE')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('10')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_IMPLEMENTATION_OWNER_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('11')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_LIQUIDATION_INCENTIVE_OWNER_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('12')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_LIQUIDATION_INCENTIVE_VALIDATION')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('13')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_MAX_ASSETS_OWNER_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('14')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_PENDING_ADMIN_OWNER_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('15')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_PENDING_IMPLEMENTATION_OWNER_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('16')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SET_PRICE_ORACLE_OWNER_CHECK')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('17')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SUPPORT_MARKET_EXISTS')
														]))
												]))
										])),
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('18')
												])),
											A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SUPPORT_MARKET_OWNER_CHECK')
														]))
												]))
										]))
								]))
						]))
				]))
		]);
};
var $author$project$LandingSite$Developers$comptrollerNavList = function (userLanguage) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'#comptroller',
			$author$project$Strings$Translations$introduction(userLanguage)),
			_Utils_Tuple2(
			'#architecture',
			$author$project$Strings$Translations$architecture(userLanguage)),
			_Utils_Tuple2(
			'#enter-markets',
			$author$project$Strings$Translations$enter_markets(userLanguage)),
			_Utils_Tuple2(
			'#exit-market',
			$author$project$Strings$Translations$exit_market(userLanguage)),
			_Utils_Tuple2(
			'#assets-in',
			$author$project$Strings$Translations$get_assets_in(userLanguage)),
			_Utils_Tuple2(
			'#collateral-factor',
			$author$project$Strings$Translations$collateral_factor(userLanguage)),
			_Utils_Tuple2(
			'#account-liquidity',
			$author$project$Strings$Translations$get_account_liquidity(userLanguage)),
			_Utils_Tuple2(
			'#close-factor',
			$author$project$Strings$Translations$close_factor(userLanguage)),
			_Utils_Tuple2(
			'#liquidation-incentive',
			$author$project$Strings$Translations$liquidation_incentive(userLanguage)),
			_Utils_Tuple2(
			'#comptroller-events',
			$author$project$Strings$Translations$key_events(userLanguage)),
			_Utils_Tuple2(
			'#comptroller-error-codes',
			$author$project$Strings$Translations$error_codes(userLanguage))
		]);
};
var $author$project$LandingSite$Developers$CopyMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$LandingSite$Developers$SelectNetwork = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Eth$Ethereum$TokenAddress = function (a) {
	return {$: 1, a: a};
};
var $author$project$Bootstrap$Carousel$Config = $elm$core$Basics$identity;
var $author$project$Bootstrap$Carousel$config = F2(
	function (toMsg, attributes) {
		return {dQ: attributes, co: false, cM: false, b5: _List_Nil, bk: toMsg};
	});
var $author$project$Bootstrap$Carousel$SlideInternal$Config = $elm$core$Basics$identity;
var $author$project$Bootstrap$Carousel$Slide$config = F2(
	function (attributes, content) {
		return {dQ: attributes, dW: $elm$core$Maybe$Nothing, f8: content};
	});
var $author$project$Bootstrap$Carousel$SlideInternal$Custom = function (a) {
	return {$: 1, a: a};
};
var $author$project$Bootstrap$Carousel$Slide$customContent = function (html) {
	return $author$project$Bootstrap$Carousel$SlideInternal$Custom(
		{gz: html});
};
var $author$project$Utils$CompoundHtmlAttributes$property = F2(
	function (propertyName, propertyValue) {
		return A2($elm$html$Html$Attributes$attribute, propertyName, propertyValue);
	});
var $author$project$Bootstrap$Carousel$slides = F2(
	function (newSlides, _v0) {
		var settings = _v0;
		return _Utils_update(
			settings,
			{b5: newSlides});
	});
var $author$project$Bootstrap$Carousel$EndTransition = function (a) {
	return {$: 4, a: a};
};
var $author$project$Bootstrap$Carousel$SetHover = function (a) {
	return {$: 5, a: a};
};
var $author$project$Bootstrap$Carousel$controlNext = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('btn btn-link carousel-control-next'),
			A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
			$elm$html$Html$Events$onClick(
			$author$project$Bootstrap$Carousel$StartTransition($author$project$Bootstrap$Carousel$Next))
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel-control-next-icon'),
					A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sr-only')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Next')
				]))
		]));
var $author$project$Bootstrap$Carousel$Prev = {$: 1};
var $author$project$Bootstrap$Carousel$controlPrev = A2(
	$elm$html$Html$button,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('btn btn-link carousel-control-prev'),
			$elm$html$Html$Events$onClick(
			$author$project$Bootstrap$Carousel$StartTransition($author$project$Bootstrap$Carousel$Prev))
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel-control-prev-icon'),
					A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
				]),
			_List_Nil),
			A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('sr-only')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Previous')
				]))
		]));
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Bootstrap$Carousel$dirtyHack = function (size) {
	return A3(
		$elm$html$Html$Keyed$node,
		'div',
		_List_Nil,
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dirtyHack',
				A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$Events$on,
							'load',
							$elm$json$Json$Decode$succeed(
								$author$project$Bootstrap$Carousel$EndTransition(size))),
							$elm$html$Html$Attributes$src('https://package.elm-lang.org/assets/favicon.ico'),
							A2($elm$html$Html$Attributes$style, 'display', 'none')
						]),
					_List_Nil))
			]));
};
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $author$project$Bootstrap$Carousel$indicators = F2(
	function (size, activeIndex) {
		var item = function (n) {
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'active',
								_Utils_eq(n, activeIndex))
							])),
						$elm$html$Html$Events$onClick(
						$author$project$Bootstrap$Carousel$StartTransition(
							$author$project$Bootstrap$Carousel$Number(n)))
					]),
				_List_Nil);
		};
		var items = A2(
			$elm$core$List$map,
			item,
			A2($elm$core$List$range, 0, size - 1));
		return A2(
			$elm$html$Html$ol,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel-indicators')
				]),
			items);
	});
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Bootstrap$Carousel$SlideInternal$addAttributes = F2(
	function (newAttributes, _v0) {
		var settings = _v0;
		return _Utils_update(
			settings,
			{
				dQ: _Utils_ap(settings.dQ, newAttributes)
			});
	});
var $author$project$Bootstrap$Carousel$transitionClassNames = F2(
	function (currentIndex, transition) {
		var base = 'carousel-item';
		var leftNext = {bE: base + '-left', bZ: base + '-next'};
		var rightPrev = {bE: base + '-right', bZ: base + '-prev'};
		switch (transition.$) {
			case 0:
				return leftNext;
			case 2:
				var n = transition.a;
				return (_Utils_cmp(n, currentIndex) > 0) ? leftNext : rightPrev;
			default:
				return rightPrev;
		}
	});
var $author$project$Bootstrap$Carousel$transitionClasses = F4(
	function (index, currentIndex, newIndex, tstage) {
		if (_Utils_eq(index, currentIndex)) {
			switch (tstage.$) {
				case 2:
					return _List_fromArray(
						[
							_Utils_Tuple2('active', true)
						]);
				case 0:
					var transition = tstage.a;
					return _List_fromArray(
						[
							_Utils_Tuple2('active', true)
						]);
				default:
					var transition = tstage.a;
					var _v1 = A2($author$project$Bootstrap$Carousel$transitionClassNames, currentIndex, transition);
					var directionalClassName = _v1.bE;
					return _List_fromArray(
						[
							_Utils_Tuple2('active', true),
							_Utils_Tuple2(directionalClassName, true)
						]);
			}
		} else {
			if (_Utils_eq(index, newIndex)) {
				switch (tstage.$) {
					case 2:
						return _List_Nil;
					case 0:
						var transition = tstage.a;
						return _List_fromArray(
							[
								_Utils_Tuple2(
								function ($) {
									return $.bZ;
								}(
									A2($author$project$Bootstrap$Carousel$transitionClassNames, currentIndex, transition)),
								true)
							]);
					default:
						var transition = tstage.a;
						var _v3 = A2($author$project$Bootstrap$Carousel$transitionClassNames, currentIndex, transition);
						var directionalClassName = _v3.bE;
						var orderClassName = _v3.bZ;
						return _List_fromArray(
							[
								_Utils_Tuple2(directionalClassName, true),
								_Utils_Tuple2(orderClassName, true)
							]);
				}
			} else {
				return _List_Nil;
			}
		}
	});
var $author$project$Bootstrap$Carousel$SlideInternal$view = function (_v0) {
	var attributes = _v0.dQ;
	var content = _v0.f8;
	var caption = _v0.dW;
	var captionHtml = function () {
		if (caption.$ === 1) {
			return $elm$html$Html$text('');
		} else {
			var rec = caption.a;
			return A2(
				$elm$html$Html$div,
				_Utils_ap(
					rec.dQ,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('carousel-caption d-none d-md-block')
						])),
				rec.f3);
		}
	}();
	return A2(
		$elm$html$Html$div,
		_Utils_ap(
			attributes,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel-item')
				])),
		function () {
			if (!content.$) {
				var rec = content.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_Utils_ap(
							rec.dQ,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('d-block img-fluid'),
									$elm$html$Html$Attributes$src(rec.hj)
								])),
						_List_Nil),
						captionHtml
					]);
			} else {
				var html = content.a.gz;
				return _List_fromArray(
					[html, captionHtml]);
			}
		}());
};
var $author$project$Bootstrap$Carousel$viewSlide = F3(
	function (model, index, slide) {
		var tstage = model.a;
		var currentIndex = model.b.V;
		var size = model.b.ak;
		var newIndex = A3($author$project$Bootstrap$Carousel$nextIndex, tstage, currentIndex, size);
		return $author$project$Bootstrap$Carousel$SlideInternal$view(
			A2(
				$author$project$Bootstrap$Carousel$SlideInternal$addAttributes,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						A4($author$project$Bootstrap$Carousel$transitionClasses, index, currentIndex, newIndex, tstage))
					]),
				slide));
	});
var $author$project$Bootstrap$Carousel$view = F2(
	function (model, _v0) {
		var tstage = model.a;
		var hovering = model.b.a1;
		var currentIndex = model.b.V;
		var wrap = model.b.ao;
		var settings = _v0;
		var slidesHtml = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel-inner'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'listbox')
				]),
			A2(
				$elm$core$List$indexedMap,
				$author$project$Bootstrap$Carousel$viewSlide(model),
				settings.b5));
		var size = $elm$core$List$length(settings.b5);
		var indicatorsHtml = settings.cM ? A2(
			$author$project$Bootstrap$Carousel$indicators,
			size,
			A3($author$project$Bootstrap$Carousel$nextIndex, tstage, currentIndex, size)) : $elm$html$Html$text('');
		var defaultCarouselAttributes = _Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('carousel slide'),
					A2(
					$elm$html$Html$Events$on,
					'transitionend',
					$elm$json$Json$Decode$succeed(
						settings.bk(
							$author$project$Bootstrap$Carousel$EndTransition(size))))
				]),
			(hovering !== 2) ? _List_fromArray(
				[
					$elm$html$Html$Events$onMouseEnter(
					settings.bk(
						$author$project$Bootstrap$Carousel$SetHover(0))),
					$elm$html$Html$Events$onMouseLeave(
					settings.bk(
						$author$project$Bootstrap$Carousel$SetHover(1)))
				]) : _List_Nil);
		var controlsHtml = settings.co ? ((wrap || ((!(!currentIndex)) && (!_Utils_eq(currentIndex, size - 1)))) ? _List_fromArray(
			[$author$project$Bootstrap$Carousel$controlPrev, $author$project$Bootstrap$Carousel$controlNext]) : ((!currentIndex) ? _List_fromArray(
			[$author$project$Bootstrap$Carousel$controlNext]) : _List_fromArray(
			[$author$project$Bootstrap$Carousel$controlPrev]))) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			_Utils_ap(settings.dQ, defaultCarouselAttributes),
			A2(
				$elm$core$List$cons,
				slidesHtml,
				A2(
					$elm$core$List$map,
					$elm$html$Html$map(settings.bk),
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Bootstrap$Carousel$dirtyHack(size),
								indicatorsHtml
							]),
						controlsHtml))));
	});
var $author$project$LandingSite$Developers$contractsView = F2(
	function (_v0, configs) {
		var networksCarouselState = _v0.N;
		var selectedNetwork = _v0.b4;
		var networkSortOrder = $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2('mainnet', 1),
					_Utils_Tuple2('rinkeby', 2),
					_Utils_Tuple2('kovan', 3),
					_Utils_Tuple2('ropsten', 4),
					_Utils_Tuple2('goerli', 5)
				]));
		var networkList = _List_fromArray(
			[1, 4, 7, 3, 5]);
		var networkTabs = A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, network) {
					var name = $author$project$Network$networkName(network);
					var active = _Utils_eq(network, selectedNetwork) ? ' tab-group__option--active' : '';
					return A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('tab-group__option' + active),
								$elm$html$Html$Events$onClick(
								A2($author$project$LandingSite$Developers$SelectNetwork, network, index))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							]));
				}),
			networkList);
		var nameToNetwork = $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2('mainnet', 1),
					_Utils_Tuple2('rinkeby', 4),
					_Utils_Tuple2('kovan', 7),
					_Utils_Tuple2('ropsten', 3),
					_Utils_Tuple2('goerli', 5)
				]));
		var configsSorter = F2(
			function (a, b) {
				var bValue = A2(
					$elm$core$Maybe$withDefault,
					999,
					A2($elm$core$Dict$get, b.a, networkSortOrder));
				var aValue = A2(
					$elm$core$Maybe$withDefault,
					999,
					A2($elm$core$Dict$get, a.a, networkSortOrder));
				return A2($elm$core$Basics$compare, aValue, bValue);
			});
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('tab-group networks-tab-group')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('tab-group__options')
							]),
						networkTabs),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('tab-group__line')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('networks-carousel')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Bootstrap$Carousel$view,
						networksCarouselState,
						A2(
							$author$project$Bootstrap$Carousel$slides,
							_Utils_ap(
								_List_Nil,
								A2(
									$elm$core$List$filterMap,
									function (_v1) {
										var networkName = _v1.a;
										var maybeNetworkConfig = _v1.b;
										if (!maybeNetworkConfig.$) {
											var networkConfig = maybeNetworkConfig.a;
											var maybeNetwork = A2($elm$core$Dict$get, networkName, nameToNetwork);
											return $elm$core$Maybe$Just(
												A2(
													$author$project$Bootstrap$Carousel$Slide$config,
													_List_Nil,
													$author$project$Bootstrap$Carousel$Slide$customContent(
														A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('tab'),
																	A2($author$project$Utils$CompoundHtmlAttributes$property, 'data-network', networkName)
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$table,
																	_List_fromArray(
																		[
																			$author$project$Utils$CompoundHtmlAttributes$class('networks-table')
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$thead,
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$tr,
																					_List_Nil,
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('Contract')
																								])),
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('ABI')
																								])),
																							A2(
																							$elm$html$Html$th,
																							_List_Nil,
																							_List_fromArray(
																								[
																									$elm$html$Html$text('Address')
																								]))
																						]))
																				])),
																			A2(
																			$elm$html$Html$tbody,
																			_List_Nil,
																			_Utils_ap(
																				_List_Nil,
																				_Utils_ap(
																					A2(
																						$elm$core$List$map,
																						function (_v3) {
																							var cTokenSymbol = _v3.a;
																							var cTokenConfig = _v3.b;
																							var contractType = (cTokenSymbol === 'cETH') ? 'cEther' : 'cToken';
																							var addressString = $author$project$Eth$Ethereum$getContractAddressString(cTokenConfig.dL);
																							return A2(
																								$elm$html$Html$tr,
																								_List_fromArray(
																									[
																										$author$project$Utils$CompoundHtmlAttributes$class('ctoken-contract')
																									]),
																								_List_fromArray(
																									[
																										A2(
																										$elm$html$Html$td,
																										_List_fromArray(
																											[
																												$author$project$Utils$CompoundHtmlAttributes$class('contract')
																											]),
																										_List_fromArray(
																											[
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$author$project$Utils$CompoundHtmlAttributes$class('ctoken ctoken--small ctoken--' + cTokenSymbol)
																													]),
																												_List_Nil),
																												A2(
																												$elm$html$Html$span,
																												_List_fromArray(
																													[
																														$author$project$Utils$CompoundHtmlAttributes$class('token-symbol')
																													]),
																												_List_fromArray(
																													[
																														$elm$html$Html$text(cTokenSymbol)
																													])),
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$author$project$Utils$CompoundHtmlAttributes$class('token-badge')
																													]),
																												_List_fromArray(
																													[
																														$elm$html$Html$text(contractType)
																													]))
																											])),
																										A2(
																										$elm$html$Html$td,
																										_List_fromArray(
																											[
																												$author$project$Utils$CompoundHtmlAttributes$class('ABI')
																											]),
																										_List_fromArray(
																											[
																												A2(
																												$elm$html$Html$a,
																												A2(
																													$author$project$Utils$CompoundHtmlAttributes$href,
																													0,
																													$author$project$LandingSite$Page$getHrefUrl(
																														A2($author$project$LandingSite$Page$DevelopersABIView, networkName, cTokenSymbol))),
																												_List_fromArray(
																													[
																														$elm$html$Html$text('JSON')
																													]))
																											])),
																										A2(
																										$elm$html$Html$td,
																										_List_Nil,
																										_List_fromArray(
																											[
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$author$project$Utils$CompoundHtmlAttributes$id(cTokenSymbol + '_contract_address'),
																														$author$project$Utils$CompoundHtmlAttributes$class('contract-address')
																													]),
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$div,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide contract-address__value')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text(
																																A3($author$project$Eth$Ethereum$shortenedAddressString, 10, 10, addressString))
																															])),
																														A2(
																														$elm$html$Html$div,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('mobile-only contract-address__value')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text(addressString)
																															])),
																														A2(
																														$elm$html$Html$div,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide line-icon line-icon--copy'),
																																$elm$html$Html$Events$onClick(
																																$author$project$LandingSite$Developers$CopyMsg(addressString))
																															]),
																														_List_Nil),
																														A4(
																														$author$project$Eth$Ethereum$etherscanLink,
																														maybeNetwork,
																														$author$project$Eth$Ethereum$TokenAddress(addressString),
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('external-link')
																															]),
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link')
																																	]),
																																_List_Nil)
																															]))
																													]))
																											]))
																									]));
																						},
																						$elm$core$Dict$toList(networkConfig.dV)),
																					_Utils_ap(
																						A2(
																							$elm$core$List$filterMap,
																							function (_v4) {
																								var contractName = _v4.a;
																								var contractAddress = _v4.b;
																								var addressString = $author$project$Eth$Ethereum$getContractAddressString(contractAddress);
																								switch (contractName) {
																									case 'Comptroller':
																										return $elm$core$Maybe$Just(
																											A2(
																												$elm$html$Html$tr,
																												_List_Nil,
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('contract')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text('Comptroller')
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('ABI')
																															]),
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$a,
																																A2(
																																	$author$project$Utils$CompoundHtmlAttributes$href,
																																	0,
																																	$author$project$LandingSite$Page$getHrefUrl(
																																		A2($author$project$LandingSite$Page$DevelopersABIView, networkName, 'Comptroller'))),
																																_List_fromArray(
																																	[
																																		$elm$html$Html$text('JSON')
																																	]))
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_Nil,
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$id('comptroller_contract_address'),
																																		$author$project$Utils$CompoundHtmlAttributes$class('contract-address')
																																	]),
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				A3($author$project$Eth$Ethereum$shortenedAddressString, 10, 10, addressString))
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-only contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(addressString)
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide line-icon line-icon--copy'),
																																				$elm$html$Html$Events$onClick(
																																				$author$project$LandingSite$Developers$CopyMsg(addressString))
																																			]),
																																		_List_Nil),
																																		A4(
																																		$author$project$Eth$Ethereum$etherscanLink,
																																		maybeNetwork,
																																		$author$project$Eth$Ethereum$EtherscanAddress(addressString),
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('external-link')
																																			]),
																																		_List_fromArray(
																																			[
																																				A2(
																																				$elm$html$Html$div,
																																				_List_fromArray(
																																					[
																																						$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link')
																																					]),
																																				_List_Nil)
																																			]))
																																	]))
																															]))
																													])));
																									case 'PriceOracleProxy':
																										return $elm$core$Maybe$Just(
																											A2(
																												$elm$html$Html$tr,
																												_List_Nil,
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('contract')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text('PriceOracle')
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('ABI')
																															]),
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$a,
																																A2(
																																	$author$project$Utils$CompoundHtmlAttributes$href,
																																	0,
																																	$author$project$LandingSite$Page$getHrefUrl(
																																		A2($author$project$LandingSite$Page$DevelopersABIView, networkName, 'PriceOracle'))),
																																_List_fromArray(
																																	[
																																		$elm$html$Html$text('JSON')
																																	]))
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_Nil,
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$id('price_oracle_contract_address'),
																																		$author$project$Utils$CompoundHtmlAttributes$class('contract-address')
																																	]),
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				A3($author$project$Eth$Ethereum$shortenedAddressString, 10, 10, addressString))
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-only contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(addressString)
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide line-icon line-icon--copy'),
																																				$elm$html$Html$Events$onClick(
																																				$author$project$LandingSite$Developers$CopyMsg(addressString))
																																			]),
																																		_List_Nil),
																																		A4(
																																		$author$project$Eth$Ethereum$etherscanLink,
																																		maybeNetwork,
																																		$author$project$Eth$Ethereum$EtherscanAddress(addressString),
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('external-link')
																																			]),
																																		_List_fromArray(
																																			[
																																				A2(
																																				$elm$html$Html$div,
																																				_List_fromArray(
																																					[
																																						$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link')
																																					]),
																																				_List_Nil)
																																			]))
																																	]))
																															]))
																													])));
																									case 'Timelock':
																										return $elm$core$Maybe$Just(
																											A2(
																												$elm$html$Html$tr,
																												_List_Nil,
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('contract')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text('Timelock')
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('ABI')
																															]),
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$a,
																																A2(
																																	$author$project$Utils$CompoundHtmlAttributes$href,
																																	0,
																																	$author$project$LandingSite$Page$getHrefUrl(
																																		A2($author$project$LandingSite$Page$DevelopersABIView, networkName, 'Timelock'))),
																																_List_fromArray(
																																	[
																																		$elm$html$Html$text('JSON')
																																	]))
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_Nil,
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$id('comptroller_contract_address'),
																																		$author$project$Utils$CompoundHtmlAttributes$class('contract-address')
																																	]),
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				A3($author$project$Eth$Ethereum$shortenedAddressString, 10, 10, addressString))
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-only contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(addressString)
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide line-icon line-icon--copy'),
																																				$elm$html$Html$Events$onClick(
																																				$author$project$LandingSite$Developers$CopyMsg(addressString))
																																			]),
																																		_List_Nil),
																																		A4(
																																		$author$project$Eth$Ethereum$etherscanLink,
																																		maybeNetwork,
																																		$author$project$Eth$Ethereum$EtherscanAddress(addressString),
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('external-link')
																																			]),
																																		_List_fromArray(
																																			[
																																				A2(
																																				$elm$html$Html$div,
																																				_List_fromArray(
																																					[
																																						$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link')
																																					]),
																																				_List_Nil)
																																			]))
																																	]))
																															]))
																													])));
																									case 'Comp':
																										return $elm$core$Maybe$Just(
																											A2(
																												$elm$html$Html$tr,
																												_List_Nil,
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('contract')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text('COMP')
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('ABI')
																															]),
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$a,
																																A2(
																																	$author$project$Utils$CompoundHtmlAttributes$href,
																																	0,
																																	$author$project$LandingSite$Page$getHrefUrl(
																																		A2($author$project$LandingSite$Page$DevelopersABIView, networkName, 'Comp'))),
																																_List_fromArray(
																																	[
																																		$elm$html$Html$text('JSON')
																																	]))
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_Nil,
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$id('comptroller_contract_address'),
																																		$author$project$Utils$CompoundHtmlAttributes$class('contract-address')
																																	]),
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				A3($author$project$Eth$Ethereum$shortenedAddressString, 10, 10, addressString))
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-only contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(addressString)
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide line-icon line-icon--copy'),
																																				$elm$html$Html$Events$onClick(
																																				$author$project$LandingSite$Developers$CopyMsg(addressString))
																																			]),
																																		_List_Nil),
																																		A4(
																																		$author$project$Eth$Ethereum$etherscanLink,
																																		maybeNetwork,
																																		$author$project$Eth$Ethereum$EtherscanAddress(addressString),
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('external-link')
																																			]),
																																		_List_fromArray(
																																			[
																																				A2(
																																				$elm$html$Html$div,
																																				_List_fromArray(
																																					[
																																						$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link')
																																					]),
																																				_List_Nil)
																																			]))
																																	]))
																															]))
																													])));
																									case 'GovernorAlpha':
																										return $elm$core$Maybe$Just(
																											A2(
																												$elm$html$Html$tr,
																												_List_Nil,
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('contract')
																															]),
																														_List_fromArray(
																															[
																																$elm$html$Html$text('Governance')
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$class('ABI')
																															]),
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$a,
																																A2(
																																	$author$project$Utils$CompoundHtmlAttributes$href,
																																	0,
																																	$author$project$LandingSite$Page$getHrefUrl(
																																		A2($author$project$LandingSite$Page$DevelopersABIView, networkName, 'GovernorAlpha'))),
																																_List_fromArray(
																																	[
																																		$elm$html$Html$text('JSON')
																																	]))
																															])),
																														A2(
																														$elm$html$Html$td,
																														_List_Nil,
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$id('comptroller_contract_address'),
																																		$author$project$Utils$CompoundHtmlAttributes$class('contract-address')
																																	]),
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				A3($author$project$Eth$Ethereum$shortenedAddressString, 10, 10, addressString))
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-only contract-address__value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(addressString)
																																			])),
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide line-icon line-icon--copy'),
																																				$elm$html$Html$Events$onClick(
																																				$author$project$LandingSite$Developers$CopyMsg(addressString))
																																			]),
																																		_List_Nil),
																																		A4(
																																		$author$project$Eth$Ethereum$etherscanLink,
																																		maybeNetwork,
																																		$author$project$Eth$Ethereum$EtherscanAddress(addressString),
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('external-link')
																																			]),
																																		_List_fromArray(
																																			[
																																				A2(
																																				$elm$html$Html$div,
																																				_List_fromArray(
																																					[
																																						$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link')
																																					]),
																																				_List_Nil)
																																			]))
																																	]))
																															]))
																													])));
																									default:
																										return $elm$core$Maybe$Nothing;
																								}
																							},
																							$elm$core$Dict$toList(networkConfig.d0)),
																						A2(
																							$elm$core$List$filterMap,
																							function (_v6) {
																								var modelRealName = _v6.a;
																								var modelConfig = _v6.b;
																								var userFriendlyRateModelName = (modelRealName === 'DSR_Kink_9000bps_Jump_12000bps_AssumedRF_500bps') ? 'Dai Rate Model' : modelRealName;
																								var addressString = $author$project$Eth$Ethereum$getContractAddressString(modelConfig.dL);
																								return (modelRealName === 'Base200bps_Slope222bps_Kink90_Jump40') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
																									A2(
																										$elm$html$Html$tr,
																										_List_Nil,
																										_List_fromArray(
																											[
																												A2(
																												$elm$html$Html$td,
																												_List_fromArray(
																													[
																														$author$project$Utils$CompoundHtmlAttributes$class('contract')
																													]),
																												_List_fromArray(
																													[
																														$elm$html$Html$text(userFriendlyRateModelName)
																													])),
																												A2(
																												$elm$html$Html$td,
																												_List_fromArray(
																													[
																														$author$project$Utils$CompoundHtmlAttributes$class('ABI')
																													]),
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$a,
																														A2(
																															$author$project$Utils$CompoundHtmlAttributes$href,
																															0,
																															$author$project$LandingSite$Page$getHrefUrl(
																																A2($author$project$LandingSite$Page$DevelopersABIView, networkName, modelRealName))),
																														_List_fromArray(
																															[
																																$elm$html$Html$text('JSON')
																															]))
																													])),
																												A2(
																												$elm$html$Html$td,
																												_List_Nil,
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$div,
																														_List_fromArray(
																															[
																																$author$project$Utils$CompoundHtmlAttributes$id(modelRealName + '_contract_address'),
																																$author$project$Utils$CompoundHtmlAttributes$class('contract-address')
																															]),
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide contract-address__value')
																																	]),
																																_List_fromArray(
																																	[
																																		$elm$html$Html$text(
																																		A3($author$project$Eth$Ethereum$shortenedAddressString, 10, 10, addressString))
																																	])),
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$class('mobile-only contract-address__value')
																																	]),
																																_List_fromArray(
																																	[
																																		$elm$html$Html$text(addressString)
																																	])),
																																A2(
																																$elm$html$Html$div,
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide line-icon line-icon--copy'),
																																		$elm$html$Html$Events$onClick(
																																		$author$project$LandingSite$Developers$CopyMsg(addressString))
																																	]),
																																_List_Nil),
																																A4(
																																$author$project$Eth$Ethereum$etherscanLink,
																																maybeNetwork,
																																$author$project$Eth$Ethereum$EtherscanAddress(addressString),
																																_List_fromArray(
																																	[
																																		$author$project$Utils$CompoundHtmlAttributes$class('external-link')
																																	]),
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$div,
																																		_List_fromArray(
																																			[
																																				$author$project$Utils$CompoundHtmlAttributes$class('line-icon line-icon--external-link')
																																			]),
																																		_List_Nil)
																																	]))
																															]))
																													]))
																											])));
																							},
																							$elm$core$Dict$toList(networkConfig.gE))))))
																		]))
																])))));
										} else {
											return $elm$core$Maybe$Nothing;
										}
									},
									A2(
										$elm$core$List$sortWith,
										configsSorter,
										$elm$core$Dict$toList(configs)))),
							A2(
								$author$project$Bootstrap$Carousel$config,
								A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$LandingSite$Developers$NetworkCarouselMsg),
								_List_Nil)))
					]))
			]);
	});
var $author$project$Strings$Translations$docs_exponential_math_description = F2(
	function (lang, exponentialMath) {
		switch (lang) {
			case 0:
				return 'The Compound smart contracts use a system of exponential math in order to represent fractional quantities with sufficient precision. Throughout the documentation and code we make reference to mantissas, which are unsigned integers scaled up by a factor of 1e18 from their nominal value. By using mantissas within our contracts, we may perform basic mathematical operations like multiplication and division at a higher resolution than working with the unscaled quantities directly as integers. To gain a better understanding of how this works, see ' + (exponentialMath + '');
			case 1:
				return 'Los contratos inteligentes de Compound utilizan un sistema de matemática exponencial para representar cantidades fraccionarias con suficiente precisión. A lo largo de la documentación y el código, hacemos referencia a las mantisas, que son enteros sin signo aumentados en un factor de 1e18 a partir de su valor nominal. Al usar mantisas dentro de nuestros contratos, podemos realizar operaciones matemáticas básicas como la multiplicación y la división en una resolución más alta que trabajar con las cantidades sin escala directamente como números enteros. Para comprender mejor cómo funciona esto, vea ' + (exponentialMath + '');
			default:
				return '复合智能合约使用指数数学系统，以便以足够的精度表示分数量。在整个文档和代码中，我们引用了mantissas，它是无符号整数，从它们的名义值缩小了1e18倍。通过在我们的合同中使用尾数，我们可以以更高的分辨率执行基本的数学运算，如乘法和除法，而不是直接作为整数处理未缩放的量。要更好地了解其工作原理，请参阅' + (exponentialMath + '');
		}
	});
var $author$project$Strings$Translations$docs_gas_costs_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The gas usage of the protocol functions may fluctuate by market and user. External calls, such as to underlying ERC-20 tokens, may use an arbitrary amount of gas. Any calculations that involve checking ';
		case 1:
			return 'El uso de gas de las funciones del protocolo puede fluctuar según el mercado y el usuario. Las llamadas externas, como los tokens ERC-20 subyacentes, pueden usar una cantidad arbitraria de gas. Cualquier cálculo que implique verificar';
		default:
			return '协议功能的燃气使用可能会因市场和用户而波动。外部呼叫，例如潜在的ERC-20令牌，可以使用任意数量的气体。任何涉及检查的计算';
	}
};
var $author$project$Strings$Translations$docs_gas_costs_description_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'account liquidity';
		case 1:
			return 'liquidez de cuenta';
		default:
			return '账户流动性';
	}
};
var $author$project$Strings$Translations$docs_gas_costs_description_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ', have gas costs that increase with the number of ';
		case 1:
			return ', tienen costos de gas que aumentan con la cantidad de';
		default:
			return '，燃气成本随着数量的增加而增加';
	}
};
var $author$project$Strings$Translations$docs_gas_costs_description_part4 = function (lang) {
	switch (lang) {
		case 0:
			return 'entered markets';
		case 1:
			return 'mercados ingresados';
		default:
			return '进入市场';
	}
};
var $author$project$Strings$Translations$docs_gas_costs_description_part5 = function (lang) {
	switch (lang) {
		case 0:
			return '. Thus, while it can be difficult to provide any guarantees about costs, we provide the table below for guidance:';
		case 1:
			return '. Por lo tanto, si bien puede ser difícil proporcionar garantías sobre los costos, proporcionamos la siguiente tabla como guía:';
		default:
			return '。因此，尽管可能难以对成本提供任何保证，但我们提供以下表格以获取指导：';
	}
};
var $author$project$Strings$Translations$docs_getting_started_intro_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The Compound protocol codebase is hosted on ';
		case 1:
			return 'La base de código del protocolo compuesto está alojada en';
		default:
			return '复合协议代码库托管在';
	}
};
var $author$project$Strings$Translations$docs_guides = function (lang) {
	switch (lang) {
		case 0:
			return 'Guides';
		case 1:
			return 'Guías';
		default:
			return '导游';
	}
};
var $author$project$Strings$Translations$docs_guides_01 = function (lang) {
	switch (lang) {
		case 0:
			return 'Setting up an Ethereum Development Environment';
		case 1:
			return 'Configuración de un entorno de desarrollo de Ethereum';
		default:
			return '搭建以太坊开发环境';
	}
};
var $author$project$Strings$Translations$docs_guides_02 = function (lang) {
	switch (lang) {
		case 0:
			return 'Supplying Assets to the Compound Protocol';
		case 1:
			return 'Suministro de activos al protocolo compuesto';
		default:
			return '向复合协议提供资产';
	}
};
var $author$project$Strings$Translations$docs_support_description_part1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Please join the #development room in the Compound community ';
		case 1:
			return 'Únase a la sala de #developers en la comunidad de Compound';
		default:
			return '请加入Compound社区的#development会议室';
	}
};
var $author$project$Strings$Translations$docs_support_description_part2 = function (lang) {
	switch (lang) {
		case 0:
			return 'Discord';
		case 1:
			return 'Discordia';
		default:
			return '不和';
	}
};
var $author$project$Strings$Translations$docs_support_description_part3 = function (lang) {
	switch (lang) {
		case 0:
			return ' server; our team, and members of the community, look forward to helping you build an application on top of Compound. Your questions help us improve, so please don\'t hesitate to ask if you can\'t find what you are looking for here.';
		case 1:
			return 'servidor; nuestro equipo y los miembros de la comunidad esperan poder ayudarlo a crear una aplicación sobre Compound. Sus preguntas nos ayudan a mejorar, así que no dude en preguntar si no puede encontrar lo que está buscando aquí.';
		default:
			return '服务器;我们的团队和社区成员期待帮助您在Compound上构建应用程序。您的问题有助于我们改进，所以请不要犹豫，询问您是否找不到您想要的内容。';
	}
};
var $author$project$Strings$Translations$docs_supported_networks = function (lang) {
	switch (lang) {
		case 0:
			return 'The Compound Protocol is currently deployed on the following networks:';
		case 1:
			return 'El Protocolo Compound v2 se implementa actualmente en las siguientes redes:';
		default:
			return 'Compound 协议 v2 当前部署在以下网络中：';
	}
};
var $author$project$Strings$Translations$exponential_math = function (lang) {
	switch (lang) {
		case 0:
			return 'Exponential Math';
		case 1:
			return 'Matemática exponencial';
		default:
			return '指数数学';
	}
};
var $author$project$Strings$Translations$gas_costs = function (lang) {
	switch (lang) {
		case 0:
			return 'Gas Costs';
		case 1:
			return 'Costos de gas';
		default:
			return 'Gas 成本';
	}
};
var $author$project$Strings$Translations$getting_started = function (lang) {
	switch (lang) {
		case 0:
			return 'Getting Started';
		case 1:
			return 'Empezando';
		default:
			return '开始';
	}
};
var $author$project$Strings$Translations$networks = function (lang) {
	switch (lang) {
		case 0:
			return 'Networks';
		case 1:
			return 'Redes';
		default:
			return '网络';
	}
};
var $author$project$LandingSite$Developers$gettingStartedContent = F3(
	function (userLanguage, model, configs) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('getting-started')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('big')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$getting_started(userLanguage))
							])),
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('subheader')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$introduction(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_getting_started_intro_part1(userLanguage)),
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://github.com/compound-finance/compound-protocol')),
								_List_fromArray(
									[
										$elm$html$Html$text('Github')
									])),
								$elm$html$Html$text('.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_support_description_part1(userLanguage)),
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://discord.gg/874ntdw')),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_support_description_part2(userLanguage))
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_support_description_part3(userLanguage))
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('guides')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_guides(userLanguage))
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/setting-up-an-ethereum-development-environment-7c387664c5fe')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('01')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_guides_01(userLanguage))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/supplying-assets-to-the-compound-protocol-ec2cf5df5aa')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('02')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_guides_02(userLanguage))
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('networks')
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$networks(userLanguage))
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$docs_supported_networks(userLanguage))
								]))
						]),
					A2($author$project$LandingSite$Developers$contractsView, model, configs))),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('exponential-math')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$exponential_math(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Strings$Translations$docs_exponential_math_description, userLanguage, '')),
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://github.com/compound-finance/compound-money-market/blob/master/contracts/Exponential.sol')),
								_List_fromArray(
									[
										$elm$html$Html$text('Exponential.sol')
									])),
								$elm$html$Html$text('.')
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('gas-costs')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$gas_costs(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_gas_costs_description_part1(userLanguage)),
								A2(
								$elm$html$Html$a,
								A2(
									$author$project$Utils$CompoundHtmlAttributes$href,
									0,
									$author$project$LandingSite$Page$getHrefUrl(
										A2(
											$author$project$LandingSite$Page$Developers,
											2,
											$elm$core$Maybe$Just('account-liquidity')))),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_gas_costs_description_part2(userLanguage))
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_gas_costs_description_part3(userLanguage)),
								A2(
								$elm$html$Html$a,
								A2(
									$author$project$Utils$CompoundHtmlAttributes$href,
									0,
									$author$project$LandingSite$Page$getHrefUrl(
										A2(
											$author$project$LandingSite$Page$Developers,
											2,
											$elm$core$Maybe$Just('enter-markets')))),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Strings$Translations$docs_gas_costs_description_part4(userLanguage))
									])),
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_gas_costs_description_part5(userLanguage))
							])),
						A2(
						$elm$html$Html$table,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('costs-table')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Function')
													])),
												A2(
												$elm$html$Html$th,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Typical Gas Cost')
													]))
											]))
									])),
								A2(
								$elm$html$Html$tbody,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Mint')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('< 150K, cDAI < 300k')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Redeem, Transfer')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('< 250K if borrowing, otherwise < 90K')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Borrow')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('< 300K')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Repay Borrow')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('< 90K')
													]))
											])),
										A2(
										$elm$html$Html$tr,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Liquidate Borrow')
													])),
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('< 400K')
													]))
											]))
									]))
							]))
					]))
			]);
	});
var $author$project$LandingSite$Developers$gettingStartedNavList = function (userLanguage) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'#getting-started',
			$author$project$Strings$Translations$introduction(userLanguage)),
			_Utils_Tuple2(
			'#guides',
			$author$project$Strings$Translations$docs_guides(userLanguage)),
			_Utils_Tuple2(
			'#networks',
			$author$project$Strings$Translations$networks(userLanguage)),
			_Utils_Tuple2(
			'#exponential-math',
			$author$project$Strings$Translations$exponential_math(userLanguage)),
			_Utils_Tuple2(
			'#gas-costs',
			$author$project$Strings$Translations$gas_costs(userLanguage))
		]);
};
var $author$project$Strings$Translations$governance_description_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The governance system may update the interest rate model and Reserve Factor of any cToken, and reduce Reserves of any cToken.';
		case 1:
			return 'El sistema de gobierno puede actualizar el modelo de tasa de interés y el Factor de Reserva de cualquier cToken, y reducir las Reservas de cualquier cToken.';
		default:
			return '治理系统可以更新任何cToken的利率模型和储备因子，并减少任何cToken的储备。';
	}
};
var $author$project$Strings$Translations$governance_description_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'The governance system may completely replace the implementation and behavior of the cDAI contract.';
		case 1:
			return 'El sistema de gobierno puede reemplazar completamente la implementación y el comportamiento del contrato cDAI.';
		default:
			return '治理系统可以完全替代cDAI合同的实施和行为。';
	}
};
var $author$project$Strings$Translations$governance_description_3 = function (lang) {
	switch (lang) {
		case 0:
			return 'The governance system may update the price feeds (Oracle) address, the Collateral Factor of an asset, support new assets, and may completely replace the implementation and behavior of the Comptroller.';
		case 1:
			return 'El sistema de gobernanza puede actualizar la dirección de feeds de precios (Oracle), el factor colateral de un activo, admitir nuevos activos y puede reemplazar por completo la implementación y el comportamiento del Contralor.';
		default:
			return '治理系统可以更新价格馈送（Oracle）地址，资产的抵押因子，支持新资产，并且可以完全取代主计长的实现和行为。';
	}
};
var $author$project$Strings$Translations$pause_guardian = function (lang) {
	switch (lang) {
		case 0:
			return 'Pause Guardian';
		case 1:
			return 'Pausar guardián';
		default:
			return '暂停守护者';
	}
};
var $author$project$Strings$Translations$pause_guardian_description_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'The Comptroller contract designates a Pause Guardian address capable of disabling protocol functionality. Used only in the event of an unforeseen vulnerability, the Pause Guardian has one and only one ability: to disable a select set of functions: Mint, Borrow, Transfer, and Liquidate. The Pause Guardian cannot unpause an action, nor can it ever prevent users from calling Redeem, or Repay Borrow to close positions & exit the protocol.';
		case 1:
			return 'El contrato de Contralor designa una dirección de Pause Guardian capaz de deshabilitar la funcionalidad del protocolo. Utilizado solo en el caso de una vulnerabilidad imprevista, Pause Guardian tiene una y única habilidad: deshabilitar un conjunto selecto de funciones: Menta, Préstamo, Transferencia y Liquidación. Pause Guardian no puede anular la pausa de una acción, ni puede evitar que los usuarios llamen a Canjear o a Devolver préstamo para cerrar posiciones y salir del protocolo.';
		default:
			return '审计员合同指定一个能够禁用协议功能的暂停守护者地址。 Pause Guardian仅在出现无法预料的漏洞时使用，它只有一个功能：禁用一组选定的功能：薄荷，借用，转移和清算。暂停监护人不能取消暂停操作，也不能阻止用户致电赎回或偿还借贷以平仓并退出协议。';
	}
};
var $author$project$Strings$Translations$pause_guardian_description_2 = function (lang) {
	switch (lang) {
		case 0:
			return 'Currently, the Compound team controls the Pause Guardian address.';
		case 1:
			return 'El contrato de Contralor designa una dirección de Pause Guardian capaz de deshabilitar la funcionalidad del protocolo. Utilizado solo en el caso de una vulnerabilidad imprevista, Pause Guardian tiene una y única habilidad: deshabilitar un conjunto selecto de funciones: Menta, Préstamo, Transferencia y Liquidación. Pause Guardian no puede anular la pausa de una acción, ni puede evitar que los usuarios llamen a Canjear o a Devolver préstamo para cerrar posiciones y salir del protocolo.';
		default:
			return '审计员合同指定一个能够禁用协议功能的暂停守护者地址。 Pause Guardian仅在出现无法预料的漏洞时使用，它只有一个功能：禁用一组选定的功能：薄荷，借用，转移和清算。暂停监护人不能取消暂停操作，也不能阻止用户致电赎回或偿还借贷以平仓并退出协议。';
	}
};
var $author$project$Strings$Translations$timelock = function (lang) {
	switch (lang) {
		case 0:
			return 'Timelock';
		case 1:
			return 'Timelock';
		default:
			return '时间锁';
	}
};
var $author$project$Strings$Translations$timelock_description_1 = function (lang) {
	switch (lang) {
		case 0:
			return 'Each cToken contract and the Comptroller contract allow a single address, the Timelock, to modify system parameters, logic, and contracts in a \'time-delayed, opt-out\' upgrade pattern.';
		case 1:
			return 'El sistema de gobernanza puede actualizar la dirección de feeds de precios (Oracle), el factor colateral de un activo, admitir nuevos activos y puede reemplazar por completo la implementación y el comportamiento del Contralor.';
		default:
			return '治理系统可以更新价格馈送（Oracle）地址，资产的抵押因子，支持新资产，并且可以完全取代主计长的实现和行为。';
	}
};
var $author$project$Strings$Translations$timelock_description_2_beginning = function (lang) {
	switch (lang) {
		case 0:
			return 'The Timelock has a hard-coded minimum delay of 2 days, which is the least amount of notice possible for a governance action. Each proposed action will be published with an ';
		case 1:
			return 'El Timelock tiene un retraso mínimo codificado de 2 días, que es la menor cantidad de aviso posible para una acción de gobernanza. Cada acción propuesta se publicará con un \'eta\' al menos 2 días en el futuro desde el momento del anuncio. Por ejemplo, las actualizaciones importantes, como cambiar el sistema de riesgo, pueden tener un retraso de 14 días.';
		default:
			return '时间锁的硬编码最小延迟时间为2天，这是对治理操作可能发出的最少通知。自公告之日起，至少在未来两天以“ eta”发布每个建议的操作。例如，重大升级（例如更改风险系统）可能会延迟14天。';
	}
};
var $author$project$Strings$Translations$timelock_description_2_end = function (lang) {
	switch (lang) {
		case 0:
			return ' at least 2 days in the future from the time of announcement. For instance, major upgrades, such as changing the risk system, may have a 14 day delay.';
		case 1:
			return 'al menos 2 días en el futuro desde el momento del anuncio. Por ejemplo, las actualizaciones importantes, como cambiar el sistema de riesgo, pueden tener un retraso de 14 días.';
		default:
			return '自公告之日起至少未来2天。例如，重大升级（例如更改风险系统）可能会延迟14天。';
	}
};
var $author$project$Strings$Translations$timelock_description_2_eta = function (lang) {
	switch (lang) {
		case 0:
			return 'eta';
		case 1:
			return 'eta';
		default:
			return 'eta';
	}
};
var $author$project$Strings$Translations$timelock_description_3 = function (lang) {
	switch (lang) {
		case 0:
			return 'The Timelock is administered by a designated address. Currently, the Compound team controls the Timelock administrator address.';
		case 1:
			return 'El Timelock tiene un retraso mínimo codificado de 2 días, que es la menor cantidad de aviso posible para una acción de gobernanza. Cada acción propuesta se publicará con un \'eta\' al menos 2 días en el futuro desde el momento del anuncio. Por ejemplo, las actualizaciones importantes, como cambiar el sistema de riesgo, pueden tener un retraso de 14 días.';
		default:
			return '时间锁的硬编码最小延迟时间为2天，这是对治理操作可能发出的最少通知。自公告之日起，至少在未来两天以“ eta”形式发布每个建议的操作。例如，重大升级（例如更改风险系统）可能会延迟14天。';
	}
};
var $author$project$Strings$Translations$timelock_description_4 = function (lang) {
	switch (lang) {
		case 0:
			return 'Pending and completed governance actions can be monitored on the ';
		case 1:
			return 'Las acciones de gobierno pendientes y completadas pueden ser monitoreadas en';
		default:
			return '可以在';
	}
};
var $author$project$Strings$Translations$timelock_description_4_end = function (lang) {
	switch (lang) {
		case 0:
			return '.';
		case 1:
			return '.';
		default:
			return '。';
	}
};
var $author$project$Strings$Translations$timelock_description_4_link = function (lang) {
	switch (lang) {
		case 0:
			return 'Timelock Dashboard';
		case 1:
			return 'Tablero de Timelock';
		default:
			return '时间锁仪表板';
	}
};
var $author$project$LandingSite$Developers$governanceContent = function (userLanguage) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('governance')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('big')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$governance(userLanguage))
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('subheader')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$introduction(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$governance_description_1(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$governance_description_2(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$governance_description_3(userLanguage))
						]))
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('timelock')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$timelock(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$timelock_description_1(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$timelock_description_2_beginning(userLanguage)),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('inline-code')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$timelock_description_2_eta(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$timelock_description_2_end(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$timelock_description_3(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$timelock_description_4(userLanguage)),
							A2(
							$elm$html$Html$a,
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://app.compound.finance/timelock'),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$author$project$Strings$Translations$timelock_description_4_link(userLanguage))
								])),
							$elm$html$Html$text(
							$author$project$Strings$Translations$timelock_description_4_end(userLanguage))
						]))
				])),
			A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('pause-guardian')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$pause_guardian(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$pause_guardian_description_1(userLanguage))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Strings$Translations$pause_guardian_description_2(userLanguage))
						]))
				]))
		]);
};
var $author$project$LandingSite$Developers$governanceNavList = function (userLanguage) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'#governance',
			$author$project$Strings$Translations$introduction(userLanguage)),
			_Utils_Tuple2(
			'#timelock',
			$author$project$Strings$Translations$timelock(userLanguage)),
			_Utils_Tuple2(
			'#pause-guardian',
			$author$project$Strings$Translations$pause_guardian(userLanguage))
		]);
};
var $author$project$Utils$Highlighter$highlighted = A2($elm$html$Html$span, _List_Nil, _List_Nil);
var $author$project$Strings$Translations$security = function (lang) {
	switch (lang) {
		case 0:
			return 'Security';
		case 1:
			return 'Seguridad';
		default:
			return '安全';
	}
};
var $author$project$Strings$Translations$audits = function (lang) {
	switch (lang) {
		case 0:
			return 'Audits';
		case 1:
			return 'Auditorias';
		default:
			return '审计';
	}
};
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$Strings$Translations$docs_security_overview = function (lang) {
	switch (lang) {
		case 0:
			return 'The security of the Compound protocol is our highest priority; our development team, alongside third-party auditors and consultants, has invested considerable effort to create a protocol that we believe is safe and dependable. All contract code and balances are publicly verifiable, and security researchers are eligible for a bug bounty for reporting undiscovered vulnerabilities.';
		case 1:
			return 'La seguridad del Protocolo Compound es nuestra máxima prioridad; Nuestro equipo de desarrollo, junto con auditores y consultores externos, ha invertido un esfuerzo considerable para crear un protocolo que creemos que es seguro y confiable. Todos los códigos y saldos contractuales son públicamente verificables, y los investigadores de seguridad son elegibles para una recompensa por errores por informar vulnerabilidades no descubiertas.';
		default:
			return '复合协议的安全性是我们的最高优先级;我们的开发团队与第三方审核员和顾问一起投入了大量精力来创建我们认为安全可靠的协议。所有合同代码和余额都是可公开验证的，安全研究人员有资格获得报告未发现漏洞的漏洞奖励。';
	}
};
var $author$project$Strings$Translations$economic_security = function (lang) {
	switch (lang) {
		case 0:
			return 'Economic Security';
		case 1:
			return 'Seguridad economica';
		default:
			return '经济安全';
	}
};
var $author$project$Strings$Translations$formal_verification = function (lang) {
	switch (lang) {
		case 0:
			return 'Formal Verification';
		case 1:
			return 'Verificación formal';
		default:
			return '正式验证';
	}
};
var $author$project$LandingSite$Page$getCertoraUrl = '/documents/Certora.pdf';
var $author$project$LandingSite$Developers$securityContent = F3(
	function (userLanguage, model, configs) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('security')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('big')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$security(userLanguage))
							])),
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('subheader')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$introduction(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$docs_security_overview(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('We believe that size, visibility, and time are the true test for the security of a smart contract; please exercise caution, and make your own determination of security and suitability.')
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('audits')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$audits(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The Compound protocol has been reviewed & audited by '),
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.trailofbits.com/')),
								_List_fromArray(
									[
										$elm$html$Html$text('Trail of Bits')
									])),
								$elm$html$Html$text(' and '),
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://openzeppelin.com/')),
								_List_fromArray(
									[
										$elm$html$Html$text('OpenZeppelin')
									])),
								$elm$html$Html$text('.')
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://github.com/trailofbits/publications/blob/master/reviews/compound-2.pdf')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('01')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Trail of Bits - April 2019')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://blog.openzeppelin.com/compound-audit/')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('02')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('OpenZeppelin - August 2019')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://github.com/trailofbits/publications/blob/master/reviews/compound-3.pdf')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('03')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Trail of Bits - August 2019')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://blog.openzeppelin.com/compound-finance-patch-audit')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('04')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('OpenZeppelin - Timelock & Pause Guardian')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://blog.openzeppelin.com/compound-finance-mcd-dsr-integration/')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('05')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('OpenZeppelin - cDAI')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://blog.openzeppelin.com/compound-alpha-governance-system-audit/')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('06')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('OpenZeppelin - COMP & Governance')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('formal-verification')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$formal_verification(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The Compound protocol was developed with a specifications of security principles, and formally verified by '),
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://www.certora.com/')),
								_List_fromArray(
									[
										$elm$html$Html$text('Certora')
									])),
								$elm$html$Html$text(' using Certora ASA (Accurate Static Analysis), which is integrated into Compound\'s continuous integration system.')
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 1, $author$project$LandingSite$Page$getCertoraUrl)),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('01')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Certora Verification Summary')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('economic-security')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$economic_security(userLanguage))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_Utils_ap(
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$target('_blank')
										]),
									A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://gauntlet.network/')),
								_List_fromArray(
									[
										$elm$html$Html$text('Gauntlet')
									])),
								$elm$html$Html$text(' has constructed a simulation-based market stress-testing platform to evaluate the economic security of the Compound protocol, as it scales supported assets and volume.')
							])),
						A2(
						$elm$html$Html$a,
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$target('_blank'),
									$author$project$Utils$CompoundHtmlAttributes$class('build-item')
								]),
							A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://gauntlet.network/reports/CompoundMarketRiskAssessment.pdf')),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('medium')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('01')
									])),
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Gauntlet Market Risk Assessment')
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$id('bug-bounty')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Bug Bounty Program')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Security is core to our values, and we value the input of hackers acting in good faith to help us maintain the highest standard for the security and safety of the Ethereum ecosystem. The Compound protocol, while it has gone through professional audits and formal verification, depends on new technology that may contain undiscovered vulnerabilities.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Compound encourages the community to audit our contracts and security; we also encourage the responsible disclosure of any issues. This program is intended to recognize the value of working with the community of independent security researchers, and sets out our definition of good faith in the context of finding and reporting vulnerabilities, as well as what you can expect from us in return.')
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Rewards')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Compound offers substantial rewards for discoveries that can prevent the loss of assets, the freezing of assets, or harm to a user, commensurate with the severity and exploitability of the vulnerability. Compound will pay a reward of $500 to $150,000 for eligible discoveries according to the terms and conditions provided below.')
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Scope')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The primary scope of the bug bounty program is for vulnerabilities affecting the on-chain Compound Protocol, deployed to the Ethereum Mainnet, for contract addresses listed in this developer documentation.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('This list may change as new contracts are deployed, or as existing contracts are removed from usage. Vulnerabilities in contracts built on top of the Protocol by third-party developers (such as smart contract wallets) are not in-scope, nor are vulnerabilities that require ownership of an admin key.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('The secondary scope of the bug bounty program is for vulnerabilities affecting the Compound Interface hosted at app.compound.finance that could conceivably result in exploitation of user accounts.')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Finally, test contracts (Rinkeby and other testnets) and staging servers are out of scope, unless the discovered vulnerability also affects the Compound Protocol or Interface, or could otherwise be exploited in a way that risks user funds.')
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Disclosure')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Submit all bug bounty disclosures to security@compound.finance. The disclosure must include clear and concise steps to reproduce the discovered vulnerability in either written or video format. Compound will follow up promptly with acknowledgement of the disclosure.')
							])),
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Terms and Conditions')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To be eligible for bug bounty reward consideration, you must:')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Identify an original, previously unreported, non-public vulnerability within the scope of the Compound bug bounty program as described above.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Include sufficient detail in your disclosure to enable our engineers to quickly reproduce, understand, and fix the vulnerability.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Be at least 18 years of age.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Be reporting in an individual capacity, or if employed by a company, reporting with the company’s written approval to submit a disclosure to Compound.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Not be subject to US sanctions or reside in a US-embargoed country.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Not be a current or former Compound employee, vendor, contractor, or employee of a Compound vendor or contractor.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('To encourage vulnerability research and to avoid any confusion between good-faith hacking and malicious attack, we require that you:')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Play by the rules, including following the terms and conditions of this program and any other relevant agreements. If there is any inconsistency between this program and any other relevant agreements, the terms of this program will prevail.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Report any vulnerability you’ve discovered promptly.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Avoid violating the privacy of others, disrupting our systems, destroying data, or harming user experience.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Use only security@compound.finance to discuss vulnerabilities with us.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Keep the details of any discovered vulnerabilities confidential until they are fixed.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Perform testing only on in-scope systems, and respect systems and activities which are out-of-scope.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Only interact with accounts you own or with explicit permission from the account holder.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Not engage in blackmail, extortion, or any other unlawful conduct.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('When working with us according to this program, you can expect us to:')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('ul-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Pay generous rewards for eligible discoveries based on the severity and exploitability of the discovery, at Compound’s sole discretion')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Extend Safe Harbor for your vulnerability research that is related to this program, meaning we will not threaten or bring any legal action against anyone who makes a good faith effort to comply with our bug bounty program.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Work with you to understand and validate your report, including a timely initial response to the submission.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Work to remediate discovered vulnerabilities in a timely manner.')
											])),
										A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Recognize your contribution to improving our security if you are the first to report a unique vulnerability, and your report triggers a code or configuration change.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$b,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('All reward determinations, including eligibility and payment amount, are made at Compound’s sole discretion. Compound reserves the right to reject submissions and alter the terms and conditions of this program.')
							]))
					]))
			]);
	});
var $author$project$Strings$Translations$bug_bounty = function (lang) {
	switch (lang) {
		case 0:
			return 'Bug Bounty';
		case 1:
			return 'Bug Bounty';
		default:
			return 'Bug Bounty';
	}
};
var $author$project$LandingSite$Developers$securityNavList = function (userLanguage) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'#security',
			$author$project$Strings$Translations$introduction(userLanguage)),
			_Utils_Tuple2(
			'#audits',
			$author$project$Strings$Translations$audits(userLanguage)),
			_Utils_Tuple2(
			'#formal-verification',
			$author$project$Strings$Translations$formal_verification(userLanguage)),
			_Utils_Tuple2(
			'#economic-security',
			$author$project$Strings$Translations$economic_security(userLanguage)),
			_Utils_Tuple2(
			'#bug-bounty',
			$author$project$Strings$Translations$bug_bounty(userLanguage))
		]);
};
var $author$project$LandingSite$Developers$view = F4(
	function (userLanguage, subPage, configs, model) {
		var navList = function () {
			switch (subPage) {
				case 0:
					return $author$project$LandingSite$Developers$gettingStartedNavList(userLanguage);
				case 1:
					return $author$project$LandingSite$Developers$cTokensNavList(userLanguage);
				case 2:
					return $author$project$LandingSite$Developers$comptrollerNavList(userLanguage);
				case 3:
					return $author$project$LandingSite$Developers$governanceNavList(userLanguage);
				case 4:
					return A2($author$project$LandingSite$Developers$apiNavList, userLanguage, model.be);
				default:
					return $author$project$LandingSite$Developers$securityNavList(userLanguage);
			}
		}();
		var mobileNavListClass = function () {
			var _v4 = model.a9;
			if (_v4) {
				return ' active';
			} else {
				return '';
			}
		}();
		var content = function () {
			switch (subPage) {
				case 0:
					return A3($author$project$LandingSite$Developers$gettingStartedContent, userLanguage, model, configs);
				case 1:
					return $author$project$LandingSite$Developers$cTokensContent(userLanguage);
				case 2:
					return $author$project$LandingSite$Developers$comptrollerContent(userLanguage);
				case 3:
					return $author$project$LandingSite$Developers$governanceContent(userLanguage);
				case 4:
					return A2($author$project$LandingSite$Developers$apiContent, userLanguage, model.be);
				default:
					return A3($author$project$LandingSite$Developers$securityContent, userLanguage, model, configs);
			}
		}();
		var _v0 = function () {
			var _default = {cg: '', d$: '', cp: '', cC: '', cD: '', dk: ''};
			switch (subPage) {
				case 0:
					return _Utils_update(
						_default,
						{cC: ' active'});
				case 1:
					return _Utils_update(
						_default,
						{cp: ' active'});
				case 2:
					return _Utils_update(
						_default,
						{d$: ' active'});
				case 3:
					return _Utils_update(
						_default,
						{cD: ' active'});
				case 4:
					return _Utils_update(
						_default,
						{cg: ' active'});
				default:
					return _Utils_update(
						_default,
						{dk: ' active'});
			}
		}();
		var getStarted = _v0.cC;
		var ctokens = _v0.cp;
		var comptroller = _v0.d$;
		var governance = _v0.cD;
		var api = _v0.cg;
		var security = _v0.dk;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('documentation'),
					$author$project$Utils$CompoundHtmlAttributes$id('documentation')
				]),
			_List_fromArray(
				[
					$author$project$Utils$Highlighter$highlighted,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('docs-navigation'),
							$author$project$Utils$CompoundHtmlAttributes$class('docs-navigation')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large docs-navigation__content')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide' + getStarted)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Developers, 0, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$getting_started(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide' + ctokens)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Developers, 1, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$ctokens(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide' + comptroller)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Developers, 2, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$comptroller(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide' + governance)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Developers, 3, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$governance(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide' + api)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Developers, 4, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$api(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(security)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Developers, 5, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$security(userLanguage))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('chevron-container'),
											$elm$html$Html$Events$onClick(
											$author$project$LandingSite$Developers$ToggleMobileNavMsg(!model.a9))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('chevron' + mobileNavListClass)
												]),
											_List_Nil)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('docs-navigation__content--mobile' + mobileNavListClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(getStarted),
												$elm$html$Html$Events$onClick(
												$author$project$LandingSite$Developers$ToggleMobileNavMsg(false))
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Developers, 0, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$getting_started(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(ctokens),
												$elm$html$Html$Events$onClick(
												$author$project$LandingSite$Developers$ToggleMobileNavMsg(false))
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Developers, 1, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$ctokens(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(comptroller),
												$elm$html$Html$Events$onClick(
												$author$project$LandingSite$Developers$ToggleMobileNavMsg(false))
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Developers, 2, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$comptroller(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(governance),
												$elm$html$Html$Events$onClick(
												$author$project$LandingSite$Developers$ToggleMobileNavMsg(false))
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Developers, 3, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$governance(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(api),
												$elm$html$Html$Events$onClick(
												$author$project$LandingSite$Developers$ToggleMobileNavMsg(false))
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Developers, 4, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$api(userLanguage))
										])),
									A2(
									$elm$html$Html$a,
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Utils$CompoundHtmlAttributes$class(security)
											]),
										A2(
											$author$project$Utils$CompoundHtmlAttributes$href,
											0,
											$author$project$LandingSite$Page$getHrefUrl(
												A2($author$project$LandingSite$Page$Developers, 5, $elm$core$Maybe$Nothing)))),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$security(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('docs container-large')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('side-navigation col-sm-3')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$id('docs-side-navigation'),
													$author$project$Utils$CompoundHtmlAttributes$class('side-navigation__content')
												]),
											A2(
												$elm$core$List$map,
												function (_v2) {
													var hrefText = _v2.a;
													var linkText = _v2.b;
													return A2(
														$elm$html$Html$a,
														_Utils_ap(
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('section')
																]),
															A2($author$project$Utils$CompoundHtmlAttributes$href, 0, hrefText)),
														_List_fromArray(
															[
																$elm$html$Html$text(linkText)
															]));
												},
												_Utils_ap(_List_Nil, navList)))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-xs-12 col-sm-9 content')
										]),
									content)
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$api_documentation = function (lang) {
	switch (lang) {
		case 0:
			return 'API documentation';
		case 1:
			return 'Documentación API';
		default:
			return 'API 文档';
	}
};
var $author$project$Strings$Translations$argent = function (lang) {
	switch (lang) {
		case 0:
			return 'Argent';
		case 1:
			return 'Argén';
		default:
			return 'Argent';
	}
};
var $author$project$Strings$Translations$argent_description = function (lang) {
	switch (lang) {
		case 0:
			return 'A secure, non-custodial mobile wallet to earn interest & transfer tokens.';
		case 1:
			return 'Una billetera móvil segura y sin custodia para ganar intereses y transferir tokens.';
		default:
			return '一个以赚取利息与转账代币为主要功能的安全的，非托管的移动钱包。';
	}
};
var $author$project$Strings$Translations$chat_with_compound = function (lang) {
	switch (lang) {
		case 0:
			return 'Chat with Compound';
		case 1:
			return 'Chat con Compound';
		default:
			return '联系 Compound';
	}
};
var $author$project$Strings$Translations$coinbase_wallet = function (lang) {
	switch (lang) {
		case 0:
			return 'Coinbase Wallet';
		case 1:
			return 'Coinbase Wallet';
		default:
			return 'Coinbase Wallet';
	}
};
var $author$project$Strings$Translations$coinbase_wallet_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Easily send & receive cTokens, and track your Compound balance in real-time.';
		case 1:
			return 'Envíe y reciba cTokens fácilmente, y rastree su saldo de Compound en tiempo real.';
		default:
			return '轻松发送和接收 cTokens，并实时跟踪您的 Compound 余额。';
	}
};
var $author$project$Strings$Translations$compound_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound is an algorithmic, autonomous interest rate protocol built for developers, to unlock a universe of open financial applications.';
		case 1:
			return 'Compound es un protocolo autónomo de código abierto creado para desarrolladores, para desbloquear un universo de nuevas aplicaciones financieras. Intereses y préstamos, para el sistema financiero abierto.';
		default:
			return 'Compound 是为开放金融系统而为开发者构建的开源协议，基于此可以开发一系列新的金融应用程序。';
	}
};
var $author$project$Strings$Translations$compound_interface = function (lang) {
	switch (lang) {
		case 0:
			return 'Compound Interface';
		case 1:
			return 'Interfaz de Compound';
		default:
			return 'Compound 接口';
	}
};
var $author$project$Strings$Translations$compound_interface_description = function (lang) {
	switch (lang) {
		case 0:
			return 'The original interface to interact directly with the Compound protocol.';
		case 1:
			return 'La interfaz original para interactuar directamente con el Protocolo Compound.';
		default:
			return '直接与 Compound 协议交互的原始接口';
	}
};
var $author$project$Strings$Translations$dharma = function (lang) {
	switch (lang) {
		case 0:
			return 'Dharma';
		case 1:
			return 'Dharma';
		default:
			return 'Dharma';
	}
};
var $author$project$Strings$Translations$dharma_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Dharma is the easiest way to save money from anywhere in the world.';
		case 1:
			return 'Dharma es la forma más fácil de ahorrar dinero desde cualquier parte del mundo.';
		default:
			return 'Dharma 是世界上最简单的省钱方法。';
	}
};
var $author$project$Strings$Translations$faqs = function (lang) {
	switch (lang) {
		case 0:
			return 'FAQs';
		case 1:
			return 'Preguntas frecuentes';
		default:
			return 'FAQs';
	}
};
var $author$project$Strings$Translations$huobi = function (lang) {
	switch (lang) {
		case 0:
			return 'Huobi Wallet';
		case 1:
			return 'Billetera Huobi';
		default:
			return 'Huobi 钱包';
	}
};
var $author$project$Strings$Translations$huobi_description = function (lang) {
	switch (lang) {
		case 0:
			return 'A multi-asset wallet app. Track your Compound balance in real-time.';
		case 1:
			return 'Una aplicación de billetera de múltiples activos. Rastree su saldo de Compound en tiempo real.';
		default:
			return '多链钱包应用。实时跟踪您的 Compound 余额。';
	}
};
var $author$project$Strings$Translations$instadapp = function (lang) {
	switch (lang) {
		case 0:
			return 'InstaDapp';
		case 1:
			return 'InstaDapp';
		default:
			return 'InstaDapp';
	}
};
var $author$project$Strings$Translations$instadapp_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Supply, borrow, and migrate MakerDAO CDPs into Compound.';
		case 1:
			return 'Suministre, pida prestado y migre los CDP de MakerDAO a Compound.';
		default:
			return '供应，借贷并将 MakerDAO CDPs 迁移到 Compound 中。';
	}
};
var $author$project$Strings$Translations$linen = function (lang) {
	switch (lang) {
		case 0:
			return 'Linen';
		case 1:
			return 'Lino';
		default:
			return '麻布';
	}
};
var $author$project$Strings$Translations$linen_description = function (lang) {
	switch (lang) {
		case 0:
			return 'A high interest crypto account & debit card, in a beautiful mobile app.';
		case 1:
			return 'Una cuenta criptográfica de alto interés y tarjeta de débito, en una hermosa aplicación móvil.';
		default:
			return '美丽的移动应用程序中的高利息加密帐户和借记卡。';
	}
};
var $author$project$Strings$Translations$lumina = function (lang) {
	switch (lang) {
		case 0:
			return 'Lumina';
		case 1:
			return 'Lumina';
		default:
			return '发光度';
	}
};
var $author$project$Strings$Translations$lumina_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Institutional-grade portfolio management and tax accounting, including Compound.';
		case 1:
			return 'Gestión de cartera de grado institucional y contabilidad fiscal, incluido el Compuesto.';
		default:
			return '机构级投资组合管理和税收会计，包括复合。';
	}
};
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Strings$Translations$carousel_prefix = function (lang) {
	switch (lang) {
		case 0:
			return 'The Compound protocol currently has ';
		case 1:
			return 'El Compound Protocol actualmente tiene';
		default:
			return 'Compound 协议目前有 ';
	}
};
var $author$project$Strings$Translations$carousel_suffix_1 = function (lang) {
	switch (lang) {
		case 0:
			return ' of assets earning interest across ';
		case 1:
			return 'de activos que generan intereses en';
		default:
			return ' 赚取利息的资产 ';
	}
};
var $author$project$Strings$Translations$carousel_suffix_2 = F2(
	function (lang, cToken) {
		switch (lang) {
			case 0:
				return ' of ' + (cToken + ' earning  ');
			case 1:
				return 'de ' + (cToken + ' ganar');
			default:
				return ' ' + (cToken + ' 的收入  ');
		}
	});
var $author$project$Preferences$calculateEuroValue = F2(
	function (maybeEtherPrice, value) {
		var _v0 = _Utils_Tuple2(
			maybeEtherPrice,
			$author$project$Decimal$fromFloat(1.08));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var etherPrice = _v0.a.a;
			var euroDivisor = _v0.b.a;
			return function (usdPrice) {
				return A2($author$project$Decimal$fastdiv, usdPrice, euroDivisor);
			}(
				A2($author$project$Decimal$mul, etherPrice, value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Preferences$calculateGbpValue = F2(
	function (maybeEtherPrice, value) {
		var _v0 = _Utils_Tuple2(
			maybeEtherPrice,
			$author$project$Decimal$fromFloat(1.3));
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var etherPrice = _v0.a.a;
			var gbpDivisor = _v0.b.a;
			return function (usdPrice) {
				return A2($author$project$Decimal$fastdiv, usdPrice, gbpDivisor);
			}(
				A2($author$project$Decimal$mul, etherPrice, value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Utils$NumberFormatter$formatEth = function (decimalValue) {
	var _v0 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(decimalValue);
	var signString = _v0.a;
	var absoluteDecimalValue = _v0.b;
	return signString + ('Ξ' + A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, $author$project$Utils$NumberFormatter$tokenDecimalPlaces, false, absoluteDecimalValue));
};
var $author$project$Utils$NumberFormatter$formatEuro = F2(
	function (shouldTruncate, decimalValue) {
		var roundedValue = A2($author$project$Decimal$round, -2, decimalValue);
		var numberOfDecimalPlaces = function () {
			if (shouldTruncate) {
				return 0;
			} else {
				return 2;
			}
		}();
		var _v0 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(roundedValue);
		var signString = _v0.a;
		var absoluteRoundedValue = _v0.b;
		return signString + ('€' + A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, numberOfDecimalPlaces, false, absoluteRoundedValue));
	});
var $author$project$Utils$NumberFormatter$formatGbp = F2(
	function (shouldTruncate, decimalValue) {
		var roundedValue = A2($author$project$Decimal$round, -2, decimalValue);
		var numberOfDecimalPlaces = function () {
			if (shouldTruncate) {
				return 0;
			} else {
				return 2;
			}
		}();
		var _v0 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(roundedValue);
		var signString = _v0.a;
		var absoluteRoundedValue = _v0.b;
		return signString + ('£' + A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, numberOfDecimalPlaces, false, absoluteRoundedValue));
	});
var $author$project$Utils$NumberFormatter$formatUsd = F2(
	function (shouldTruncate, decimalValue) {
		var roundedValue = A2($author$project$Decimal$round, -2, decimalValue);
		var numberOfDecimalPlaces = function () {
			if (shouldTruncate) {
				return 0;
			} else {
				return 2;
			}
		}();
		var _v0 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(roundedValue);
		var signString = _v0.a;
		var absoluteRoundedValue = _v0.b;
		return signString + ('$' + A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, numberOfDecimalPlaces, false, absoluteRoundedValue));
	});
var $author$project$Preferences$formatDisplayCurrencyTruncated = F3(
	function (displayCurrency, maybeEtherPrice, value) {
		switch (displayCurrency) {
			case 0:
				return $elm$core$Maybe$Just(
					$author$project$Utils$NumberFormatter$formatEth(value));
			case 1:
				if (!maybeEtherPrice.$) {
					var etherPrice = maybeEtherPrice.a;
					return $elm$core$Maybe$Just(
						A2(
							$author$project$Utils$NumberFormatter$formatUsd,
							true,
							A2($author$project$Decimal$mul, etherPrice, value)));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 2:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Utils$NumberFormatter$formatGbp(true),
					A2($author$project$Preferences$calculateGbpValue, maybeEtherPrice, value));
			default:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Utils$NumberFormatter$formatEuro(true),
					A2($author$project$Preferences$calculateEuroValue, maybeEtherPrice, value));
		}
	});
var $author$project$Preferences$getPlaceholderPrefCurrency = function (displayCurrency) {
	switch (displayCurrency) {
		case 0:
			return 'Ξ –';
		case 1:
			return '$ –';
		case 2:
			return '£ –';
		default:
			return '€ –';
	}
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$LandingSite$Home$usdPerEth = function (tokens) {
	var ethPerUsd = function () {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (token) {
					return token.dB === 'USDC';
				},
				tokens));
		if (!_v0.$) {
			var usdc = _v0.a;
			return usdc.fz;
		} else {
			return $author$project$Decimal$zero;
		}
	}();
	return A2($author$project$Decimal$fastdiv, $author$project$Decimal$one, ethPerUsd);
};
var $author$project$Utils$DigitAnimatorHelper$valueFormattedStringToRandomDigits = function (totalValueFormattedString) {
	return A2(
		$elm$core$List$map,
		function (character) {
			var charAsString = $elm$core$String$fromChar(character);
			var _v0 = function () {
				var _v1 = $elm$core$String$toInt(charAsString);
				if (!_v1.$) {
					var digitAsInt = _v1.a;
					var digitsRange = A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						$elm$core$List$reverse(
							A2($elm$core$List$range, 0, digitAsInt)));
					var digitClass = function () {
						switch (digitAsInt) {
							case 2:
								return ' digit-thousand';
							case 7:
								return ' digit-thousand';
							case 9:
								return ' digit-hundred';
							case 1:
								return ' digit-hundred';
							case 4:
								return ' digit-ten';
							case 5:
								return ' digit-ten';
							default:
								return ' digit-thousand';
						}
					}();
					return _Utils_Tuple3(
						'',
						digitClass,
						A2($elm$core$String$join, ' ', digitsRange));
				} else {
					return ((character === ',') || (character === '.')) ? _Utils_Tuple3(' comma', '', charAsString) : _Utils_Tuple3('', '', charAsString);
				}
			}();
			var digitExtraClass = _v0.a;
			var containerExtraClass = _v0.b;
			var textContent = _v0.c;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('digit' + digitExtraClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('digit-container' + (containerExtraClass + ' active'))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(textContent)
							]))
					]));
		},
		$elm$core$String$toList(totalValueFormattedString));
};
var $author$project$LandingSite$Home$marketsCarousel = F5(
	function (userLanguage, latestTokens, aprFormatter, carouselState, shouldAnimate) {
		var total = A3(
			$elm$core$List$foldl,
			$author$project$Decimal$add,
			$author$project$Decimal$zero,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.hO;
				},
				latestTokens));
		var numberOfMarkets = $elm$core$List$length(latestTokens);
		var numberOfMarketsString = function () {
			if (!numberOfMarkets) {
				return '–';
			} else {
				return $elm$core$String$fromInt(numberOfMarkets);
			}
		}();
		var loadingFill = function () {
			if (shouldAnimate) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('fill')
						]),
					_List_Nil);
			} else {
				return $elm$html$Html$text('');
			}
		}();
		var etherPrice = $author$project$LandingSite$Home$usdPerEth(latestTokens);
		var templateDollarFormatter = F2(
			function (formatter, value) {
				var _v1 = A3(formatter, 1, etherPrice, value);
				if (!_v1.$) {
					var string = _v1.a;
					return string;
				} else {
					return $author$project$Preferences$getPlaceholderPrefCurrency(1);
				}
			});
		var marketTotalDollarFormatter = function (tokenValue) {
			return A2(templateDollarFormatter, $author$project$Preferences$formatDisplayCurrencyTruncated, tokenValue);
		};
		var totalValueDigitsView = function (totalMarketsValue) {
			var totalValueFormattedString = marketTotalDollarFormatter(totalMarketsValue);
			var digitsListView = A2($author$project$Decimal$eq, totalMarketsValue, $author$project$Decimal$zero) ? _List_fromArray(
				[
					$elm$html$Html$text(totalValueFormattedString)
				]) : $author$project$Utils$DigitAnimatorHelper$valueFormattedStringToRandomDigits(totalValueFormattedString);
			return A2($elm$html$Html$span, _List_Nil, digitsListView);
		};
		var carouselData = function () {
			var state = carouselState.b;
			return state;
		}();
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Bootstrap$Carousel$view,
					carouselState,
					A2(
						$author$project$Bootstrap$Carousel$slides,
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$author$project$Bootstrap$Carousel$Slide$config,
									_List_Nil,
									$author$project$Bootstrap$Carousel$Slide$customContent(
										A2(
											$elm$html$Html$h1,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													$author$project$Strings$Translations$carousel_prefix(userLanguage)),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('totals')
														]),
													_List_fromArray(
														[
															totalValueDigitsView(total)
														])),
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$carousel_suffix_1(userLanguage))
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('totals')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(numberOfMarketsString + ' markets')
														]))
												]))))
								]),
							A2(
								$elm$core$List$map,
								function (cToken) {
									return A2(
										$author$project$Bootstrap$Carousel$Slide$config,
										_List_Nil,
										$author$project$Bootstrap$Carousel$Slide$customContent(
											A2(
												$elm$html$Html$h1,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														$author$project$Strings$Translations$carousel_prefix(userLanguage)),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('totals')
															]),
														_List_fromArray(
															[
																totalValueDigitsView(cToken.hO)
															])),
														$elm$html$Html$text(
														A2($author$project$Strings$Translations$carousel_suffix_2, userLanguage, cToken.dB)),
														A2(
														$elm$html$Html$br,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('mobile-hide')
															]),
														_List_Nil),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('totals')
															]),
														_List_fromArray(
															[
																aprFormatter(cToken.hu)
															])),
														$elm$html$Html$text(' interest')
													]))));
								},
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.hv;
									},
									latestTokens))),
						A2(
							$author$project$Bootstrap$Carousel$config,
							A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$LandingSite$Home$CarouselMsg),
							_List_Nil))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('carousel-indicator')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('small current-index')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'0' + $elm$core$String$fromInt(carouselData.V + 1))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('bar')
								]),
							_List_fromArray(
								[loadingFill])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('small total-slides')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'0' + $elm$core$String$fromInt(numberOfMarkets + 1))
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$multis = function (lang) {
	switch (lang) {
		case 0:
			return 'Multis';
		case 1:
			return 'Multis';
		default:
			return 'Multis';
	}
};
var $author$project$Strings$Translations$multis_description = function (lang) {
	switch (lang) {
		case 0:
			return 'A simple and powerful interface designed for teams to manage a single account.';
		case 1:
			return 'Una interfaz simple y potente diseñada para que los equipos administren una sola cuenta.';
		default:
			return '一个为团队管理单个帐户而设计的简单而强大的界面。';
	}
};
var $author$project$Strings$Translations$pool_together = function (lang) {
	switch (lang) {
		case 0:
			return 'Pool Together';
		case 1:
			return 'Pool Together';
		default:
			return 'Pool Together';
	}
};
var $author$project$Strings$Translations$pool_together_description = function (lang) {
	switch (lang) {
		case 0:
			return 'A no-loss lottery utilizing the interest earned in Compound as the prize.';
		case 1:
			return 'Una lotería sin pérdidas que utiliza el interés ganado en Compound como premio.';
		default:
			return '以 Compound 利息为奖品的无损失彩票。';
	}
};
var $author$project$LandingSite$Home$projectCard = F4(
	function (projectUrl, projectName, projectTitle, projectDescription) {
		return A2(
			$elm$html$Html$a,
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('col-sm-4 col-xs-12'),
						$author$project$Utils$CompoundHtmlAttributes$target('_blank')
					]),
				A2($author$project$Utils$CompoundHtmlAttributes$href, 2, projectUrl)),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('panel')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('icon ' + projectName)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('project-card-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(projectTitle)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('project-card-description')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(projectDescription)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('project-card-try')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('small')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Try')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
											$author$project$Utils$CompoundHtmlAttributes$class('arrow')
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$protocol_documentation = function (lang) {
	switch (lang) {
		case 0:
			return 'Protocol documentation';
		case 1:
			return 'Documentación de protocolo';
		default:
			return '协议文档';
	}
};
var $author$project$Strings$Translations$read_whitepaper = function (lang) {
	switch (lang) {
		case 0:
			return 'Read Whitepaper';
		case 1:
			return 'Leer Whitepaper';
		default:
			return '阅读白皮书';
	}
};
var $author$project$Strings$Translations$start_building = function (lang) {
	switch (lang) {
		case 0:
			return 'Start Building';
		case 1:
			return 'Comience a construir';
		default:
			return '开始构建';
	}
};
var $author$project$Strings$Translations$start_building_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Everything you need to launch an app';
		case 1:
			return 'Todo lo que necesitas para iniciar una aplicación';
		default:
			return '启动应用程序所需的一切';
	}
};
var $author$project$Strings$Translations$token_sets = function (lang) {
	switch (lang) {
		case 0:
			return 'TokenSets';
		case 1:
			return 'TokenSets';
		default:
			return '令牌集';
	}
};
var $author$project$Strings$Translations$token_sets_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Automated trading strategies, using cTokens and Ethereum assets.';
		case 1:
			return 'Estrategias comerciales automatizadas, utilizando cTokens y activos de Ethereum.';
		default:
			return '使用cToken和以太坊资产的自动化交易策略。';
	}
};
var $author$project$Strings$Translations$try_compound = function (lang) {
	switch (lang) {
		case 0:
			return 'Try Compound';
		case 1:
			return 'Probar Compound';
		default:
			return '体验 Compound';
	}
};
var $author$project$Strings$Translations$try_compound_description = function (lang) {
	switch (lang) {
		case 0:
			return 'Community-built interfaces integrating the protocol';
		case 1:
			return 'Interfaces construidas en la comunidad que integran el protocolo.';
		default:
			return '社区构建的集成协议的接口';
	}
};
var $author$project$Strings$Translations$zerion = function (lang) {
	switch (lang) {
		case 0:
			return 'Zerion';
		case 1:
			return 'Zerion';
		default:
			return 'Zerion';
	}
};
var $author$project$Strings$Translations$zerion_description = function (lang) {
	switch (lang) {
		case 0:
			return 'An intuitive interface to blockchain-based protocols for decentralized finance.';
		case 1:
			return 'Una interfaz intuitiva para protocolos basados en blockchain para finanzas descentralizadas.';
		default:
			return '基于区块链的分布式融资协议的直观界面。';
	}
};
var $author$project$LandingSite$Home$view = F3(
	function (userLanguage, maybeLatestTokens, model) {
		var latestTokens = function () {
			if (!maybeLatestTokens.$) {
				var tokens = maybeLatestTokens.a;
				return tokens.f$;
			} else {
				return _List_Nil;
			}
		}();
		var shouldAnimate = !$elm$core$List$isEmpty(latestTokens);
		var aprFormatter = function (rate) {
			return $elm$html$Html$text(
				$author$project$Utils$NumberFormatter$formatPercentage(rate));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('landing-overview')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$id('dot-grid')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('illo')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-10 text-left compound-data')
												]),
											_List_fromArray(
												[
													A5($author$project$LandingSite$Home$marketsCarousel, userLanguage, latestTokens, aprFormatter, model.aq, shouldAnimate)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6 text-left compound-description')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$compound_description(userLanguage))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('call-to-action')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$a,
															_Utils_ap(
																_List_fromArray(
																	[
																		$author$project$Utils$CompoundHtmlAttributes$target('_blank')
																	]),
																A2($author$project$Utils$CompoundHtmlAttributes$href, 1, $author$project$LandingSite$Page$getWhitepaperUrl)),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$read_whitepaper(userLanguage))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$id('arrow'),
																	$author$project$Utils$CompoundHtmlAttributes$class('arrow')
																]),
															_List_Nil)
														]))
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('try-compound')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-5 text-left try-compound-header')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('label big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$try_compound(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('summary')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$try_compound_description(userLanguage))
														]))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row projects')
										]),
									_List_fromArray(
										[
											A4(
											$author$project$LandingSite$Home$projectCard,
											'https://app.compound.finance/',
											'compound',
											$author$project$Strings$Translations$compound_interface(userLanguage),
											$author$project$Strings$Translations$compound_interface_description(userLanguage)),
											A4(
											$author$project$LandingSite$Home$projectCard,
											'https://zerion.io/en',
											'zerion',
											$author$project$Strings$Translations$zerion(userLanguage),
											$author$project$Strings$Translations$zerion_description(userLanguage)),
											A4(
											$author$project$LandingSite$Home$projectCard,
											'https://wallet.coinbase.com',
											'coinbase',
											$author$project$Strings$Translations$coinbase_wallet(userLanguage),
											$author$project$Strings$Translations$coinbase_wallet_description(userLanguage)),
											A4(
											$author$project$LandingSite$Home$projectCard,
											'https://instadapp.io/compound/',
											'instadapp',
											$author$project$Strings$Translations$instadapp(userLanguage),
											$author$project$Strings$Translations$instadapp_description(userLanguage)),
											A4(
											$author$project$LandingSite$Home$projectCard,
											'https://www.pooltogether.us',
											'pool-together',
											$author$project$Strings$Translations$pool_together(userLanguage),
											$author$project$Strings$Translations$pool_together_description(userLanguage)),
											A4(
											$author$project$LandingSite$Home$projectCard,
											'https://multis.co/',
											'multis',
											$author$project$Strings$Translations$multis(userLanguage),
											$author$project$Strings$Translations$multis_description(userLanguage)),
											A4(
											$author$project$LandingSite$Home$projectCard,
											'https://www.argent.xyz/',
											'argent',
											$author$project$Strings$Translations$argent(userLanguage),
											$author$project$Strings$Translations$argent_description(userLanguage)),
											A4(
											$author$project$LandingSite$Home$projectCard,
											'https://www.huobiwallet.com/en/',
											'huobi',
											$author$project$Strings$Translations$huobi(userLanguage),
											$author$project$Strings$Translations$huobi_description(userLanguage)),
											A4(
											$author$project$LandingSite$Home$projectCard,
											'https://www.dharma.io/',
											'dharma',
											$author$project$Strings$Translations$dharma(userLanguage),
											$author$project$Strings$Translations$dharma_description(userLanguage)),
											A4(
											$author$project$LandingSite$Home$projectCard,
											'https://linen.app/',
											'linen',
											$author$project$Strings$Translations$linen(userLanguage),
											$author$project$Strings$Translations$linen_description(userLanguage)),
											A4(
											$author$project$LandingSite$Home$projectCard,
											'https://www.lumina.app/',
											'lumina',
											$author$project$Strings$Translations$lumina(userLanguage),
											$author$project$Strings$Translations$lumina_description(userLanguage)),
											A4(
											$author$project$LandingSite$Home$projectCard,
											'https://www.tokensets.com/set/ethrsiapy',
											'token-sets',
											$author$project$Strings$Translations$token_sets(userLanguage),
											$author$project$Strings$Translations$token_sets_description(userLanguage))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('dot-grid-left')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$id('dot-grid-right')
										]),
									_List_Nil)
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$id('start-building')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container-large')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-5 text-left')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$label,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('label big')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$start_building(userLanguage))
														])),
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('summary')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$start_building_description(userLanguage))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('col-sm-7 col-xs-12')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('build-item')
															]),
														A2(
															$author$project$Utils$CompoundHtmlAttributes$href,
															0,
															$author$project$LandingSite$Page$getHrefUrl(
																A2($author$project$LandingSite$Page$Developers, 0, $elm$core$Maybe$Nothing)))),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('medium')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('01')
																])),
															A2(
															$elm$html$Html$h3,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$protocol_documentation(userLanguage))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
																]),
															_List_Nil)
														])),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('build-item')
															]),
														A2(
															$author$project$Utils$CompoundHtmlAttributes$href,
															0,
															$author$project$LandingSite$Page$getHrefUrl(
																A2($author$project$LandingSite$Page$Developers, 4, $elm$core$Maybe$Nothing)))),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('medium')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('02')
																])),
															A2(
															$elm$html$Html$h3,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$api_documentation(userLanguage))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
																]),
															_List_Nil)
														])),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('build-item'),
																$author$project$Utils$CompoundHtmlAttributes$target('_blank')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://medium.com/compound-finance/faq-1a2636713b69')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('medium')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('03')
																])),
															A2(
															$elm$html$Html$h3,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$faqs(userLanguage))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
																]),
															_List_Nil)
														])),
													A2(
													$elm$html$Html$a,
													_Utils_ap(
														_List_fromArray(
															[
																$author$project$Utils$CompoundHtmlAttributes$class('build-item'),
																$author$project$Utils$CompoundHtmlAttributes$target('_blank')
															]),
														A2($author$project$Utils$CompoundHtmlAttributes$href, 2, 'https://discord.gg/874ntdw')),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('medium')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('04')
																])),
															A2(
															$elm$html$Html$h3,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('build-item-text')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$chat_with_compound(userLanguage))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$author$project$Utils$CompoundHtmlAttributes$class('arrow big')
																]),
															_List_Nil)
														]))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Strings$Translations$all_markets = function (lang) {
	switch (lang) {
		case 0:
			return 'All Markets';
		case 1:
			return 'Todos los mercados';
		default:
			return '所有市场';
	}
};
var $author$project$LandingSite$Markets$deltaSpan = F2(
	function (delta, formatter) {
		var rounded = A2($author$project$Decimal$round, -2, delta);
		var _v0 = A2($author$project$Decimal$compare, rounded, $author$project$Decimal$zero);
		switch (_v0) {
			case 2:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('change up')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'+' + formatter(rounded))
						]));
			case 0:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('change down')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							formatter(rounded))
						]));
			default:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('change neutral')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('–')
						]));
		}
	});
var $author$project$Utils$NumberFormatter$formatRate = function (dec) {
	var rounded = A2($author$project$Decimal$round, -2, dec);
	return $author$project$Decimal$toString(rounded) + '%';
};
var $author$project$Decimal$negate = function (_v0) {
	var m = _v0.a;
	var e = _v0.b;
	return A2(
		$author$project$Decimal$Decimal,
		$cmditch$elm_bigint$BigInt$negate(m),
		e);
};
var $author$project$Decimal$sub = F2(
	function (a, b) {
		return A2(
			$author$project$Decimal$add,
			a,
			$author$project$Decimal$negate(b));
	});
var $author$project$LandingSite$Markets$percentGrowth = F2(
	function (latest, historic) {
		var _v0 = A2($author$project$Decimal$fastdiv, latest, historic);
		if (!_v0.$) {
			var d = _v0.a;
			return A2(
				$author$project$Decimal$mul,
				$author$project$Decimal$fromInt(100),
				A2($author$project$Decimal$sub, d, $author$project$Decimal$one));
		} else {
			return $author$project$Decimal$zero;
		}
	});
var $author$project$LandingSite$Markets$assetRow = F2(
	function (dollarFormatter, _v0) {
		var latestToken = _v0.a;
		var maybeHistoricToken = _v0.b;
		var historicToken = function () {
			if (!maybeHistoricToken.$) {
				var t = maybeHistoricToken.a;
				return t;
			} else {
				return latestToken;
			}
		}();
		var supplyDeltaPercent = A2($author$project$LandingSite$Markets$percentGrowth, latestToken.hN, historicToken.hN);
		var supplyRateDelta = A2(
			$author$project$Decimal$mul,
			$author$project$Decimal$fromInt(100),
			A2($author$project$Decimal$sub, latestToken.hu, historicToken.hu));
		var borrowRateDelta = A2(
			$author$project$Decimal$mul,
			$author$project$Decimal$fromInt(100),
			A2($author$project$Decimal$sub, latestToken.fX, historicToken.fX));
		var borrowDeltaPercent = A2($author$project$LandingSite$Markets$percentGrowth, latestToken.hI, historicToken.hI);
		var apyFormatter = function (rate) {
			return $elm$html$Html$text(
				$author$project$Utils$NumberFormatter$formatRate(
					A2(
						$author$project$Decimal$mul,
						$author$project$Decimal$fromInt(100),
						rate)));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('asset')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-5 identity')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('icon ' + latestToken.dB)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(latestToken.fy)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('symbol')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(latestToken.dB)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									dollarFormatter(latestToken.hO)
								])),
							A2($author$project$LandingSite$Markets$deltaSpan, supplyDeltaPercent, $author$project$Utils$NumberFormatter$formatRate)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									apyFormatter(latestToken.hu)
								])),
							A2($author$project$LandingSite$Markets$deltaSpan, supplyRateDelta, $author$project$Decimal$toString)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									dollarFormatter(latestToken.hH)
								])),
							A2($author$project$LandingSite$Markets$deltaSpan, borrowDeltaPercent, $author$project$Utils$NumberFormatter$formatRate)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									apyFormatter(latestToken.fX)
								])),
							A2($author$project$LandingSite$Markets$deltaSpan, borrowRateDelta, $author$project$Decimal$toString)
						]))
				]));
	});
var $author$project$Strings$Translations$borrow_apy = function (lang) {
	switch (lang) {
		case 0:
			return 'Borrow APY';
		case 1:
			return 'Pedir prestado APY';
		default:
			return '借用APY';
	}
};
var $author$project$Preferences$formatDisplayCurrency = F3(
	function (displayCurrency, maybeEtherPrice, value) {
		switch (displayCurrency) {
			case 0:
				return $elm$core$Maybe$Just(
					$author$project$Utils$NumberFormatter$formatEth(value));
			case 1:
				if (!maybeEtherPrice.$) {
					var etherPrice = maybeEtherPrice.a;
					return $elm$core$Maybe$Just(
						A2(
							$author$project$Utils$NumberFormatter$formatUsd,
							false,
							A2($author$project$Decimal$mul, etherPrice, value)));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 2:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Utils$NumberFormatter$formatGbp(false),
					A2($author$project$Preferences$calculateGbpValue, maybeEtherPrice, value));
			default:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Utils$NumberFormatter$formatGbp(false),
					A2($author$project$Preferences$calculateEuroValue, maybeEtherPrice, value));
		}
	});
var $author$project$Utils$NumberFormatter$formatEthToZeroDecimals = function (decimalValue) {
	var _v0 = $author$project$Utils$NumberFormatter$getSignAndAbsValue(decimalValue);
	var signString = _v0.a;
	var absoluteDecimalValue = _v0.b;
	return signString + ('Ξ' + A3($author$project$Utils$NumberFormatter$formatToDecimalPlaces, 0, false, absoluteDecimalValue));
};
var $author$project$Utils$NumberFormatter$formatEuroInThousandsOrMillions = function (decimalValue) {
	return A2($author$project$Utils$NumberFormatter$commonFormatInThousandsOrMillions, '€', decimalValue);
};
var $author$project$Utils$NumberFormatter$formatGbpInThousandsOrMillions = function (decimalValue) {
	return A2($author$project$Utils$NumberFormatter$commonFormatInThousandsOrMillions, '£', decimalValue);
};
var $author$project$Utils$NumberFormatter$formatUsdInThousandsOrMillions = function (decimalValue) {
	return A2($author$project$Utils$NumberFormatter$commonFormatInThousandsOrMillions, '$', decimalValue);
};
var $author$project$Preferences$formatMarketSize = F3(
	function (displayCurrency, maybeEtherPrice, value) {
		switch (displayCurrency) {
			case 0:
				return $elm$core$Maybe$Just(
					$author$project$Utils$NumberFormatter$formatEthToZeroDecimals(value));
			case 1:
				if (!maybeEtherPrice.$) {
					var etherPrice = maybeEtherPrice.a;
					return $elm$core$Maybe$Just(
						$author$project$Utils$NumberFormatter$formatUsdInThousandsOrMillions(
							A2($author$project$Decimal$mul, etherPrice, value)));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 2:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Utils$NumberFormatter$formatGbpInThousandsOrMillions,
					A2($author$project$Preferences$calculateGbpValue, maybeEtherPrice, value));
			default:
				return A2(
					$elm$core$Maybe$map,
					$author$project$Utils$NumberFormatter$formatEuroInThousandsOrMillions,
					A2($author$project$Preferences$calculateEuroValue, maybeEtherPrice, value));
		}
	});
var $author$project$Strings$Translations$gross_borrow = function (lang) {
	switch (lang) {
		case 0:
			return 'Gross Borrow';
		case 1:
			return 'Préstamo bruto';
		default:
			return '总借贷';
	}
};
var $author$project$Strings$Translations$gross_supply = function (lang) {
	switch (lang) {
		case 0:
			return 'Gross Supply';
		case 1:
			return 'Oferta bruta';
		default:
			return '总供应';
	}
};
var $author$project$Strings$Translations$market = function (lang) {
	switch (lang) {
		case 0:
			return 'Market';
		case 1:
			return 'Mercado';
		default:
			return '市场';
	}
};
var $author$project$LandingSite$Markets$Borrow = 1;
var $author$project$LandingSite$Markets$Supply = 0;
var $author$project$Strings$Translations$top_3_markets = function (lang) {
	switch (lang) {
		case 0:
			return 'Top 3 Markets';
		case 1:
			return 'Los 3 principales mercados';
		default:
			return 'Top 3 市场';
	}
};
var $author$project$LandingSite$Markets$topMarketsBars = F4(
	function (userLanguage, cardType, topTokens, total) {
		var _v0 = function () {
			if (cardType === 1) {
				return _Utils_Tuple2(
					function ($) {
						return $.hH;
					},
					'borrow');
			} else {
				return _Utils_Tuple2(
					function ($) {
						return $.hO;
					},
					'supply');
			}
		}();
		var totalValue = _v0.a;
		var classType = _v0.b;
		var percentOfTotal = function (token) {
			return $author$project$Utils$NumberFormatter$formatRate(
				A2(
					$author$project$Decimal$mul,
					$author$project$Decimal$fromInt(100),
					function () {
						var _v2 = A2(
							$author$project$Decimal$fastdiv,
							totalValue(token),
							total);
						if (!_v2.$) {
							var percent = _v2.a;
							return percent;
						} else {
							return $author$project$Decimal$zero;
						}
					}()));
		};
		var tokenBar = function (token) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$author$project$Utils$CompoundHtmlAttributes$class('market-bar ' + classType)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(token.dB)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-right ')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										percentOfTotal(token))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Utils$CompoundHtmlAttributes$class('bar ' + classType)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Utils$CompoundHtmlAttributes$class('fill ' + classType),
										A2(
										$author$project$Utils$CompoundHtmlAttributes$style,
										'width',
										percentOfTotal(token))
									]),
								_List_Nil)
							]))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$Strings$Translations$top_3_markets(userLanguage))
							]))
					]),
				A2($elm$core$List$map, tokenBar, topTokens)));
	});
var $author$project$Strings$Translations$twenty_four_hour_borrow = function (lang) {
	switch (lang) {
		case 0:
			return '24H Borrow Volume';
		case 1:
			return 'Volumen prestado las 24 horas';
		default:
			return '24H 借款量';
	}
};
var $author$project$Strings$Translations$twenty_four_hour_supply = function (lang) {
	switch (lang) {
		case 0:
			return '24H Supply Volume';
		case 1:
			return 'Volumen de suministro 24H';
		default:
			return '24H 供应量';
	}
};
var $author$project$LandingSite$Markets$totalCard = F6(
	function (userLanguage, cardType, latestTokens, maybeMetadata, maybeHistoricTokens, dollarFormatter) {
		var reduceTotals = F2(
			function (tokens, valueFun) {
				return A3(
					$elm$core$List$foldl,
					$author$project$Decimal$add,
					$author$project$Decimal$zero,
					A2($elm$core$List$map, valueFun, tokens));
			});
		var currentValue = function (oldToken) {
			var todaysData = function () {
				var _v9 = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (t) {
							return _Utils_eq(t.gT, oldToken.gT);
						},
						latestTokens));
				if (!_v9.$) {
					var token = _v9.a;
					return token;
				} else {
					return oldToken;
				}
			}();
			if (!cardType) {
				return A2(
					$author$project$Decimal$round,
					-2,
					A2(
						$author$project$Decimal$mul,
						todaysData.fz,
						A2($author$project$Decimal$mul, todaysData.gp, oldToken.hN)));
			} else {
				return A2(
					$author$project$Decimal$round,
					-2,
					A2($author$project$Decimal$mul, todaysData.fz, oldToken.hI));
			}
		};
		var maybeHistoricTotal = function () {
			if (!maybeHistoricTokens.$) {
				var historicTokens = maybeHistoricTokens.a;
				return $elm$core$Maybe$Just(
					A2(reduceTotals, historicTokens, currentValue));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = function () {
			if (!cardType) {
				return _Utils_Tuple3(
					$author$project$Strings$Translations$total_supply(userLanguage),
					$author$project$Strings$Translations$number_suppliers(userLanguage),
					$author$project$Strings$Translations$twenty_four_hour_supply(userLanguage));
			} else {
				return _Utils_Tuple3(
					$author$project$Strings$Translations$total_borrow(userLanguage),
					$author$project$Strings$Translations$number_borrowers(userLanguage),
					$author$project$Strings$Translations$twenty_four_hour_borrow(userLanguage));
			}
		}();
		var header = _v0.a;
		var userCountText = _v0.b;
		var volumeText = _v0.c;
		var _v2 = function () {
			if (!cardType) {
				return _Utils_Tuple3(
					function ($) {
						return $.hO;
					},
					function ($) {
						return $.hS;
					},
					function ($) {
						return $.hN;
					});
			} else {
				return _Utils_Tuple3(
					function ($) {
						return $.hH;
					},
					function ($) {
						return $.hR;
					},
					function ($) {
						return $.hI;
					});
			}
		}();
		var valueKey = _v2.a;
		var userKey = _v2.b;
		var nativeAmountKey = _v2.c;
		var usersString = function () {
			if (!maybeMetadata.$) {
				var metadata = maybeMetadata.a;
				return $elm$core$String$fromInt(
					userKey(metadata));
			} else {
				return '-';
			}
		}();
		var tokenSorter = F2(
			function (a, b) {
				return A2(
					$author$project$Decimal$compare,
					valueKey(b),
					valueKey(a));
			});
		var topAssets = A2(
			$elm$core$List$take,
			3,
			A2($elm$core$List$sortWith, tokenSorter, latestTokens));
		var total = A2(reduceTotals, latestTokens, valueKey);
		var _v4 = function () {
			if (!maybeHistoricTotal.$) {
				var historicTotal = maybeHistoricTotal.a;
				return _Utils_Tuple2(
					A2($author$project$LandingSite$Markets$percentGrowth, total, historicTotal),
					dollarFormatter(
						A2($author$project$Decimal$sub, total, historicTotal)));
			} else {
				return _Utils_Tuple2(
					$author$project$Decimal$zero,
					$elm$html$Html$text(
						$author$project$Preferences$getPlaceholderPrefCurrency(1)));
			}
		}();
		var delta = _v4.a;
		var twentyFourHourVolumeText = _v4.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('panel')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(header)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('text-largest')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											dollarFormatter(total)
										])),
									A2($author$project$LandingSite$Markets$deltaSpan, delta, $author$project$Utils$NumberFormatter$formatRate)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('bars-row')
								]),
							_List_fromArray(
								[
									A4($author$project$LandingSite$Markets$topMarketsBars, userLanguage, cardType, topAssets, total)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('demi row')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(volumeText)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('text-large total')
												]),
											_List_fromArray(
												[twentyFourHourVolumeText]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('col-xs-6 text-right')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(userCountText)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('text-large total')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(usersString)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$LandingSite$Markets$marketTotals = F5(
	function (userLanguage, latestTokens, maybeMetadata, maybeHistoricTokens, dollarFormatter) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$class('row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
						]),
					_List_fromArray(
						[
							A6($author$project$LandingSite$Markets$totalCard, userLanguage, 0, latestTokens, maybeMetadata, maybeHistoricTokens, dollarFormatter)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('col-sm-6')
						]),
					_List_fromArray(
						[
							A6($author$project$LandingSite$Markets$totalCard, userLanguage, 1, latestTokens, maybeMetadata, maybeHistoricTokens, dollarFormatter)
						]))
				]));
	});
var $author$project$Strings$Translations$market_overview = function (lang) {
	switch (lang) {
		case 0:
			return 'Market Overview';
		case 1:
			return 'Visión general del mercado';
		default:
			return '市场概述';
	}
};
var $author$project$Strings$Translations$supply_apy = function (lang) {
	switch (lang) {
		case 0:
			return 'Supply APY';
		case 1:
			return 'Suministro APY';
		default:
			return '供应APY';
	}
};
var $author$project$LandingSite$Markets$usdPerEth = function (tokens) {
	var ethPerUsd = function () {
		var _v0 = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (token) {
					return token.dB === 'USDC';
				},
				tokens));
		if (!_v0.$) {
			var usdc = _v0.a;
			return usdc.fz;
		} else {
			return $author$project$Decimal$zero;
		}
	}();
	return A2($author$project$Decimal$fastdiv, $author$project$Decimal$one, ethPerUsd);
};
var $author$project$LandingSite$Markets$view = F2(
	function (userLanguage, model) {
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(model.a4, model.gy);
			if (!_v1.a.$) {
				if (!_v1.b.$) {
					var tokens = _v1.a.a;
					var oldTokens = _v1.b.a;
					return _Utils_Tuple3(
						tokens.f$,
						tokens.gO,
						$elm$core$Maybe$Just(oldTokens.f$));
				} else {
					var tokens = _v1.a.a;
					return _Utils_Tuple3(tokens.f$, tokens.gO, $elm$core$Maybe$Nothing);
				}
			} else {
				return _Utils_Tuple3(_List_Nil, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
			}
		}();
		var latestTokens = _v0.a;
		var maybeMetadata = _v0.b;
		var maybeHistoricTokens = _v0.c;
		var etherPrice = $author$project$LandingSite$Markets$usdPerEth(latestTokens);
		var templateDollarFormatter = F2(
			function (formatter, value) {
				var _v3 = A3(formatter, 1, etherPrice, value);
				if (!_v3.$) {
					var string = _v3.a;
					return $elm$html$Html$text(string);
				} else {
					return $elm$html$Html$text(
						$author$project$Preferences$getPlaceholderPrefCurrency(1));
				}
			});
		var assetRowDollarFormatter = function (tokenValue) {
			return A2(templateDollarFormatter, $author$project$Preferences$formatMarketSize, tokenValue);
		};
		var marketTotalDollarFormatter = function (tokenValue) {
			return A2(templateDollarFormatter, $author$project$Preferences$formatDisplayCurrency, tokenValue);
		};
		var historyDict = function () {
			if (!maybeHistoricTokens.$) {
				var historicTokens = maybeHistoricTokens.a;
				return $elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (token) {
							return _Utils_Tuple2(token.fq, token);
						},
						historicTokens));
			} else {
				return $elm$core$Dict$empty;
			}
		}();
		var matchWithHistoric = function (cToken) {
			return _Utils_Tuple2(
				cToken,
				A2($elm$core$Dict$get, cToken.fq, historyDict));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('Markets')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$author$project$Utils$CompoundHtmlAttributes$class('hero')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Strings$Translations$market_overview(userLanguage))
										]))
								]))
						])),
					A2(
					$elm$html$Html$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$Utils$CompoundHtmlAttributes$class('container')
								]),
							_List_fromArray(
								[
									A5($author$project$LandingSite$Markets$marketTotals, userLanguage, latestTokens, maybeMetadata, maybeHistoricTokens, marketTotalDollarFormatter),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$Utils$CompoundHtmlAttributes$class('panel')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('header')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Strings$Translations$all_markets(userLanguage))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('labels')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-xs-4 col-sm-5')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$market(userLanguage))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$gross_supply(userLanguage))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$supply_apy(userLanguage))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$gross_borrow(userLanguage))
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$author$project$Utils$CompoundHtmlAttributes$class('col-xs-3 text-right')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$label,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Strings$Translations$borrow_apy(userLanguage))
																]))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$author$project$Utils$CompoundHtmlAttributes$class('assets')
												]),
											A2(
												$elm$core$List$map,
												$author$project$LandingSite$Markets$assetRow(assetRowDollarFormatter),
												A2(
													$elm$core$List$map,
													matchWithHistoric,
													A2(
														$elm$core$List$sortWith,
														F2(
															function (a, b) {
																return A2(
																	$author$project$Decimal$compare,
																	function ($) {
																		return $.hO;
																	}(b),
																	function ($) {
																		return $.hO;
																	}(a));
															}),
														latestTokens))))
										]))
								]))
						]))
				]));
	});
var $author$project$LandingSite$Main$viewPage = function (model) {
	var configs = model.bB;
	var latestTokens = model.a4;
	var network = model.ae;
	var page = model.z;
	var pages = model.P;
	var userLanguage = model.bp;
	var maybeConfig = $author$project$LandingSite$Main$getMainNetConfig(model);
	var backPage = A2(
		$elm$core$Maybe$withDefault,
		$author$project$LandingSite$Page$GovernanceHome,
		$elm$core$List$head(pages));
	var pageMainContent = function () {
		switch (page.$) {
			case 0:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingHomeTranslator,
					A3($author$project$LandingSite$Home$view, userLanguage, latestTokens, model.M));
			case 1:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingAboutTranslator,
					A2($author$project$LandingSite$About$view, userLanguage, model.aD));
			case 2:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingCTokensTranslator,
					A5($author$project$LandingSite$CTokens$view, userLanguage, maybeConfig, latestTokens, model.a0, model.L));
			case 3:
				var subPage = page.a;
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingDevelopersPresidioTranslator,
					A4($author$project$LandingSite$Developers$view, userLanguage, subPage, configs, model.ab));
			case 4:
				return $elm$html$Html$text('');
			case 5:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingMarketsTranslator,
					A2($author$project$LandingSite$Markets$view, userLanguage, model.B));
			case 6:
				var address = page.a;
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$accountProfileTranslator,
					A6($author$project$Governance$AccountProfile$view, userLanguage, backPage, address, model.q, network, model.ax));
			case 7:
				return A3($author$project$Governance$Home$view, userLanguage, model.q, model.aZ);
			case 8:
				var proposalId = page.a;
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$proposalDetailTranslator,
					A6($author$project$Governance$ProposalDetail$view, userLanguage, network, backPage, proposalId, model.q, model.ay));
			case 9:
				return A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$proposalOverviewTranslator,
					A3($author$project$Governance$ProposalOverview$view, userLanguage, model.q, model.a$));
			default:
				return A2($author$project$Governance$Leaderboard$view, userLanguage, model.a_);
		}
	}();
	return pageMainContent;
};
var $author$project$LandingSite$Main$view = function (model) {
	var page = model.z;
	var userLanguage = model.bp;
	var mobileMenuShowing = model.bX;
	var _v0 = model.aU;
	if (!_v0.$) {
		var _v1 = _v0.a;
		var targetNetwork = _v1.a;
		var contractName = _v1.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('main')
				]),
			_List_fromArray(
				[
					A3($author$project$LandingSite$AbiViewer$view, targetNetwork, contractName, model.cl)
				]));
	} else {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Utils$CompoundHtmlAttributes$id('main')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					$author$project$LandingSite$Main$landingCommonTranslator,
					A3($author$project$LandingSite$CommonViews$pageHeader, userLanguage, page, mobileMenuShowing)),
					$author$project$LandingSite$Main$viewPage(model),
					$author$project$LandingSite$CommonViews$pageFooter(userLanguage)
				]));
	}
};
var $author$project$LandingSite$Main$main = $elm$browser$Browser$element(
	{gC: $author$project$LandingSite$Main$init, ht: $author$project$LandingSite$Main$subscriptions, hT: $author$project$LandingSite$Main$update, fA: $author$project$LandingSite$Main$view});
_Platform_export({'LandingSite':{'Main':{'init':$author$project$LandingSite$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (targetNetwork) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (protoDocJson) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (path) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (language) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (configurations) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (configAbiFiles) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (apiBaseUrlMap) {
															return $elm$json$Json$Decode$succeed(
																{m: apiBaseUrlMap, ck: configAbiFiles, cm: configurations, cO: language, c8: path, aI: protoDocJson, dw: targetNetwork});
														},
														A2($elm$json$Json$Decode$field, 'apiBaseUrlMap', $elm$json$Json$Decode$value));
												},
												A2($elm$json$Json$Decode$field, 'configAbiFiles', $elm$json$Json$Decode$value));
										},
										A2($elm$json$Json$Decode$field, 'configurations', $elm$json$Json$Decode$value));
								},
								A2($elm$json$Json$Decode$field, 'language', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'path', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'protoDocJson', $elm$json$Json$Decode$value));
		},
		A2($elm$json$Json$Decode$field, 'targetNetwork', $elm$json$Json$Decode$string)))(0)}}});}(this));